// src/generated/endpoints/audit/audit.ts
import {
  useQuery
} from "@tanstack/react-query";

// src/mutator.ts
var fetcher;
function configureApiClient(apiFetcher) {
  fetcher = apiFetcher;
}
async function apiRequest(config) {
  if (!fetcher) throw new Error("API client not configured: call configureApiClient() at startup");
  const response = await fetcher({
    method: config.method,
    url: config.url,
    ...config.params ? { params: config.params } : {},
    ...config.data === void 0 ? {} : { data: config.data },
    ...config.headers ? { headers: config.headers } : {},
    ...config.signal ? { signal: config.signal } : {}
  });
  return response.data;
}

// src/generated/endpoints/audit/audit.ts
var withQueryKey = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var auditControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/audit-events`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getAuditControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/audit-events`,
    ...params ? [params] : []
  ];
};
var getAuditControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAuditControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => auditControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useAuditControllerList(orgId, params, options, queryClient) {
  const queryOptions = getAuditControllerListQueryOptions(orgId, params, options);
  const query = useQuery(queryOptions, queryClient);
  return withQueryKey(query, queryOptions.queryKey);
}
var auditControllerVerify = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/audit-events/verify`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getAuditControllerVerifyQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/audit-events/verify`
  ];
};
var getAuditControllerVerifyQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAuditControllerVerifyQueryKey(orgId);
  const queryFn = ({ signal }) => auditControllerVerify(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useAuditControllerVerify(orgId, options, queryClient) {
  const queryOptions = getAuditControllerVerifyQueryOptions(orgId, options);
  const query = useQuery(queryOptions, queryClient);
  return withQueryKey(query, queryOptions.queryKey);
}

// src/generated/endpoints/auth/auth.ts
import {
  useMutation,
  useQuery as useQuery2
} from "@tanstack/react-query";
var withQueryKey2 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var authControllerSignIn = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/auth/login`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getAuthControllerSignInQueryKey = (params) => {
  return [
    `/api/v1/auth/login`,
    ...params ? [params] : []
  ];
};
var getAuthControllerSignInQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAuthControllerSignInQueryKey(params);
  const queryFn = ({ signal }) => authControllerSignIn(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useAuthControllerSignIn(params, options, queryClient) {
  const queryOptions = getAuthControllerSignInQueryOptions(params, options);
  const query = useQuery2(queryOptions, queryClient);
  return withQueryKey2(query, queryOptions.queryKey);
}
var authControllerCallback = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/auth/callback`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getAuthControllerCallbackQueryKey = (params) => {
  return [
    `/api/v1/auth/callback`,
    ...params ? [params] : []
  ];
};
var getAuthControllerCallbackQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAuthControllerCallbackQueryKey(params);
  const queryFn = ({ signal }) => authControllerCallback(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useAuthControllerCallback(params, options, queryClient) {
  const queryOptions = getAuthControllerCallbackQueryOptions(params, options);
  const query = useQuery2(queryOptions, queryClient);
  return withQueryKey2(query, queryOptions.queryKey);
}
var authControllerLogout = (signal) => {
  return apiRequest(
    {
      url: `/api/v1/auth/logout`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getAuthControllerLogoutMutationKey = () => ["authControllerLogout"];
var getAuthControllerLogoutMutationOptions = (options) => {
  const mutationKey = getAuthControllerLogoutMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = () => {
    return authControllerLogout();
  };
  return { mutationFn, ...mutationOptions };
};
var useAuthControllerLogout = (options, queryClient) => {
  return useMutation(getAuthControllerLogoutMutationOptions(options), queryClient);
};
var authControllerBackchannelLogout = (backchannelLogoutBodyDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/auth/backchannel-logout`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: backchannelLogoutBodyDto,
      ...signal ? { signal } : {}
    }
  );
};
var getAuthControllerBackchannelLogoutMutationKey = () => ["authControllerBackchannelLogout"];
var getAuthControllerBackchannelLogoutMutationOptions = (options) => {
  const mutationKey = getAuthControllerBackchannelLogoutMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return authControllerBackchannelLogout(data);
  };
  return { mutationFn, ...mutationOptions };
};
var useAuthControllerBackchannelLogout = (options, queryClient) => {
  return useMutation(getAuthControllerBackchannelLogoutMutationOptions(options), queryClient);
};
var authControllerStepUp = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/auth/step-up`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getAuthControllerStepUpQueryKey = (params) => {
  return [
    `/api/v1/auth/step-up`,
    ...params ? [params] : []
  ];
};
var getAuthControllerStepUpQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAuthControllerStepUpQueryKey(params);
  const queryFn = ({ signal }) => authControllerStepUp(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useAuthControllerStepUp(params, options, queryClient) {
  const queryOptions = getAuthControllerStepUpQueryOptions(params, options);
  const query = useQuery2(queryOptions, queryClient);
  return withQueryKey2(query, queryOptions.queryKey);
}

// src/generated/endpoints/billing/billing.ts
import {
  useMutation as useMutation2,
  useQuery as useQuery3
} from "@tanstack/react-query";
var withQueryKey3 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var plansControllerList = (signal) => {
  return apiRequest(
    {
      url: `/api/v1/plans`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPlansControllerListQueryKey = () => {
  return [
    `/api/v1/plans`
  ];
};
var getPlansControllerListQueryOptions = (options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlansControllerListQueryKey();
  const queryFn = ({ signal }) => plansControllerList(signal);
  return { queryKey, queryFn, ...queryOptions };
};
function usePlansControllerList(options, queryClient) {
  const queryOptions = getPlansControllerListQueryOptions(options);
  const query = useQuery3(queryOptions, queryClient);
  return withQueryKey3(query, queryOptions.queryKey);
}
var entitlementsControllerGet = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/entitlements`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getEntitlementsControllerGetQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/entitlements`
  ];
};
var getEntitlementsControllerGetQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getEntitlementsControllerGetQueryKey(orgId);
  const queryFn = ({ signal }) => entitlementsControllerGet(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useEntitlementsControllerGet(orgId, options, queryClient) {
  const queryOptions = getEntitlementsControllerGetQueryOptions(orgId, options);
  const query = useQuery3(queryOptions, queryClient);
  return withQueryKey3(query, queryOptions.queryKey);
}
var subscriptionControllerGet = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/subscription`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getSubscriptionControllerGetQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/subscription`
  ];
};
var getSubscriptionControllerGetQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSubscriptionControllerGetQueryKey(orgId);
  const queryFn = ({ signal }) => subscriptionControllerGet(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useSubscriptionControllerGet(orgId, options, queryClient) {
  const queryOptions = getSubscriptionControllerGetQueryOptions(orgId, options);
  const query = useQuery3(queryOptions, queryClient);
  return withQueryKey3(query, queryOptions.queryKey);
}
var subscriptionControllerQuote = (orgId, subscriptionShapeDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/subscription/quote`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: subscriptionShapeDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSubscriptionControllerQuoteMutationKey = () => ["subscriptionControllerQuote"];
var getSubscriptionControllerQuoteMutationOptions = (options) => {
  const mutationKey = getSubscriptionControllerQuoteMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return subscriptionControllerQuote(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSubscriptionControllerQuote = (options, queryClient) => {
  return useMutation2(getSubscriptionControllerQuoteMutationOptions(options), queryClient);
};
var subscriptionControllerChange = (orgId, subscriptionShapeDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/subscription/change`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: subscriptionShapeDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSubscriptionControllerChangeMutationKey = () => ["subscriptionControllerChange"];
var getSubscriptionControllerChangeMutationOptions = (options) => {
  const mutationKey = getSubscriptionControllerChangeMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return subscriptionControllerChange(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSubscriptionControllerChange = (options, queryClient) => {
  return useMutation2(getSubscriptionControllerChangeMutationOptions(options), queryClient);
};
var subscriptionControllerRenew = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/subscription/renew`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getSubscriptionControllerRenewMutationKey = () => ["subscriptionControllerRenew"];
var getSubscriptionControllerRenewMutationOptions = (options) => {
  const mutationKey = getSubscriptionControllerRenewMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId } = props ?? {};
    return subscriptionControllerRenew(orgId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSubscriptionControllerRenew = (options, queryClient) => {
  return useMutation2(getSubscriptionControllerRenewMutationOptions(options), queryClient);
};
var subscriptionControllerPause = (orgId, subscriptionPauseDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/subscription/pause`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: subscriptionPauseDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSubscriptionControllerPauseMutationKey = () => ["subscriptionControllerPause"];
var getSubscriptionControllerPauseMutationOptions = (options) => {
  const mutationKey = getSubscriptionControllerPauseMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return subscriptionControllerPause(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSubscriptionControllerPause = (options, queryClient) => {
  return useMutation2(getSubscriptionControllerPauseMutationOptions(options), queryClient);
};
var subscriptionControllerResume = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/subscription/resume`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getSubscriptionControllerResumeMutationKey = () => ["subscriptionControllerResume"];
var getSubscriptionControllerResumeMutationOptions = (options) => {
  const mutationKey = getSubscriptionControllerResumeMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId } = props ?? {};
    return subscriptionControllerResume(orgId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSubscriptionControllerResume = (options, queryClient) => {
  return useMutation2(getSubscriptionControllerResumeMutationOptions(options), queryClient);
};
var subscriptionControllerCancel = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/subscription/cancel`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getSubscriptionControllerCancelMutationKey = () => ["subscriptionControllerCancel"];
var getSubscriptionControllerCancelMutationOptions = (options) => {
  const mutationKey = getSubscriptionControllerCancelMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId } = props ?? {};
    return subscriptionControllerCancel(orgId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSubscriptionControllerCancel = (options, queryClient) => {
  return useMutation2(getSubscriptionControllerCancelMutationOptions(options), queryClient);
};
var subscriptionControllerWithdraw = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/subscription/pending-change`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getSubscriptionControllerWithdrawMutationKey = () => ["subscriptionControllerWithdraw"];
var getSubscriptionControllerWithdrawMutationOptions = (options) => {
  const mutationKey = getSubscriptionControllerWithdrawMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId } = props ?? {};
    return subscriptionControllerWithdraw(orgId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSubscriptionControllerWithdraw = (options, queryClient) => {
  return useMutation2(getSubscriptionControllerWithdrawMutationOptions(options), queryClient);
};
var subscriptionControllerInvoices = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/subscription/invoices`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getSubscriptionControllerInvoicesQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/subscription/invoices`
  ];
};
var getSubscriptionControllerInvoicesQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSubscriptionControllerInvoicesQueryKey(orgId);
  const queryFn = ({ signal }) => subscriptionControllerInvoices(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useSubscriptionControllerInvoices(orgId, options, queryClient) {
  const queryOptions = getSubscriptionControllerInvoicesQueryOptions(orgId, options);
  const query = useQuery3(queryOptions, queryClient);
  return withQueryKey3(query, queryOptions.queryKey);
}
var subscriptionControllerPaymentLink = (orgId, createPaymentLinkDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/subscription/payment-links`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createPaymentLinkDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSubscriptionControllerPaymentLinkMutationKey = () => ["subscriptionControllerPaymentLink"];
var getSubscriptionControllerPaymentLinkMutationOptions = (options) => {
  const mutationKey = getSubscriptionControllerPaymentLinkMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return subscriptionControllerPaymentLink(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSubscriptionControllerPaymentLink = (options, queryClient) => {
  return useMutation2(getSubscriptionControllerPaymentLinkMutationOptions(options), queryClient);
};
var subscriptionControllerPdfUrl = (orgId, invoiceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/subscription/invoices/${invoiceId}/pdf-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getSubscriptionControllerPdfUrlQueryKey = (orgId, invoiceId) => {
  return [
    `/api/v1/orgs/${orgId}/subscription/invoices/${invoiceId}/pdf-url`
  ];
};
var getSubscriptionControllerPdfUrlQueryOptions = (orgId, invoiceId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSubscriptionControllerPdfUrlQueryKey(orgId, invoiceId);
  const queryFn = ({ signal }) => subscriptionControllerPdfUrl(orgId, invoiceId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && invoiceId !== null && invoiceId !== void 0, ...queryOptions };
};
function useSubscriptionControllerPdfUrl(orgId, invoiceId, options, queryClient) {
  const queryOptions = getSubscriptionControllerPdfUrlQueryOptions(orgId, invoiceId, options);
  const query = useQuery3(queryOptions, queryClient);
  return withQueryKey3(query, queryOptions.queryKey);
}
var paymentWebhookControllerReceive = (provider, signal) => {
  return apiRequest(
    {
      url: `/api/v1/webhooks/payments/${provider}`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getPaymentWebhookControllerReceiveMutationKey = () => ["paymentWebhookControllerReceive"];
var getPaymentWebhookControllerReceiveMutationOptions = (options) => {
  const mutationKey = getPaymentWebhookControllerReceiveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { provider } = props ?? {};
    return paymentWebhookControllerReceive(provider);
  };
  return { mutationFn, ...mutationOptions };
};
var usePaymentWebhookControllerReceive = (options, queryClient) => {
  return useMutation2(getPaymentWebhookControllerReceiveMutationOptions(options), queryClient);
};

// src/generated/endpoints/calendar/calendar.ts
import {
  useMutation as useMutation3,
  useQuery as useQuery4
} from "@tanstack/react-query";
var withQueryKey4 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var spaceEventsControllerList = (spaceId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/events`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getSpaceEventsControllerListQueryKey = (spaceId, params) => {
  return [
    `/api/v1/spaces/${spaceId}/events`,
    ...params ? [params] : []
  ];
};
var getSpaceEventsControllerListQueryOptions = (spaceId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSpaceEventsControllerListQueryKey(spaceId, params);
  const queryFn = ({ signal }) => spaceEventsControllerList(spaceId, params, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useSpaceEventsControllerList(spaceId, params, options, queryClient) {
  const queryOptions = getSpaceEventsControllerListQueryOptions(spaceId, params, options);
  const query = useQuery4(queryOptions, queryClient);
  return withQueryKey4(query, queryOptions.queryKey);
}
var spaceEventsControllerCreate = (spaceId, createEventDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/events`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createEventDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSpaceEventsControllerCreateMutationKey = () => ["spaceEventsControllerCreate"];
var getSpaceEventsControllerCreateMutationOptions = (options) => {
  const mutationKey = getSpaceEventsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return spaceEventsControllerCreate(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSpaceEventsControllerCreate = (options, queryClient) => {
  return useMutation3(getSpaceEventsControllerCreateMutationOptions(options), queryClient);
};
var eventControllerGet = (eventId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/events/${eventId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getEventControllerGetQueryKey = (eventId) => {
  return [
    `/api/v1/events/${eventId}`
  ];
};
var getEventControllerGetQueryOptions = (eventId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getEventControllerGetQueryKey(eventId);
  const queryFn = ({ signal }) => eventControllerGet(eventId, signal);
  return { queryKey, queryFn, enabled: eventId !== null && eventId !== void 0, ...queryOptions };
};
function useEventControllerGet(eventId, options, queryClient) {
  const queryOptions = getEventControllerGetQueryOptions(eventId, options);
  const query = useQuery4(queryOptions, queryClient);
  return withQueryKey4(query, queryOptions.queryKey);
}
var eventControllerUpdate = (eventId, updateEventDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/events/${eventId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateEventDto,
      ...signal ? { signal } : {}
    }
  );
};
var getEventControllerUpdateMutationKey = () => ["eventControllerUpdate"];
var getEventControllerUpdateMutationOptions = (options) => {
  const mutationKey = getEventControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { eventId, data } = props ?? {};
    return eventControllerUpdate(eventId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useEventControllerUpdate = (options, queryClient) => {
  return useMutation3(getEventControllerUpdateMutationOptions(options), queryClient);
};
var eventControllerRemove = (eventId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/events/${eventId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getEventControllerRemoveMutationKey = () => ["eventControllerRemove"];
var getEventControllerRemoveMutationOptions = (options) => {
  const mutationKey = getEventControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { eventId } = props ?? {};
    return eventControllerRemove(eventId);
  };
  return { mutationFn, ...mutationOptions };
};
var useEventControllerRemove = (options, queryClient) => {
  return useMutation3(getEventControllerRemoveMutationOptions(options), queryClient);
};
var eventControllerRespond = (eventId, eventResponseDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/events/${eventId}/response`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: eventResponseDto,
      ...signal ? { signal } : {}
    }
  );
};
var getEventControllerRespondMutationKey = () => ["eventControllerRespond"];
var getEventControllerRespondMutationOptions = (options) => {
  const mutationKey = getEventControllerRespondMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { eventId, data } = props ?? {};
    return eventControllerRespond(eventId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useEventControllerRespond = (options, queryClient) => {
  return useMutation3(getEventControllerRespondMutationOptions(options), queryClient);
};
var myCalendarControllerCalendarOf = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/calendar`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getMyCalendarControllerCalendarOfQueryKey = (params) => {
  return [
    `/api/v1/me/calendar`,
    ...params ? [params] : []
  ];
};
var getMyCalendarControllerCalendarOfQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMyCalendarControllerCalendarOfQueryKey(params);
  const queryFn = ({ signal }) => myCalendarControllerCalendarOf(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useMyCalendarControllerCalendarOf(params, options, queryClient) {
  const queryOptions = getMyCalendarControllerCalendarOfQueryOptions(params, options);
  const query = useQuery4(queryOptions, queryClient);
  return withQueryKey4(query, queryOptions.queryKey);
}
var myCalendarControllerListFeeds = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/ics-feeds`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getMyCalendarControllerListFeedsQueryKey = (params) => {
  return [
    `/api/v1/me/ics-feeds`,
    ...params ? [params] : []
  ];
};
var getMyCalendarControllerListFeedsQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMyCalendarControllerListFeedsQueryKey(params);
  const queryFn = ({ signal }) => myCalendarControllerListFeeds(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useMyCalendarControllerListFeeds(params, options, queryClient) {
  const queryOptions = getMyCalendarControllerListFeedsQueryOptions(params, options);
  const query = useQuery4(queryOptions, queryClient);
  return withQueryKey4(query, queryOptions.queryKey);
}
var myCalendarControllerCreateFeed = (createIcsFeedDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/ics-feeds`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createIcsFeedDto,
      ...signal ? { signal } : {}
    }
  );
};
var getMyCalendarControllerCreateFeedMutationKey = () => ["myCalendarControllerCreateFeed"];
var getMyCalendarControllerCreateFeedMutationOptions = (options) => {
  const mutationKey = getMyCalendarControllerCreateFeedMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return myCalendarControllerCreateFeed(data);
  };
  return { mutationFn, ...mutationOptions };
};
var useMyCalendarControllerCreateFeed = (options, queryClient) => {
  return useMutation3(getMyCalendarControllerCreateFeedMutationOptions(options), queryClient);
};
var myCalendarControllerRevokeFeed = (feedId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/ics-feeds/${feedId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getMyCalendarControllerRevokeFeedMutationKey = () => ["myCalendarControllerRevokeFeed"];
var getMyCalendarControllerRevokeFeedMutationOptions = (options) => {
  const mutationKey = getMyCalendarControllerRevokeFeedMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { feedId } = props ?? {};
    return myCalendarControllerRevokeFeed(feedId);
  };
  return { mutationFn, ...mutationOptions };
};
var useMyCalendarControllerRevokeFeed = (options, queryClient) => {
  return useMutation3(getMyCalendarControllerRevokeFeedMutationOptions(options), queryClient);
};
var icsPublicControllerFeed = (token, signal) => {
  return apiRequest(
    {
      url: `/api/v1/ics/${token}.ics`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getIcsPublicControllerFeedQueryKey = (token) => {
  return [
    `/api/v1/ics/${token}.ics`
  ];
};
var getIcsPublicControllerFeedQueryOptions = (token, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getIcsPublicControllerFeedQueryKey(token);
  const queryFn = ({ signal }) => icsPublicControllerFeed(token, signal);
  return { queryKey, queryFn, enabled: token !== null && token !== void 0, ...queryOptions };
};
function useIcsPublicControllerFeed(token, options, queryClient) {
  const queryOptions = getIcsPublicControllerFeedQueryOptions(token, options);
  const query = useQuery4(queryOptions, queryClient);
  return withQueryKey4(query, queryOptions.queryKey);
}

// src/generated/endpoints/client-errors/client-errors.ts
import {
  useMutation as useMutation4
} from "@tanstack/react-query";
var clientErrorsControllerReport = (clientErrorReportDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/client-errors`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: clientErrorReportDto,
      ...signal ? { signal } : {}
    }
  );
};
var getClientErrorsControllerReportMutationKey = () => ["clientErrorsControllerReport"];
var getClientErrorsControllerReportMutationOptions = (options) => {
  const mutationKey = getClientErrorsControllerReportMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return clientErrorsControllerReport(data);
  };
  return { mutationFn, ...mutationOptions };
};
var useClientErrorsControllerReport = (options, queryClient) => {
  return useMutation4(getClientErrorsControllerReportMutationOptions(options), queryClient);
};

// src/generated/endpoints/clients/clients.ts
import {
  useMutation as useMutation5,
  useQuery as useQuery5
} from "@tanstack/react-query";
var withQueryKey5 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var clientsControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/clients`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getClientsControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/clients`,
    ...params ? [params] : []
  ];
};
var getClientsControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getClientsControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => clientsControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useClientsControllerList(orgId, params, options, queryClient) {
  const queryOptions = getClientsControllerListQueryOptions(orgId, params, options);
  const query = useQuery5(queryOptions, queryClient);
  return withQueryKey5(query, queryOptions.queryKey);
}
var clientsControllerCreate = (orgId, createClientDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/clients`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createClientDto,
      ...signal ? { signal } : {}
    }
  );
};
var getClientsControllerCreateMutationKey = () => ["clientsControllerCreate"];
var getClientsControllerCreateMutationOptions = (options) => {
  const mutationKey = getClientsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return clientsControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useClientsControllerCreate = (options, queryClient) => {
  return useMutation5(getClientsControllerCreateMutationOptions(options), queryClient);
};
var clientsControllerGet = (orgId, clientId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/clients/${clientId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getClientsControllerGetQueryKey = (orgId, clientId) => {
  return [
    `/api/v1/orgs/${orgId}/clients/${clientId}`
  ];
};
var getClientsControllerGetQueryOptions = (orgId, clientId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getClientsControllerGetQueryKey(orgId, clientId);
  const queryFn = ({ signal }) => clientsControllerGet(orgId, clientId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && clientId !== null && clientId !== void 0, ...queryOptions };
};
function useClientsControllerGet(orgId, clientId, options, queryClient) {
  const queryOptions = getClientsControllerGetQueryOptions(orgId, clientId, options);
  const query = useQuery5(queryOptions, queryClient);
  return withQueryKey5(query, queryOptions.queryKey);
}
var clientsControllerUpdate = (orgId, clientId, updateClientDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/clients/${clientId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateClientDto,
      ...signal ? { signal } : {}
    }
  );
};
var getClientsControllerUpdateMutationKey = () => ["clientsControllerUpdate"];
var getClientsControllerUpdateMutationOptions = (options) => {
  const mutationKey = getClientsControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, clientId, data } = props ?? {};
    return clientsControllerUpdate(orgId, clientId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useClientsControllerUpdate = (options, queryClient) => {
  return useMutation5(getClientsControllerUpdateMutationOptions(options), queryClient);
};
var clientsControllerArchive = (orgId, clientId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/clients/${clientId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getClientsControllerArchiveMutationKey = () => ["clientsControllerArchive"];
var getClientsControllerArchiveMutationOptions = (options) => {
  const mutationKey = getClientsControllerArchiveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, clientId } = props ?? {};
    return clientsControllerArchive(orgId, clientId);
  };
  return { mutationFn, ...mutationOptions };
};
var useClientsControllerArchive = (options, queryClient) => {
  return useMutation5(getClientsControllerArchiveMutationOptions(options), queryClient);
};
var clientsControllerListContacts = (orgId, clientId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/clients/${clientId}/contacts`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getClientsControllerListContactsQueryKey = (orgId, clientId) => {
  return [
    `/api/v1/orgs/${orgId}/clients/${clientId}/contacts`
  ];
};
var getClientsControllerListContactsQueryOptions = (orgId, clientId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getClientsControllerListContactsQueryKey(orgId, clientId);
  const queryFn = ({ signal }) => clientsControllerListContacts(orgId, clientId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && clientId !== null && clientId !== void 0, ...queryOptions };
};
function useClientsControllerListContacts(orgId, clientId, options, queryClient) {
  const queryOptions = getClientsControllerListContactsQueryOptions(orgId, clientId, options);
  const query = useQuery5(queryOptions, queryClient);
  return withQueryKey5(query, queryOptions.queryKey);
}
var clientsControllerCreateContact = (orgId, clientId, createClientContactDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/clients/${clientId}/contacts`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createClientContactDto,
      ...signal ? { signal } : {}
    }
  );
};
var getClientsControllerCreateContactMutationKey = () => ["clientsControllerCreateContact"];
var getClientsControllerCreateContactMutationOptions = (options) => {
  const mutationKey = getClientsControllerCreateContactMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, clientId, data } = props ?? {};
    return clientsControllerCreateContact(orgId, clientId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useClientsControllerCreateContact = (options, queryClient) => {
  return useMutation5(getClientsControllerCreateContactMutationOptions(options), queryClient);
};
var clientsControllerUpdateContact = (orgId, clientId, contactId, updateClientContactDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/clients/${clientId}/contacts/${contactId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateClientContactDto,
      ...signal ? { signal } : {}
    }
  );
};
var getClientsControllerUpdateContactMutationKey = () => ["clientsControllerUpdateContact"];
var getClientsControllerUpdateContactMutationOptions = (options) => {
  const mutationKey = getClientsControllerUpdateContactMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, clientId, contactId, data } = props ?? {};
    return clientsControllerUpdateContact(orgId, clientId, contactId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useClientsControllerUpdateContact = (options, queryClient) => {
  return useMutation5(getClientsControllerUpdateContactMutationOptions(options), queryClient);
};
var clientsControllerDeleteContact = (orgId, clientId, contactId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/clients/${clientId}/contacts/${contactId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getClientsControllerDeleteContactMutationKey = () => ["clientsControllerDeleteContact"];
var getClientsControllerDeleteContactMutationOptions = (options) => {
  const mutationKey = getClientsControllerDeleteContactMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, clientId, contactId } = props ?? {};
    return clientsControllerDeleteContact(orgId, clientId, contactId);
  };
  return { mutationFn, ...mutationOptions };
};
var useClientsControllerDeleteContact = (options, queryClient) => {
  return useMutation5(getClientsControllerDeleteContactMutationOptions(options), queryClient);
};

// src/generated/endpoints/directory/directory.ts
import {
  useMutation as useMutation6,
  useQuery as useQuery6
} from "@tanstack/react-query";
var withQueryKey6 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var directoryProfileControllerGet = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/directory-profile`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getDirectoryProfileControllerGetQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/directory-profile`
  ];
};
var getDirectoryProfileControllerGetQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getDirectoryProfileControllerGetQueryKey(orgId);
  const queryFn = ({ signal }) => directoryProfileControllerGet(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useDirectoryProfileControllerGet(orgId, options, queryClient) {
  const queryOptions = getDirectoryProfileControllerGetQueryOptions(orgId, options);
  const query = useQuery6(queryOptions, queryClient);
  return withQueryKey6(query, queryOptions.queryKey);
}
var directoryProfileControllerUpdate = (orgId, updateDirectoryProfileDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/directory-profile`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateDirectoryProfileDto,
      ...signal ? { signal } : {}
    }
  );
};
var getDirectoryProfileControllerUpdateMutationKey = () => ["directoryProfileControllerUpdate"];
var getDirectoryProfileControllerUpdateMutationOptions = (options) => {
  const mutationKey = getDirectoryProfileControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return directoryProfileControllerUpdate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useDirectoryProfileControllerUpdate = (options, queryClient) => {
  return useMutation6(getDirectoryProfileControllerUpdateMutationOptions(options), queryClient);
};
var directoryControllerSearch = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/directory`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getDirectoryControllerSearchQueryKey = (params) => {
  return [
    `/api/v1/directory`,
    ...params ? [params] : []
  ];
};
var getDirectoryControllerSearchQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getDirectoryControllerSearchQueryKey(params);
  const queryFn = ({ signal }) => directoryControllerSearch(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useDirectoryControllerSearch(params, options, queryClient) {
  const queryOptions = getDirectoryControllerSearchQueryOptions(params, options);
  const query = useQuery6(queryOptions, queryClient);
  return withQueryKey6(query, queryOptions.queryKey);
}
var directoryControllerContact = (organizationId, directoryContactDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/directory/${organizationId}/contact`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: directoryContactDto,
      ...signal ? { signal } : {}
    }
  );
};
var getDirectoryControllerContactMutationKey = () => ["directoryControllerContact"];
var getDirectoryControllerContactMutationOptions = (options) => {
  const mutationKey = getDirectoryControllerContactMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { organizationId, data } = props ?? {};
    return directoryControllerContact(organizationId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useDirectoryControllerContact = (options, queryClient) => {
  return useMutation6(getDirectoryControllerContactMutationOptions(options), queryClient);
};

// src/generated/endpoints/documents/documents.ts
import {
  useMutation as useMutation7,
  useQuery as useQuery7
} from "@tanstack/react-query";
var withQueryKey7 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var foldersControllerList = (spaceId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/folders`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getFoldersControllerListQueryKey = (spaceId, params) => {
  return [
    `/api/v1/spaces/${spaceId}/folders`,
    ...params ? [params] : []
  ];
};
var getFoldersControllerListQueryOptions = (spaceId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getFoldersControllerListQueryKey(spaceId, params);
  const queryFn = ({ signal }) => foldersControllerList(spaceId, params, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useFoldersControllerList(spaceId, params, options, queryClient) {
  const queryOptions = getFoldersControllerListQueryOptions(spaceId, params, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var foldersControllerCreate = (spaceId, createFolderDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/folders`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createFolderDto,
      ...signal ? { signal } : {}
    }
  );
};
var getFoldersControllerCreateMutationKey = () => ["foldersControllerCreate"];
var getFoldersControllerCreateMutationOptions = (options) => {
  const mutationKey = getFoldersControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return foldersControllerCreate(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useFoldersControllerCreate = (options, queryClient) => {
  return useMutation7(getFoldersControllerCreateMutationOptions(options), queryClient);
};
var foldersControllerGet = (spaceId, folderId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/folders/${folderId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getFoldersControllerGetQueryKey = (spaceId, folderId) => {
  return [
    `/api/v1/spaces/${spaceId}/folders/${folderId}`
  ];
};
var getFoldersControllerGetQueryOptions = (spaceId, folderId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getFoldersControllerGetQueryKey(spaceId, folderId);
  const queryFn = ({ signal }) => foldersControllerGet(spaceId, folderId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && folderId !== null && folderId !== void 0, ...queryOptions };
};
function useFoldersControllerGet(spaceId, folderId, options, queryClient) {
  const queryOptions = getFoldersControllerGetQueryOptions(spaceId, folderId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var foldersControllerUpdate = (spaceId, folderId, updateFolderDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/folders/${folderId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateFolderDto,
      ...signal ? { signal } : {}
    }
  );
};
var getFoldersControllerUpdateMutationKey = () => ["foldersControllerUpdate"];
var getFoldersControllerUpdateMutationOptions = (options) => {
  const mutationKey = getFoldersControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, folderId, data } = props ?? {};
    return foldersControllerUpdate(spaceId, folderId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useFoldersControllerUpdate = (options, queryClient) => {
  return useMutation7(getFoldersControllerUpdateMutationOptions(options), queryClient);
};
var foldersControllerRemove = (spaceId, folderId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/folders/${folderId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getFoldersControllerRemoveMutationKey = () => ["foldersControllerRemove"];
var getFoldersControllerRemoveMutationOptions = (options) => {
  const mutationKey = getFoldersControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, folderId } = props ?? {};
    return foldersControllerRemove(spaceId, folderId);
  };
  return { mutationFn, ...mutationOptions };
};
var useFoldersControllerRemove = (options, queryClient) => {
  return useMutation7(getFoldersControllerRemoveMutationOptions(options), queryClient);
};
var foldersControllerItems = (spaceId, folderId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/folders/${folderId}/items`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getFoldersControllerItemsQueryKey = (spaceId, folderId, params) => {
  return [
    `/api/v1/spaces/${spaceId}/folders/${folderId}/items`,
    ...params ? [params] : []
  ];
};
var getFoldersControllerItemsQueryOptions = (spaceId, folderId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getFoldersControllerItemsQueryKey(spaceId, folderId, params);
  const queryFn = ({ signal }) => foldersControllerItems(spaceId, folderId, params, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && folderId !== null && folderId !== void 0, ...queryOptions };
};
function useFoldersControllerItems(spaceId, folderId, params, options, queryClient) {
  const queryOptions = getFoldersControllerItemsQueryOptions(spaceId, folderId, params, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var foldersControllerAcl = (spaceId, folderId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/folders/${folderId}/acl`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getFoldersControllerAclQueryKey = (spaceId, folderId) => {
  return [
    `/api/v1/spaces/${spaceId}/folders/${folderId}/acl`
  ];
};
var getFoldersControllerAclQueryOptions = (spaceId, folderId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getFoldersControllerAclQueryKey(spaceId, folderId);
  const queryFn = ({ signal }) => foldersControllerAcl(spaceId, folderId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && folderId !== null && folderId !== void 0, ...queryOptions };
};
function useFoldersControllerAcl(spaceId, folderId, options, queryClient) {
  const queryOptions = getFoldersControllerAclQueryOptions(spaceId, folderId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var foldersControllerReplaceAcl = (spaceId, folderId, putFolderAclDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/folders/${folderId}/acl`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: putFolderAclDto,
      ...signal ? { signal } : {}
    }
  );
};
var getFoldersControllerReplaceAclMutationKey = () => ["foldersControllerReplaceAcl"];
var getFoldersControllerReplaceAclMutationOptions = (options) => {
  const mutationKey = getFoldersControllerReplaceAclMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, folderId, data } = props ?? {};
    return foldersControllerReplaceAcl(spaceId, folderId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useFoldersControllerReplaceAcl = (options, queryClient) => {
  return useMutation7(getFoldersControllerReplaceAclMutationOptions(options), queryClient);
};
var documentsControllerList = (spaceId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getDocumentsControllerListQueryKey = (spaceId, params) => {
  return [
    `/api/v1/spaces/${spaceId}/documents`,
    ...params ? [params] : []
  ];
};
var getDocumentsControllerListQueryOptions = (spaceId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getDocumentsControllerListQueryKey(spaceId, params);
  const queryFn = ({ signal }) => documentsControllerList(spaceId, params, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useDocumentsControllerList(spaceId, params, options, queryClient) {
  const queryOptions = getDocumentsControllerListQueryOptions(spaceId, params, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var documentsControllerGet = (spaceId, documentId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getDocumentsControllerGetQueryKey = (spaceId, documentId) => {
  return [
    `/api/v1/spaces/${spaceId}/documents/${documentId}`
  ];
};
var getDocumentsControllerGetQueryOptions = (spaceId, documentId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getDocumentsControllerGetQueryKey(spaceId, documentId);
  const queryFn = ({ signal }) => documentsControllerGet(spaceId, documentId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && documentId !== null && documentId !== void 0, ...queryOptions };
};
function useDocumentsControllerGet(spaceId, documentId, options, queryClient) {
  const queryOptions = getDocumentsControllerGetQueryOptions(spaceId, documentId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var documentsControllerUpdate = (spaceId, documentId, updateDocumentDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateDocumentDto,
      ...signal ? { signal } : {}
    }
  );
};
var getDocumentsControllerUpdateMutationKey = () => ["documentsControllerUpdate"];
var getDocumentsControllerUpdateMutationOptions = (options) => {
  const mutationKey = getDocumentsControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, documentId, data } = props ?? {};
    return documentsControllerUpdate(spaceId, documentId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useDocumentsControllerUpdate = (options, queryClient) => {
  return useMutation7(getDocumentsControllerUpdateMutationOptions(options), queryClient);
};
var documentsControllerRemove = (spaceId, documentId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getDocumentsControllerRemoveMutationKey = () => ["documentsControllerRemove"];
var getDocumentsControllerRemoveMutationOptions = (options) => {
  const mutationKey = getDocumentsControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, documentId } = props ?? {};
    return documentsControllerRemove(spaceId, documentId);
  };
  return { mutationFn, ...mutationOptions };
};
var useDocumentsControllerRemove = (options, queryClient) => {
  return useMutation7(getDocumentsControllerRemoveMutationOptions(options), queryClient);
};
var documentsControllerVersions = (spaceId, documentId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}/versions`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getDocumentsControllerVersionsQueryKey = (spaceId, documentId) => {
  return [
    `/api/v1/spaces/${spaceId}/documents/${documentId}/versions`
  ];
};
var getDocumentsControllerVersionsQueryOptions = (spaceId, documentId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getDocumentsControllerVersionsQueryKey(spaceId, documentId);
  const queryFn = ({ signal }) => documentsControllerVersions(spaceId, documentId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && documentId !== null && documentId !== void 0, ...queryOptions };
};
function useDocumentsControllerVersions(spaceId, documentId, options, queryClient) {
  const queryOptions = getDocumentsControllerVersionsQueryOptions(spaceId, documentId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var documentsControllerPreviewUrl = (spaceId, documentId, versionId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}/versions/${versionId}/preview-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getDocumentsControllerPreviewUrlQueryKey = (spaceId, documentId, versionId) => {
  return [
    `/api/v1/spaces/${spaceId}/documents/${documentId}/versions/${versionId}/preview-url`
  ];
};
var getDocumentsControllerPreviewUrlQueryOptions = (spaceId, documentId, versionId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getDocumentsControllerPreviewUrlQueryKey(spaceId, documentId, versionId);
  const queryFn = ({ signal }) => documentsControllerPreviewUrl(spaceId, documentId, versionId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && documentId !== null && documentId !== void 0 && versionId !== null && versionId !== void 0, ...queryOptions };
};
function useDocumentsControllerPreviewUrl(spaceId, documentId, versionId, options, queryClient) {
  const queryOptions = getDocumentsControllerPreviewUrlQueryOptions(spaceId, documentId, versionId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var documentsControllerDownloadUrl = (spaceId, documentId, versionId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}/versions/${versionId}/download-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getDocumentsControllerDownloadUrlQueryKey = (spaceId, documentId, versionId) => {
  return [
    `/api/v1/spaces/${spaceId}/documents/${documentId}/versions/${versionId}/download-url`
  ];
};
var getDocumentsControllerDownloadUrlQueryOptions = (spaceId, documentId, versionId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getDocumentsControllerDownloadUrlQueryKey(spaceId, documentId, versionId);
  const queryFn = ({ signal }) => documentsControllerDownloadUrl(spaceId, documentId, versionId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && documentId !== null && documentId !== void 0 && versionId !== null && versionId !== void 0, ...queryOptions };
};
function useDocumentsControllerDownloadUrl(spaceId, documentId, versionId, options, queryClient) {
  const queryOptions = getDocumentsControllerDownloadUrlQueryOptions(spaceId, documentId, versionId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var documentsControllerRestore = (spaceId, documentId, versionId, restoreVersionDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}/versions/${versionId}/restore`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: restoreVersionDto,
      ...signal ? { signal } : {}
    }
  );
};
var getDocumentsControllerRestoreMutationKey = () => ["documentsControllerRestore"];
var getDocumentsControllerRestoreMutationOptions = (options) => {
  const mutationKey = getDocumentsControllerRestoreMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, documentId, versionId, data } = props ?? {};
    return documentsControllerRestore(spaceId, documentId, versionId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useDocumentsControllerRestore = (options, queryClient) => {
  return useMutation7(getDocumentsControllerRestoreMutationOptions(options), queryClient);
};
var uploadsControllerCreate = (spaceId, createUploadDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/uploads`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createUploadDto,
      ...signal ? { signal } : {}
    }
  );
};
var getUploadsControllerCreateMutationKey = () => ["uploadsControllerCreate"];
var getUploadsControllerCreateMutationOptions = (options) => {
  const mutationKey = getUploadsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return uploadsControllerCreate(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useUploadsControllerCreate = (options, queryClient) => {
  return useMutation7(getUploadsControllerCreateMutationOptions(options), queryClient);
};
var uploadsControllerStatus = (spaceId, uploadId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/uploads/${uploadId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getUploadsControllerStatusQueryKey = (spaceId, uploadId) => {
  return [
    `/api/v1/spaces/${spaceId}/uploads/${uploadId}`
  ];
};
var getUploadsControllerStatusQueryOptions = (spaceId, uploadId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getUploadsControllerStatusQueryKey(spaceId, uploadId);
  const queryFn = ({ signal }) => uploadsControllerStatus(spaceId, uploadId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && uploadId !== null && uploadId !== void 0, ...queryOptions };
};
function useUploadsControllerStatus(spaceId, uploadId, options, queryClient) {
  const queryOptions = getUploadsControllerStatusQueryOptions(spaceId, uploadId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var uploadsControllerAbort = (spaceId, uploadId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/uploads/${uploadId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getUploadsControllerAbortMutationKey = () => ["uploadsControllerAbort"];
var getUploadsControllerAbortMutationOptions = (options) => {
  const mutationKey = getUploadsControllerAbortMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, uploadId } = props ?? {};
    return uploadsControllerAbort(spaceId, uploadId);
  };
  return { mutationFn, ...mutationOptions };
};
var useUploadsControllerAbort = (options, queryClient) => {
  return useMutation7(getUploadsControllerAbortMutationOptions(options), queryClient);
};
var uploadsControllerRefreshParts = (spaceId, uploadId, refreshUploadPartsDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/uploads/${uploadId}/parts`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: refreshUploadPartsDto,
      ...signal ? { signal } : {}
    }
  );
};
var getUploadsControllerRefreshPartsMutationKey = () => ["uploadsControllerRefreshParts"];
var getUploadsControllerRefreshPartsMutationOptions = (options) => {
  const mutationKey = getUploadsControllerRefreshPartsMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, uploadId, data } = props ?? {};
    return uploadsControllerRefreshParts(spaceId, uploadId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useUploadsControllerRefreshParts = (options, queryClient) => {
  return useMutation7(getUploadsControllerRefreshPartsMutationOptions(options), queryClient);
};
var uploadsControllerComplete = (spaceId, uploadId, completeUploadDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/uploads/${uploadId}/complete`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: completeUploadDto,
      ...signal ? { signal } : {}
    }
  );
};
var getUploadsControllerCompleteMutationKey = () => ["uploadsControllerComplete"];
var getUploadsControllerCompleteMutationOptions = (options) => {
  const mutationKey = getUploadsControllerCompleteMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, uploadId, data } = props ?? {};
    return uploadsControllerComplete(spaceId, uploadId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useUploadsControllerComplete = (options, queryClient) => {
  return useMutation7(getUploadsControllerCompleteMutationOptions(options), queryClient);
};
var documentSettingsControllerGet = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/document-settings`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getDocumentSettingsControllerGetQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/document-settings`
  ];
};
var getDocumentSettingsControllerGetQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getDocumentSettingsControllerGetQueryKey(orgId);
  const queryFn = ({ signal }) => documentSettingsControllerGet(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useDocumentSettingsControllerGet(orgId, options, queryClient) {
  const queryOptions = getDocumentSettingsControllerGetQueryOptions(orgId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var documentSettingsControllerPut = (orgId, documentSettingsDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/document-settings`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: documentSettingsDto,
      ...signal ? { signal } : {}
    }
  );
};
var getDocumentSettingsControllerPutMutationKey = () => ["documentSettingsControllerPut"];
var getDocumentSettingsControllerPutMutationOptions = (options) => {
  const mutationKey = getDocumentSettingsControllerPutMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return documentSettingsControllerPut(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useDocumentSettingsControllerPut = (options, queryClient) => {
  return useMutation7(getDocumentSettingsControllerPutMutationOptions(options), queryClient);
};
var annotationsControllerList = (spaceId, documentId, versionId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}/versions/${versionId}/annotations`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getAnnotationsControllerListQueryKey = (spaceId, documentId, versionId, params) => {
  return [
    `/api/v1/spaces/${spaceId}/documents/${documentId}/versions/${versionId}/annotations`,
    ...params ? [params] : []
  ];
};
var getAnnotationsControllerListQueryOptions = (spaceId, documentId, versionId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAnnotationsControllerListQueryKey(spaceId, documentId, versionId, params);
  const queryFn = ({ signal }) => annotationsControllerList(spaceId, documentId, versionId, params, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && documentId !== null && documentId !== void 0 && versionId !== null && versionId !== void 0, ...queryOptions };
};
function useAnnotationsControllerList(spaceId, documentId, versionId, params, options, queryClient) {
  const queryOptions = getAnnotationsControllerListQueryOptions(spaceId, documentId, versionId, params, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var annotationsControllerCreate = (spaceId, documentId, versionId, createAnnotationDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}/versions/${versionId}/annotations`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createAnnotationDto,
      ...signal ? { signal } : {}
    }
  );
};
var getAnnotationsControllerCreateMutationKey = () => ["annotationsControllerCreate"];
var getAnnotationsControllerCreateMutationOptions = (options) => {
  const mutationKey = getAnnotationsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, documentId, versionId, data } = props ?? {};
    return annotationsControllerCreate(spaceId, documentId, versionId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useAnnotationsControllerCreate = (options, queryClient) => {
  return useMutation7(getAnnotationsControllerCreateMutationOptions(options), queryClient);
};
var annotationsControllerUpdate = (spaceId, documentId, versionId, annotationId, updateAnnotationDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}/versions/${versionId}/annotations/${annotationId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateAnnotationDto,
      ...signal ? { signal } : {}
    }
  );
};
var getAnnotationsControllerUpdateMutationKey = () => ["annotationsControllerUpdate"];
var getAnnotationsControllerUpdateMutationOptions = (options) => {
  const mutationKey = getAnnotationsControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, documentId, versionId, annotationId, data } = props ?? {};
    return annotationsControllerUpdate(spaceId, documentId, versionId, annotationId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useAnnotationsControllerUpdate = (options, queryClient) => {
  return useMutation7(getAnnotationsControllerUpdateMutationOptions(options), queryClient);
};
var annotationsControllerRemove = (spaceId, documentId, versionId, annotationId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}/versions/${versionId}/annotations/${annotationId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getAnnotationsControllerRemoveMutationKey = () => ["annotationsControllerRemove"];
var getAnnotationsControllerRemoveMutationOptions = (options) => {
  const mutationKey = getAnnotationsControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, documentId, versionId, annotationId } = props ?? {};
    return annotationsControllerRemove(spaceId, documentId, versionId, annotationId);
  };
  return { mutationFn, ...mutationOptions };
};
var useAnnotationsControllerRemove = (options, queryClient) => {
  return useMutation7(getAnnotationsControllerRemoveMutationOptions(options), queryClient);
};
var annotationsControllerResolve = (spaceId, documentId, versionId, annotationId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}/versions/${versionId}/annotations/${annotationId}/resolve`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getAnnotationsControllerResolveMutationKey = () => ["annotationsControllerResolve"];
var getAnnotationsControllerResolveMutationOptions = (options) => {
  const mutationKey = getAnnotationsControllerResolveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, documentId, versionId, annotationId } = props ?? {};
    return annotationsControllerResolve(spaceId, documentId, versionId, annotationId);
  };
  return { mutationFn, ...mutationOptions };
};
var useAnnotationsControllerResolve = (options, queryClient) => {
  return useMutation7(getAnnotationsControllerResolveMutationOptions(options), queryClient);
};
var annotationsControllerReopen = (spaceId, documentId, versionId, annotationId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}/versions/${versionId}/annotations/${annotationId}/reopen`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getAnnotationsControllerReopenMutationKey = () => ["annotationsControllerReopen"];
var getAnnotationsControllerReopenMutationOptions = (options) => {
  const mutationKey = getAnnotationsControllerReopenMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, documentId, versionId, annotationId } = props ?? {};
    return annotationsControllerReopen(spaceId, documentId, versionId, annotationId);
  };
  return { mutationFn, ...mutationOptions };
};
var useAnnotationsControllerReopen = (options, queryClient) => {
  return useMutation7(getAnnotationsControllerReopenMutationOptions(options), queryClient);
};
var annotationsControllerComments = (spaceId, documentId, versionId, annotationId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}/versions/${versionId}/annotations/${annotationId}/comments`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getAnnotationsControllerCommentsQueryKey = (spaceId, documentId, versionId, annotationId, params) => {
  return [
    `/api/v1/spaces/${spaceId}/documents/${documentId}/versions/${versionId}/annotations/${annotationId}/comments`,
    ...params ? [params] : []
  ];
};
var getAnnotationsControllerCommentsQueryOptions = (spaceId, documentId, versionId, annotationId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAnnotationsControllerCommentsQueryKey(spaceId, documentId, versionId, annotationId, params);
  const queryFn = ({ signal }) => annotationsControllerComments(spaceId, documentId, versionId, annotationId, params, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && documentId !== null && documentId !== void 0 && versionId !== null && versionId !== void 0 && annotationId !== null && annotationId !== void 0, ...queryOptions };
};
function useAnnotationsControllerComments(spaceId, documentId, versionId, annotationId, params, options, queryClient) {
  const queryOptions = getAnnotationsControllerCommentsQueryOptions(spaceId, documentId, versionId, annotationId, params, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var annotationsControllerAddComment = (spaceId, documentId, versionId, annotationId, createAnnotationCommentDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}/versions/${versionId}/annotations/${annotationId}/comments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createAnnotationCommentDto,
      ...signal ? { signal } : {}
    }
  );
};
var getAnnotationsControllerAddCommentMutationKey = () => ["annotationsControllerAddComment"];
var getAnnotationsControllerAddCommentMutationOptions = (options) => {
  const mutationKey = getAnnotationsControllerAddCommentMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, documentId, versionId, annotationId, data } = props ?? {};
    return annotationsControllerAddComment(spaceId, documentId, versionId, annotationId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useAnnotationsControllerAddComment = (options, queryClient) => {
  return useMutation7(getAnnotationsControllerAddCommentMutationOptions(options), queryClient);
};
var approvalsControllerStart = (spaceId, documentId, startDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}/approval-flows`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: startDto,
      ...signal ? { signal } : {}
    }
  );
};
var getApprovalsControllerStartMutationKey = () => ["approvalsControllerStart"];
var getApprovalsControllerStartMutationOptions = (options) => {
  const mutationKey = getApprovalsControllerStartMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, documentId, data } = props ?? {};
    return approvalsControllerStart(spaceId, documentId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useApprovalsControllerStart = (options, queryClient) => {
  return useMutation7(getApprovalsControllerStartMutationOptions(options), queryClient);
};
var approvalsControllerListForDocument = (spaceId, documentId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}/approval-flows`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getApprovalsControllerListForDocumentQueryKey = (spaceId, documentId) => {
  return [
    `/api/v1/spaces/${spaceId}/documents/${documentId}/approval-flows`
  ];
};
var getApprovalsControllerListForDocumentQueryOptions = (spaceId, documentId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getApprovalsControllerListForDocumentQueryKey(spaceId, documentId);
  const queryFn = ({ signal }) => approvalsControllerListForDocument(spaceId, documentId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && documentId !== null && documentId !== void 0, ...queryOptions };
};
function useApprovalsControllerListForDocument(spaceId, documentId, options, queryClient) {
  const queryOptions = getApprovalsControllerListForDocumentQueryOptions(spaceId, documentId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var approvalsControllerList = (spaceId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/approval-flows`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getApprovalsControllerListQueryKey = (spaceId, params) => {
  return [
    `/api/v1/spaces/${spaceId}/approval-flows`,
    ...params ? [params] : []
  ];
};
var getApprovalsControllerListQueryOptions = (spaceId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getApprovalsControllerListQueryKey(spaceId, params);
  const queryFn = ({ signal }) => approvalsControllerList(spaceId, params, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useApprovalsControllerList(spaceId, params, options, queryClient) {
  const queryOptions = getApprovalsControllerListQueryOptions(spaceId, params, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var approvalsControllerGet = (spaceId, flowId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/approval-flows/${flowId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getApprovalsControllerGetQueryKey = (spaceId, flowId) => {
  return [
    `/api/v1/spaces/${spaceId}/approval-flows/${flowId}`
  ];
};
var getApprovalsControllerGetQueryOptions = (spaceId, flowId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getApprovalsControllerGetQueryKey(spaceId, flowId);
  const queryFn = ({ signal }) => approvalsControllerGet(spaceId, flowId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && flowId !== null && flowId !== void 0, ...queryOptions };
};
function useApprovalsControllerGet(spaceId, flowId, options, queryClient) {
  const queryOptions = getApprovalsControllerGetQueryOptions(spaceId, flowId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var approvalsControllerCancel = (spaceId, flowId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/approval-flows/${flowId}/cancel`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getApprovalsControllerCancelMutationKey = () => ["approvalsControllerCancel"];
var getApprovalsControllerCancelMutationOptions = (options) => {
  const mutationKey = getApprovalsControllerCancelMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, flowId } = props ?? {};
    return approvalsControllerCancel(spaceId, flowId);
  };
  return { mutationFn, ...mutationOptions };
};
var useApprovalsControllerCancel = (options, queryClient) => {
  return useMutation7(getApprovalsControllerCancelMutationOptions(options), queryClient);
};
var approvalsControllerDecide = (spaceId, stepId, decideDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/approval-steps/${stepId}/decisions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: decideDto,
      ...signal ? { signal } : {}
    }
  );
};
var getApprovalsControllerDecideMutationKey = () => ["approvalsControllerDecide"];
var getApprovalsControllerDecideMutationOptions = (options) => {
  const mutationKey = getApprovalsControllerDecideMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, stepId, data } = props ?? {};
    return approvalsControllerDecide(spaceId, stepId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useApprovalsControllerDecide = (options, queryClient) => {
  return useMutation7(getApprovalsControllerDecideMutationOptions(options), queryClient);
};
var approvalTemplatesControllerList = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/approval-templates`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getApprovalTemplatesControllerListQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/approval-templates`
  ];
};
var getApprovalTemplatesControllerListQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getApprovalTemplatesControllerListQueryKey(orgId);
  const queryFn = ({ signal }) => approvalTemplatesControllerList(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useApprovalTemplatesControllerList(orgId, options, queryClient) {
  const queryOptions = getApprovalTemplatesControllerListQueryOptions(orgId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var approvalTemplatesControllerCreate = (orgId, createTemplateDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/approval-templates`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createTemplateDto,
      ...signal ? { signal } : {}
    }
  );
};
var getApprovalTemplatesControllerCreateMutationKey = () => ["approvalTemplatesControllerCreate"];
var getApprovalTemplatesControllerCreateMutationOptions = (options) => {
  const mutationKey = getApprovalTemplatesControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return approvalTemplatesControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useApprovalTemplatesControllerCreate = (options, queryClient) => {
  return useMutation7(getApprovalTemplatesControllerCreateMutationOptions(options), queryClient);
};
var approvalTemplatesControllerRemove = (orgId, templateId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/approval-templates/${templateId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getApprovalTemplatesControllerRemoveMutationKey = () => ["approvalTemplatesControllerRemove"];
var getApprovalTemplatesControllerRemoveMutationOptions = (options) => {
  const mutationKey = getApprovalTemplatesControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, templateId } = props ?? {};
    return approvalTemplatesControllerRemove(orgId, templateId);
  };
  return { mutationFn, ...mutationOptions };
};
var useApprovalTemplatesControllerRemove = (options, queryClient) => {
  return useMutation7(getApprovalTemplatesControllerRemoveMutationOptions(options), queryClient);
};
var partnerOfficesControllerList = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/partner-offices`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPartnerOfficesControllerListQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/partner-offices`
  ];
};
var getPartnerOfficesControllerListQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPartnerOfficesControllerListQueryKey(orgId);
  const queryFn = ({ signal }) => partnerOfficesControllerList(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function usePartnerOfficesControllerList(orgId, options, queryClient) {
  const queryOptions = getPartnerOfficesControllerListQueryOptions(orgId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var trashControllerList = (spaceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/trash`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getTrashControllerListQueryKey = (spaceId) => {
  return [
    `/api/v1/spaces/${spaceId}/trash`
  ];
};
var getTrashControllerListQueryOptions = (spaceId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTrashControllerListQueryKey(spaceId);
  const queryFn = ({ signal }) => trashControllerList(spaceId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useTrashControllerList(spaceId, options, queryClient) {
  const queryOptions = getTrashControllerListQueryOptions(spaceId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var trashControllerRestore = (spaceId, trashTargetDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/trash/restore`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: trashTargetDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTrashControllerRestoreMutationKey = () => ["trashControllerRestore"];
var getTrashControllerRestoreMutationOptions = (options) => {
  const mutationKey = getTrashControllerRestoreMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return trashControllerRestore(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTrashControllerRestore = (options, queryClient) => {
  return useMutation7(getTrashControllerRestoreMutationOptions(options), queryClient);
};
var trashControllerPurge = (spaceId, purgeRequestDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/trash/purge`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: purgeRequestDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTrashControllerPurgeMutationKey = () => ["trashControllerPurge"];
var getTrashControllerPurgeMutationOptions = (options) => {
  const mutationKey = getTrashControllerPurgeMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return trashControllerPurge(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTrashControllerPurge = (options, queryClient) => {
  return useMutation7(getTrashControllerPurgeMutationOptions(options), queryClient);
};
var storageControllerReport = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/storage`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getStorageControllerReportQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/storage`
  ];
};
var getStorageControllerReportQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getStorageControllerReportQueryKey(orgId);
  const queryFn = ({ signal }) => storageControllerReport(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useStorageControllerReport(orgId, options, queryClient) {
  const queryOptions = getStorageControllerReportQueryOptions(orgId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var recentDocumentsControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/documents/recent`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getRecentDocumentsControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/documents/recent`,
    ...params ? [params] : []
  ];
};
var getRecentDocumentsControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getRecentDocumentsControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => recentDocumentsControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useRecentDocumentsControllerList(orgId, params, options, queryClient) {
  const queryOptions = getRecentDocumentsControllerListQueryOptions(orgId, params, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var transmittalsControllerCreate = (spaceId, createTransmittalDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/transmittals`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createTransmittalDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTransmittalsControllerCreateMutationKey = () => ["transmittalsControllerCreate"];
var getTransmittalsControllerCreateMutationOptions = (options) => {
  const mutationKey = getTransmittalsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return transmittalsControllerCreate(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTransmittalsControllerCreate = (options, queryClient) => {
  return useMutation7(getTransmittalsControllerCreateMutationOptions(options), queryClient);
};
var transmittalsControllerList = (spaceId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/transmittals`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getTransmittalsControllerListQueryKey = (spaceId, params) => {
  return [
    `/api/v1/spaces/${spaceId}/transmittals`,
    ...params ? [params] : []
  ];
};
var getTransmittalsControllerListQueryOptions = (spaceId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTransmittalsControllerListQueryKey(spaceId, params);
  const queryFn = ({ signal }) => transmittalsControllerList(spaceId, params, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useTransmittalsControllerList(spaceId, params, options, queryClient) {
  const queryOptions = getTransmittalsControllerListQueryOptions(spaceId, params, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var transmittalsControllerGet = (spaceId, transmittalId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/transmittals/${transmittalId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getTransmittalsControllerGetQueryKey = (spaceId, transmittalId) => {
  return [
    `/api/v1/spaces/${spaceId}/transmittals/${transmittalId}`
  ];
};
var getTransmittalsControllerGetQueryOptions = (spaceId, transmittalId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTransmittalsControllerGetQueryKey(spaceId, transmittalId);
  const queryFn = ({ signal }) => transmittalsControllerGet(spaceId, transmittalId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && transmittalId !== null && transmittalId !== void 0, ...queryOptions };
};
function useTransmittalsControllerGet(spaceId, transmittalId, options, queryClient) {
  const queryOptions = getTransmittalsControllerGetQueryOptions(spaceId, transmittalId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var transmittalsControllerPdfUrl = (spaceId, transmittalId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/transmittals/${transmittalId}/pdf-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getTransmittalsControllerPdfUrlQueryKey = (spaceId, transmittalId) => {
  return [
    `/api/v1/spaces/${spaceId}/transmittals/${transmittalId}/pdf-url`
  ];
};
var getTransmittalsControllerPdfUrlQueryOptions = (spaceId, transmittalId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTransmittalsControllerPdfUrlQueryKey(spaceId, transmittalId);
  const queryFn = ({ signal }) => transmittalsControllerPdfUrl(spaceId, transmittalId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && transmittalId !== null && transmittalId !== void 0, ...queryOptions };
};
function useTransmittalsControllerPdfUrl(spaceId, transmittalId, options, queryClient) {
  const queryOptions = getTransmittalsControllerPdfUrlQueryOptions(spaceId, transmittalId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var transmittalsControllerAcknowledge = (spaceId, transmittalId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/transmittals/${transmittalId}/acknowledge`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getTransmittalsControllerAcknowledgeMutationKey = () => ["transmittalsControllerAcknowledge"];
var getTransmittalsControllerAcknowledgeMutationOptions = (options) => {
  const mutationKey = getTransmittalsControllerAcknowledgeMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, transmittalId } = props ?? {};
    return transmittalsControllerAcknowledge(spaceId, transmittalId);
  };
  return { mutationFn, ...mutationOptions };
};
var useTransmittalsControllerAcknowledge = (options, queryClient) => {
  return useMutation7(getTransmittalsControllerAcknowledgeMutationOptions(options), queryClient);
};
var transmittalsControllerDiffusion = (spaceId, documentId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/documents/${documentId}/diffusion`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getTransmittalsControllerDiffusionQueryKey = (spaceId, documentId) => {
  return [
    `/api/v1/spaces/${spaceId}/documents/${documentId}/diffusion`
  ];
};
var getTransmittalsControllerDiffusionQueryOptions = (spaceId, documentId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTransmittalsControllerDiffusionQueryKey(spaceId, documentId);
  const queryFn = ({ signal }) => transmittalsControllerDiffusion(spaceId, documentId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && documentId !== null && documentId !== void 0, ...queryOptions };
};
function useTransmittalsControllerDiffusion(spaceId, documentId, options, queryClient) {
  const queryOptions = getTransmittalsControllerDiffusionQueryOptions(spaceId, documentId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var publicTransmittalsControllerGet = (token, signal) => {
  return apiRequest(
    {
      url: `/api/v1/public/transmittals/${token}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPublicTransmittalsControllerGetQueryKey = (token) => {
  return [
    `/api/v1/public/transmittals/${token}`
  ];
};
var getPublicTransmittalsControllerGetQueryOptions = (token, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPublicTransmittalsControllerGetQueryKey(token);
  const queryFn = ({ signal }) => publicTransmittalsControllerGet(token, signal);
  return { queryKey, queryFn, enabled: token !== null && token !== void 0, ...queryOptions };
};
function usePublicTransmittalsControllerGet(token, options, queryClient) {
  const queryOptions = getPublicTransmittalsControllerGetQueryOptions(token, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var publicTransmittalsControllerAcknowledge = (token, signal) => {
  return apiRequest(
    {
      url: `/api/v1/public/transmittals/${token}/ack`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getPublicTransmittalsControllerAcknowledgeMutationKey = () => ["publicTransmittalsControllerAcknowledge"];
var getPublicTransmittalsControllerAcknowledgeMutationOptions = (options) => {
  const mutationKey = getPublicTransmittalsControllerAcknowledgeMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { token } = props ?? {};
    return publicTransmittalsControllerAcknowledge(token);
  };
  return { mutationFn, ...mutationOptions };
};
var usePublicTransmittalsControllerAcknowledge = (options, queryClient) => {
  return useMutation7(getPublicTransmittalsControllerAcknowledgeMutationOptions(options), queryClient);
};
var publicTransmittalsControllerPreviewUrl = (token, itemId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/public/transmittals/${token}/items/${itemId}/preview-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPublicTransmittalsControllerPreviewUrlQueryKey = (token, itemId) => {
  return [
    `/api/v1/public/transmittals/${token}/items/${itemId}/preview-url`
  ];
};
var getPublicTransmittalsControllerPreviewUrlQueryOptions = (token, itemId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPublicTransmittalsControllerPreviewUrlQueryKey(token, itemId);
  const queryFn = ({ signal }) => publicTransmittalsControllerPreviewUrl(token, itemId, signal);
  return { queryKey, queryFn, enabled: token !== null && token !== void 0 && itemId !== null && itemId !== void 0, ...queryOptions };
};
function usePublicTransmittalsControllerPreviewUrl(token, itemId, options, queryClient) {
  const queryOptions = getPublicTransmittalsControllerPreviewUrlQueryOptions(token, itemId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var publicTransmittalsControllerDownloadUrl = (token, itemId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/public/transmittals/${token}/items/${itemId}/download-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPublicTransmittalsControllerDownloadUrlQueryKey = (token, itemId) => {
  return [
    `/api/v1/public/transmittals/${token}/items/${itemId}/download-url`
  ];
};
var getPublicTransmittalsControllerDownloadUrlQueryOptions = (token, itemId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPublicTransmittalsControllerDownloadUrlQueryKey(token, itemId);
  const queryFn = ({ signal }) => publicTransmittalsControllerDownloadUrl(token, itemId, signal);
  return { queryKey, queryFn, enabled: token !== null && token !== void 0 && itemId !== null && itemId !== void 0, ...queryOptions };
};
function usePublicTransmittalsControllerDownloadUrl(token, itemId, options, queryClient) {
  const queryOptions = getPublicTransmittalsControllerDownloadUrlQueryOptions(token, itemId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var shareLinksControllerCreate = (spaceId, createShareLinkDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/share-links`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createShareLinkDto,
      ...signal ? { signal } : {}
    }
  );
};
var getShareLinksControllerCreateMutationKey = () => ["shareLinksControllerCreate"];
var getShareLinksControllerCreateMutationOptions = (options) => {
  const mutationKey = getShareLinksControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return shareLinksControllerCreate(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useShareLinksControllerCreate = (options, queryClient) => {
  return useMutation7(getShareLinksControllerCreateMutationOptions(options), queryClient);
};
var shareLinksControllerList = (spaceId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/share-links`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getShareLinksControllerListQueryKey = (spaceId, params) => {
  return [
    `/api/v1/spaces/${spaceId}/share-links`,
    ...params ? [params] : []
  ];
};
var getShareLinksControllerListQueryOptions = (spaceId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getShareLinksControllerListQueryKey(spaceId, params);
  const queryFn = ({ signal }) => shareLinksControllerList(spaceId, params, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useShareLinksControllerList(spaceId, params, options, queryClient) {
  const queryOptions = getShareLinksControllerListQueryOptions(spaceId, params, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var shareLinksControllerRevoke = (spaceId, linkId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/share-links/${linkId}/revoke`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getShareLinksControllerRevokeMutationKey = () => ["shareLinksControllerRevoke"];
var getShareLinksControllerRevokeMutationOptions = (options) => {
  const mutationKey = getShareLinksControllerRevokeMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, linkId } = props ?? {};
    return shareLinksControllerRevoke(spaceId, linkId);
  };
  return { mutationFn, ...mutationOptions };
};
var useShareLinksControllerRevoke = (options, queryClient) => {
  return useMutation7(getShareLinksControllerRevokeMutationOptions(options), queryClient);
};
var publicShareLinksControllerGet = (token, signal) => {
  return apiRequest(
    {
      url: `/api/v1/public/share-links/${token}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPublicShareLinksControllerGetQueryKey = (token) => {
  return [
    `/api/v1/public/share-links/${token}`
  ];
};
var getPublicShareLinksControllerGetQueryOptions = (token, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPublicShareLinksControllerGetQueryKey(token);
  const queryFn = ({ signal }) => publicShareLinksControllerGet(token, signal);
  return { queryKey, queryFn, enabled: token !== null && token !== void 0, ...queryOptions };
};
function usePublicShareLinksControllerGet(token, options, queryClient) {
  const queryOptions = getPublicShareLinksControllerGetQueryOptions(token, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var publicShareLinksControllerUnlock = (token, unlockShareLinkDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/public/share-links/${token}/unlock`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: unlockShareLinkDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPublicShareLinksControllerUnlockMutationKey = () => ["publicShareLinksControllerUnlock"];
var getPublicShareLinksControllerUnlockMutationOptions = (options) => {
  const mutationKey = getPublicShareLinksControllerUnlockMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { token, data } = props ?? {};
    return publicShareLinksControllerUnlock(token, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePublicShareLinksControllerUnlock = (options, queryClient) => {
  return useMutation7(getPublicShareLinksControllerUnlockMutationOptions(options), queryClient);
};
var publicShareLinksControllerPreviewUrl = (token, documentId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/public/share-links/${token}/documents/${documentId}/preview-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPublicShareLinksControllerPreviewUrlQueryKey = (token, documentId) => {
  return [
    `/api/v1/public/share-links/${token}/documents/${documentId}/preview-url`
  ];
};
var getPublicShareLinksControllerPreviewUrlQueryOptions = (token, documentId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPublicShareLinksControllerPreviewUrlQueryKey(token, documentId);
  const queryFn = ({ signal }) => publicShareLinksControllerPreviewUrl(token, documentId, signal);
  return { queryKey, queryFn, enabled: token !== null && token !== void 0 && documentId !== null && documentId !== void 0, ...queryOptions };
};
function usePublicShareLinksControllerPreviewUrl(token, documentId, options, queryClient) {
  const queryOptions = getPublicShareLinksControllerPreviewUrlQueryOptions(token, documentId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}
var publicShareLinksControllerDownloadUrl = (token, documentId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/public/share-links/${token}/documents/${documentId}/download-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPublicShareLinksControllerDownloadUrlQueryKey = (token, documentId) => {
  return [
    `/api/v1/public/share-links/${token}/documents/${documentId}/download-url`
  ];
};
var getPublicShareLinksControllerDownloadUrlQueryOptions = (token, documentId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPublicShareLinksControllerDownloadUrlQueryKey(token, documentId);
  const queryFn = ({ signal }) => publicShareLinksControllerDownloadUrl(token, documentId, signal);
  return { queryKey, queryFn, enabled: token !== null && token !== void 0 && documentId !== null && documentId !== void 0, ...queryOptions };
};
function usePublicShareLinksControllerDownloadUrl(token, documentId, options, queryClient) {
  const queryOptions = getPublicShareLinksControllerDownloadUrlQueryOptions(token, documentId, options);
  const query = useQuery7(queryOptions, queryClient);
  return withQueryKey7(query, queryOptions.queryKey);
}

// src/generated/endpoints/einvoicing/einvoicing.ts
import {
  useMutation as useMutation8,
  useQuery as useQuery8
} from "@tanstack/react-query";
var withQueryKey8 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var signingBatchesControllerPending = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/einvoicing/signing-batches/pending`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getSigningBatchesControllerPendingQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/einvoicing/signing-batches/pending`
  ];
};
var getSigningBatchesControllerPendingQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSigningBatchesControllerPendingQueryKey(orgId);
  const queryFn = ({ signal }) => signingBatchesControllerPending(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useSigningBatchesControllerPending(orgId, options, queryClient) {
  const queryOptions = getSigningBatchesControllerPendingQueryOptions(orgId, options);
  const query = useQuery8(queryOptions, queryClient);
  return withQueryKey8(query, queryOptions.queryKey);
}
var signingBatchesControllerStart = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/einvoicing/signing-batches`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getSigningBatchesControllerStartMutationKey = () => ["signingBatchesControllerStart"];
var getSigningBatchesControllerStartMutationOptions = (options) => {
  const mutationKey = getSigningBatchesControllerStartMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId } = props ?? {};
    return signingBatchesControllerStart(orgId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSigningBatchesControllerStart = (options, queryClient) => {
  return useMutation8(getSigningBatchesControllerStartMutationOptions(options), queryClient);
};
var signingBatchesControllerConfirm = (orgId, batchId, confirmSigningBatchDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/einvoicing/signing-batches/${batchId}/confirm`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: confirmSigningBatchDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSigningBatchesControllerConfirmMutationKey = () => ["signingBatchesControllerConfirm"];
var getSigningBatchesControllerConfirmMutationOptions = (options) => {
  const mutationKey = getSigningBatchesControllerConfirmMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, batchId, data } = props ?? {};
    return signingBatchesControllerConfirm(orgId, batchId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSigningBatchesControllerConfirm = (options, queryClient) => {
  return useMutation8(getSigningBatchesControllerConfirmMutationOptions(options), queryClient);
};
var einvoicingControllerSettings = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/einvoicing/settings`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getEinvoicingControllerSettingsQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/einvoicing/settings`
  ];
};
var getEinvoicingControllerSettingsQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getEinvoicingControllerSettingsQueryKey(orgId);
  const queryFn = ({ signal }) => einvoicingControllerSettings(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useEinvoicingControllerSettings(orgId, options, queryClient) {
  const queryOptions = getEinvoicingControllerSettingsQueryOptions(orgId, options);
  const query = useQuery8(queryOptions, queryClient);
  return withQueryKey8(query, queryOptions.queryKey);
}
var einvoicingControllerUpdateSettings = (orgId, updateSettingsDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/einvoicing/settings`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateSettingsDto,
      ...signal ? { signal } : {}
    }
  );
};
var getEinvoicingControllerUpdateSettingsMutationKey = () => ["einvoicingControllerUpdateSettings"];
var getEinvoicingControllerUpdateSettingsMutationOptions = (options) => {
  const mutationKey = getEinvoicingControllerUpdateSettingsMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return einvoicingControllerUpdateSettings(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useEinvoicingControllerUpdateSettings = (options, queryClient) => {
  return useMutation8(getEinvoicingControllerUpdateSettingsMutationOptions(options), queryClient);
};
var einvoicingControllerList = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/einvoicing/credentials`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getEinvoicingControllerListQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/einvoicing/credentials`
  ];
};
var getEinvoicingControllerListQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getEinvoicingControllerListQueryKey(orgId);
  const queryFn = ({ signal }) => einvoicingControllerList(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useEinvoicingControllerList(orgId, options, queryClient) {
  const queryOptions = getEinvoicingControllerListQueryOptions(orgId, options);
  const query = useQuery8(queryOptions, queryClient);
  return withQueryKey8(query, queryOptions.queryKey);
}
var einvoicingControllerCreate = (orgId, createCredentialDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/einvoicing/credentials`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCredentialDto,
      ...signal ? { signal } : {}
    }
  );
};
var getEinvoicingControllerCreateMutationKey = () => ["einvoicingControllerCreate"];
var getEinvoicingControllerCreateMutationOptions = (options) => {
  const mutationKey = getEinvoicingControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return einvoicingControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useEinvoicingControllerCreate = (options, queryClient) => {
  return useMutation8(getEinvoicingControllerCreateMutationOptions(options), queryClient);
};
var einvoicingControllerRevoke = (orgId, credentialId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/einvoicing/credentials/${credentialId}/revoke`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getEinvoicingControllerRevokeMutationKey = () => ["einvoicingControllerRevoke"];
var getEinvoicingControllerRevokeMutationOptions = (options) => {
  const mutationKey = getEinvoicingControllerRevokeMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, credentialId } = props ?? {};
    return einvoicingControllerRevoke(orgId, credentialId);
  };
  return { mutationFn, ...mutationOptions };
};
var useEinvoicingControllerRevoke = (options, queryClient) => {
  return useMutation8(getEinvoicingControllerRevokeMutationOptions(options), queryClient);
};
var invoiceEinvoiceControllerGet = (orgId, invoiceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoices/${invoiceId}/einvoice`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getInvoiceEinvoiceControllerGetQueryKey = (orgId, invoiceId) => {
  return [
    `/api/v1/orgs/${orgId}/invoices/${invoiceId}/einvoice`
  ];
};
var getInvoiceEinvoiceControllerGetQueryOptions = (orgId, invoiceId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getInvoiceEinvoiceControllerGetQueryKey(orgId, invoiceId);
  const queryFn = ({ signal }) => invoiceEinvoiceControllerGet(orgId, invoiceId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && invoiceId !== null && invoiceId !== void 0, ...queryOptions };
};
function useInvoiceEinvoiceControllerGet(orgId, invoiceId, options, queryClient) {
  const queryOptions = getInvoiceEinvoiceControllerGetQueryOptions(orgId, invoiceId, options);
  const query = useQuery8(queryOptions, queryClient);
  return withQueryKey8(query, queryOptions.queryKey);
}
var invoiceEinvoiceControllerResubmit = (orgId, invoiceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoices/${invoiceId}/einvoice/resubmit`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getInvoiceEinvoiceControllerResubmitMutationKey = () => ["invoiceEinvoiceControllerResubmit"];
var getInvoiceEinvoiceControllerResubmitMutationOptions = (options) => {
  const mutationKey = getInvoiceEinvoiceControllerResubmitMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, invoiceId } = props ?? {};
    return invoiceEinvoiceControllerResubmit(orgId, invoiceId);
  };
  return { mutationFn, ...mutationOptions };
};
var useInvoiceEinvoiceControllerResubmit = (options, queryClient) => {
  return useMutation8(getInvoiceEinvoiceControllerResubmitMutationOptions(options), queryClient);
};
var invoiceEinvoiceControllerManual = (orgId, invoiceId, manualEinvoiceDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoices/${invoiceId}/einvoice/manual`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: manualEinvoiceDto,
      ...signal ? { signal } : {}
    }
  );
};
var getInvoiceEinvoiceControllerManualMutationKey = () => ["invoiceEinvoiceControllerManual"];
var getInvoiceEinvoiceControllerManualMutationOptions = (options) => {
  const mutationKey = getInvoiceEinvoiceControllerManualMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, invoiceId, data } = props ?? {};
    return invoiceEinvoiceControllerManual(orgId, invoiceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useInvoiceEinvoiceControllerManual = (options, queryClient) => {
  return useMutation8(getInvoiceEinvoiceControllerManualMutationOptions(options), queryClient);
};
var invoiceEinvoiceControllerTeifUrl = (orgId, invoiceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoices/${invoiceId}/einvoice/teif-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getInvoiceEinvoiceControllerTeifUrlQueryKey = (orgId, invoiceId) => {
  return [
    `/api/v1/orgs/${orgId}/invoices/${invoiceId}/einvoice/teif-url`
  ];
};
var getInvoiceEinvoiceControllerTeifUrlQueryOptions = (orgId, invoiceId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getInvoiceEinvoiceControllerTeifUrlQueryKey(orgId, invoiceId);
  const queryFn = ({ signal }) => invoiceEinvoiceControllerTeifUrl(orgId, invoiceId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && invoiceId !== null && invoiceId !== void 0, ...queryOptions };
};
function useInvoiceEinvoiceControllerTeifUrl(orgId, invoiceId, options, queryClient) {
  const queryOptions = getInvoiceEinvoiceControllerTeifUrlQueryOptions(orgId, invoiceId, options);
  const query = useQuery8(queryOptions, queryClient);
  return withQueryKey8(query, queryOptions.queryKey);
}

// src/generated/endpoints/field/field.ts
import {
  useMutation as useMutation9,
  useQuery as useQuery9
} from "@tanstack/react-query";
var withQueryKey9 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var registerControllerGet = (orgId, projectId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/register`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getRegisterControllerGetQueryKey = (orgId, projectId, params) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/register`,
    ...params ? [params] : []
  ];
};
var getRegisterControllerGetQueryOptions = (orgId, projectId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getRegisterControllerGetQueryKey(orgId, projectId, params);
  const queryFn = ({ signal }) => registerControllerGet(orgId, projectId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0, ...queryOptions };
};
function useRegisterControllerGet(orgId, projectId, params, options, queryClient) {
  const queryOptions = getRegisterControllerGetQueryOptions(orgId, projectId, params, options);
  const query = useQuery9(queryOptions, queryClient);
  return withQueryKey9(query, queryOptions.queryKey);
}
var registerControllerRequestExport = (orgId, projectId, registerExportRequestDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/register/exports`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: registerExportRequestDto,
      ...signal ? { signal } : {}
    }
  );
};
var getRegisterControllerRequestExportMutationKey = () => ["registerControllerRequestExport"];
var getRegisterControllerRequestExportMutationOptions = (options) => {
  const mutationKey = getRegisterControllerRequestExportMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, data } = props ?? {};
    return registerControllerRequestExport(orgId, projectId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useRegisterControllerRequestExport = (options, queryClient) => {
  return useMutation9(getRegisterControllerRequestExportMutationOptions(options), queryClient);
};
var registerControllerGetExport = (orgId, projectId, exportId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/register/exports/${exportId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getRegisterControllerGetExportQueryKey = (orgId, projectId, exportId) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/register/exports/${exportId}`
  ];
};
var getRegisterControllerGetExportQueryOptions = (orgId, projectId, exportId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getRegisterControllerGetExportQueryKey(orgId, projectId, exportId);
  const queryFn = ({ signal }) => registerControllerGetExport(orgId, projectId, exportId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0 && exportId !== null && exportId !== void 0, ...queryOptions };
};
function useRegisterControllerGetExport(orgId, projectId, exportId, options, queryClient) {
  const queryOptions = getRegisterControllerGetExportQueryOptions(orgId, projectId, exportId, options);
  const query = useQuery9(queryOptions, queryClient);
  return withQueryKey9(query, queryOptions.queryKey);
}
var checklistTemplatesControllerList = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/checklist-templates`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getChecklistTemplatesControllerListQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/checklist-templates`
  ];
};
var getChecklistTemplatesControllerListQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getChecklistTemplatesControllerListQueryKey(orgId);
  const queryFn = ({ signal }) => checklistTemplatesControllerList(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useChecklistTemplatesControllerList(orgId, options, queryClient) {
  const queryOptions = getChecklistTemplatesControllerListQueryOptions(orgId, options);
  const query = useQuery9(queryOptions, queryClient);
  return withQueryKey9(query, queryOptions.queryKey);
}
var checklistTemplatesControllerCreate = (orgId, createChecklistTemplateDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/checklist-templates`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createChecklistTemplateDto,
      ...signal ? { signal } : {}
    }
  );
};
var getChecklistTemplatesControllerCreateMutationKey = () => ["checklistTemplatesControllerCreate"];
var getChecklistTemplatesControllerCreateMutationOptions = (options) => {
  const mutationKey = getChecklistTemplatesControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return checklistTemplatesControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useChecklistTemplatesControllerCreate = (options, queryClient) => {
  return useMutation9(getChecklistTemplatesControllerCreateMutationOptions(options), queryClient);
};
var checklistTemplatesControllerUpdate = (orgId, templateId, updateChecklistTemplateDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/checklist-templates/${templateId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateChecklistTemplateDto,
      ...signal ? { signal } : {}
    }
  );
};
var getChecklistTemplatesControllerUpdateMutationKey = () => ["checklistTemplatesControllerUpdate"];
var getChecklistTemplatesControllerUpdateMutationOptions = (options) => {
  const mutationKey = getChecklistTemplatesControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, templateId, data } = props ?? {};
    return checklistTemplatesControllerUpdate(orgId, templateId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useChecklistTemplatesControllerUpdate = (options, queryClient) => {
  return useMutation9(getChecklistTemplatesControllerUpdateMutationOptions(options), queryClient);
};
var checklistTemplatesControllerRetire = (orgId, templateId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/checklist-templates/${templateId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getChecklistTemplatesControllerRetireMutationKey = () => ["checklistTemplatesControllerRetire"];
var getChecklistTemplatesControllerRetireMutationOptions = (options) => {
  const mutationKey = getChecklistTemplatesControllerRetireMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, templateId } = props ?? {};
    return checklistTemplatesControllerRetire(orgId, templateId);
  };
  return { mutationFn, ...mutationOptions };
};
var useChecklistTemplatesControllerRetire = (options, queryClient) => {
  return useMutation9(getChecklistTemplatesControllerRetireMutationOptions(options), queryClient);
};
var checklistsControllerList = (orgId, projectId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/checklists`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getChecklistsControllerListQueryKey = (orgId, projectId) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/checklists`
  ];
};
var getChecklistsControllerListQueryOptions = (orgId, projectId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getChecklistsControllerListQueryKey(orgId, projectId);
  const queryFn = ({ signal }) => checklistsControllerList(orgId, projectId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0, ...queryOptions };
};
function useChecklistsControllerList(orgId, projectId, options, queryClient) {
  const queryOptions = getChecklistsControllerListQueryOptions(orgId, projectId, options);
  const query = useQuery9(queryOptions, queryClient);
  return withQueryKey9(query, queryOptions.queryKey);
}
var checklistsControllerCreate = (orgId, projectId, createChecklistDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/checklists`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createChecklistDto,
      ...signal ? { signal } : {}
    }
  );
};
var getChecklistsControllerCreateMutationKey = () => ["checklistsControllerCreate"];
var getChecklistsControllerCreateMutationOptions = (options) => {
  const mutationKey = getChecklistsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, data } = props ?? {};
    return checklistsControllerCreate(orgId, projectId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useChecklistsControllerCreate = (options, queryClient) => {
  return useMutation9(getChecklistsControllerCreateMutationOptions(options), queryClient);
};
var checklistsControllerGet = (orgId, projectId, checklistId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/checklists/${checklistId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getChecklistsControllerGetQueryKey = (orgId, projectId, checklistId) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/checklists/${checklistId}`
  ];
};
var getChecklistsControllerGetQueryOptions = (orgId, projectId, checklistId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getChecklistsControllerGetQueryKey(orgId, projectId, checklistId);
  const queryFn = ({ signal }) => checklistsControllerGet(orgId, projectId, checklistId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0 && checklistId !== null && checklistId !== void 0, ...queryOptions };
};
function useChecklistsControllerGet(orgId, projectId, checklistId, options, queryClient) {
  const queryOptions = getChecklistsControllerGetQueryOptions(orgId, projectId, checklistId, options);
  const query = useQuery9(queryOptions, queryClient);
  return withQueryKey9(query, queryOptions.queryKey);
}
var checklistsControllerSetItem = (orgId, projectId, checklistId, itemId, setChecklistItemDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/checklists/${checklistId}/items/${itemId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: setChecklistItemDto,
      ...signal ? { signal } : {}
    }
  );
};
var getChecklistsControllerSetItemMutationKey = () => ["checklistsControllerSetItem"];
var getChecklistsControllerSetItemMutationOptions = (options) => {
  const mutationKey = getChecklistsControllerSetItemMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, checklistId, itemId, data } = props ?? {};
    return checklistsControllerSetItem(orgId, projectId, checklistId, itemId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useChecklistsControllerSetItem = (options, queryClient) => {
  return useMutation9(getChecklistsControllerSetItemMutationOptions(options), queryClient);
};
var checklistsControllerArchive = (orgId, projectId, checklistId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/checklists/${checklistId}/archive`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getChecklistsControllerArchiveMutationKey = () => ["checklistsControllerArchive"];
var getChecklistsControllerArchiveMutationOptions = (options) => {
  const mutationKey = getChecklistsControllerArchiveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, checklistId } = props ?? {};
    return checklistsControllerArchive(orgId, projectId, checklistId);
  };
  return { mutationFn, ...mutationOptions };
};
var useChecklistsControllerArchive = (options, queryClient) => {
  return useMutation9(getChecklistsControllerArchiveMutationOptions(options), queryClient);
};
var observationsControllerList = (orgId, projectId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/observations`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getObservationsControllerListQueryKey = (orgId, projectId, params) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/observations`,
    ...params ? [params] : []
  ];
};
var getObservationsControllerListQueryOptions = (orgId, projectId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getObservationsControllerListQueryKey(orgId, projectId, params);
  const queryFn = ({ signal }) => observationsControllerList(orgId, projectId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0, ...queryOptions };
};
function useObservationsControllerList(orgId, projectId, params, options, queryClient) {
  const queryOptions = getObservationsControllerListQueryOptions(orgId, projectId, params, options);
  const query = useQuery9(queryOptions, queryClient);
  return withQueryKey9(query, queryOptions.queryKey);
}
var observationsControllerCreate = (orgId, projectId, createObservationDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/observations`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createObservationDto,
      ...signal ? { signal } : {}
    }
  );
};
var getObservationsControllerCreateMutationKey = () => ["observationsControllerCreate"];
var getObservationsControllerCreateMutationOptions = (options) => {
  const mutationKey = getObservationsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, data } = props ?? {};
    return observationsControllerCreate(orgId, projectId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useObservationsControllerCreate = (options, queryClient) => {
  return useMutation9(getObservationsControllerCreateMutationOptions(options), queryClient);
};
var observationsControllerPhotoFolder = (orgId, projectId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/observations/photo-folder`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getObservationsControllerPhotoFolderMutationKey = () => ["observationsControllerPhotoFolder"];
var getObservationsControllerPhotoFolderMutationOptions = (options) => {
  const mutationKey = getObservationsControllerPhotoFolderMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId } = props ?? {};
    return observationsControllerPhotoFolder(orgId, projectId);
  };
  return { mutationFn, ...mutationOptions };
};
var useObservationsControllerPhotoFolder = (options, queryClient) => {
  return useMutation9(getObservationsControllerPhotoFolderMutationOptions(options), queryClient);
};
var observationsControllerGet = (orgId, projectId, observationId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/observations/${observationId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getObservationsControllerGetQueryKey = (orgId, projectId, observationId) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/observations/${observationId}`
  ];
};
var getObservationsControllerGetQueryOptions = (orgId, projectId, observationId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getObservationsControllerGetQueryKey(orgId, projectId, observationId);
  const queryFn = ({ signal }) => observationsControllerGet(orgId, projectId, observationId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0 && observationId !== null && observationId !== void 0, ...queryOptions };
};
function useObservationsControllerGet(orgId, projectId, observationId, options, queryClient) {
  const queryOptions = getObservationsControllerGetQueryOptions(orgId, projectId, observationId, options);
  const query = useQuery9(queryOptions, queryClient);
  return withQueryKey9(query, queryOptions.queryKey);
}
var observationsControllerUpdate = (orgId, projectId, observationId, updateObservationDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/observations/${observationId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateObservationDto,
      ...signal ? { signal } : {}
    }
  );
};
var getObservationsControllerUpdateMutationKey = () => ["observationsControllerUpdate"];
var getObservationsControllerUpdateMutationOptions = (options) => {
  const mutationKey = getObservationsControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, observationId, data } = props ?? {};
    return observationsControllerUpdate(orgId, projectId, observationId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useObservationsControllerUpdate = (options, queryClient) => {
  return useMutation9(getObservationsControllerUpdateMutationOptions(options), queryClient);
};
var observationsControllerRemove = (orgId, projectId, observationId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/observations/${observationId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getObservationsControllerRemoveMutationKey = () => ["observationsControllerRemove"];
var getObservationsControllerRemoveMutationOptions = (options) => {
  const mutationKey = getObservationsControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, observationId } = props ?? {};
    return observationsControllerRemove(orgId, projectId, observationId);
  };
  return { mutationFn, ...mutationOptions };
};
var useObservationsControllerRemove = (options, queryClient) => {
  return useMutation9(getObservationsControllerRemoveMutationOptions(options), queryClient);
};
var observationsControllerResolve = (orgId, projectId, observationId, resolveObservationDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/observations/${observationId}/resolve`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: resolveObservationDto,
      ...signal ? { signal } : {}
    }
  );
};
var getObservationsControllerResolveMutationKey = () => ["observationsControllerResolve"];
var getObservationsControllerResolveMutationOptions = (options) => {
  const mutationKey = getObservationsControllerResolveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, observationId, data } = props ?? {};
    return observationsControllerResolve(orgId, projectId, observationId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useObservationsControllerResolve = (options, queryClient) => {
  return useMutation9(getObservationsControllerResolveMutationOptions(options), queryClient);
};
var observationsControllerReopen = (orgId, projectId, observationId, reopenObservationDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/observations/${observationId}/reopen`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: reopenObservationDto,
      ...signal ? { signal } : {}
    }
  );
};
var getObservationsControllerReopenMutationKey = () => ["observationsControllerReopen"];
var getObservationsControllerReopenMutationOptions = (options) => {
  const mutationKey = getObservationsControllerReopenMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, observationId, data } = props ?? {};
    return observationsControllerReopen(orgId, projectId, observationId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useObservationsControllerReopen = (options, queryClient) => {
  return useMutation9(getObservationsControllerReopenMutationOptions(options), queryClient);
};
var receptionReportsControllerList = (orgId, projectId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/reception-reports`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getReceptionReportsControllerListQueryKey = (orgId, projectId) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/reception-reports`
  ];
};
var getReceptionReportsControllerListQueryOptions = (orgId, projectId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getReceptionReportsControllerListQueryKey(orgId, projectId);
  const queryFn = ({ signal }) => receptionReportsControllerList(orgId, projectId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0, ...queryOptions };
};
function useReceptionReportsControllerList(orgId, projectId, options, queryClient) {
  const queryOptions = getReceptionReportsControllerListQueryOptions(orgId, projectId, options);
  const query = useQuery9(queryOptions, queryClient);
  return withQueryKey9(query, queryOptions.queryKey);
}
var receptionReportsControllerCreate = (orgId, projectId, createReceptionReportDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/reception-reports`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createReceptionReportDto,
      ...signal ? { signal } : {}
    }
  );
};
var getReceptionReportsControllerCreateMutationKey = () => ["receptionReportsControllerCreate"];
var getReceptionReportsControllerCreateMutationOptions = (options) => {
  const mutationKey = getReceptionReportsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, data } = props ?? {};
    return receptionReportsControllerCreate(orgId, projectId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useReceptionReportsControllerCreate = (options, queryClient) => {
  return useMutation9(getReceptionReportsControllerCreateMutationOptions(options), queryClient);
};
var receptionReportsControllerGet = (orgId, projectId, reportId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/reception-reports/${reportId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getReceptionReportsControllerGetQueryKey = (orgId, projectId, reportId) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/reception-reports/${reportId}`
  ];
};
var getReceptionReportsControllerGetQueryOptions = (orgId, projectId, reportId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getReceptionReportsControllerGetQueryKey(orgId, projectId, reportId);
  const queryFn = ({ signal }) => receptionReportsControllerGet(orgId, projectId, reportId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0 && reportId !== null && reportId !== void 0, ...queryOptions };
};
function useReceptionReportsControllerGet(orgId, projectId, reportId, options, queryClient) {
  const queryOptions = getReceptionReportsControllerGetQueryOptions(orgId, projectId, reportId, options);
  const query = useQuery9(queryOptions, queryClient);
  return withQueryKey9(query, queryOptions.queryKey);
}
var receptionReportsControllerDownloadUrl = (orgId, projectId, reportId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/reception-reports/${reportId}/download-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getReceptionReportsControllerDownloadUrlQueryKey = (orgId, projectId, reportId) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/reception-reports/${reportId}/download-url`
  ];
};
var getReceptionReportsControllerDownloadUrlQueryOptions = (orgId, projectId, reportId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getReceptionReportsControllerDownloadUrlQueryKey(orgId, projectId, reportId);
  const queryFn = ({ signal }) => receptionReportsControllerDownloadUrl(orgId, projectId, reportId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0 && reportId !== null && reportId !== void 0, ...queryOptions };
};
function useReceptionReportsControllerDownloadUrl(orgId, projectId, reportId, options, queryClient) {
  const queryOptions = getReceptionReportsControllerDownloadUrlQueryOptions(orgId, projectId, reportId, options);
  const query = useQuery9(queryOptions, queryClient);
  return withQueryKey9(query, queryOptions.queryKey);
}

// src/generated/endpoints/finance/finance.ts
import {
  useMutation as useMutation10,
  useQuery as useQuery10
} from "@tanstack/react-query";
var withQueryKey10 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var quotesControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/quotes`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getQuotesControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/quotes`,
    ...params ? [params] : []
  ];
};
var getQuotesControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getQuotesControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => quotesControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useQuotesControllerList(orgId, params, options, queryClient) {
  const queryOptions = getQuotesControllerListQueryOptions(orgId, params, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var quotesControllerCreate = (orgId, createQuoteDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/quotes`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createQuoteDto,
      ...signal ? { signal } : {}
    }
  );
};
var getQuotesControllerCreateMutationKey = () => ["quotesControllerCreate"];
var getQuotesControllerCreateMutationOptions = (options) => {
  const mutationKey = getQuotesControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return quotesControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useQuotesControllerCreate = (options, queryClient) => {
  return useMutation10(getQuotesControllerCreateMutationOptions(options), queryClient);
};
var quotesControllerGet = (orgId, quoteId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/quotes/${quoteId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getQuotesControllerGetQueryKey = (orgId, quoteId) => {
  return [
    `/api/v1/orgs/${orgId}/quotes/${quoteId}`
  ];
};
var getQuotesControllerGetQueryOptions = (orgId, quoteId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getQuotesControllerGetQueryKey(orgId, quoteId);
  const queryFn = ({ signal }) => quotesControllerGet(orgId, quoteId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && quoteId !== null && quoteId !== void 0, ...queryOptions };
};
function useQuotesControllerGet(orgId, quoteId, options, queryClient) {
  const queryOptions = getQuotesControllerGetQueryOptions(orgId, quoteId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var quotesControllerUpdate = (orgId, quoteId, updateQuoteDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/quotes/${quoteId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateQuoteDto,
      ...signal ? { signal } : {}
    }
  );
};
var getQuotesControllerUpdateMutationKey = () => ["quotesControllerUpdate"];
var getQuotesControllerUpdateMutationOptions = (options) => {
  const mutationKey = getQuotesControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, quoteId, data } = props ?? {};
    return quotesControllerUpdate(orgId, quoteId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useQuotesControllerUpdate = (options, queryClient) => {
  return useMutation10(getQuotesControllerUpdateMutationOptions(options), queryClient);
};
var quotesControllerRemove = (orgId, quoteId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/quotes/${quoteId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getQuotesControllerRemoveMutationKey = () => ["quotesControllerRemove"];
var getQuotesControllerRemoveMutationOptions = (options) => {
  const mutationKey = getQuotesControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, quoteId } = props ?? {};
    return quotesControllerRemove(orgId, quoteId);
  };
  return { mutationFn, ...mutationOptions };
};
var useQuotesControllerRemove = (options, queryClient) => {
  return useMutation10(getQuotesControllerRemoveMutationOptions(options), queryClient);
};
var quotesControllerSend = (orgId, quoteId, sendQuoteDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/quotes/${quoteId}/send`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: sendQuoteDto,
      ...signal ? { signal } : {}
    }
  );
};
var getQuotesControllerSendMutationKey = () => ["quotesControllerSend"];
var getQuotesControllerSendMutationOptions = (options) => {
  const mutationKey = getQuotesControllerSendMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, quoteId, data } = props ?? {};
    return quotesControllerSend(orgId, quoteId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useQuotesControllerSend = (options, queryClient) => {
  return useMutation10(getQuotesControllerSendMutationOptions(options), queryClient);
};
var quotesControllerRequestPdf = (orgId, quoteId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/quotes/${quoteId}/pdf`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getQuotesControllerRequestPdfMutationKey = () => ["quotesControllerRequestPdf"];
var getQuotesControllerRequestPdfMutationOptions = (options) => {
  const mutationKey = getQuotesControllerRequestPdfMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, quoteId } = props ?? {};
    return quotesControllerRequestPdf(orgId, quoteId);
  };
  return { mutationFn, ...mutationOptions };
};
var useQuotesControllerRequestPdf = (options, queryClient) => {
  return useMutation10(getQuotesControllerRequestPdfMutationOptions(options), queryClient);
};
var quotesControllerPdfUrl = (orgId, quoteId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/quotes/${quoteId}/pdf-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getQuotesControllerPdfUrlQueryKey = (orgId, quoteId) => {
  return [
    `/api/v1/orgs/${orgId}/quotes/${quoteId}/pdf-url`
  ];
};
var getQuotesControllerPdfUrlQueryOptions = (orgId, quoteId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getQuotesControllerPdfUrlQueryKey(orgId, quoteId);
  const queryFn = ({ signal }) => quotesControllerPdfUrl(orgId, quoteId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && quoteId !== null && quoteId !== void 0, ...queryOptions };
};
function useQuotesControllerPdfUrl(orgId, quoteId, options, queryClient) {
  const queryOptions = getQuotesControllerPdfUrlQueryOptions(orgId, quoteId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var quotesControllerReject = (orgId, quoteId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/quotes/${quoteId}/reject`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getQuotesControllerRejectMutationKey = () => ["quotesControllerReject"];
var getQuotesControllerRejectMutationOptions = (options) => {
  const mutationKey = getQuotesControllerRejectMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, quoteId } = props ?? {};
    return quotesControllerReject(orgId, quoteId);
  };
  return { mutationFn, ...mutationOptions };
};
var useQuotesControllerReject = (options, queryClient) => {
  return useMutation10(getQuotesControllerRejectMutationOptions(options), queryClient);
};
var quotesControllerConvert = (orgId, quoteId, convertQuoteDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/quotes/${quoteId}/project`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: convertQuoteDto,
      ...signal ? { signal } : {}
    }
  );
};
var getQuotesControllerConvertMutationKey = () => ["quotesControllerConvert"];
var getQuotesControllerConvertMutationOptions = (options) => {
  const mutationKey = getQuotesControllerConvertMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, quoteId, data } = props ?? {};
    return quotesControllerConvert(orgId, quoteId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useQuotesControllerConvert = (options, queryClient) => {
  return useMutation10(getQuotesControllerConvertMutationOptions(options), queryClient);
};
var quotesControllerFeeScales = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/fee-scales`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getQuotesControllerFeeScalesQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/fee-scales`
  ];
};
var getQuotesControllerFeeScalesQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getQuotesControllerFeeScalesQueryKey(orgId);
  const queryFn = ({ signal }) => quotesControllerFeeScales(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useQuotesControllerFeeScales(orgId, options, queryClient) {
  const queryOptions = getQuotesControllerFeeScalesQueryOptions(orgId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var quotesControllerCreateFeeScale = (orgId, createFeeScaleDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/fee-scales`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createFeeScaleDto,
      ...signal ? { signal } : {}
    }
  );
};
var getQuotesControllerCreateFeeScaleMutationKey = () => ["quotesControllerCreateFeeScale"];
var getQuotesControllerCreateFeeScaleMutationOptions = (options) => {
  const mutationKey = getQuotesControllerCreateFeeScaleMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return quotesControllerCreateFeeScale(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useQuotesControllerCreateFeeScale = (options, queryClient) => {
  return useMutation10(getQuotesControllerCreateFeeScaleMutationOptions(options), queryClient);
};
var quotesControllerDeleteFeeScale = (orgId, scaleId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/fee-scales/${scaleId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getQuotesControllerDeleteFeeScaleMutationKey = () => ["quotesControllerDeleteFeeScale"];
var getQuotesControllerDeleteFeeScaleMutationOptions = (options) => {
  const mutationKey = getQuotesControllerDeleteFeeScaleMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, scaleId } = props ?? {};
    return quotesControllerDeleteFeeScale(orgId, scaleId);
  };
  return { mutationFn, ...mutationOptions };
};
var useQuotesControllerDeleteFeeScale = (options, queryClient) => {
  return useMutation10(getQuotesControllerDeleteFeeScaleMutationOptions(options), queryClient);
};
var publicQuotesControllerGet = (token, signal) => {
  return apiRequest(
    {
      url: `/api/v1/public/quotes/${token}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPublicQuotesControllerGetQueryKey = (token) => {
  return [
    `/api/v1/public/quotes/${token}`
  ];
};
var getPublicQuotesControllerGetQueryOptions = (token, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPublicQuotesControllerGetQueryKey(token);
  const queryFn = ({ signal }) => publicQuotesControllerGet(token, signal);
  return { queryKey, queryFn, enabled: token !== null && token !== void 0, ...queryOptions };
};
function usePublicQuotesControllerGet(token, options, queryClient) {
  const queryOptions = getPublicQuotesControllerGetQueryOptions(token, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var publicQuotesControllerPdf = (token, signal) => {
  return apiRequest(
    {
      url: `/api/v1/public/quotes/${token}/pdf`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPublicQuotesControllerPdfQueryKey = (token) => {
  return [
    `/api/v1/public/quotes/${token}/pdf`
  ];
};
var getPublicQuotesControllerPdfQueryOptions = (token, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPublicQuotesControllerPdfQueryKey(token);
  const queryFn = ({ signal }) => publicQuotesControllerPdf(token, signal);
  return { queryKey, queryFn, enabled: token !== null && token !== void 0, ...queryOptions };
};
function usePublicQuotesControllerPdf(token, options, queryClient) {
  const queryOptions = getPublicQuotesControllerPdfQueryOptions(token, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var publicQuotesControllerAccept = (token, acceptQuoteDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/public/quotes/${token}/accept`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: acceptQuoteDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPublicQuotesControllerAcceptMutationKey = () => ["publicQuotesControllerAccept"];
var getPublicQuotesControllerAcceptMutationOptions = (options) => {
  const mutationKey = getPublicQuotesControllerAcceptMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { token, data } = props ?? {};
    return publicQuotesControllerAccept(token, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePublicQuotesControllerAccept = (options, queryClient) => {
  return useMutation10(getPublicQuotesControllerAcceptMutationOptions(options), queryClient);
};
var contractsControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/contracts`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getContractsControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/contracts`,
    ...params ? [params] : []
  ];
};
var getContractsControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getContractsControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => contractsControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useContractsControllerList(orgId, params, options, queryClient) {
  const queryOptions = getContractsControllerListQueryOptions(orgId, params, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var contractsControllerCreate = (orgId, createContractDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/contracts`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createContractDto,
      ...signal ? { signal } : {}
    }
  );
};
var getContractsControllerCreateMutationKey = () => ["contractsControllerCreate"];
var getContractsControllerCreateMutationOptions = (options) => {
  const mutationKey = getContractsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return contractsControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useContractsControllerCreate = (options, queryClient) => {
  return useMutation10(getContractsControllerCreateMutationOptions(options), queryClient);
};
var contractsControllerGet = (orgId, contractId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/contracts/${contractId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getContractsControllerGetQueryKey = (orgId, contractId) => {
  return [
    `/api/v1/orgs/${orgId}/contracts/${contractId}`
  ];
};
var getContractsControllerGetQueryOptions = (orgId, contractId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getContractsControllerGetQueryKey(orgId, contractId);
  const queryFn = ({ signal }) => contractsControllerGet(orgId, contractId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && contractId !== null && contractId !== void 0, ...queryOptions };
};
function useContractsControllerGet(orgId, contractId, options, queryClient) {
  const queryOptions = getContractsControllerGetQueryOptions(orgId, contractId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var contractsControllerUpdate = (orgId, contractId, updateContractDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/contracts/${contractId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateContractDto,
      ...signal ? { signal } : {}
    }
  );
};
var getContractsControllerUpdateMutationKey = () => ["contractsControllerUpdate"];
var getContractsControllerUpdateMutationOptions = (options) => {
  const mutationKey = getContractsControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, contractId, data } = props ?? {};
    return contractsControllerUpdate(orgId, contractId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useContractsControllerUpdate = (options, queryClient) => {
  return useMutation10(getContractsControllerUpdateMutationOptions(options), queryClient);
};
var contractsControllerAmendments = (orgId, contractId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/contracts/${contractId}/amendments`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getContractsControllerAmendmentsQueryKey = (orgId, contractId) => {
  return [
    `/api/v1/orgs/${orgId}/contracts/${contractId}/amendments`
  ];
};
var getContractsControllerAmendmentsQueryOptions = (orgId, contractId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getContractsControllerAmendmentsQueryKey(orgId, contractId);
  const queryFn = ({ signal }) => contractsControllerAmendments(orgId, contractId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && contractId !== null && contractId !== void 0, ...queryOptions };
};
function useContractsControllerAmendments(orgId, contractId, options, queryClient) {
  const queryOptions = getContractsControllerAmendmentsQueryOptions(orgId, contractId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var contractsControllerAddAmendment = (orgId, contractId, createContractAmendmentDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/contracts/${contractId}/amendments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createContractAmendmentDto,
      ...signal ? { signal } : {}
    }
  );
};
var getContractsControllerAddAmendmentMutationKey = () => ["contractsControllerAddAmendment"];
var getContractsControllerAddAmendmentMutationOptions = (options) => {
  const mutationKey = getContractsControllerAddAmendmentMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, contractId, data } = props ?? {};
    return contractsControllerAddAmendment(orgId, contractId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useContractsControllerAddAmendment = (options, queryClient) => {
  return useMutation10(getContractsControllerAddAmendmentMutationOptions(options), queryClient);
};
var invoicesControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoices`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getInvoicesControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/invoices`,
    ...params ? [params] : []
  ];
};
var getInvoicesControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getInvoicesControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => invoicesControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useInvoicesControllerList(orgId, params, options, queryClient) {
  const queryOptions = getInvoicesControllerListQueryOptions(orgId, params, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var invoicesControllerCreate = (orgId, createInvoiceDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoices`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createInvoiceDto,
      ...signal ? { signal } : {}
    }
  );
};
var getInvoicesControllerCreateMutationKey = () => ["invoicesControllerCreate"];
var getInvoicesControllerCreateMutationOptions = (options) => {
  const mutationKey = getInvoicesControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return invoicesControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useInvoicesControllerCreate = (options, queryClient) => {
  return useMutation10(getInvoicesControllerCreateMutationOptions(options), queryClient);
};
var invoicesControllerGet = (orgId, invoiceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoices/${invoiceId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getInvoicesControllerGetQueryKey = (orgId, invoiceId) => {
  return [
    `/api/v1/orgs/${orgId}/invoices/${invoiceId}`
  ];
};
var getInvoicesControllerGetQueryOptions = (orgId, invoiceId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getInvoicesControllerGetQueryKey(orgId, invoiceId);
  const queryFn = ({ signal }) => invoicesControllerGet(orgId, invoiceId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && invoiceId !== null && invoiceId !== void 0, ...queryOptions };
};
function useInvoicesControllerGet(orgId, invoiceId, options, queryClient) {
  const queryOptions = getInvoicesControllerGetQueryOptions(orgId, invoiceId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var invoicesControllerUpdate = (orgId, invoiceId, updateInvoiceDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoices/${invoiceId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateInvoiceDto,
      ...signal ? { signal } : {}
    }
  );
};
var getInvoicesControllerUpdateMutationKey = () => ["invoicesControllerUpdate"];
var getInvoicesControllerUpdateMutationOptions = (options) => {
  const mutationKey = getInvoicesControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, invoiceId, data } = props ?? {};
    return invoicesControllerUpdate(orgId, invoiceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useInvoicesControllerUpdate = (options, queryClient) => {
  return useMutation10(getInvoicesControllerUpdateMutationOptions(options), queryClient);
};
var invoicesControllerRemove = (orgId, invoiceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoices/${invoiceId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getInvoicesControllerRemoveMutationKey = () => ["invoicesControllerRemove"];
var getInvoicesControllerRemoveMutationOptions = (options) => {
  const mutationKey = getInvoicesControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, invoiceId } = props ?? {};
    return invoicesControllerRemove(orgId, invoiceId);
  };
  return { mutationFn, ...mutationOptions };
};
var useInvoicesControllerRemove = (options, queryClient) => {
  return useMutation10(getInvoicesControllerRemoveMutationOptions(options), queryClient);
};
var invoicesControllerIssue = (orgId, invoiceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoices/${invoiceId}/issue`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getInvoicesControllerIssueMutationKey = () => ["invoicesControllerIssue"];
var getInvoicesControllerIssueMutationOptions = (options) => {
  const mutationKey = getInvoicesControllerIssueMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, invoiceId } = props ?? {};
    return invoicesControllerIssue(orgId, invoiceId);
  };
  return { mutationFn, ...mutationOptions };
};
var useInvoicesControllerIssue = (options, queryClient) => {
  return useMutation10(getInvoicesControllerIssueMutationOptions(options), queryClient);
};
var invoicesControllerCreditNote = (orgId, invoiceId, createCreditNoteDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoices/${invoiceId}/credit-notes`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCreditNoteDto,
      ...signal ? { signal } : {}
    }
  );
};
var getInvoicesControllerCreditNoteMutationKey = () => ["invoicesControllerCreditNote"];
var getInvoicesControllerCreditNoteMutationOptions = (options) => {
  const mutationKey = getInvoicesControllerCreditNoteMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, invoiceId, data } = props ?? {};
    return invoicesControllerCreditNote(orgId, invoiceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useInvoicesControllerCreditNote = (options, queryClient) => {
  return useMutation10(getInvoicesControllerCreditNoteMutationOptions(options), queryClient);
};
var invoicesControllerRequestPdf = (orgId, invoiceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoices/${invoiceId}/pdf`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getInvoicesControllerRequestPdfMutationKey = () => ["invoicesControllerRequestPdf"];
var getInvoicesControllerRequestPdfMutationOptions = (options) => {
  const mutationKey = getInvoicesControllerRequestPdfMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, invoiceId } = props ?? {};
    return invoicesControllerRequestPdf(orgId, invoiceId);
  };
  return { mutationFn, ...mutationOptions };
};
var useInvoicesControllerRequestPdf = (options, queryClient) => {
  return useMutation10(getInvoicesControllerRequestPdfMutationOptions(options), queryClient);
};
var invoicesControllerPdfUrl = (orgId, invoiceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoices/${invoiceId}/pdf-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getInvoicesControllerPdfUrlQueryKey = (orgId, invoiceId) => {
  return [
    `/api/v1/orgs/${orgId}/invoices/${invoiceId}/pdf-url`
  ];
};
var getInvoicesControllerPdfUrlQueryOptions = (orgId, invoiceId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getInvoicesControllerPdfUrlQueryKey(orgId, invoiceId);
  const queryFn = ({ signal }) => invoicesControllerPdfUrl(orgId, invoiceId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && invoiceId !== null && invoiceId !== void 0, ...queryOptions };
};
function useInvoicesControllerPdfUrl(orgId, invoiceId, options, queryClient) {
  const queryOptions = getInvoicesControllerPdfUrlQueryOptions(orgId, invoiceId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var progressInvoicesControllerGet = (orgId, contractId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/contracts/${contractId}/progress`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getProgressInvoicesControllerGetQueryKey = (orgId, contractId) => {
  return [
    `/api/v1/orgs/${orgId}/contracts/${contractId}/progress`
  ];
};
var getProgressInvoicesControllerGetQueryOptions = (orgId, contractId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getProgressInvoicesControllerGetQueryKey(orgId, contractId);
  const queryFn = ({ signal }) => progressInvoicesControllerGet(orgId, contractId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && contractId !== null && contractId !== void 0, ...queryOptions };
};
function useProgressInvoicesControllerGet(orgId, contractId, options, queryClient) {
  const queryOptions = getProgressInvoicesControllerGetQueryOptions(orgId, contractId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var progressInvoicesControllerCreate = (orgId, contractId, progressInvoiceRequestDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/contracts/${contractId}/progress-invoices`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: progressInvoiceRequestDto,
      ...signal ? { signal } : {}
    }
  );
};
var getProgressInvoicesControllerCreateMutationKey = () => ["progressInvoicesControllerCreate"];
var getProgressInvoicesControllerCreateMutationOptions = (options) => {
  const mutationKey = getProgressInvoicesControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, contractId, data } = props ?? {};
    return progressInvoicesControllerCreate(orgId, contractId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useProgressInvoicesControllerCreate = (options, queryClient) => {
  return useMutation10(getProgressInvoicesControllerCreateMutationOptions(options), queryClient);
};
var paymentsControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/payments`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getPaymentsControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/payments`,
    ...params ? [params] : []
  ];
};
var getPaymentsControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPaymentsControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => paymentsControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function usePaymentsControllerList(orgId, params, options, queryClient) {
  const queryOptions = getPaymentsControllerListQueryOptions(orgId, params, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var paymentsControllerRecord = (orgId, createPaymentDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/payments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createPaymentDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPaymentsControllerRecordMutationKey = () => ["paymentsControllerRecord"];
var getPaymentsControllerRecordMutationOptions = (options) => {
  const mutationKey = getPaymentsControllerRecordMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return paymentsControllerRecord(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePaymentsControllerRecord = (options, queryClient) => {
  return useMutation10(getPaymentsControllerRecordMutationOptions(options), queryClient);
};
var paymentsControllerAttachCertificate = (orgId, paymentId, attachCertificateDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/payments/${paymentId}/certificate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: attachCertificateDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPaymentsControllerAttachCertificateMutationKey = () => ["paymentsControllerAttachCertificate"];
var getPaymentsControllerAttachCertificateMutationOptions = (options) => {
  const mutationKey = getPaymentsControllerAttachCertificateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, paymentId, data } = props ?? {};
    return paymentsControllerAttachCertificate(orgId, paymentId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePaymentsControllerAttachCertificate = (options, queryClient) => {
  return useMutation10(getPaymentsControllerAttachCertificateMutationOptions(options), queryClient);
};
var paymentsControllerAging = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/receivables/aging`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPaymentsControllerAgingQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/receivables/aging`
  ];
};
var getPaymentsControllerAgingQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPaymentsControllerAgingQueryKey(orgId);
  const queryFn = ({ signal }) => paymentsControllerAging(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function usePaymentsControllerAging(orgId, options, queryClient) {
  const queryOptions = getPaymentsControllerAgingQueryOptions(orgId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var paymentsControllerSettings = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/finance/settings`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPaymentsControllerSettingsQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/finance/settings`
  ];
};
var getPaymentsControllerSettingsQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPaymentsControllerSettingsQueryKey(orgId);
  const queryFn = ({ signal }) => paymentsControllerSettings(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function usePaymentsControllerSettings(orgId, options, queryClient) {
  const queryOptions = getPaymentsControllerSettingsQueryOptions(orgId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var paymentsControllerUpdateSettings = (orgId, updateFinanceSettingsDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/finance/settings`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateFinanceSettingsDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPaymentsControllerUpdateSettingsMutationKey = () => ["paymentsControllerUpdateSettings"];
var getPaymentsControllerUpdateSettingsMutationOptions = (options) => {
  const mutationKey = getPaymentsControllerUpdateSettingsMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return paymentsControllerUpdateSettings(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePaymentsControllerUpdateSettings = (options, queryClient) => {
  return useMutation10(getPaymentsControllerUpdateSettingsMutationOptions(options), queryClient);
};
var financeDashboardControllerGet = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/finance/dashboard`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getFinanceDashboardControllerGetQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/finance/dashboard`
  ];
};
var getFinanceDashboardControllerGetQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getFinanceDashboardControllerGetQueryKey(orgId);
  const queryFn = ({ signal }) => financeDashboardControllerGet(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useFinanceDashboardControllerGet(orgId, options, queryClient) {
  const queryOptions = getFinanceDashboardControllerGetQueryOptions(orgId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var expensesControllerReceiptFolder = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/expenses/receipt-folder`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getExpensesControllerReceiptFolderMutationKey = () => ["expensesControllerReceiptFolder"];
var getExpensesControllerReceiptFolderMutationOptions = (options) => {
  const mutationKey = getExpensesControllerReceiptFolderMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId } = props ?? {};
    return expensesControllerReceiptFolder(orgId);
  };
  return { mutationFn, ...mutationOptions };
};
var useExpensesControllerReceiptFolder = (options, queryClient) => {
  return useMutation10(getExpensesControllerReceiptFolderMutationOptions(options), queryClient);
};
var expensesControllerSubmit = (orgId, createExpenseDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/expenses`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createExpenseDto,
      ...signal ? { signal } : {}
    }
  );
};
var getExpensesControllerSubmitMutationKey = () => ["expensesControllerSubmit"];
var getExpensesControllerSubmitMutationOptions = (options) => {
  const mutationKey = getExpensesControllerSubmitMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return expensesControllerSubmit(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useExpensesControllerSubmit = (options, queryClient) => {
  return useMutation10(getExpensesControllerSubmitMutationOptions(options), queryClient);
};
var expensesControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/expenses`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getExpensesControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/expenses`,
    ...params ? [params] : []
  ];
};
var getExpensesControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getExpensesControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => expensesControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useExpensesControllerList(orgId, params, options, queryClient) {
  const queryOptions = getExpensesControllerListQueryOptions(orgId, params, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var expensesControllerMine = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/expenses/mine`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getExpensesControllerMineQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/expenses/mine`,
    ...params ? [params] : []
  ];
};
var getExpensesControllerMineQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getExpensesControllerMineQueryKey(orgId, params);
  const queryFn = ({ signal }) => expensesControllerMine(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useExpensesControllerMine(orgId, params, options, queryClient) {
  const queryOptions = getExpensesControllerMineQueryOptions(orgId, params, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var expensesControllerGet = (orgId, expenseId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/expenses/${expenseId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getExpensesControllerGetQueryKey = (orgId, expenseId) => {
  return [
    `/api/v1/orgs/${orgId}/expenses/${expenseId}`
  ];
};
var getExpensesControllerGetQueryOptions = (orgId, expenseId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getExpensesControllerGetQueryKey(orgId, expenseId);
  const queryFn = ({ signal }) => expensesControllerGet(orgId, expenseId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && expenseId !== null && expenseId !== void 0, ...queryOptions };
};
function useExpensesControllerGet(orgId, expenseId, options, queryClient) {
  const queryOptions = getExpensesControllerGetQueryOptions(orgId, expenseId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var expensesControllerReceiptUrl = (orgId, expenseId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/expenses/${expenseId}/receipt-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getExpensesControllerReceiptUrlQueryKey = (orgId, expenseId) => {
  return [
    `/api/v1/orgs/${orgId}/expenses/${expenseId}/receipt-url`
  ];
};
var getExpensesControllerReceiptUrlQueryOptions = (orgId, expenseId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getExpensesControllerReceiptUrlQueryKey(orgId, expenseId);
  const queryFn = ({ signal }) => expensesControllerReceiptUrl(orgId, expenseId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && expenseId !== null && expenseId !== void 0, ...queryOptions };
};
function useExpensesControllerReceiptUrl(orgId, expenseId, options, queryClient) {
  const queryOptions = getExpensesControllerReceiptUrlQueryOptions(orgId, expenseId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var expensesControllerApprove = (orgId, expenseId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/expenses/${expenseId}/approve`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getExpensesControllerApproveMutationKey = () => ["expensesControllerApprove"];
var getExpensesControllerApproveMutationOptions = (options) => {
  const mutationKey = getExpensesControllerApproveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, expenseId } = props ?? {};
    return expensesControllerApprove(orgId, expenseId);
  };
  return { mutationFn, ...mutationOptions };
};
var useExpensesControllerApprove = (options, queryClient) => {
  return useMutation10(getExpensesControllerApproveMutationOptions(options), queryClient);
};
var expensesControllerReject = (orgId, expenseId, rejectExpenseDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/expenses/${expenseId}/reject`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: rejectExpenseDto,
      ...signal ? { signal } : {}
    }
  );
};
var getExpensesControllerRejectMutationKey = () => ["expensesControllerReject"];
var getExpensesControllerRejectMutationOptions = (options) => {
  const mutationKey = getExpensesControllerRejectMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, expenseId, data } = props ?? {};
    return expensesControllerReject(orgId, expenseId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useExpensesControllerReject = (options, queryClient) => {
  return useMutation10(getExpensesControllerRejectMutationOptions(options), queryClient);
};
var expensesControllerReimbursed = (orgId, expenseId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/expenses/${expenseId}/reimbursed`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getExpensesControllerReimbursedMutationKey = () => ["expensesControllerReimbursed"];
var getExpensesControllerReimbursedMutationOptions = (options) => {
  const mutationKey = getExpensesControllerReimbursedMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, expenseId } = props ?? {};
    return expensesControllerReimbursed(orgId, expenseId);
  };
  return { mutationFn, ...mutationOptions };
};
var useExpensesControllerReimbursed = (options, queryClient) => {
  return useMutation10(getExpensesControllerReimbursedMutationOptions(options), queryClient);
};
var suppliersControllerListSuppliers = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/suppliers`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerListSuppliersQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/suppliers`,
    ...params ? [params] : []
  ];
};
var getSuppliersControllerListSuppliersQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSuppliersControllerListSuppliersQueryKey(orgId, params);
  const queryFn = ({ signal }) => suppliersControllerListSuppliers(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useSuppliersControllerListSuppliers(orgId, params, options, queryClient) {
  const queryOptions = getSuppliersControllerListSuppliersQueryOptions(orgId, params, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var suppliersControllerCreateSupplier = (orgId, createSupplierDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/suppliers`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createSupplierDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerCreateSupplierMutationKey = () => ["suppliersControllerCreateSupplier"];
var getSuppliersControllerCreateSupplierMutationOptions = (options) => {
  const mutationKey = getSuppliersControllerCreateSupplierMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return suppliersControllerCreateSupplier(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSuppliersControllerCreateSupplier = (options, queryClient) => {
  return useMutation10(getSuppliersControllerCreateSupplierMutationOptions(options), queryClient);
};
var suppliersControllerGetSupplier = (orgId, supplierId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/suppliers/${supplierId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerGetSupplierQueryKey = (orgId, supplierId) => {
  return [
    `/api/v1/orgs/${orgId}/suppliers/${supplierId}`
  ];
};
var getSuppliersControllerGetSupplierQueryOptions = (orgId, supplierId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSuppliersControllerGetSupplierQueryKey(orgId, supplierId);
  const queryFn = ({ signal }) => suppliersControllerGetSupplier(orgId, supplierId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && supplierId !== null && supplierId !== void 0, ...queryOptions };
};
function useSuppliersControllerGetSupplier(orgId, supplierId, options, queryClient) {
  const queryOptions = getSuppliersControllerGetSupplierQueryOptions(orgId, supplierId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var suppliersControllerUpdateSupplier = (orgId, supplierId, updateSupplierDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/suppliers/${supplierId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateSupplierDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerUpdateSupplierMutationKey = () => ["suppliersControllerUpdateSupplier"];
var getSuppliersControllerUpdateSupplierMutationOptions = (options) => {
  const mutationKey = getSuppliersControllerUpdateSupplierMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, supplierId, data } = props ?? {};
    return suppliersControllerUpdateSupplier(orgId, supplierId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSuppliersControllerUpdateSupplier = (options, queryClient) => {
  return useMutation10(getSuppliersControllerUpdateSupplierMutationOptions(options), queryClient);
};
var suppliersControllerRevealBankDetails = (orgId, supplierId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/suppliers/${supplierId}/bank-details/reveal`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerRevealBankDetailsMutationKey = () => ["suppliersControllerRevealBankDetails"];
var getSuppliersControllerRevealBankDetailsMutationOptions = (options) => {
  const mutationKey = getSuppliersControllerRevealBankDetailsMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, supplierId } = props ?? {};
    return suppliersControllerRevealBankDetails(orgId, supplierId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSuppliersControllerRevealBankDetails = (options, queryClient) => {
  return useMutation10(getSuppliersControllerRevealBankDetailsMutationOptions(options), queryClient);
};
var suppliersControllerListInvoices = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/supplier-invoices`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerListInvoicesQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/supplier-invoices`,
    ...params ? [params] : []
  ];
};
var getSuppliersControllerListInvoicesQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSuppliersControllerListInvoicesQueryKey(orgId, params);
  const queryFn = ({ signal }) => suppliersControllerListInvoices(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useSuppliersControllerListInvoices(orgId, params, options, queryClient) {
  const queryOptions = getSuppliersControllerListInvoicesQueryOptions(orgId, params, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var suppliersControllerCreateInvoice = (orgId, createSupplierInvoiceDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/supplier-invoices`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createSupplierInvoiceDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerCreateInvoiceMutationKey = () => ["suppliersControllerCreateInvoice"];
var getSuppliersControllerCreateInvoiceMutationOptions = (options) => {
  const mutationKey = getSuppliersControllerCreateInvoiceMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return suppliersControllerCreateInvoice(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSuppliersControllerCreateInvoice = (options, queryClient) => {
  return useMutation10(getSuppliersControllerCreateInvoiceMutationOptions(options), queryClient);
};
var suppliersControllerGetInvoice = (orgId, supplierInvoiceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/supplier-invoices/${supplierInvoiceId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerGetInvoiceQueryKey = (orgId, supplierInvoiceId) => {
  return [
    `/api/v1/orgs/${orgId}/supplier-invoices/${supplierInvoiceId}`
  ];
};
var getSuppliersControllerGetInvoiceQueryOptions = (orgId, supplierInvoiceId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSuppliersControllerGetInvoiceQueryKey(orgId, supplierInvoiceId);
  const queryFn = ({ signal }) => suppliersControllerGetInvoice(orgId, supplierInvoiceId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && supplierInvoiceId !== null && supplierInvoiceId !== void 0, ...queryOptions };
};
function useSuppliersControllerGetInvoice(orgId, supplierInvoiceId, options, queryClient) {
  const queryOptions = getSuppliersControllerGetInvoiceQueryOptions(orgId, supplierInvoiceId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var suppliersControllerUpdateInvoice = (orgId, supplierInvoiceId, updateSupplierInvoiceDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/supplier-invoices/${supplierInvoiceId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateSupplierInvoiceDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerUpdateInvoiceMutationKey = () => ["suppliersControllerUpdateInvoice"];
var getSuppliersControllerUpdateInvoiceMutationOptions = (options) => {
  const mutationKey = getSuppliersControllerUpdateInvoiceMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, supplierInvoiceId, data } = props ?? {};
    return suppliersControllerUpdateInvoice(orgId, supplierInvoiceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSuppliersControllerUpdateInvoice = (options, queryClient) => {
  return useMutation10(getSuppliersControllerUpdateInvoiceMutationOptions(options), queryClient);
};
var suppliersControllerCancelInvoice = (orgId, supplierInvoiceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/supplier-invoices/${supplierInvoiceId}/cancel`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerCancelInvoiceMutationKey = () => ["suppliersControllerCancelInvoice"];
var getSuppliersControllerCancelInvoiceMutationOptions = (options) => {
  const mutationKey = getSuppliersControllerCancelInvoiceMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, supplierInvoiceId } = props ?? {};
    return suppliersControllerCancelInvoice(orgId, supplierInvoiceId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSuppliersControllerCancelInvoice = (options, queryClient) => {
  return useMutation10(getSuppliersControllerCancelInvoiceMutationOptions(options), queryClient);
};
var suppliersControllerPreviewPayment = (orgId, supplierInvoiceId, supplierPaymentPreviewRequestDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/supplier-invoices/${supplierInvoiceId}/payments/preview`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: supplierPaymentPreviewRequestDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerPreviewPaymentMutationKey = () => ["suppliersControllerPreviewPayment"];
var getSuppliersControllerPreviewPaymentMutationOptions = (options) => {
  const mutationKey = getSuppliersControllerPreviewPaymentMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, supplierInvoiceId, data } = props ?? {};
    return suppliersControllerPreviewPayment(orgId, supplierInvoiceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSuppliersControllerPreviewPayment = (options, queryClient) => {
  return useMutation10(getSuppliersControllerPreviewPaymentMutationOptions(options), queryClient);
};
var suppliersControllerPay = (orgId, supplierInvoiceId, createSupplierPaymentDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/supplier-invoices/${supplierInvoiceId}/payments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createSupplierPaymentDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerPayMutationKey = () => ["suppliersControllerPay"];
var getSuppliersControllerPayMutationOptions = (options) => {
  const mutationKey = getSuppliersControllerPayMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, supplierInvoiceId, data } = props ?? {};
    return suppliersControllerPay(orgId, supplierInvoiceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSuppliersControllerPay = (options, queryClient) => {
  return useMutation10(getSuppliersControllerPayMutationOptions(options), queryClient);
};
var suppliersControllerCancelPayment = (orgId, supplierInvoiceId, supplierPaymentId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/supplier-invoices/${supplierInvoiceId}/payments/${supplierPaymentId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerCancelPaymentMutationKey = () => ["suppliersControllerCancelPayment"];
var getSuppliersControllerCancelPaymentMutationOptions = (options) => {
  const mutationKey = getSuppliersControllerCancelPaymentMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, supplierInvoiceId, supplierPaymentId } = props ?? {};
    return suppliersControllerCancelPayment(orgId, supplierInvoiceId, supplierPaymentId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSuppliersControllerCancelPayment = (options, queryClient) => {
  return useMutation10(getSuppliersControllerCancelPaymentMutationOptions(options), queryClient);
};
var suppliersControllerSummary = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/withholding/summary`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerSummaryQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/withholding/summary`,
    ...params ? [params] : []
  ];
};
var getSuppliersControllerSummaryQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSuppliersControllerSummaryQueryKey(orgId, params);
  const queryFn = ({ signal }) => suppliersControllerSummary(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useSuppliersControllerSummary(orgId, params, options, queryClient) {
  const queryOptions = getSuppliersControllerSummaryQueryOptions(orgId, params, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var suppliersControllerListTejExports = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/withholding/tej-exports`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerListTejExportsQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/withholding/tej-exports`
  ];
};
var getSuppliersControllerListTejExportsQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSuppliersControllerListTejExportsQueryKey(orgId);
  const queryFn = ({ signal }) => suppliersControllerListTejExports(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useSuppliersControllerListTejExports(orgId, options, queryClient) {
  const queryOptions = getSuppliersControllerListTejExportsQueryOptions(orgId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var suppliersControllerCreateTejExport = (orgId, createTejExportDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/withholding/tej-exports`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createTejExportDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerCreateTejExportMutationKey = () => ["suppliersControllerCreateTejExport"];
var getSuppliersControllerCreateTejExportMutationOptions = (options) => {
  const mutationKey = getSuppliersControllerCreateTejExportMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return suppliersControllerCreateTejExport(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSuppliersControllerCreateTejExport = (options, queryClient) => {
  return useMutation10(getSuppliersControllerCreateTejExportMutationOptions(options), queryClient);
};
var suppliersControllerDownloadTejExport = (orgId, tejExportId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/withholding/tej-exports/${tejExportId}/file`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getSuppliersControllerDownloadTejExportQueryKey = (orgId, tejExportId) => {
  return [
    `/api/v1/orgs/${orgId}/withholding/tej-exports/${tejExportId}/file`
  ];
};
var getSuppliersControllerDownloadTejExportQueryOptions = (orgId, tejExportId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSuppliersControllerDownloadTejExportQueryKey(orgId, tejExportId);
  const queryFn = ({ signal }) => suppliersControllerDownloadTejExport(orgId, tejExportId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && tejExportId !== null && tejExportId !== void 0, ...queryOptions };
};
function useSuppliersControllerDownloadTejExport(orgId, tejExportId, options, queryClient) {
  const queryOptions = getSuppliersControllerDownloadTejExportQueryOptions(orgId, tejExportId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var profitabilityControllerListRates = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/cost-rates`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getProfitabilityControllerListRatesQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/cost-rates`
  ];
};
var getProfitabilityControllerListRatesQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getProfitabilityControllerListRatesQueryKey(orgId);
  const queryFn = ({ signal }) => profitabilityControllerListRates(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useProfitabilityControllerListRates(orgId, options, queryClient) {
  const queryOptions = getProfitabilityControllerListRatesQueryOptions(orgId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var profitabilityControllerCreateRate = (orgId, createCostRateDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/cost-rates`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCostRateDto,
      ...signal ? { signal } : {}
    }
  );
};
var getProfitabilityControllerCreateRateMutationKey = () => ["profitabilityControllerCreateRate"];
var getProfitabilityControllerCreateRateMutationOptions = (options) => {
  const mutationKey = getProfitabilityControllerCreateRateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return profitabilityControllerCreateRate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useProfitabilityControllerCreateRate = (options, queryClient) => {
  return useMutation10(getProfitabilityControllerCreateRateMutationOptions(options), queryClient);
};
var profitabilityControllerRemoveRate = (orgId, costRateId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/cost-rates/${costRateId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getProfitabilityControllerRemoveRateMutationKey = () => ["profitabilityControllerRemoveRate"];
var getProfitabilityControllerRemoveRateMutationOptions = (options) => {
  const mutationKey = getProfitabilityControllerRemoveRateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, costRateId } = props ?? {};
    return profitabilityControllerRemoveRate(orgId, costRateId);
  };
  return { mutationFn, ...mutationOptions };
};
var useProfitabilityControllerRemoveRate = (options, queryClient) => {
  return useMutation10(getProfitabilityControllerRemoveRateMutationOptions(options), queryClient);
};
var profitabilityControllerProject = (orgId, projectId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/profitability`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getProfitabilityControllerProjectQueryKey = (orgId, projectId) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/profitability`
  ];
};
var getProfitabilityControllerProjectQueryOptions = (orgId, projectId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getProfitabilityControllerProjectQueryKey(orgId, projectId);
  const queryFn = ({ signal }) => profitabilityControllerProject(orgId, projectId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0, ...queryOptions };
};
function useProfitabilityControllerProject(orgId, projectId, options, queryClient) {
  const queryOptions = getProfitabilityControllerProjectQueryOptions(orgId, projectId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var profitabilityControllerOverview = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/profitability`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getProfitabilityControllerOverviewQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/profitability`,
    ...params ? [params] : []
  ];
};
var getProfitabilityControllerOverviewQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getProfitabilityControllerOverviewQueryKey(orgId, params);
  const queryFn = ({ signal }) => profitabilityControllerOverview(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useProfitabilityControllerOverview(orgId, params, options, queryClient) {
  const queryOptions = getProfitabilityControllerOverviewQueryOptions(orgId, params, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var accountingControllerClosedPeriods = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/closed-periods`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getAccountingControllerClosedPeriodsQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/closed-periods`
  ];
};
var getAccountingControllerClosedPeriodsQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAccountingControllerClosedPeriodsQueryKey(orgId);
  const queryFn = ({ signal }) => accountingControllerClosedPeriods(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useAccountingControllerClosedPeriods(orgId, options, queryClient) {
  const queryOptions = getAccountingControllerClosedPeriodsQueryOptions(orgId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var accountingControllerClose = (orgId, closeRequestDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/closed-periods`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: closeRequestDto,
      ...signal ? { signal } : {}
    }
  );
};
var getAccountingControllerCloseMutationKey = () => ["accountingControllerClose"];
var getAccountingControllerCloseMutationOptions = (options) => {
  const mutationKey = getAccountingControllerCloseMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return accountingControllerClose(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useAccountingControllerClose = (options, queryClient) => {
  return useMutation10(getAccountingControllerCloseMutationOptions(options), queryClient);
};
var accountingControllerReopen = (orgId, period, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/closed-periods/${period}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getAccountingControllerReopenMutationKey = () => ["accountingControllerReopen"];
var getAccountingControllerReopenMutationOptions = (options) => {
  const mutationKey = getAccountingControllerReopenMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, period } = props ?? {};
    return accountingControllerReopen(orgId, period);
  };
  return { mutationFn, ...mutationOptions };
};
var useAccountingControllerReopen = (options, queryClient) => {
  return useMutation10(getAccountingControllerReopenMutationOptions(options), queryClient);
};
var accountingControllerSettings = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/accounting-settings`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getAccountingControllerSettingsQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/accounting-settings`
  ];
};
var getAccountingControllerSettingsQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAccountingControllerSettingsQueryKey(orgId);
  const queryFn = ({ signal }) => accountingControllerSettings(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useAccountingControllerSettings(orgId, options, queryClient) {
  const queryOptions = getAccountingControllerSettingsQueryOptions(orgId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var accountingControllerUpdateSettings = (orgId, updateAccountingSettingsDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/accounting-settings`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateAccountingSettingsDto,
      ...signal ? { signal } : {}
    }
  );
};
var getAccountingControllerUpdateSettingsMutationKey = () => ["accountingControllerUpdateSettings"];
var getAccountingControllerUpdateSettingsMutationOptions = (options) => {
  const mutationKey = getAccountingControllerUpdateSettingsMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return accountingControllerUpdateSettings(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useAccountingControllerUpdateSettings = (options, queryClient) => {
  return useMutation10(getAccountingControllerUpdateSettingsMutationOptions(options), queryClient);
};
var accountingControllerList = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/accounting-exports`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getAccountingControllerListQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/accounting-exports`
  ];
};
var getAccountingControllerListQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAccountingControllerListQueryKey(orgId);
  const queryFn = ({ signal }) => accountingControllerList(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useAccountingControllerList(orgId, options, queryClient) {
  const queryOptions = getAccountingControllerListQueryOptions(orgId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var accountingControllerCreate = (orgId, createAccountingExportDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/accounting-exports`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createAccountingExportDto,
      ...signal ? { signal } : {}
    }
  );
};
var getAccountingControllerCreateMutationKey = () => ["accountingControllerCreate"];
var getAccountingControllerCreateMutationOptions = (options) => {
  const mutationKey = getAccountingControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return accountingControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useAccountingControllerCreate = (options, queryClient) => {
  return useMutation10(getAccountingControllerCreateMutationOptions(options), queryClient);
};
var accountingControllerDownloadUrl = (orgId, exportId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/accounting-exports/${exportId}/download-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getAccountingControllerDownloadUrlQueryKey = (orgId, exportId) => {
  return [
    `/api/v1/orgs/${orgId}/accounting-exports/${exportId}/download-url`
  ];
};
var getAccountingControllerDownloadUrlQueryOptions = (orgId, exportId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAccountingControllerDownloadUrlQueryKey(orgId, exportId);
  const queryFn = ({ signal }) => accountingControllerDownloadUrl(orgId, exportId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && exportId !== null && exportId !== void 0, ...queryOptions };
};
function useAccountingControllerDownloadUrl(orgId, exportId, options, queryClient) {
  const queryOptions = getAccountingControllerDownloadUrlQueryOptions(orgId, exportId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var lateInterestControllerRates = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tmm-rates`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getLateInterestControllerRatesQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/tmm-rates`
  ];
};
var getLateInterestControllerRatesQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getLateInterestControllerRatesQueryKey(orgId);
  const queryFn = ({ signal }) => lateInterestControllerRates(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useLateInterestControllerRates(orgId, options, queryClient) {
  const queryOptions = getLateInterestControllerRatesQueryOptions(orgId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var lateInterestControllerSetRate = (orgId, period, setTmmRateDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tmm-rates/${period}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: setTmmRateDto,
      ...signal ? { signal } : {}
    }
  );
};
var getLateInterestControllerSetRateMutationKey = () => ["lateInterestControllerSetRate"];
var getLateInterestControllerSetRateMutationOptions = (options) => {
  const mutationKey = getLateInterestControllerSetRateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, period, data } = props ?? {};
    return lateInterestControllerSetRate(orgId, period, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useLateInterestControllerSetRate = (options, queryClient) => {
  return useMutation10(getLateInterestControllerSetRateMutationOptions(options), queryClient);
};
var lateInterestControllerDeleteRate = (orgId, period, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tmm-rates/${period}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getLateInterestControllerDeleteRateMutationKey = () => ["lateInterestControllerDeleteRate"];
var getLateInterestControllerDeleteRateMutationOptions = (options) => {
  const mutationKey = getLateInterestControllerDeleteRateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, period } = props ?? {};
    return lateInterestControllerDeleteRate(orgId, period);
  };
  return { mutationFn, ...mutationOptions };
};
var useLateInterestControllerDeleteRate = (options, queryClient) => {
  return useMutation10(getLateInterestControllerDeleteRateMutationOptions(options), queryClient);
};
var lateInterestControllerEstimate = (orgId, invoiceId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoices/${invoiceId}/late-interest`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getLateInterestControllerEstimateQueryKey = (orgId, invoiceId, params) => {
  return [
    `/api/v1/orgs/${orgId}/invoices/${invoiceId}/late-interest`,
    ...params ? [params] : []
  ];
};
var getLateInterestControllerEstimateQueryOptions = (orgId, invoiceId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getLateInterestControllerEstimateQueryKey(orgId, invoiceId, params);
  const queryFn = ({ signal }) => lateInterestControllerEstimate(orgId, invoiceId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && invoiceId !== null && invoiceId !== void 0, ...queryOptions };
};
function useLateInterestControllerEstimate(orgId, invoiceId, params, options, queryClient) {
  const queryOptions = getLateInterestControllerEstimateQueryOptions(orgId, invoiceId, params, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var managementControllerDashboard = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/management/dashboard`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getManagementControllerDashboardQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/management/dashboard`
  ];
};
var getManagementControllerDashboardQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getManagementControllerDashboardQueryKey(orgId);
  const queryFn = ({ signal }) => managementControllerDashboard(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useManagementControllerDashboard(orgId, options, queryClient) {
  const queryOptions = getManagementControllerDashboardQueryOptions(orgId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var managementControllerForecast = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/treasury/forecast`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getManagementControllerForecastQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/treasury/forecast`
  ];
};
var getManagementControllerForecastQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getManagementControllerForecastQueryKey(orgId);
  const queryFn = ({ signal }) => managementControllerForecast(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useManagementControllerForecast(orgId, options, queryClient) {
  const queryOptions = getManagementControllerForecastQueryOptions(orgId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var fiscalSettingsControllerListProfiles = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/fiscal-profiles`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getFiscalSettingsControllerListProfilesQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/fiscal-profiles`
  ];
};
var getFiscalSettingsControllerListProfilesQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getFiscalSettingsControllerListProfilesQueryKey(orgId);
  const queryFn = ({ signal }) => fiscalSettingsControllerListProfiles(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useFiscalSettingsControllerListProfiles(orgId, options, queryClient) {
  const queryOptions = getFiscalSettingsControllerListProfilesQueryOptions(orgId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var fiscalSettingsControllerCreateProfile = (orgId, createFiscalProfileDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/fiscal-profiles`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createFiscalProfileDto,
      ...signal ? { signal } : {}
    }
  );
};
var getFiscalSettingsControllerCreateProfileMutationKey = () => ["fiscalSettingsControllerCreateProfile"];
var getFiscalSettingsControllerCreateProfileMutationOptions = (options) => {
  const mutationKey = getFiscalSettingsControllerCreateProfileMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return fiscalSettingsControllerCreateProfile(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useFiscalSettingsControllerCreateProfile = (options, queryClient) => {
  return useMutation10(getFiscalSettingsControllerCreateProfileMutationOptions(options), queryClient);
};
var fiscalSettingsControllerRevealBankDetails = (orgId, profileId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/fiscal-profiles/${profileId}/bank-details`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getFiscalSettingsControllerRevealBankDetailsQueryKey = (orgId, profileId) => {
  return [
    `/api/v1/orgs/${orgId}/fiscal-profiles/${profileId}/bank-details`
  ];
};
var getFiscalSettingsControllerRevealBankDetailsQueryOptions = (orgId, profileId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getFiscalSettingsControllerRevealBankDetailsQueryKey(orgId, profileId);
  const queryFn = ({ signal }) => fiscalSettingsControllerRevealBankDetails(orgId, profileId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && profileId !== null && profileId !== void 0, ...queryOptions };
};
function useFiscalSettingsControllerRevealBankDetails(orgId, profileId, options, queryClient) {
  const queryOptions = getFiscalSettingsControllerRevealBankDetailsQueryOptions(orgId, profileId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var fiscalSettingsControllerListSeries = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoice-series`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getFiscalSettingsControllerListSeriesQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/invoice-series`
  ];
};
var getFiscalSettingsControllerListSeriesQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getFiscalSettingsControllerListSeriesQueryKey(orgId);
  const queryFn = ({ signal }) => fiscalSettingsControllerListSeries(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useFiscalSettingsControllerListSeries(orgId, options, queryClient) {
  const queryOptions = getFiscalSettingsControllerListSeriesQueryOptions(orgId, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var fiscalSettingsControllerCreateSeries = (orgId, createInvoiceSeriesDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoice-series`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createInvoiceSeriesDto,
      ...signal ? { signal } : {}
    }
  );
};
var getFiscalSettingsControllerCreateSeriesMutationKey = () => ["fiscalSettingsControllerCreateSeries"];
var getFiscalSettingsControllerCreateSeriesMutationOptions = (options) => {
  const mutationKey = getFiscalSettingsControllerCreateSeriesMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return fiscalSettingsControllerCreateSeries(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useFiscalSettingsControllerCreateSeries = (options, queryClient) => {
  return useMutation10(getFiscalSettingsControllerCreateSeriesMutationOptions(options), queryClient);
};
var fiscalSettingsControllerUpdateSeries = (orgId, seriesId, updateInvoiceSeriesDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoice-series/${seriesId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateInvoiceSeriesDto,
      ...signal ? { signal } : {}
    }
  );
};
var getFiscalSettingsControllerUpdateSeriesMutationKey = () => ["fiscalSettingsControllerUpdateSeries"];
var getFiscalSettingsControllerUpdateSeriesMutationOptions = (options) => {
  const mutationKey = getFiscalSettingsControllerUpdateSeriesMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, seriesId, data } = props ?? {};
    return fiscalSettingsControllerUpdateSeries(orgId, seriesId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useFiscalSettingsControllerUpdateSeries = (options, queryClient) => {
  return useMutation10(getFiscalSettingsControllerUpdateSeriesMutationOptions(options), queryClient);
};
var fiscalSettingsControllerDeleteSeries = (orgId, seriesId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invoice-series/${seriesId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getFiscalSettingsControllerDeleteSeriesMutationKey = () => ["fiscalSettingsControllerDeleteSeries"];
var getFiscalSettingsControllerDeleteSeriesMutationOptions = (options) => {
  const mutationKey = getFiscalSettingsControllerDeleteSeriesMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, seriesId } = props ?? {};
    return fiscalSettingsControllerDeleteSeries(orgId, seriesId);
  };
  return { mutationFn, ...mutationOptions };
};
var useFiscalSettingsControllerDeleteSeries = (options, queryClient) => {
  return useMutation10(getFiscalSettingsControllerDeleteSeriesMutationOptions(options), queryClient);
};
var financeControllerCurrentRuleSet = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/tax-rule-sets/current`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getFinanceControllerCurrentRuleSetQueryKey = (params) => {
  return [
    `/api/v1/tax-rule-sets/current`,
    ...params ? [params] : []
  ];
};
var getFinanceControllerCurrentRuleSetQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getFinanceControllerCurrentRuleSetQueryKey(params);
  const queryFn = ({ signal }) => financeControllerCurrentRuleSet(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useFinanceControllerCurrentRuleSet(params, options, queryClient) {
  const queryOptions = getFinanceControllerCurrentRuleSetQueryOptions(params, options);
  const query = useQuery10(queryOptions, queryClient);
  return withQueryKey10(query, queryOptions.queryKey);
}
var financeControllerPreview = (orgId, financePreviewRequestDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/finance/preview`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: financePreviewRequestDto,
      ...signal ? { signal } : {}
    }
  );
};
var getFinanceControllerPreviewMutationKey = () => ["financeControllerPreview"];
var getFinanceControllerPreviewMutationOptions = (options) => {
  const mutationKey = getFinanceControllerPreviewMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return financeControllerPreview(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useFinanceControllerPreview = (options, queryClient) => {
  return useMutation10(getFinanceControllerPreviewMutationOptions(options), queryClient);
};

// src/generated/endpoints/health/health.ts
import {
  useQuery as useQuery11
} from "@tanstack/react-query";
var withQueryKey11 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var healthControllerLive = (signal) => {
  return apiRequest(
    {
      url: `/api/health/live`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getHealthControllerLiveQueryKey = () => {
  return [
    `/api/health/live`
  ];
};
var getHealthControllerLiveQueryOptions = (options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getHealthControllerLiveQueryKey();
  const queryFn = ({ signal }) => healthControllerLive(signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useHealthControllerLive(options, queryClient) {
  const queryOptions = getHealthControllerLiveQueryOptions(options);
  const query = useQuery11(queryOptions, queryClient);
  return withQueryKey11(query, queryOptions.queryKey);
}
var healthControllerReady = (signal) => {
  return apiRequest(
    {
      url: `/api/health/ready`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getHealthControllerReadyQueryKey = () => {
  return [
    `/api/health/ready`
  ];
};
var getHealthControllerReadyQueryOptions = (options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getHealthControllerReadyQueryKey();
  const queryFn = ({ signal }) => healthControllerReady(signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useHealthControllerReady(options, queryClient) {
  const queryOptions = getHealthControllerReadyQueryOptions(options);
  const query = useQuery11(queryOptions, queryClient);
  return withQueryKey11(query, queryOptions.queryKey);
}

// src/generated/endpoints/me/me.ts
import {
  useMutation as useMutation11,
  useQuery as useQuery12
} from "@tanstack/react-query";
var withQueryKey12 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var meControllerCurrent = (signal) => {
  return apiRequest(
    {
      url: `/api/v1/me`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getMeControllerCurrentQueryKey = () => {
  return [
    `/api/v1/me`
  ];
};
var getMeControllerCurrentQueryOptions = (options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMeControllerCurrentQueryKey();
  const queryFn = ({ signal }) => meControllerCurrent(signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useMeControllerCurrent(options, queryClient) {
  const queryOptions = getMeControllerCurrentQueryOptions(options);
  const query = useQuery12(queryOptions, queryClient);
  return withQueryKey12(query, queryOptions.queryKey);
}
var meControllerSessions = (signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/sessions`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getMeControllerSessionsQueryKey = () => {
  return [
    `/api/v1/me/sessions`
  ];
};
var getMeControllerSessionsQueryOptions = (options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMeControllerSessionsQueryKey();
  const queryFn = ({ signal }) => meControllerSessions(signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useMeControllerSessions(options, queryClient) {
  const queryOptions = getMeControllerSessionsQueryOptions(options);
  const query = useQuery12(queryOptions, queryClient);
  return withQueryKey12(query, queryOptions.queryKey);
}
var meControllerRevoke = (sessionId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/sessions/${sessionId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getMeControllerRevokeMutationKey = () => ["meControllerRevoke"];
var getMeControllerRevokeMutationOptions = (options) => {
  const mutationKey = getMeControllerRevokeMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { sessionId } = props ?? {};
    return meControllerRevoke(sessionId);
  };
  return { mutationFn, ...mutationOptions };
};
var useMeControllerRevoke = (options, queryClient) => {
  return useMutation11(getMeControllerRevokeMutationOptions(options), queryClient);
};
var meControllerRevokeOthers = (signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/sessions/revoke-others`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getMeControllerRevokeOthersMutationKey = () => ["meControllerRevokeOthers"];
var getMeControllerRevokeOthersMutationOptions = (options) => {
  const mutationKey = getMeControllerRevokeOthersMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = () => {
    return meControllerRevokeOthers();
  };
  return { mutationFn, ...mutationOptions };
};
var useMeControllerRevokeOthers = (options, queryClient) => {
  return useMutation11(getMeControllerRevokeOthersMutationOptions(options), queryClient);
};
var accountSecurityControllerView = (signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/security`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getAccountSecurityControllerViewQueryKey = () => {
  return [
    `/api/v1/me/security`
  ];
};
var getAccountSecurityControllerViewQueryOptions = (options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAccountSecurityControllerViewQueryKey();
  const queryFn = ({ signal }) => accountSecurityControllerView(signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useAccountSecurityControllerView(options, queryClient) {
  const queryOptions = getAccountSecurityControllerViewQueryOptions(options);
  const query = useQuery12(queryOptions, queryClient);
  return withQueryKey12(query, queryOptions.queryKey);
}
var accountSecurityControllerChangePassword = (changePasswordRequestDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/security/password`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: changePasswordRequestDto,
      ...signal ? { signal } : {}
    }
  );
};
var getAccountSecurityControllerChangePasswordMutationKey = () => ["accountSecurityControllerChangePassword"];
var getAccountSecurityControllerChangePasswordMutationOptions = (options) => {
  const mutationKey = getAccountSecurityControllerChangePasswordMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return accountSecurityControllerChangePassword(data);
  };
  return { mutationFn, ...mutationOptions };
};
var useAccountSecurityControllerChangePassword = (options, queryClient) => {
  return useMutation11(getAccountSecurityControllerChangePasswordMutationOptions(options), queryClient);
};
var accountSecurityControllerRemoveAuthenticator = (authenticatorId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/security/authenticators/${authenticatorId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getAccountSecurityControllerRemoveAuthenticatorMutationKey = () => ["accountSecurityControllerRemoveAuthenticator"];
var getAccountSecurityControllerRemoveAuthenticatorMutationOptions = (options) => {
  const mutationKey = getAccountSecurityControllerRemoveAuthenticatorMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { authenticatorId } = props ?? {};
    return accountSecurityControllerRemoveAuthenticator(authenticatorId);
  };
  return { mutationFn, ...mutationOptions };
};
var useAccountSecurityControllerRemoveAuthenticator = (options, queryClient) => {
  return useMutation11(getAccountSecurityControllerRemoveAuthenticatorMutationOptions(options), queryClient);
};
var profileControllerUpdate = (updateProfileDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/profile`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateProfileDto,
      ...signal ? { signal } : {}
    }
  );
};
var getProfileControllerUpdateMutationKey = () => ["profileControllerUpdate"];
var getProfileControllerUpdateMutationOptions = (options) => {
  const mutationKey = getProfileControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return profileControllerUpdate(data);
  };
  return { mutationFn, ...mutationOptions };
};
var useProfileControllerUpdate = (options, queryClient) => {
  return useMutation11(getProfileControllerUpdateMutationOptions(options), queryClient);
};
var profileControllerGetPreferences = (signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/notification-preferences`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getProfileControllerGetPreferencesQueryKey = () => {
  return [
    `/api/v1/me/notification-preferences`
  ];
};
var getProfileControllerGetPreferencesQueryOptions = (options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getProfileControllerGetPreferencesQueryKey();
  const queryFn = ({ signal }) => profileControllerGetPreferences(signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useProfileControllerGetPreferences(options, queryClient) {
  const queryOptions = getProfileControllerGetPreferencesQueryOptions(options);
  const query = useQuery12(queryOptions, queryClient);
  return withQueryKey12(query, queryOptions.queryKey);
}
var profileControllerPutPreferences = (notificationPreferencesBodyDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/notification-preferences`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: notificationPreferencesBodyDto,
      ...signal ? { signal } : {}
    }
  );
};
var getProfileControllerPutPreferencesMutationKey = () => ["profileControllerPutPreferences"];
var getProfileControllerPutPreferencesMutationOptions = (options) => {
  const mutationKey = getProfileControllerPutPreferencesMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return profileControllerPutPreferences(data);
  };
  return { mutationFn, ...mutationOptions };
};
var useProfileControllerPutPreferences = (options, queryClient) => {
  return useMutation11(getProfileControllerPutPreferencesMutationOptions(options), queryClient);
};
var notificationsControllerList = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/notifications`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getNotificationsControllerListQueryKey = (params) => {
  return [
    `/api/v1/me/notifications`,
    ...params ? [params] : []
  ];
};
var getNotificationsControllerListQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getNotificationsControllerListQueryKey(params);
  const queryFn = ({ signal }) => notificationsControllerList(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useNotificationsControllerList(params, options, queryClient) {
  const queryOptions = getNotificationsControllerListQueryOptions(params, options);
  const query = useQuery12(queryOptions, queryClient);
  return withQueryKey12(query, queryOptions.queryKey);
}
var notificationsControllerMarkRead = (markNotificationsReadDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/notifications/read`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: markNotificationsReadDto,
      ...signal ? { signal } : {}
    }
  );
};
var getNotificationsControllerMarkReadMutationKey = () => ["notificationsControllerMarkRead"];
var getNotificationsControllerMarkReadMutationOptions = (options) => {
  const mutationKey = getNotificationsControllerMarkReadMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return notificationsControllerMarkRead(data);
  };
  return { mutationFn, ...mutationOptions };
};
var useNotificationsControllerMarkRead = (options, queryClient) => {
  return useMutation11(getNotificationsControllerMarkReadMutationOptions(options), queryClient);
};
var notificationsControllerActivity = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/activity`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getNotificationsControllerActivityQueryKey = (params) => {
  return [
    `/api/v1/me/activity`,
    ...params ? [params] : []
  ];
};
var getNotificationsControllerActivityQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getNotificationsControllerActivityQueryKey(params);
  const queryFn = ({ signal }) => notificationsControllerActivity(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useNotificationsControllerActivity(params, options, queryClient) {
  const queryOptions = getNotificationsControllerActivityQueryOptions(params, options);
  const query = useQuery12(queryOptions, queryClient);
  return withQueryKey12(query, queryOptions.queryKey);
}

// src/generated/endpoints/meetings/meetings.ts
import {
  useMutation as useMutation12,
  useQuery as useQuery13
} from "@tanstack/react-query";
var withQueryKey13 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var spaceMeetingsControllerCreate = (spaceId, createMeetingDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/meetings`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createMeetingDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSpaceMeetingsControllerCreateMutationKey = () => ["spaceMeetingsControllerCreate"];
var getSpaceMeetingsControllerCreateMutationOptions = (options) => {
  const mutationKey = getSpaceMeetingsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return spaceMeetingsControllerCreate(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSpaceMeetingsControllerCreate = (options, queryClient) => {
  return useMutation12(getSpaceMeetingsControllerCreateMutationOptions(options), queryClient);
};
var spaceMeetingsControllerList = (spaceId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/meetings`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getSpaceMeetingsControllerListQueryKey = (spaceId, params) => {
  return [
    `/api/v1/spaces/${spaceId}/meetings`,
    ...params ? [params] : []
  ];
};
var getSpaceMeetingsControllerListQueryOptions = (spaceId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSpaceMeetingsControllerListQueryKey(spaceId, params);
  const queryFn = ({ signal }) => spaceMeetingsControllerList(spaceId, params, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useSpaceMeetingsControllerList(spaceId, params, options, queryClient) {
  const queryOptions = getSpaceMeetingsControllerListQueryOptions(spaceId, params, options);
  const query = useQuery13(queryOptions, queryClient);
  return withQueryKey13(query, queryOptions.queryKey);
}
var orgCallsControllerStart = (orgId, startCallDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/calls`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: startCallDto,
      ...signal ? { signal } : {}
    }
  );
};
var getOrgCallsControllerStartMutationKey = () => ["orgCallsControllerStart"];
var getOrgCallsControllerStartMutationOptions = (options) => {
  const mutationKey = getOrgCallsControllerStartMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return orgCallsControllerStart(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrgCallsControllerStart = (options, queryClient) => {
  return useMutation12(getOrgCallsControllerStartMutationOptions(options), queryClient);
};
var orgMeetingsControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/meetings`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getOrgMeetingsControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/meetings`,
    ...params ? [params] : []
  ];
};
var getOrgMeetingsControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getOrgMeetingsControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => orgMeetingsControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useOrgMeetingsControllerList(orgId, params, options, queryClient) {
  const queryOptions = getOrgMeetingsControllerListQueryOptions(orgId, params, options);
  const query = useQuery13(queryOptions, queryClient);
  return withQueryKey13(query, queryOptions.queryKey);
}
var channelMeetingsControllerList = (channelId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/channels/${channelId}/meetings`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getChannelMeetingsControllerListQueryKey = (channelId, params) => {
  return [
    `/api/v1/channels/${channelId}/meetings`,
    ...params ? [params] : []
  ];
};
var getChannelMeetingsControllerListQueryOptions = (channelId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getChannelMeetingsControllerListQueryKey(channelId, params);
  const queryFn = ({ signal }) => channelMeetingsControllerList(channelId, params, signal);
  return { queryKey, queryFn, enabled: channelId !== null && channelId !== void 0, ...queryOptions };
};
function useChannelMeetingsControllerList(channelId, params, options, queryClient) {
  const queryOptions = getChannelMeetingsControllerListQueryOptions(channelId, params, options);
  const query = useQuery13(queryOptions, queryClient);
  return withQueryKey13(query, queryOptions.queryKey);
}
var meetingsControllerGet = (meetingId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/meetings/${meetingId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getMeetingsControllerGetQueryKey = (meetingId) => {
  return [
    `/api/v1/meetings/${meetingId}`
  ];
};
var getMeetingsControllerGetQueryOptions = (meetingId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMeetingsControllerGetQueryKey(meetingId);
  const queryFn = ({ signal }) => meetingsControllerGet(meetingId, signal);
  return { queryKey, queryFn, enabled: meetingId !== null && meetingId !== void 0, ...queryOptions };
};
function useMeetingsControllerGet(meetingId, options, queryClient) {
  const queryOptions = getMeetingsControllerGetQueryOptions(meetingId, options);
  const query = useQuery13(queryOptions, queryClient);
  return withQueryKey13(query, queryOptions.queryKey);
}
var meetingsControllerToken = (meetingId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/meetings/${meetingId}/token`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getMeetingsControllerTokenMutationKey = () => ["meetingsControllerToken"];
var getMeetingsControllerTokenMutationOptions = (options) => {
  const mutationKey = getMeetingsControllerTokenMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { meetingId } = props ?? {};
    return meetingsControllerToken(meetingId);
  };
  return { mutationFn, ...mutationOptions };
};
var useMeetingsControllerToken = (options, queryClient) => {
  return useMutation12(getMeetingsControllerTokenMutationOptions(options), queryClient);
};
var meetingsControllerInviteMembers = (meetingId, inviteParticipantsDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/meetings/${meetingId}/participants`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: inviteParticipantsDto,
      ...signal ? { signal } : {}
    }
  );
};
var getMeetingsControllerInviteMembersMutationKey = () => ["meetingsControllerInviteMembers"];
var getMeetingsControllerInviteMembersMutationOptions = (options) => {
  const mutationKey = getMeetingsControllerInviteMembersMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { meetingId, data } = props ?? {};
    return meetingsControllerInviteMembers(meetingId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useMeetingsControllerInviteMembers = (options, queryClient) => {
  return useMutation12(getMeetingsControllerInviteMembersMutationOptions(options), queryClient);
};
var meetingsControllerInvite = (meetingId, createMeetingInvitationDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/meetings/${meetingId}/invitations`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createMeetingInvitationDto,
      ...signal ? { signal } : {}
    }
  );
};
var getMeetingsControllerInviteMutationKey = () => ["meetingsControllerInvite"];
var getMeetingsControllerInviteMutationOptions = (options) => {
  const mutationKey = getMeetingsControllerInviteMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { meetingId, data } = props ?? {};
    return meetingsControllerInvite(meetingId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useMeetingsControllerInvite = (options, queryClient) => {
  return useMutation12(getMeetingsControllerInviteMutationOptions(options), queryClient);
};
var meetingInvitationsControllerPreview = (meetingInvitationTokenDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/meeting-invitations/preview`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: meetingInvitationTokenDto,
      ...signal ? { signal } : {}
    }
  );
};
var getMeetingInvitationsControllerPreviewMutationKey = () => ["meetingInvitationsControllerPreview"];
var getMeetingInvitationsControllerPreviewMutationOptions = (options) => {
  const mutationKey = getMeetingInvitationsControllerPreviewMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return meetingInvitationsControllerPreview(data);
  };
  return { mutationFn, ...mutationOptions };
};
var useMeetingInvitationsControllerPreview = (options, queryClient) => {
  return useMutation12(getMeetingInvitationsControllerPreviewMutationOptions(options), queryClient);
};
var meetingInvitationsControllerJoin = (meetingInvitationTokenDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/meeting-invitations/join`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: meetingInvitationTokenDto,
      ...signal ? { signal } : {}
    }
  );
};
var getMeetingInvitationsControllerJoinMutationKey = () => ["meetingInvitationsControllerJoin"];
var getMeetingInvitationsControllerJoinMutationOptions = (options) => {
  const mutationKey = getMeetingInvitationsControllerJoinMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return meetingInvitationsControllerJoin(data);
  };
  return { mutationFn, ...mutationOptions };
};
var useMeetingInvitationsControllerJoin = (options, queryClient) => {
  return useMutation12(getMeetingInvitationsControllerJoinMutationOptions(options), queryClient);
};
var livekitWebhookControllerReceive = (signal) => {
  return apiRequest(
    {
      url: `/api/v1/webhooks/livekit`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getLivekitWebhookControllerReceiveMutationKey = () => ["livekitWebhookControllerReceive"];
var getLivekitWebhookControllerReceiveMutationOptions = (options) => {
  const mutationKey = getLivekitWebhookControllerReceiveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = () => {
    return livekitWebhookControllerReceive();
  };
  return { mutationFn, ...mutationOptions };
};
var useLivekitWebhookControllerReceive = (options, queryClient) => {
  return useMutation12(getLivekitWebhookControllerReceiveMutationOptions(options), queryClient);
};
var minutesControllerList = (spaceId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/meeting-minutes`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getMinutesControllerListQueryKey = (spaceId, params) => {
  return [
    `/api/v1/spaces/${spaceId}/meeting-minutes`,
    ...params ? [params] : []
  ];
};
var getMinutesControllerListQueryOptions = (spaceId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMinutesControllerListQueryKey(spaceId, params);
  const queryFn = ({ signal }) => minutesControllerList(spaceId, params, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useMinutesControllerList(spaceId, params, options, queryClient) {
  const queryOptions = getMinutesControllerListQueryOptions(spaceId, params, options);
  const query = useQuery13(queryOptions, queryClient);
  return withQueryKey13(query, queryOptions.queryKey);
}
var minutesControllerCreate = (spaceId, createMinutesDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/meeting-minutes`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createMinutesDto,
      ...signal ? { signal } : {}
    }
  );
};
var getMinutesControllerCreateMutationKey = () => ["minutesControllerCreate"];
var getMinutesControllerCreateMutationOptions = (options) => {
  const mutationKey = getMinutesControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return minutesControllerCreate(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useMinutesControllerCreate = (options, queryClient) => {
  return useMutation12(getMinutesControllerCreateMutationOptions(options), queryClient);
};
var minutesControllerGet = (spaceId, minutesId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/meeting-minutes/${minutesId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getMinutesControllerGetQueryKey = (spaceId, minutesId) => {
  return [
    `/api/v1/spaces/${spaceId}/meeting-minutes/${minutesId}`
  ];
};
var getMinutesControllerGetQueryOptions = (spaceId, minutesId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMinutesControllerGetQueryKey(spaceId, minutesId);
  const queryFn = ({ signal }) => minutesControllerGet(spaceId, minutesId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && minutesId !== null && minutesId !== void 0, ...queryOptions };
};
function useMinutesControllerGet(spaceId, minutesId, options, queryClient) {
  const queryOptions = getMinutesControllerGetQueryOptions(spaceId, minutesId, options);
  const query = useQuery13(queryOptions, queryClient);
  return withQueryKey13(query, queryOptions.queryKey);
}
var minutesControllerUpdate = (spaceId, minutesId, updateMinutesDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/meeting-minutes/${minutesId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateMinutesDto,
      ...signal ? { signal } : {}
    }
  );
};
var getMinutesControllerUpdateMutationKey = () => ["minutesControllerUpdate"];
var getMinutesControllerUpdateMutationOptions = (options) => {
  const mutationKey = getMinutesControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, minutesId, data } = props ?? {};
    return minutesControllerUpdate(spaceId, minutesId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useMinutesControllerUpdate = (options, queryClient) => {
  return useMutation12(getMinutesControllerUpdateMutationOptions(options), queryClient);
};
var minutesControllerPublish = (spaceId, minutesId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/meeting-minutes/${minutesId}/publish`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getMinutesControllerPublishMutationKey = () => ["minutesControllerPublish"];
var getMinutesControllerPublishMutationOptions = (options) => {
  const mutationKey = getMinutesControllerPublishMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, minutesId } = props ?? {};
    return minutesControllerPublish(spaceId, minutesId);
  };
  return { mutationFn, ...mutationOptions };
};
var useMinutesControllerPublish = (options, queryClient) => {
  return useMutation12(getMinutesControllerPublishMutationOptions(options), queryClient);
};
var minutesControllerPdf = (spaceId, minutesId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/meeting-minutes/${minutesId}/pdf`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getMinutesControllerPdfQueryKey = (spaceId, minutesId) => {
  return [
    `/api/v1/spaces/${spaceId}/meeting-minutes/${minutesId}/pdf`
  ];
};
var getMinutesControllerPdfQueryOptions = (spaceId, minutesId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMinutesControllerPdfQueryKey(spaceId, minutesId);
  const queryFn = ({ signal }) => minutesControllerPdf(spaceId, minutesId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0 && minutesId !== null && minutesId !== void 0, ...queryOptions };
};
function useMinutesControllerPdf(spaceId, minutesId, options, queryClient) {
  const queryOptions = getMinutesControllerPdfQueryOptions(spaceId, minutesId, options);
  const query = useQuery13(queryOptions, queryClient);
  return withQueryKey13(query, queryOptions.queryKey);
}

// src/generated/endpoints/members/members.ts
import {
  useMutation as useMutation13,
  useQuery as useQuery14
} from "@tanstack/react-query";
var withQueryKey14 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var invitationsControllerList = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invitations`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getInvitationsControllerListQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/invitations`
  ];
};
var getInvitationsControllerListQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getInvitationsControllerListQueryKey(orgId);
  const queryFn = ({ signal }) => invitationsControllerList(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useInvitationsControllerList(orgId, options, queryClient) {
  const queryOptions = getInvitationsControllerListQueryOptions(orgId, options);
  const query = useQuery14(queryOptions, queryClient);
  return withQueryKey14(query, queryOptions.queryKey);
}
var invitationsControllerCreate = (orgId, createInvitationDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invitations`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createInvitationDto,
      ...signal ? { signal } : {}
    }
  );
};
var getInvitationsControllerCreateMutationKey = () => ["invitationsControllerCreate"];
var getInvitationsControllerCreateMutationOptions = (options) => {
  const mutationKey = getInvitationsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return invitationsControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useInvitationsControllerCreate = (options, queryClient) => {
  return useMutation13(getInvitationsControllerCreateMutationOptions(options), queryClient);
};
var invitationsControllerResend = (orgId, invitationId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invitations/${invitationId}/resend`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getInvitationsControllerResendMutationKey = () => ["invitationsControllerResend"];
var getInvitationsControllerResendMutationOptions = (options) => {
  const mutationKey = getInvitationsControllerResendMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, invitationId } = props ?? {};
    return invitationsControllerResend(orgId, invitationId);
  };
  return { mutationFn, ...mutationOptions };
};
var useInvitationsControllerResend = (options, queryClient) => {
  return useMutation13(getInvitationsControllerResendMutationOptions(options), queryClient);
};
var invitationsControllerRevoke = (orgId, invitationId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/invitations/${invitationId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getInvitationsControllerRevokeMutationKey = () => ["invitationsControllerRevoke"];
var getInvitationsControllerRevokeMutationOptions = (options) => {
  const mutationKey = getInvitationsControllerRevokeMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, invitationId } = props ?? {};
    return invitationsControllerRevoke(orgId, invitationId);
  };
  return { mutationFn, ...mutationOptions };
};
var useInvitationsControllerRevoke = (options, queryClient) => {
  return useMutation13(getInvitationsControllerRevokeMutationOptions(options), queryClient);
};
var invitationAcceptanceControllerPreview = (invitationTokenDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/invitations/preview`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: invitationTokenDto,
      ...signal ? { signal } : {}
    }
  );
};
var getInvitationAcceptanceControllerPreviewMutationKey = () => ["invitationAcceptanceControllerPreview"];
var getInvitationAcceptanceControllerPreviewMutationOptions = (options) => {
  const mutationKey = getInvitationAcceptanceControllerPreviewMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return invitationAcceptanceControllerPreview(data);
  };
  return { mutationFn, ...mutationOptions };
};
var useInvitationAcceptanceControllerPreview = (options, queryClient) => {
  return useMutation13(getInvitationAcceptanceControllerPreviewMutationOptions(options), queryClient);
};
var invitationAcceptanceControllerAccept = (invitationTokenDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/invitations/accept`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: invitationTokenDto,
      ...signal ? { signal } : {}
    }
  );
};
var getInvitationAcceptanceControllerAcceptMutationKey = () => ["invitationAcceptanceControllerAccept"];
var getInvitationAcceptanceControllerAcceptMutationOptions = (options) => {
  const mutationKey = getInvitationAcceptanceControllerAcceptMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return invitationAcceptanceControllerAccept(data);
  };
  return { mutationFn, ...mutationOptions };
};
var useInvitationAcceptanceControllerAccept = (options, queryClient) => {
  return useMutation13(getInvitationAcceptanceControllerAcceptMutationOptions(options), queryClient);
};
var membersControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/members`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getMembersControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/members`,
    ...params ? [params] : []
  ];
};
var getMembersControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMembersControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => membersControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useMembersControllerList(orgId, params, options, queryClient) {
  const queryOptions = getMembersControllerListQueryOptions(orgId, params, options);
  const query = useQuery14(queryOptions, queryClient);
  return withQueryKey14(query, queryOptions.queryKey);
}
var membersControllerChangeRole = (orgId, memberId, changeRoleDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/members/${memberId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: changeRoleDto,
      ...signal ? { signal } : {}
    }
  );
};
var getMembersControllerChangeRoleMutationKey = () => ["membersControllerChangeRole"];
var getMembersControllerChangeRoleMutationOptions = (options) => {
  const mutationKey = getMembersControllerChangeRoleMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, memberId, data } = props ?? {};
    return membersControllerChangeRole(orgId, memberId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useMembersControllerChangeRole = (options, queryClient) => {
  return useMutation13(getMembersControllerChangeRoleMutationOptions(options), queryClient);
};
var membersControllerTransferPlan = (orgId, memberId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/members/${memberId}/transfer-plan`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getMembersControllerTransferPlanQueryKey = (orgId, memberId) => {
  return [
    `/api/v1/orgs/${orgId}/members/${memberId}/transfer-plan`
  ];
};
var getMembersControllerTransferPlanQueryOptions = (orgId, memberId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMembersControllerTransferPlanQueryKey(orgId, memberId);
  const queryFn = ({ signal }) => membersControllerTransferPlan(orgId, memberId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && memberId !== null && memberId !== void 0, ...queryOptions };
};
function useMembersControllerTransferPlan(orgId, memberId, options, queryClient) {
  const queryOptions = getMembersControllerTransferPlanQueryOptions(orgId, memberId, options);
  const query = useQuery14(queryOptions, queryClient);
  return withQueryKey14(query, queryOptions.queryKey);
}
var membersControllerDeactivate = (orgId, memberId, deactivateMemberDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/members/${memberId}/deactivate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: deactivateMemberDto,
      ...signal ? { signal } : {}
    }
  );
};
var getMembersControllerDeactivateMutationKey = () => ["membersControllerDeactivate"];
var getMembersControllerDeactivateMutationOptions = (options) => {
  const mutationKey = getMembersControllerDeactivateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, memberId, data } = props ?? {};
    return membersControllerDeactivate(orgId, memberId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useMembersControllerDeactivate = (options, queryClient) => {
  return useMutation13(getMembersControllerDeactivateMutationOptions(options), queryClient);
};
var ownerTransferControllerState = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/owner-transfer`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getOwnerTransferControllerStateQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/owner-transfer`
  ];
};
var getOwnerTransferControllerStateQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getOwnerTransferControllerStateQueryKey(orgId);
  const queryFn = ({ signal }) => ownerTransferControllerState(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useOwnerTransferControllerState(orgId, options, queryClient) {
  const queryOptions = getOwnerTransferControllerStateQueryOptions(orgId, options);
  const query = useQuery14(queryOptions, queryClient);
  return withQueryKey14(query, queryOptions.queryKey);
}
var ownerTransferControllerPropose = (orgId, proposeOwnerTransferDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/owner-transfer`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: proposeOwnerTransferDto,
      ...signal ? { signal } : {}
    }
  );
};
var getOwnerTransferControllerProposeMutationKey = () => ["ownerTransferControllerPropose"];
var getOwnerTransferControllerProposeMutationOptions = (options) => {
  const mutationKey = getOwnerTransferControllerProposeMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return ownerTransferControllerPropose(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useOwnerTransferControllerPropose = (options, queryClient) => {
  return useMutation13(getOwnerTransferControllerProposeMutationOptions(options), queryClient);
};
var ownerTransferControllerCancel = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/owner-transfer`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getOwnerTransferControllerCancelMutationKey = () => ["ownerTransferControllerCancel"];
var getOwnerTransferControllerCancelMutationOptions = (options) => {
  const mutationKey = getOwnerTransferControllerCancelMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId } = props ?? {};
    return ownerTransferControllerCancel(orgId);
  };
  return { mutationFn, ...mutationOptions };
};
var useOwnerTransferControllerCancel = (options, queryClient) => {
  return useMutation13(getOwnerTransferControllerCancelMutationOptions(options), queryClient);
};
var ownerTransferControllerAccept = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/owner-transfer/accept`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getOwnerTransferControllerAcceptMutationKey = () => ["ownerTransferControllerAccept"];
var getOwnerTransferControllerAcceptMutationOptions = (options) => {
  const mutationKey = getOwnerTransferControllerAcceptMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId } = props ?? {};
    return ownerTransferControllerAccept(orgId);
  };
  return { mutationFn, ...mutationOptions };
};
var useOwnerTransferControllerAccept = (options, queryClient) => {
  return useMutation13(getOwnerTransferControllerAcceptMutationOptions(options), queryClient);
};
var rolesControllerList = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/roles`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getRolesControllerListQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/roles`
  ];
};
var getRolesControllerListQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getRolesControllerListQueryKey(orgId);
  const queryFn = ({ signal }) => rolesControllerList(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useRolesControllerList(orgId, options, queryClient) {
  const queryOptions = getRolesControllerListQueryOptions(orgId, options);
  const query = useQuery14(queryOptions, queryClient);
  return withQueryKey14(query, queryOptions.queryKey);
}
var rolesControllerCreate = (orgId, createRoleDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/roles`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createRoleDto,
      ...signal ? { signal } : {}
    }
  );
};
var getRolesControllerCreateMutationKey = () => ["rolesControllerCreate"];
var getRolesControllerCreateMutationOptions = (options) => {
  const mutationKey = getRolesControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return rolesControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useRolesControllerCreate = (options, queryClient) => {
  return useMutation13(getRolesControllerCreateMutationOptions(options), queryClient);
};
var rolesControllerUpdate = (orgId, roleId, updateRoleDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/roles/${roleId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateRoleDto,
      ...signal ? { signal } : {}
    }
  );
};
var getRolesControllerUpdateMutationKey = () => ["rolesControllerUpdate"];
var getRolesControllerUpdateMutationOptions = (options) => {
  const mutationKey = getRolesControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, roleId, data } = props ?? {};
    return rolesControllerUpdate(orgId, roleId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useRolesControllerUpdate = (options, queryClient) => {
  return useMutation13(getRolesControllerUpdateMutationOptions(options), queryClient);
};
var rolesControllerRemove = (orgId, roleId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/roles/${roleId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getRolesControllerRemoveMutationKey = () => ["rolesControllerRemove"];
var getRolesControllerRemoveMutationOptions = (options) => {
  const mutationKey = getRolesControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, roleId } = props ?? {};
    return rolesControllerRemove(orgId, roleId);
  };
  return { mutationFn, ...mutationOptions };
};
var useRolesControllerRemove = (options, queryClient) => {
  return useMutation13(getRolesControllerRemoveMutationOptions(options), queryClient);
};

// src/generated/endpoints/messaging/messaging.ts
import {
  useMutation as useMutation14,
  useQuery as useQuery15
} from "@tanstack/react-query";
var withQueryKey15 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var spaceChannelsControllerList = (spaceId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/channels`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getSpaceChannelsControllerListQueryKey = (spaceId, params) => {
  return [
    `/api/v1/spaces/${spaceId}/channels`,
    ...params ? [params] : []
  ];
};
var getSpaceChannelsControllerListQueryOptions = (spaceId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSpaceChannelsControllerListQueryKey(spaceId, params);
  const queryFn = ({ signal }) => spaceChannelsControllerList(spaceId, params, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useSpaceChannelsControllerList(spaceId, params, options, queryClient) {
  const queryOptions = getSpaceChannelsControllerListQueryOptions(spaceId, params, options);
  const query = useQuery15(queryOptions, queryClient);
  return withQueryKey15(query, queryOptions.queryKey);
}
var spaceChannelsControllerCreate = (spaceId, createSpaceChannelDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/channels`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createSpaceChannelDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSpaceChannelsControllerCreateMutationKey = () => ["spaceChannelsControllerCreate"];
var getSpaceChannelsControllerCreateMutationOptions = (options) => {
  const mutationKey = getSpaceChannelsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return spaceChannelsControllerCreate(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSpaceChannelsControllerCreate = (options, queryClient) => {
  return useMutation14(getSpaceChannelsControllerCreateMutationOptions(options), queryClient);
};
var orgChannelsControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/channels`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getOrgChannelsControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/channels`,
    ...params ? [params] : []
  ];
};
var getOrgChannelsControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getOrgChannelsControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => orgChannelsControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useOrgChannelsControllerList(orgId, params, options, queryClient) {
  const queryOptions = getOrgChannelsControllerListQueryOptions(orgId, params, options);
  const query = useQuery15(queryOptions, queryClient);
  return withQueryKey15(query, queryOptions.queryKey);
}
var orgChannelsControllerCreate = (orgId, createOrgChannelDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/channels`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createOrgChannelDto,
      ...signal ? { signal } : {}
    }
  );
};
var getOrgChannelsControllerCreateMutationKey = () => ["orgChannelsControllerCreate"];
var getOrgChannelsControllerCreateMutationOptions = (options) => {
  const mutationKey = getOrgChannelsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return orgChannelsControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrgChannelsControllerCreate = (options, queryClient) => {
  return useMutation14(getOrgChannelsControllerCreateMutationOptions(options), queryClient);
};
var orgChannelsControllerUnread = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/channels/unread`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getOrgChannelsControllerUnreadQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/channels/unread`
  ];
};
var getOrgChannelsControllerUnreadQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getOrgChannelsControllerUnreadQueryKey(orgId);
  const queryFn = ({ signal }) => orgChannelsControllerUnread(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useOrgChannelsControllerUnread(orgId, options, queryClient) {
  const queryOptions = getOrgChannelsControllerUnreadQueryOptions(orgId, options);
  const query = useQuery15(queryOptions, queryClient);
  return withQueryKey15(query, queryOptions.queryKey);
}
var channelControllerGet = (channelId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/channels/${channelId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getChannelControllerGetQueryKey = (channelId) => {
  return [
    `/api/v1/channels/${channelId}`
  ];
};
var getChannelControllerGetQueryOptions = (channelId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getChannelControllerGetQueryKey(channelId);
  const queryFn = ({ signal }) => channelControllerGet(channelId, signal);
  return { queryKey, queryFn, enabled: channelId !== null && channelId !== void 0, ...queryOptions };
};
function useChannelControllerGet(channelId, options, queryClient) {
  const queryOptions = getChannelControllerGetQueryOptions(channelId, options);
  const query = useQuery15(queryOptions, queryClient);
  return withQueryKey15(query, queryOptions.queryKey);
}
var channelControllerUpdate = (channelId, updateChannelDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/channels/${channelId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateChannelDto,
      ...signal ? { signal } : {}
    }
  );
};
var getChannelControllerUpdateMutationKey = () => ["channelControllerUpdate"];
var getChannelControllerUpdateMutationOptions = (options) => {
  const mutationKey = getChannelControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { channelId, data } = props ?? {};
    return channelControllerUpdate(channelId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useChannelControllerUpdate = (options, queryClient) => {
  return useMutation14(getChannelControllerUpdateMutationOptions(options), queryClient);
};
var channelControllerAttachmentsFolder = (channelId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/channels/${channelId}/attachments-folder`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getChannelControllerAttachmentsFolderMutationKey = () => ["channelControllerAttachmentsFolder"];
var getChannelControllerAttachmentsFolderMutationOptions = (options) => {
  const mutationKey = getChannelControllerAttachmentsFolderMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { channelId } = props ?? {};
    return channelControllerAttachmentsFolder(channelId);
  };
  return { mutationFn, ...mutationOptions };
};
var useChannelControllerAttachmentsFolder = (options, queryClient) => {
  return useMutation14(getChannelControllerAttachmentsFolderMutationOptions(options), queryClient);
};
var channelControllerMarkRead = (channelId, markChannelReadDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/channels/${channelId}/read`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: markChannelReadDto,
      ...signal ? { signal } : {}
    }
  );
};
var getChannelControllerMarkReadMutationKey = () => ["channelControllerMarkRead"];
var getChannelControllerMarkReadMutationOptions = (options) => {
  const mutationKey = getChannelControllerMarkReadMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { channelId, data } = props ?? {};
    return channelControllerMarkRead(channelId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useChannelControllerMarkRead = (options, queryClient) => {
  return useMutation14(getChannelControllerMarkReadMutationOptions(options), queryClient);
};
var channelMessagesControllerList = (channelId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/channels/${channelId}/messages`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getChannelMessagesControllerListQueryKey = (channelId, params) => {
  return [
    `/api/v1/channels/${channelId}/messages`,
    ...params ? [params] : []
  ];
};
var getChannelMessagesControllerListQueryOptions = (channelId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getChannelMessagesControllerListQueryKey(channelId, params);
  const queryFn = ({ signal }) => channelMessagesControllerList(channelId, params, signal);
  return { queryKey, queryFn, enabled: channelId !== null && channelId !== void 0, ...queryOptions };
};
function useChannelMessagesControllerList(channelId, params, options, queryClient) {
  const queryOptions = getChannelMessagesControllerListQueryOptions(channelId, params, options);
  const query = useQuery15(queryOptions, queryClient);
  return withQueryKey15(query, queryOptions.queryKey);
}
var channelMessagesControllerCreate = (channelId, createMessageDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/channels/${channelId}/messages`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createMessageDto,
      ...signal ? { signal } : {}
    }
  );
};
var getChannelMessagesControllerCreateMutationKey = () => ["channelMessagesControllerCreate"];
var getChannelMessagesControllerCreateMutationOptions = (options) => {
  const mutationKey = getChannelMessagesControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { channelId, data } = props ?? {};
    return channelMessagesControllerCreate(channelId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useChannelMessagesControllerCreate = (options, queryClient) => {
  return useMutation14(getChannelMessagesControllerCreateMutationOptions(options), queryClient);
};
var messageControllerGet = (messageId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/messages/${messageId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getMessageControllerGetQueryKey = (messageId) => {
  return [
    `/api/v1/messages/${messageId}`
  ];
};
var getMessageControllerGetQueryOptions = (messageId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMessageControllerGetQueryKey(messageId);
  const queryFn = ({ signal }) => messageControllerGet(messageId, signal);
  return { queryKey, queryFn, enabled: messageId !== null && messageId !== void 0, ...queryOptions };
};
function useMessageControllerGet(messageId, options, queryClient) {
  const queryOptions = getMessageControllerGetQueryOptions(messageId, options);
  const query = useQuery15(queryOptions, queryClient);
  return withQueryKey15(query, queryOptions.queryKey);
}
var messageControllerUpdate = (messageId, updateMessageDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/messages/${messageId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateMessageDto,
      ...signal ? { signal } : {}
    }
  );
};
var getMessageControllerUpdateMutationKey = () => ["messageControllerUpdate"];
var getMessageControllerUpdateMutationOptions = (options) => {
  const mutationKey = getMessageControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { messageId, data } = props ?? {};
    return messageControllerUpdate(messageId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useMessageControllerUpdate = (options, queryClient) => {
  return useMutation14(getMessageControllerUpdateMutationOptions(options), queryClient);
};
var messageControllerRemove = (messageId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/messages/${messageId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getMessageControllerRemoveMutationKey = () => ["messageControllerRemove"];
var getMessageControllerRemoveMutationOptions = (options) => {
  const mutationKey = getMessageControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { messageId } = props ?? {};
    return messageControllerRemove(messageId);
  };
  return { mutationFn, ...mutationOptions };
};
var useMessageControllerRemove = (options, queryClient) => {
  return useMutation14(getMessageControllerRemoveMutationOptions(options), queryClient);
};
var messageControllerEdits = (messageId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/messages/${messageId}/edits`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getMessageControllerEditsQueryKey = (messageId, params) => {
  return [
    `/api/v1/messages/${messageId}/edits`,
    ...params ? [params] : []
  ];
};
var getMessageControllerEditsQueryOptions = (messageId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMessageControllerEditsQueryKey(messageId, params);
  const queryFn = ({ signal }) => messageControllerEdits(messageId, params, signal);
  return { queryKey, queryFn, enabled: messageId !== null && messageId !== void 0, ...queryOptions };
};
function useMessageControllerEdits(messageId, params, options, queryClient) {
  const queryOptions = getMessageControllerEditsQueryOptions(messageId, params, options);
  const query = useQuery15(queryOptions, queryClient);
  return withQueryKey15(query, queryOptions.queryKey);
}
var messageReactionsControllerAdd = (messageId, addReactionDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/messages/${messageId}/reactions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: addReactionDto,
      ...signal ? { signal } : {}
    }
  );
};
var getMessageReactionsControllerAddMutationKey = () => ["messageReactionsControllerAdd"];
var getMessageReactionsControllerAddMutationOptions = (options) => {
  const mutationKey = getMessageReactionsControllerAddMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { messageId, data } = props ?? {};
    return messageReactionsControllerAdd(messageId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useMessageReactionsControllerAdd = (options, queryClient) => {
  return useMutation14(getMessageReactionsControllerAddMutationOptions(options), queryClient);
};
var messageReactionsControllerRemove = (messageId, emoji, signal) => {
  return apiRequest(
    {
      url: `/api/v1/messages/${messageId}/reactions/${emoji}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getMessageReactionsControllerRemoveMutationKey = () => ["messageReactionsControllerRemove"];
var getMessageReactionsControllerRemoveMutationOptions = (options) => {
  const mutationKey = getMessageReactionsControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { messageId, emoji } = props ?? {};
    return messageReactionsControllerRemove(messageId, emoji);
  };
  return { mutationFn, ...mutationOptions };
};
var useMessageReactionsControllerRemove = (options, queryClient) => {
  return useMutation14(getMessageReactionsControllerRemoveMutationOptions(options), queryClient);
};
var channelPinsControllerList = (channelId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/channels/${channelId}/pins`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getChannelPinsControllerListQueryKey = (channelId) => {
  return [
    `/api/v1/channels/${channelId}/pins`
  ];
};
var getChannelPinsControllerListQueryOptions = (channelId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getChannelPinsControllerListQueryKey(channelId);
  const queryFn = ({ signal }) => channelPinsControllerList(channelId, signal);
  return { queryKey, queryFn, enabled: channelId !== null && channelId !== void 0, ...queryOptions };
};
function useChannelPinsControllerList(channelId, options, queryClient) {
  const queryOptions = getChannelPinsControllerListQueryOptions(channelId, options);
  const query = useQuery15(queryOptions, queryClient);
  return withQueryKey15(query, queryOptions.queryKey);
}
var channelPinsControllerPin = (channelId, pinMessageDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/channels/${channelId}/pins`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: pinMessageDto,
      ...signal ? { signal } : {}
    }
  );
};
var getChannelPinsControllerPinMutationKey = () => ["channelPinsControllerPin"];
var getChannelPinsControllerPinMutationOptions = (options) => {
  const mutationKey = getChannelPinsControllerPinMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { channelId, data } = props ?? {};
    return channelPinsControllerPin(channelId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useChannelPinsControllerPin = (options, queryClient) => {
  return useMutation14(getChannelPinsControllerPinMutationOptions(options), queryClient);
};
var channelPinsControllerUnpin = (channelId, messageId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/channels/${channelId}/pins/${messageId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getChannelPinsControllerUnpinMutationKey = () => ["channelPinsControllerUnpin"];
var getChannelPinsControllerUnpinMutationOptions = (options) => {
  const mutationKey = getChannelPinsControllerUnpinMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { channelId, messageId } = props ?? {};
    return channelPinsControllerUnpin(channelId, messageId);
  };
  return { mutationFn, ...mutationOptions };
};
var useChannelPinsControllerUnpin = (options, queryClient) => {
  return useMutation14(getChannelPinsControllerUnpinMutationOptions(options), queryClient);
};

// src/generated/endpoints/organizations/organizations.ts
import {
  useMutation as useMutation15,
  useQuery as useQuery16
} from "@tanstack/react-query";
var withQueryKey16 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var organizationsControllerCreateOrganization = (createOrganizationDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createOrganizationDto,
      ...signal ? { signal } : {}
    }
  );
};
var getOrganizationsControllerCreateOrganizationMutationKey = () => ["organizationsControllerCreateOrganization"];
var getOrganizationsControllerCreateOrganizationMutationOptions = (options) => {
  const mutationKey = getOrganizationsControllerCreateOrganizationMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return organizationsControllerCreateOrganization(data);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrganizationsControllerCreateOrganization = (options, queryClient) => {
  return useMutation15(getOrganizationsControllerCreateOrganizationMutationOptions(options), queryClient);
};
var organizationsControllerGet = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getOrganizationsControllerGetQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}`
  ];
};
var getOrganizationsControllerGetQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getOrganizationsControllerGetQueryKey(orgId);
  const queryFn = ({ signal }) => organizationsControllerGet(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useOrganizationsControllerGet(orgId, options, queryClient) {
  const queryOptions = getOrganizationsControllerGetQueryOptions(orgId, options);
  const query = useQuery16(queryOptions, queryClient);
  return withQueryKey16(query, queryOptions.queryKey);
}
var organizationSettingsControllerUpdateProfile = (orgId, updateOrganizationDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateOrganizationDto,
      ...signal ? { signal } : {}
    }
  );
};
var getOrganizationSettingsControllerUpdateProfileMutationKey = () => ["organizationSettingsControllerUpdateProfile"];
var getOrganizationSettingsControllerUpdateProfileMutationOptions = (options) => {
  const mutationKey = getOrganizationSettingsControllerUpdateProfileMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return organizationSettingsControllerUpdateProfile(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrganizationSettingsControllerUpdateProfile = (options, queryClient) => {
  return useMutation15(getOrganizationSettingsControllerUpdateProfileMutationOptions(options), queryClient);
};
var organizationSettingsControllerPolicies = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/policies`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getOrganizationSettingsControllerPoliciesQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/policies`
  ];
};
var getOrganizationSettingsControllerPoliciesQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getOrganizationSettingsControllerPoliciesQueryKey(orgId);
  const queryFn = ({ signal }) => organizationSettingsControllerPolicies(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useOrganizationSettingsControllerPolicies(orgId, options, queryClient) {
  const queryOptions = getOrganizationSettingsControllerPoliciesQueryOptions(orgId, options);
  const query = useQuery16(queryOptions, queryClient);
  return withQueryKey16(query, queryOptions.queryKey);
}
var organizationSettingsControllerUpdatePolicies = (orgId, updatePoliciesDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/policies`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updatePoliciesDto,
      ...signal ? { signal } : {}
    }
  );
};
var getOrganizationSettingsControllerUpdatePoliciesMutationKey = () => ["organizationSettingsControllerUpdatePolicies"];
var getOrganizationSettingsControllerUpdatePoliciesMutationOptions = (options) => {
  const mutationKey = getOrganizationSettingsControllerUpdatePoliciesMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return organizationSettingsControllerUpdatePolicies(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrganizationSettingsControllerUpdatePolicies = (options, queryClient) => {
  return useMutation15(getOrganizationSettingsControllerUpdatePoliciesMutationOptions(options), queryClient);
};
var organizationLogoControllerGet = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/logo`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getOrganizationLogoControllerGetQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/logo`
  ];
};
var getOrganizationLogoControllerGetQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getOrganizationLogoControllerGetQueryKey(orgId);
  const queryFn = ({ signal }) => organizationLogoControllerGet(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useOrganizationLogoControllerGet(orgId, options, queryClient) {
  const queryOptions = getOrganizationLogoControllerGetQueryOptions(orgId, options);
  const query = useQuery16(queryOptions, queryClient);
  return withQueryKey16(query, queryOptions.queryKey);
}
var organizationLogoControllerSet = (orgId, setLogoDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/logo`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: setLogoDto,
      ...signal ? { signal } : {}
    }
  );
};
var getOrganizationLogoControllerSetMutationKey = () => ["organizationLogoControllerSet"];
var getOrganizationLogoControllerSetMutationOptions = (options) => {
  const mutationKey = getOrganizationLogoControllerSetMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return organizationLogoControllerSet(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrganizationLogoControllerSet = (options, queryClient) => {
  return useMutation15(getOrganizationLogoControllerSetMutationOptions(options), queryClient);
};
var organizationLogoControllerRemove = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/logo`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getOrganizationLogoControllerRemoveMutationKey = () => ["organizationLogoControllerRemove"];
var getOrganizationLogoControllerRemoveMutationOptions = (options) => {
  const mutationKey = getOrganizationLogoControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId } = props ?? {};
    return organizationLogoControllerRemove(orgId);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrganizationLogoControllerRemove = (options, queryClient) => {
  return useMutation15(getOrganizationLogoControllerRemoveMutationOptions(options), queryClient);
};
var organizationLogoControllerUploadTarget = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/logo/upload-target`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getOrganizationLogoControllerUploadTargetMutationKey = () => ["organizationLogoControllerUploadTarget"];
var getOrganizationLogoControllerUploadTargetMutationOptions = (options) => {
  const mutationKey = getOrganizationLogoControllerUploadTargetMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId } = props ?? {};
    return organizationLogoControllerUploadTarget(orgId);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrganizationLogoControllerUploadTarget = (options, queryClient) => {
  return useMutation15(getOrganizationLogoControllerUploadTargetMutationOptions(options), queryClient);
};

// src/generated/endpoints/platform/platform.ts
import {
  useMutation as useMutation16,
  useQuery as useQuery17
} from "@tanstack/react-query";
var withQueryKey17 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var platformAuthControllerSignIn = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/auth/login`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformAuthControllerSignInQueryKey = (params) => {
  return [
    `/api/v1/platform/auth/login`,
    ...params ? [params] : []
  ];
};
var getPlatformAuthControllerSignInQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlatformAuthControllerSignInQueryKey(params);
  const queryFn = ({ signal }) => platformAuthControllerSignIn(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function usePlatformAuthControllerSignIn(params, options, queryClient) {
  const queryOptions = getPlatformAuthControllerSignInQueryOptions(params, options);
  const query = useQuery17(queryOptions, queryClient);
  return withQueryKey17(query, queryOptions.queryKey);
}
var platformAuthControllerCallback = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/auth/callback`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformAuthControllerCallbackQueryKey = (params) => {
  return [
    `/api/v1/platform/auth/callback`,
    ...params ? [params] : []
  ];
};
var getPlatformAuthControllerCallbackQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlatformAuthControllerCallbackQueryKey(params);
  const queryFn = ({ signal }) => platformAuthControllerCallback(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function usePlatformAuthControllerCallback(params, options, queryClient) {
  const queryOptions = getPlatformAuthControllerCallbackQueryOptions(params, options);
  const query = useQuery17(queryOptions, queryClient);
  return withQueryKey17(query, queryOptions.queryKey);
}
var platformAuthControllerStepUp = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/auth/step-up`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformAuthControllerStepUpQueryKey = (params) => {
  return [
    `/api/v1/platform/auth/step-up`,
    ...params ? [params] : []
  ];
};
var getPlatformAuthControllerStepUpQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlatformAuthControllerStepUpQueryKey(params);
  const queryFn = ({ signal }) => platformAuthControllerStepUp(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function usePlatformAuthControllerStepUp(params, options, queryClient) {
  const queryOptions = getPlatformAuthControllerStepUpQueryOptions(params, options);
  const query = useQuery17(queryOptions, queryClient);
  return withQueryKey17(query, queryOptions.queryKey);
}
var platformAuthControllerLogout = (signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/auth/logout`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformAuthControllerLogoutMutationKey = () => ["platformAuthControllerLogout"];
var getPlatformAuthControllerLogoutMutationOptions = (options) => {
  const mutationKey = getPlatformAuthControllerLogoutMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = () => {
    return platformAuthControllerLogout();
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformAuthControllerLogout = (options, queryClient) => {
  return useMutation16(getPlatformAuthControllerLogoutMutationOptions(options), queryClient);
};
var platformAuthControllerMe = (signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/me`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformAuthControllerMeQueryKey = () => {
  return [
    `/api/v1/platform/me`
  ];
};
var getPlatformAuthControllerMeQueryOptions = (options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlatformAuthControllerMeQueryKey();
  const queryFn = ({ signal }) => platformAuthControllerMe(signal);
  return { queryKey, queryFn, ...queryOptions };
};
function usePlatformAuthControllerMe(options, queryClient) {
  const queryOptions = getPlatformAuthControllerMeQueryOptions(options);
  const query = useQuery17(queryOptions, queryClient);
  return withQueryKey17(query, queryOptions.queryKey);
}
var platformBreakGlassControllerList = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/break-glass`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformBreakGlassControllerListQueryKey = (params) => {
  return [
    `/api/v1/platform/break-glass`,
    ...params ? [params] : []
  ];
};
var getPlatformBreakGlassControllerListQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlatformBreakGlassControllerListQueryKey(params);
  const queryFn = ({ signal }) => platformBreakGlassControllerList(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function usePlatformBreakGlassControllerList(params, options, queryClient) {
  const queryOptions = getPlatformBreakGlassControllerListQueryOptions(params, options);
  const query = useQuery17(queryOptions, queryClient);
  return withQueryKey17(query, queryOptions.queryKey);
}
var platformBreakGlassControllerCreate = (breakGlassCreateDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/break-glass`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: breakGlassCreateDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformBreakGlassControllerCreateMutationKey = () => ["platformBreakGlassControllerCreate"];
var getPlatformBreakGlassControllerCreateMutationOptions = (options) => {
  const mutationKey = getPlatformBreakGlassControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return platformBreakGlassControllerCreate(data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformBreakGlassControllerCreate = (options, queryClient) => {
  return useMutation16(getPlatformBreakGlassControllerCreateMutationOptions(options), queryClient);
};
var platformBreakGlassControllerApprove = (requestId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/break-glass/${requestId}/approve`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformBreakGlassControllerApproveMutationKey = () => ["platformBreakGlassControllerApprove"];
var getPlatformBreakGlassControllerApproveMutationOptions = (options) => {
  const mutationKey = getPlatformBreakGlassControllerApproveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { requestId } = props ?? {};
    return platformBreakGlassControllerApprove(requestId);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformBreakGlassControllerApprove = (options, queryClient) => {
  return useMutation16(getPlatformBreakGlassControllerApproveMutationOptions(options), queryClient);
};
var platformBreakGlassControllerReject = (requestId, breakGlassRejectDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/break-glass/${requestId}/reject`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: breakGlassRejectDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformBreakGlassControllerRejectMutationKey = () => ["platformBreakGlassControllerReject"];
var getPlatformBreakGlassControllerRejectMutationOptions = (options) => {
  const mutationKey = getPlatformBreakGlassControllerRejectMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { requestId, data } = props ?? {};
    return platformBreakGlassControllerReject(requestId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformBreakGlassControllerReject = (options, queryClient) => {
  return useMutation16(getPlatformBreakGlassControllerRejectMutationOptions(options), queryClient);
};
var platformBreakGlassControllerCancel = (requestId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/break-glass/${requestId}/cancel`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformBreakGlassControllerCancelMutationKey = () => ["platformBreakGlassControllerCancel"];
var getPlatformBreakGlassControllerCancelMutationOptions = (options) => {
  const mutationKey = getPlatformBreakGlassControllerCancelMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { requestId } = props ?? {};
    return platformBreakGlassControllerCancel(requestId);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformBreakGlassControllerCancel = (options, queryClient) => {
  return useMutation16(getPlatformBreakGlassControllerCancelMutationOptions(options), queryClient);
};
var platformBreakGlassControllerRevoke = (requestId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/break-glass/${requestId}/revoke`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformBreakGlassControllerRevokeMutationKey = () => ["platformBreakGlassControllerRevoke"];
var getPlatformBreakGlassControllerRevokeMutationOptions = (options) => {
  const mutationKey = getPlatformBreakGlassControllerRevokeMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { requestId } = props ?? {};
    return platformBreakGlassControllerRevoke(requestId);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformBreakGlassControllerRevoke = (options, queryClient) => {
  return useMutation16(getPlatformBreakGlassControllerRevokeMutationOptions(options), queryClient);
};
var platformOrganizationsControllerList = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/organizations`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformOrganizationsControllerListQueryKey = (params) => {
  return [
    `/api/v1/platform/organizations`,
    ...params ? [params] : []
  ];
};
var getPlatformOrganizationsControllerListQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlatformOrganizationsControllerListQueryKey(params);
  const queryFn = ({ signal }) => platformOrganizationsControllerList(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function usePlatformOrganizationsControllerList(params, options, queryClient) {
  const queryOptions = getPlatformOrganizationsControllerListQueryOptions(params, options);
  const query = useQuery17(queryOptions, queryClient);
  return withQueryKey17(query, queryOptions.queryKey);
}
var platformOrganizationsControllerDetail = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/organizations/${orgId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformOrganizationsControllerDetailQueryKey = (orgId) => {
  return [
    `/api/v1/platform/organizations/${orgId}`
  ];
};
var getPlatformOrganizationsControllerDetailQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlatformOrganizationsControllerDetailQueryKey(orgId);
  const queryFn = ({ signal }) => platformOrganizationsControllerDetail(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function usePlatformOrganizationsControllerDetail(orgId, options, queryClient) {
  const queryOptions = getPlatformOrganizationsControllerDetailQueryOptions(orgId, options);
  const query = useQuery17(queryOptions, queryClient);
  return withQueryKey17(query, queryOptions.queryKey);
}
var platformOrganizationsControllerOverrideStatus = (orgId, subscriptionOverrideRequestDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/organizations/${orgId}/subscription/status`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: subscriptionOverrideRequestDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformOrganizationsControllerOverrideStatusMutationKey = () => ["platformOrganizationsControllerOverrideStatus"];
var getPlatformOrganizationsControllerOverrideStatusMutationOptions = (options) => {
  const mutationKey = getPlatformOrganizationsControllerOverrideStatusMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return platformOrganizationsControllerOverrideStatus(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformOrganizationsControllerOverrideStatus = (options, queryClient) => {
  return useMutation16(getPlatformOrganizationsControllerOverrideStatusMutationOptions(options), queryClient);
};
var platformPaymentsControllerConfirm = (orgId, manualPaymentRequestDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/organizations/${orgId}/payments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: manualPaymentRequestDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformPaymentsControllerConfirmMutationKey = () => ["platformPaymentsControllerConfirm"];
var getPlatformPaymentsControllerConfirmMutationOptions = (options) => {
  const mutationKey = getPlatformPaymentsControllerConfirmMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return platformPaymentsControllerConfirm(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformPaymentsControllerConfirm = (options, queryClient) => {
  return useMutation16(getPlatformPaymentsControllerConfirmMutationOptions(options), queryClient);
};
var platformJobsControllerList = (signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/jobs/dead-letter`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformJobsControllerListQueryKey = () => {
  return [
    `/api/v1/platform/jobs/dead-letter`
  ];
};
var getPlatformJobsControllerListQueryOptions = (options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlatformJobsControllerListQueryKey();
  const queryFn = ({ signal }) => platformJobsControllerList(signal);
  return { queryKey, queryFn, ...queryOptions };
};
function usePlatformJobsControllerList(options, queryClient) {
  const queryOptions = getPlatformJobsControllerListQueryOptions(options);
  const query = useQuery17(queryOptions, queryClient);
  return withQueryKey17(query, queryOptions.queryKey);
}
var platformJobsControllerRetry = (jobId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/jobs/dead-letter/${jobId}/retry`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformJobsControllerRetryMutationKey = () => ["platformJobsControllerRetry"];
var getPlatformJobsControllerRetryMutationOptions = (options) => {
  const mutationKey = getPlatformJobsControllerRetryMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { jobId } = props ?? {};
    return platformJobsControllerRetry(jobId);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformJobsControllerRetry = (options, queryClient) => {
  return useMutation16(getPlatformJobsControllerRetryMutationOptions(options), queryClient);
};
var platformJobsControllerDiscard = (jobId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/jobs/dead-letter/${jobId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformJobsControllerDiscardMutationKey = () => ["platformJobsControllerDiscard"];
var getPlatformJobsControllerDiscardMutationOptions = (options) => {
  const mutationKey = getPlatformJobsControllerDiscardMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { jobId } = props ?? {};
    return platformJobsControllerDiscard(jobId);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformJobsControllerDiscard = (options, queryClient) => {
  return useMutation16(getPlatformJobsControllerDiscardMutationOptions(options), queryClient);
};
var platformSecurityControllerSignals = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/security/signals`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformSecurityControllerSignalsQueryKey = (params) => {
  return [
    `/api/v1/platform/security/signals`,
    ...params ? [params] : []
  ];
};
var getPlatformSecurityControllerSignalsQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlatformSecurityControllerSignalsQueryKey(params);
  const queryFn = ({ signal }) => platformSecurityControllerSignals(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function usePlatformSecurityControllerSignals(params, options, queryClient) {
  const queryOptions = getPlatformSecurityControllerSignalsQueryOptions(params, options);
  const query = useQuery17(queryOptions, queryClient);
  return withQueryKey17(query, queryOptions.queryKey);
}
var platformAuditControllerList = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/audit`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformAuditControllerListQueryKey = (params) => {
  return [
    `/api/v1/platform/audit`,
    ...params ? [params] : []
  ];
};
var getPlatformAuditControllerListQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlatformAuditControllerListQueryKey(params);
  const queryFn = ({ signal }) => platformAuditControllerList(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function usePlatformAuditControllerList(params, options, queryClient) {
  const queryOptions = getPlatformAuditControllerListQueryOptions(params, options);
  const query = useQuery17(queryOptions, queryClient);
  return withQueryKey17(query, queryOptions.queryKey);
}
var platformUsersControllerMembers = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/organizations/${orgId}/members`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformUsersControllerMembersQueryKey = (orgId, params) => {
  return [
    `/api/v1/platform/organizations/${orgId}/members`,
    ...params ? [params] : []
  ];
};
var getPlatformUsersControllerMembersQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlatformUsersControllerMembersQueryKey(orgId, params);
  const queryFn = ({ signal }) => platformUsersControllerMembers(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function usePlatformUsersControllerMembers(orgId, params, options, queryClient) {
  const queryOptions = getPlatformUsersControllerMembersQueryOptions(orgId, params, options);
  const query = useQuery17(queryOptions, queryClient);
  return withQueryKey17(query, queryOptions.queryKey);
}
var platformUsersControllerSuspend = (orgId, membershipId, platformReasonDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/organizations/${orgId}/members/${membershipId}/suspend`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: platformReasonDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformUsersControllerSuspendMutationKey = () => ["platformUsersControllerSuspend"];
var getPlatformUsersControllerSuspendMutationOptions = (options) => {
  const mutationKey = getPlatformUsersControllerSuspendMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, membershipId, data } = props ?? {};
    return platformUsersControllerSuspend(orgId, membershipId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformUsersControllerSuspend = (options, queryClient) => {
  return useMutation16(getPlatformUsersControllerSuspendMutationOptions(options), queryClient);
};
var platformUsersControllerReactivate = (orgId, membershipId, platformReasonDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/organizations/${orgId}/members/${membershipId}/reactivate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: platformReasonDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformUsersControllerReactivateMutationKey = () => ["platformUsersControllerReactivate"];
var getPlatformUsersControllerReactivateMutationOptions = (options) => {
  const mutationKey = getPlatformUsersControllerReactivateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, membershipId, data } = props ?? {};
    return platformUsersControllerReactivate(orgId, membershipId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformUsersControllerReactivate = (options, queryClient) => {
  return useMutation16(getPlatformUsersControllerReactivateMutationOptions(options), queryClient);
};
var platformUsersControllerRemove = (orgId, membershipId, platformReasonDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/organizations/${orgId}/members/${membershipId}/remove`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: platformReasonDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformUsersControllerRemoveMutationKey = () => ["platformUsersControllerRemove"];
var getPlatformUsersControllerRemoveMutationOptions = (options) => {
  const mutationKey = getPlatformUsersControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, membershipId, data } = props ?? {};
    return platformUsersControllerRemove(orgId, membershipId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformUsersControllerRemove = (options, queryClient) => {
  return useMutation16(getPlatformUsersControllerRemoveMutationOptions(options), queryClient);
};
var platformUsersControllerAccount = (userId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/users/${userId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformUsersControllerAccountQueryKey = (userId) => {
  return [
    `/api/v1/platform/users/${userId}`
  ];
};
var getPlatformUsersControllerAccountQueryOptions = (userId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlatformUsersControllerAccountQueryKey(userId);
  const queryFn = ({ signal }) => platformUsersControllerAccount(userId, signal);
  return { queryKey, queryFn, enabled: userId !== null && userId !== void 0, ...queryOptions };
};
function usePlatformUsersControllerAccount(userId, options, queryClient) {
  const queryOptions = getPlatformUsersControllerAccountQueryOptions(userId, options);
  const query = useQuery17(queryOptions, queryClient);
  return withQueryKey17(query, queryOptions.queryKey);
}
var platformUsersControllerLock = (userId, platformReasonDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/users/${userId}/lock`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: platformReasonDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformUsersControllerLockMutationKey = () => ["platformUsersControllerLock"];
var getPlatformUsersControllerLockMutationOptions = (options) => {
  const mutationKey = getPlatformUsersControllerLockMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { userId, data } = props ?? {};
    return platformUsersControllerLock(userId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformUsersControllerLock = (options, queryClient) => {
  return useMutation16(getPlatformUsersControllerLockMutationOptions(options), queryClient);
};
var platformUsersControllerUnlock = (userId, platformReasonDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/users/${userId}/unlock`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: platformReasonDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformUsersControllerUnlockMutationKey = () => ["platformUsersControllerUnlock"];
var getPlatformUsersControllerUnlockMutationOptions = (options) => {
  const mutationKey = getPlatformUsersControllerUnlockMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { userId, data } = props ?? {};
    return platformUsersControllerUnlock(userId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformUsersControllerUnlock = (options, queryClient) => {
  return useMutation16(getPlatformUsersControllerUnlockMutationOptions(options), queryClient);
};
var platformUsersControllerDelete = (userId, platformAccountDeleteDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/users/${userId}/delete`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: platformAccountDeleteDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformUsersControllerDeleteMutationKey = () => ["platformUsersControllerDelete"];
var getPlatformUsersControllerDeleteMutationOptions = (options) => {
  const mutationKey = getPlatformUsersControllerDeleteMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { userId, data } = props ?? {};
    return platformUsersControllerDelete(userId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformUsersControllerDelete = (options, queryClient) => {
  return useMutation16(getPlatformUsersControllerDeleteMutationOptions(options), queryClient);
};
var platformDeletionsControllerList = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/organization-deletions`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformDeletionsControllerListQueryKey = (params) => {
  return [
    `/api/v1/platform/organization-deletions`,
    ...params ? [params] : []
  ];
};
var getPlatformDeletionsControllerListQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlatformDeletionsControllerListQueryKey(params);
  const queryFn = ({ signal }) => platformDeletionsControllerList(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function usePlatformDeletionsControllerList(params, options, queryClient) {
  const queryOptions = getPlatformDeletionsControllerListQueryOptions(params, options);
  const query = useQuery17(queryOptions, queryClient);
  return withQueryKey17(query, queryOptions.queryKey);
}
var platformDeletionsControllerCreate = (platformDeletionCreateDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/organization-deletions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: platformDeletionCreateDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformDeletionsControllerCreateMutationKey = () => ["platformDeletionsControllerCreate"];
var getPlatformDeletionsControllerCreateMutationOptions = (options) => {
  const mutationKey = getPlatformDeletionsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return platformDeletionsControllerCreate(data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformDeletionsControllerCreate = (options, queryClient) => {
  return useMutation16(getPlatformDeletionsControllerCreateMutationOptions(options), queryClient);
};
var platformDeletionsControllerApprove = (requestId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/organization-deletions/${requestId}/approve`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformDeletionsControllerApproveMutationKey = () => ["platformDeletionsControllerApprove"];
var getPlatformDeletionsControllerApproveMutationOptions = (options) => {
  const mutationKey = getPlatformDeletionsControllerApproveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { requestId } = props ?? {};
    return platformDeletionsControllerApprove(requestId);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformDeletionsControllerApprove = (options, queryClient) => {
  return useMutation16(getPlatformDeletionsControllerApproveMutationOptions(options), queryClient);
};
var platformDeletionsControllerReject = (requestId, platformDeletionRejectDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/organization-deletions/${requestId}/reject`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: platformDeletionRejectDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformDeletionsControllerRejectMutationKey = () => ["platformDeletionsControllerReject"];
var getPlatformDeletionsControllerRejectMutationOptions = (options) => {
  const mutationKey = getPlatformDeletionsControllerRejectMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { requestId, data } = props ?? {};
    return platformDeletionsControllerReject(requestId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformDeletionsControllerReject = (options, queryClient) => {
  return useMutation16(getPlatformDeletionsControllerRejectMutationOptions(options), queryClient);
};
var platformDeletionsControllerCancel = (requestId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/platform/organization-deletions/${requestId}/cancel`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getPlatformDeletionsControllerCancelMutationKey = () => ["platformDeletionsControllerCancel"];
var getPlatformDeletionsControllerCancelMutationOptions = (options) => {
  const mutationKey = getPlatformDeletionsControllerCancelMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { requestId } = props ?? {};
    return platformDeletionsControllerCancel(requestId);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlatformDeletionsControllerCancel = (options, queryClient) => {
  return useMutation16(getPlatformDeletionsControllerCancelMutationOptions(options), queryClient);
};

// src/generated/endpoints/privacy/privacy.ts
import {
  useMutation as useMutation17,
  useQuery as useQuery18
} from "@tanstack/react-query";
var withQueryKey18 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var myDataExportControllerRequest = (signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/data-export`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getMyDataExportControllerRequestMutationKey = () => ["myDataExportControllerRequest"];
var getMyDataExportControllerRequestMutationOptions = (options) => {
  const mutationKey = getMyDataExportControllerRequestMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = () => {
    return myDataExportControllerRequest();
  };
  return { mutationFn, ...mutationOptions };
};
var useMyDataExportControllerRequest = (options, queryClient) => {
  return useMutation17(getMyDataExportControllerRequestMutationOptions(options), queryClient);
};
var myDataExportControllerList = (params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/data-exports`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getMyDataExportControllerListQueryKey = (params) => {
  return [
    `/api/v1/me/data-exports`,
    ...params ? [params] : []
  ];
};
var getMyDataExportControllerListQueryOptions = (params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMyDataExportControllerListQueryKey(params);
  const queryFn = ({ signal }) => myDataExportControllerList(params, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useMyDataExportControllerList(params, options, queryClient) {
  const queryOptions = getMyDataExportControllerListQueryOptions(params, options);
  const query = useQuery18(queryOptions, queryClient);
  return withQueryKey18(query, queryOptions.queryKey);
}
var myDataExportControllerDownloadUrl = (exportId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/data-exports/${exportId}/download-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getMyDataExportControllerDownloadUrlQueryKey = (exportId) => {
  return [
    `/api/v1/me/data-exports/${exportId}/download-url`
  ];
};
var getMyDataExportControllerDownloadUrlQueryOptions = (exportId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMyDataExportControllerDownloadUrlQueryKey(exportId);
  const queryFn = ({ signal }) => myDataExportControllerDownloadUrl(exportId, signal);
  return { queryKey, queryFn, enabled: exportId !== null && exportId !== void 0, ...queryOptions };
};
function useMyDataExportControllerDownloadUrl(exportId, options, queryClient) {
  const queryOptions = getMyDataExportControllerDownloadUrlQueryOptions(exportId, options);
  const query = useQuery18(queryOptions, queryClient);
  return withQueryKey18(query, queryOptions.queryKey);
}
var organizationPrivacyControllerRequestExport = (orgId, createOrgDataExportDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/data-exports`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createOrgDataExportDto,
      ...signal ? { signal } : {}
    }
  );
};
var getOrganizationPrivacyControllerRequestExportMutationKey = () => ["organizationPrivacyControllerRequestExport"];
var getOrganizationPrivacyControllerRequestExportMutationOptions = (options) => {
  const mutationKey = getOrganizationPrivacyControllerRequestExportMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return organizationPrivacyControllerRequestExport(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrganizationPrivacyControllerRequestExport = (options, queryClient) => {
  return useMutation17(getOrganizationPrivacyControllerRequestExportMutationOptions(options), queryClient);
};
var organizationPrivacyControllerListExports = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/data-exports`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getOrganizationPrivacyControllerListExportsQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/data-exports`,
    ...params ? [params] : []
  ];
};
var getOrganizationPrivacyControllerListExportsQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getOrganizationPrivacyControllerListExportsQueryKey(orgId, params);
  const queryFn = ({ signal }) => organizationPrivacyControllerListExports(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useOrganizationPrivacyControllerListExports(orgId, params, options, queryClient) {
  const queryOptions = getOrganizationPrivacyControllerListExportsQueryOptions(orgId, params, options);
  const query = useQuery18(queryOptions, queryClient);
  return withQueryKey18(query, queryOptions.queryKey);
}
var organizationPrivacyControllerExportUrl = (orgId, exportId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/data-exports/${exportId}/download-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getOrganizationPrivacyControllerExportUrlQueryKey = (orgId, exportId) => {
  return [
    `/api/v1/orgs/${orgId}/data-exports/${exportId}/download-url`
  ];
};
var getOrganizationPrivacyControllerExportUrlQueryOptions = (orgId, exportId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getOrganizationPrivacyControllerExportUrlQueryKey(orgId, exportId);
  const queryFn = ({ signal }) => organizationPrivacyControllerExportUrl(orgId, exportId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && exportId !== null && exportId !== void 0, ...queryOptions };
};
function useOrganizationPrivacyControllerExportUrl(orgId, exportId, options, queryClient) {
  const queryOptions = getOrganizationPrivacyControllerExportUrlQueryOptions(orgId, exportId, options);
  const query = useQuery18(queryOptions, queryClient);
  return withQueryKey18(query, queryOptions.queryKey);
}
var organizationPrivacyControllerDeletion = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/deletion-requests/current`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getOrganizationPrivacyControllerDeletionQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/deletion-requests/current`
  ];
};
var getOrganizationPrivacyControllerDeletionQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getOrganizationPrivacyControllerDeletionQueryKey(orgId);
  const queryFn = ({ signal }) => organizationPrivacyControllerDeletion(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useOrganizationPrivacyControllerDeletion(orgId, options, queryClient) {
  const queryOptions = getOrganizationPrivacyControllerDeletionQueryOptions(orgId, options);
  const query = useQuery18(queryOptions, queryClient);
  return withQueryKey18(query, queryOptions.queryKey);
}
var organizationPrivacyControllerRequestDeletion = (orgId, createDeletionRequestDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/deletion-requests`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createDeletionRequestDto,
      ...signal ? { signal } : {}
    }
  );
};
var getOrganizationPrivacyControllerRequestDeletionMutationKey = () => ["organizationPrivacyControllerRequestDeletion"];
var getOrganizationPrivacyControllerRequestDeletionMutationOptions = (options) => {
  const mutationKey = getOrganizationPrivacyControllerRequestDeletionMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return organizationPrivacyControllerRequestDeletion(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrganizationPrivacyControllerRequestDeletion = (options, queryClient) => {
  return useMutation17(getOrganizationPrivacyControllerRequestDeletionMutationOptions(options), queryClient);
};
var organizationPrivacyControllerCancelDeletion = (orgId, requestId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/deletion-requests/${requestId}/cancel`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getOrganizationPrivacyControllerCancelDeletionMutationKey = () => ["organizationPrivacyControllerCancelDeletion"];
var getOrganizationPrivacyControllerCancelDeletionMutationOptions = (options) => {
  const mutationKey = getOrganizationPrivacyControllerCancelDeletionMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, requestId } = props ?? {};
    return organizationPrivacyControllerCancelDeletion(orgId, requestId);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrganizationPrivacyControllerCancelDeletion = (options, queryClient) => {
  return useMutation17(getOrganizationPrivacyControllerCancelDeletionMutationOptions(options), queryClient);
};

// src/generated/endpoints/projects/projects.ts
import {
  useMutation as useMutation18,
  useQuery as useQuery19
} from "@tanstack/react-query";
var withQueryKey19 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var projectTemplatesControllerList = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/project-templates`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getProjectTemplatesControllerListQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/project-templates`
  ];
};
var getProjectTemplatesControllerListQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getProjectTemplatesControllerListQueryKey(orgId);
  const queryFn = ({ signal }) => projectTemplatesControllerList(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useProjectTemplatesControllerList(orgId, options, queryClient) {
  const queryOptions = getProjectTemplatesControllerListQueryOptions(orgId, options);
  const query = useQuery19(queryOptions, queryClient);
  return withQueryKey19(query, queryOptions.queryKey);
}
var orgTemplatesControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/org-project-templates`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getOrgTemplatesControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/org-project-templates`,
    ...params ? [params] : []
  ];
};
var getOrgTemplatesControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getOrgTemplatesControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => orgTemplatesControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useOrgTemplatesControllerList(orgId, params, options, queryClient) {
  const queryOptions = getOrgTemplatesControllerListQueryOptions(orgId, params, options);
  const query = useQuery19(queryOptions, queryClient);
  return withQueryKey19(query, queryOptions.queryKey);
}
var orgTemplatesControllerCreate = (orgId, createOrgTemplateDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/org-project-templates`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createOrgTemplateDto,
      ...signal ? { signal } : {}
    }
  );
};
var getOrgTemplatesControllerCreateMutationKey = () => ["orgTemplatesControllerCreate"];
var getOrgTemplatesControllerCreateMutationOptions = (options) => {
  const mutationKey = getOrgTemplatesControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return orgTemplatesControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrgTemplatesControllerCreate = (options, queryClient) => {
  return useMutation18(getOrgTemplatesControllerCreateMutationOptions(options), queryClient);
};
var orgTemplatesControllerSaveAsTemplate = (orgId, projectId, saveAsTemplateDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/save-as-template`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: saveAsTemplateDto,
      ...signal ? { signal } : {}
    }
  );
};
var getOrgTemplatesControllerSaveAsTemplateMutationKey = () => ["orgTemplatesControllerSaveAsTemplate"];
var getOrgTemplatesControllerSaveAsTemplateMutationOptions = (options) => {
  const mutationKey = getOrgTemplatesControllerSaveAsTemplateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, data } = props ?? {};
    return orgTemplatesControllerSaveAsTemplate(orgId, projectId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrgTemplatesControllerSaveAsTemplate = (options, queryClient) => {
  return useMutation18(getOrgTemplatesControllerSaveAsTemplateMutationOptions(options), queryClient);
};
var orgTemplatesControllerUpdate = (orgId, templateId, updateTemplateDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/org-project-templates/${templateId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateTemplateDto,
      ...signal ? { signal } : {}
    }
  );
};
var getOrgTemplatesControllerUpdateMutationKey = () => ["orgTemplatesControllerUpdate"];
var getOrgTemplatesControllerUpdateMutationOptions = (options) => {
  const mutationKey = getOrgTemplatesControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, templateId, data } = props ?? {};
    return orgTemplatesControllerUpdate(orgId, templateId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrgTemplatesControllerUpdate = (options, queryClient) => {
  return useMutation18(getOrgTemplatesControllerUpdateMutationOptions(options), queryClient);
};
var orgTemplatesControllerRemove = (orgId, templateId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/org-project-templates/${templateId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getOrgTemplatesControllerRemoveMutationKey = () => ["orgTemplatesControllerRemove"];
var getOrgTemplatesControllerRemoveMutationOptions = (options) => {
  const mutationKey = getOrgTemplatesControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, templateId } = props ?? {};
    return orgTemplatesControllerRemove(orgId, templateId);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrgTemplatesControllerRemove = (options, queryClient) => {
  return useMutation18(getOrgTemplatesControllerRemoveMutationOptions(options), queryClient);
};
var projectsControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getProjectsControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/projects`,
    ...params ? [params] : []
  ];
};
var getProjectsControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getProjectsControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => projectsControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useProjectsControllerList(orgId, params, options, queryClient) {
  const queryOptions = getProjectsControllerListQueryOptions(orgId, params, options);
  const query = useQuery19(queryOptions, queryClient);
  return withQueryKey19(query, queryOptions.queryKey);
}
var projectsControllerCreateProject = (orgId, createProjectDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createProjectDto,
      ...signal ? { signal } : {}
    }
  );
};
var getProjectsControllerCreateProjectMutationKey = () => ["projectsControllerCreateProject"];
var getProjectsControllerCreateProjectMutationOptions = (options) => {
  const mutationKey = getProjectsControllerCreateProjectMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return projectsControllerCreateProject(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useProjectsControllerCreateProject = (options, queryClient) => {
  return useMutation18(getProjectsControllerCreateProjectMutationOptions(options), queryClient);
};
var projectsControllerGet = (orgId, projectId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getProjectsControllerGetQueryKey = (orgId, projectId) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}`
  ];
};
var getProjectsControllerGetQueryOptions = (orgId, projectId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getProjectsControllerGetQueryKey(orgId, projectId);
  const queryFn = ({ signal }) => projectsControllerGet(orgId, projectId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0, ...queryOptions };
};
function useProjectsControllerGet(orgId, projectId, options, queryClient) {
  const queryOptions = getProjectsControllerGetQueryOptions(orgId, projectId, options);
  const query = useQuery19(queryOptions, queryClient);
  return withQueryKey19(query, queryOptions.queryKey);
}
var projectsControllerUpdate = (orgId, projectId, updateProjectDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateProjectDto,
      ...signal ? { signal } : {}
    }
  );
};
var getProjectsControllerUpdateMutationKey = () => ["projectsControllerUpdate"];
var getProjectsControllerUpdateMutationOptions = (options) => {
  const mutationKey = getProjectsControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, data } = props ?? {};
    return projectsControllerUpdate(orgId, projectId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useProjectsControllerUpdate = (options, queryClient) => {
  return useMutation18(getProjectsControllerUpdateMutationOptions(options), queryClient);
};
var projectsControllerArchive = (orgId, projectId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/archive`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getProjectsControllerArchiveMutationKey = () => ["projectsControllerArchive"];
var getProjectsControllerArchiveMutationOptions = (options) => {
  const mutationKey = getProjectsControllerArchiveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId } = props ?? {};
    return projectsControllerArchive(orgId, projectId);
  };
  return { mutationFn, ...mutationOptions };
};
var useProjectsControllerArchive = (options, queryClient) => {
  return useMutation18(getProjectsControllerArchiveMutationOptions(options), queryClient);
};
var projectsControllerRestore = (orgId, projectId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/restore`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getProjectsControllerRestoreMutationKey = () => ["projectsControllerRestore"];
var getProjectsControllerRestoreMutationOptions = (options) => {
  const mutationKey = getProjectsControllerRestoreMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId } = props ?? {};
    return projectsControllerRestore(orgId, projectId);
  };
  return { mutationFn, ...mutationOptions };
};
var useProjectsControllerRestore = (options, queryClient) => {
  return useMutation18(getProjectsControllerRestoreMutationOptions(options), queryClient);
};
var projectsControllerListMembers = (orgId, projectId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/members`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getProjectsControllerListMembersQueryKey = (orgId, projectId) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/members`
  ];
};
var getProjectsControllerListMembersQueryOptions = (orgId, projectId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getProjectsControllerListMembersQueryKey(orgId, projectId);
  const queryFn = ({ signal }) => projectsControllerListMembers(orgId, projectId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0, ...queryOptions };
};
function useProjectsControllerListMembers(orgId, projectId, options, queryClient) {
  const queryOptions = getProjectsControllerListMembersQueryOptions(orgId, projectId, options);
  const query = useQuery19(queryOptions, queryClient);
  return withQueryKey19(query, queryOptions.queryKey);
}
var projectsControllerReplaceMembers = (orgId, projectId, putProjectMembersDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/members`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: putProjectMembersDto,
      ...signal ? { signal } : {}
    }
  );
};
var getProjectsControllerReplaceMembersMutationKey = () => ["projectsControllerReplaceMembers"];
var getProjectsControllerReplaceMembersMutationOptions = (options) => {
  const mutationKey = getProjectsControllerReplaceMembersMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, data } = props ?? {};
    return projectsControllerReplaceMembers(orgId, projectId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useProjectsControllerReplaceMembers = (options, queryClient) => {
  return useMutation18(getProjectsControllerReplaceMembersMutationOptions(options), queryClient);
};
var phasesControllerList = (orgId, projectId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/phases`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPhasesControllerListQueryKey = (orgId, projectId) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/phases`
  ];
};
var getPhasesControllerListQueryOptions = (orgId, projectId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPhasesControllerListQueryKey(orgId, projectId);
  const queryFn = ({ signal }) => phasesControllerList(orgId, projectId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0, ...queryOptions };
};
function usePhasesControllerList(orgId, projectId, options, queryClient) {
  const queryOptions = getPhasesControllerListQueryOptions(orgId, projectId, options);
  const query = useQuery19(queryOptions, queryClient);
  return withQueryKey19(query, queryOptions.queryKey);
}
var phasesControllerCreate = (orgId, projectId, createPhaseDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/phases`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createPhaseDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPhasesControllerCreateMutationKey = () => ["phasesControllerCreate"];
var getPhasesControllerCreateMutationOptions = (options) => {
  const mutationKey = getPhasesControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, data } = props ?? {};
    return phasesControllerCreate(orgId, projectId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePhasesControllerCreate = (options, queryClient) => {
  return useMutation18(getPhasesControllerCreateMutationOptions(options), queryClient);
};
var phasesControllerReorder = (orgId, projectId, reorderPhasesDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/phases/order`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: reorderPhasesDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPhasesControllerReorderMutationKey = () => ["phasesControllerReorder"];
var getPhasesControllerReorderMutationOptions = (options) => {
  const mutationKey = getPhasesControllerReorderMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, data } = props ?? {};
    return phasesControllerReorder(orgId, projectId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePhasesControllerReorder = (options, queryClient) => {
  return useMutation18(getPhasesControllerReorderMutationOptions(options), queryClient);
};
var phasesControllerUpdate = (orgId, projectId, phaseId, updatePhaseDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/phases/${phaseId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updatePhaseDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPhasesControllerUpdateMutationKey = () => ["phasesControllerUpdate"];
var getPhasesControllerUpdateMutationOptions = (options) => {
  const mutationKey = getPhasesControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, phaseId, data } = props ?? {};
    return phasesControllerUpdate(orgId, projectId, phaseId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePhasesControllerUpdate = (options, queryClient) => {
  return useMutation18(getPhasesControllerUpdateMutationOptions(options), queryClient);
};
var deliverablesControllerList = (orgId, projectId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/deliverables`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getDeliverablesControllerListQueryKey = (orgId, projectId, params) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/deliverables`,
    ...params ? [params] : []
  ];
};
var getDeliverablesControllerListQueryOptions = (orgId, projectId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getDeliverablesControllerListQueryKey(orgId, projectId, params);
  const queryFn = ({ signal }) => deliverablesControllerList(orgId, projectId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0, ...queryOptions };
};
function useDeliverablesControllerList(orgId, projectId, params, options, queryClient) {
  const queryOptions = getDeliverablesControllerListQueryOptions(orgId, projectId, params, options);
  const query = useQuery19(queryOptions, queryClient);
  return withQueryKey19(query, queryOptions.queryKey);
}
var deliverablesControllerCreate = (orgId, projectId, createDeliverableDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/deliverables`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createDeliverableDto,
      ...signal ? { signal } : {}
    }
  );
};
var getDeliverablesControllerCreateMutationKey = () => ["deliverablesControllerCreate"];
var getDeliverablesControllerCreateMutationOptions = (options) => {
  const mutationKey = getDeliverablesControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, data } = props ?? {};
    return deliverablesControllerCreate(orgId, projectId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useDeliverablesControllerCreate = (options, queryClient) => {
  return useMutation18(getDeliverablesControllerCreateMutationOptions(options), queryClient);
};
var deliverablesControllerUpdate = (orgId, projectId, deliverableId, updateDeliverableDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/deliverables/${deliverableId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateDeliverableDto,
      ...signal ? { signal } : {}
    }
  );
};
var getDeliverablesControllerUpdateMutationKey = () => ["deliverablesControllerUpdate"];
var getDeliverablesControllerUpdateMutationOptions = (options) => {
  const mutationKey = getDeliverablesControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, deliverableId, data } = props ?? {};
    return deliverablesControllerUpdate(orgId, projectId, deliverableId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useDeliverablesControllerUpdate = (options, queryClient) => {
  return useMutation18(getDeliverablesControllerUpdateMutationOptions(options), queryClient);
};
var deliverablesControllerClosePhase = (orgId, projectId, phaseId, closePhaseDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/phases/${phaseId}/close`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: closePhaseDto,
      ...signal ? { signal } : {}
    }
  );
};
var getDeliverablesControllerClosePhaseMutationKey = () => ["deliverablesControllerClosePhase"];
var getDeliverablesControllerClosePhaseMutationOptions = (options) => {
  const mutationKey = getDeliverablesControllerClosePhaseMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, phaseId, data } = props ?? {};
    return deliverablesControllerClosePhase(orgId, projectId, phaseId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useDeliverablesControllerClosePhase = (options, queryClient) => {
  return useMutation18(getDeliverablesControllerClosePhaseMutationOptions(options), queryClient);
};
var planningControllerGantt = (orgId, projectId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/gantt`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPlanningControllerGanttQueryKey = (orgId, projectId) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/gantt`
  ];
};
var getPlanningControllerGanttQueryOptions = (orgId, projectId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlanningControllerGanttQueryKey(orgId, projectId);
  const queryFn = ({ signal }) => planningControllerGantt(orgId, projectId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0, ...queryOptions };
};
function usePlanningControllerGantt(orgId, projectId, options, queryClient) {
  const queryOptions = getPlanningControllerGanttQueryOptions(orgId, projectId, options);
  const query = useQuery19(queryOptions, queryClient);
  return withQueryKey19(query, queryOptions.queryKey);
}
var planningControllerListOrders = (orgId, projectId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/service-orders`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getPlanningControllerListOrdersQueryKey = (orgId, projectId) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/service-orders`
  ];
};
var getPlanningControllerListOrdersQueryOptions = (orgId, projectId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPlanningControllerListOrdersQueryKey(orgId, projectId);
  const queryFn = ({ signal }) => planningControllerListOrders(orgId, projectId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0, ...queryOptions };
};
function usePlanningControllerListOrders(orgId, projectId, options, queryClient) {
  const queryOptions = getPlanningControllerListOrdersQueryOptions(orgId, projectId, options);
  const query = useQuery19(queryOptions, queryClient);
  return withQueryKey19(query, queryOptions.queryKey);
}
var planningControllerCreateOrder = (orgId, projectId, createOrderDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/service-orders`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createOrderDto,
      ...signal ? { signal } : {}
    }
  );
};
var getPlanningControllerCreateOrderMutationKey = () => ["planningControllerCreateOrder"];
var getPlanningControllerCreateOrderMutationOptions = (options) => {
  const mutationKey = getPlanningControllerCreateOrderMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, data } = props ?? {};
    return planningControllerCreateOrder(orgId, projectId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlanningControllerCreateOrder = (options, queryClient) => {
  return useMutation18(getPlanningControllerCreateOrderMutationOptions(options), queryClient);
};
var planningControllerCancelOrder = (orgId, projectId, orderId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/service-orders/${orderId}/cancel`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getPlanningControllerCancelOrderMutationKey = () => ["planningControllerCancelOrder"];
var getPlanningControllerCancelOrderMutationOptions = (options) => {
  const mutationKey = getPlanningControllerCancelOrderMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, orderId } = props ?? {};
    return planningControllerCancelOrder(orgId, projectId, orderId);
  };
  return { mutationFn, ...mutationOptions };
};
var usePlanningControllerCancelOrder = (options, queryClient) => {
  return useMutation18(getPlanningControllerCancelOrderMutationOptions(options), queryClient);
};

// src/generated/endpoints/search/search.ts
import {
  useQuery as useQuery20
} from "@tanstack/react-query";
var withQueryKey20 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var searchControllerFind = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/search`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getSearchControllerFindQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/search`,
    ...params ? [params] : []
  ];
};
var getSearchControllerFindQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSearchControllerFindQueryKey(orgId, params);
  const queryFn = ({ signal }) => searchControllerFind(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useSearchControllerFind(orgId, params, options, queryClient) {
  const queryOptions = getSearchControllerFindQueryOptions(orgId, params, options);
  const query = useQuery20(queryOptions, queryClient);
  return withQueryKey20(query, queryOptions.queryKey);
}

// src/generated/endpoints/sharing/sharing.ts
import {
  useMutation as useMutation19,
  useQuery as useQuery21
} from "@tanstack/react-query";
var withQueryKey21 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var orgSharingControllerLookup = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/partner-lookup`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getOrgSharingControllerLookupQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/partner-lookup`,
    ...params ? [params] : []
  ];
};
var getOrgSharingControllerLookupQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getOrgSharingControllerLookupQueryKey(orgId, params);
  const queryFn = ({ signal }) => orgSharingControllerLookup(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useOrgSharingControllerLookup(orgId, params, options, queryClient) {
  const queryOptions = getOrgSharingControllerLookupQueryOptions(orgId, params, options);
  const query = useQuery21(queryOptions, queryClient);
  return withQueryKey21(query, queryOptions.queryKey);
}
var orgSharingControllerPartnerships = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/partnerships`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getOrgSharingControllerPartnershipsQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/partnerships`
  ];
};
var getOrgSharingControllerPartnershipsQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getOrgSharingControllerPartnershipsQueryKey(orgId);
  const queryFn = ({ signal }) => orgSharingControllerPartnerships(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useOrgSharingControllerPartnerships(orgId, options, queryClient) {
  const queryOptions = getOrgSharingControllerPartnershipsQueryOptions(orgId, options);
  const query = useQuery21(queryOptions, queryClient);
  return withQueryKey21(query, queryOptions.queryKey);
}
var spacePartnersControllerList = (spaceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/partners`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getSpacePartnersControllerListQueryKey = (spaceId) => {
  return [
    `/api/v1/spaces/${spaceId}/partners`
  ];
};
var getSpacePartnersControllerListQueryOptions = (spaceId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSpacePartnersControllerListQueryKey(spaceId);
  const queryFn = ({ signal }) => spacePartnersControllerList(spaceId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useSpacePartnersControllerList(spaceId, options, queryClient) {
  const queryOptions = getSpacePartnersControllerListQueryOptions(spaceId, options);
  const query = useQuery21(queryOptions, queryClient);
  return withQueryKey21(query, queryOptions.queryKey);
}
var spacePartnersControllerInvite = (spaceId, invitePartnerDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/partners`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: invitePartnerDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSpacePartnersControllerInviteMutationKey = () => ["spacePartnersControllerInvite"];
var getSpacePartnersControllerInviteMutationOptions = (options) => {
  const mutationKey = getSpacePartnersControllerInviteMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return spacePartnersControllerInvite(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSpacePartnersControllerInvite = (options, queryClient) => {
  return useMutation19(getSpacePartnersControllerInviteMutationOptions(options), queryClient);
};
var spacePartnersControllerDelegate = (spaceId, partnerId, delegateMemberDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/partners/${partnerId}/members`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: delegateMemberDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSpacePartnersControllerDelegateMutationKey = () => ["spacePartnersControllerDelegate"];
var getSpacePartnersControllerDelegateMutationOptions = (options) => {
  const mutationKey = getSpacePartnersControllerDelegateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, partnerId, data } = props ?? {};
    return spacePartnersControllerDelegate(spaceId, partnerId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSpacePartnersControllerDelegate = (options, queryClient) => {
  return useMutation19(getSpacePartnersControllerDelegateMutationOptions(options), queryClient);
};
var spacePartnersControllerMembers = (spaceId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/members`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getSpacePartnersControllerMembersQueryKey = (spaceId, params) => {
  return [
    `/api/v1/spaces/${spaceId}/members`,
    ...params ? [params] : []
  ];
};
var getSpacePartnersControllerMembersQueryOptions = (spaceId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSpacePartnersControllerMembersQueryKey(spaceId, params);
  const queryFn = ({ signal }) => spacePartnersControllerMembers(spaceId, params, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useSpacePartnersControllerMembers(spaceId, params, options, queryClient) {
  const queryOptions = getSpacePartnersControllerMembersQueryOptions(spaceId, params, options);
  const query = useQuery21(queryOptions, queryClient);
  return withQueryKey21(query, queryOptions.queryKey);
}
var mySpaceInvitationsControllerList = (signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/space-invitations`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getMySpaceInvitationsControllerListQueryKey = () => {
  return [
    `/api/v1/me/space-invitations`
  ];
};
var getMySpaceInvitationsControllerListQueryOptions = (options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMySpaceInvitationsControllerListQueryKey();
  const queryFn = ({ signal }) => mySpaceInvitationsControllerList(signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useMySpaceInvitationsControllerList(options, queryClient) {
  const queryOptions = getMySpaceInvitationsControllerListQueryOptions(options);
  const query = useQuery21(queryOptions, queryClient);
  return withQueryKey21(query, queryOptions.queryKey);
}
var spaceInvitationAnswersControllerAccept = (invitationId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/space-invitations/${invitationId}/accept`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getSpaceInvitationAnswersControllerAcceptMutationKey = () => ["spaceInvitationAnswersControllerAccept"];
var getSpaceInvitationAnswersControllerAcceptMutationOptions = (options) => {
  const mutationKey = getSpaceInvitationAnswersControllerAcceptMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { invitationId } = props ?? {};
    return spaceInvitationAnswersControllerAccept(invitationId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSpaceInvitationAnswersControllerAccept = (options, queryClient) => {
  return useMutation19(getSpaceInvitationAnswersControllerAcceptMutationOptions(options), queryClient);
};
var spaceInvitationAnswersControllerDecline = (invitationId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/space-invitations/${invitationId}/decline`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getSpaceInvitationAnswersControllerDeclineMutationKey = () => ["spaceInvitationAnswersControllerDecline"];
var getSpaceInvitationAnswersControllerDeclineMutationOptions = (options) => {
  const mutationKey = getSpaceInvitationAnswersControllerDeclineMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { invitationId } = props ?? {};
    return spaceInvitationAnswersControllerDecline(invitationId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSpaceInvitationAnswersControllerDecline = (options, queryClient) => {
  return useMutation19(getSpaceInvitationAnswersControllerDeclineMutationOptions(options), queryClient);
};
var spaceInvitationsControllerList = (spaceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/invitations`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getSpaceInvitationsControllerListQueryKey = (spaceId) => {
  return [
    `/api/v1/spaces/${spaceId}/invitations`
  ];
};
var getSpaceInvitationsControllerListQueryOptions = (spaceId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSpaceInvitationsControllerListQueryKey(spaceId);
  const queryFn = ({ signal }) => spaceInvitationsControllerList(spaceId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useSpaceInvitationsControllerList(spaceId, options, queryClient) {
  const queryOptions = getSpaceInvitationsControllerListQueryOptions(spaceId, options);
  const query = useQuery21(queryOptions, queryClient);
  return withQueryKey21(query, queryOptions.queryKey);
}
var spaceInvitationsControllerCreate = (spaceId, createSpaceInvitationDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/invitations`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createSpaceInvitationDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSpaceInvitationsControllerCreateMutationKey = () => ["spaceInvitationsControllerCreate"];
var getSpaceInvitationsControllerCreateMutationOptions = (options) => {
  const mutationKey = getSpaceInvitationsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return spaceInvitationsControllerCreate(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSpaceInvitationsControllerCreate = (options, queryClient) => {
  return useMutation19(getSpaceInvitationsControllerCreateMutationOptions(options), queryClient);
};
var spaceInvitationsControllerRevoke = (spaceId, invitationId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/invitations/${invitationId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getSpaceInvitationsControllerRevokeMutationKey = () => ["spaceInvitationsControllerRevoke"];
var getSpaceInvitationsControllerRevokeMutationOptions = (options) => {
  const mutationKey = getSpaceInvitationsControllerRevokeMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, invitationId } = props ?? {};
    return spaceInvitationsControllerRevoke(spaceId, invitationId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSpaceInvitationsControllerRevoke = (options, queryClient) => {
  return useMutation19(getSpaceInvitationsControllerRevokeMutationOptions(options), queryClient);
};
var spaceInvitationsControllerExtend = (spaceId, memberId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/members/${memberId}/extend`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getSpaceInvitationsControllerExtendMutationKey = () => ["spaceInvitationsControllerExtend"];
var getSpaceInvitationsControllerExtendMutationOptions = (options) => {
  const mutationKey = getSpaceInvitationsControllerExtendMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, memberId } = props ?? {};
    return spaceInvitationsControllerExtend(spaceId, memberId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSpaceInvitationsControllerExtend = (options, queryClient) => {
  return useMutation19(getSpaceInvitationsControllerExtendMutationOptions(options), queryClient);
};
var spaceApprovalsControllerList = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/space-approvals`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getSpaceApprovalsControllerListQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/space-approvals`
  ];
};
var getSpaceApprovalsControllerListQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSpaceApprovalsControllerListQueryKey(orgId);
  const queryFn = ({ signal }) => spaceApprovalsControllerList(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useSpaceApprovalsControllerList(orgId, options, queryClient) {
  const queryOptions = getSpaceApprovalsControllerListQueryOptions(orgId, options);
  const query = useQuery21(queryOptions, queryClient);
  return withQueryKey21(query, queryOptions.queryKey);
}
var spaceApprovalsControllerApprove = (orgId, invitationId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/space-approvals/${invitationId}/approve`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getSpaceApprovalsControllerApproveMutationKey = () => ["spaceApprovalsControllerApprove"];
var getSpaceApprovalsControllerApproveMutationOptions = (options) => {
  const mutationKey = getSpaceApprovalsControllerApproveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, invitationId } = props ?? {};
    return spaceApprovalsControllerApprove(orgId, invitationId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSpaceApprovalsControllerApprove = (options, queryClient) => {
  return useMutation19(getSpaceApprovalsControllerApproveMutationOptions(options), queryClient);
};
var spaceApprovalsControllerDecline = (orgId, invitationId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/space-approvals/${invitationId}/decline`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getSpaceApprovalsControllerDeclineMutationKey = () => ["spaceApprovalsControllerDecline"];
var getSpaceApprovalsControllerDeclineMutationOptions = (options) => {
  const mutationKey = getSpaceApprovalsControllerDeclineMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, invitationId } = props ?? {};
    return spaceApprovalsControllerDecline(orgId, invitationId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSpaceApprovalsControllerDecline = (options, queryClient) => {
  return useMutation19(getSpaceApprovalsControllerDeclineMutationOptions(options), queryClient);
};
var revokeAccessControllerRemoveMember = (spaceId, memberId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/members/${memberId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getRevokeAccessControllerRemoveMemberMutationKey = () => ["revokeAccessControllerRemoveMember"];
var getRevokeAccessControllerRemoveMemberMutationOptions = (options) => {
  const mutationKey = getRevokeAccessControllerRemoveMemberMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, memberId } = props ?? {};
    return revokeAccessControllerRemoveMember(spaceId, memberId);
  };
  return { mutationFn, ...mutationOptions };
};
var useRevokeAccessControllerRemoveMember = (options, queryClient) => {
  return useMutation19(getRevokeAccessControllerRemoveMemberMutationOptions(options), queryClient);
};
var revokeAccessControllerRemovePartner = (spaceId, partnerId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/partners/${partnerId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getRevokeAccessControllerRemovePartnerMutationKey = () => ["revokeAccessControllerRemovePartner"];
var getRevokeAccessControllerRemovePartnerMutationOptions = (options) => {
  const mutationKey = getRevokeAccessControllerRemovePartnerMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, partnerId } = props ?? {};
    return revokeAccessControllerRemovePartner(spaceId, partnerId);
  };
  return { mutationFn, ...mutationOptions };
};
var useRevokeAccessControllerRemovePartner = (options, queryClient) => {
  return useMutation19(getRevokeAccessControllerRemovePartnerMutationOptions(options), queryClient);
};
var revokeAccessControllerClose = (spaceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/close`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getRevokeAccessControllerCloseMutationKey = () => ["revokeAccessControllerClose"];
var getRevokeAccessControllerCloseMutationOptions = (options) => {
  const mutationKey = getRevokeAccessControllerCloseMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId } = props ?? {};
    return revokeAccessControllerClose(spaceId);
  };
  return { mutationFn, ...mutationOptions };
};
var useRevokeAccessControllerClose = (options, queryClient) => {
  return useMutation19(getRevokeAccessControllerCloseMutationOptions(options), queryClient);
};
var revokeAccessControllerAudit = (spaceId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/audit-events`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getRevokeAccessControllerAuditQueryKey = (spaceId, params) => {
  return [
    `/api/v1/spaces/${spaceId}/audit-events`,
    ...params ? [params] : []
  ];
};
var getRevokeAccessControllerAuditQueryOptions = (spaceId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getRevokeAccessControllerAuditQueryKey(spaceId, params);
  const queryFn = ({ signal }) => revokeAccessControllerAudit(spaceId, params, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useRevokeAccessControllerAudit(spaceId, params, options, queryClient) {
  const queryOptions = getRevokeAccessControllerAuditQueryOptions(spaceId, params, options);
  const query = useQuery21(queryOptions, queryClient);
  return withQueryKey21(query, queryOptions.queryKey);
}

// src/generated/endpoints/signatures/signatures.ts
import {
  useMutation as useMutation20,
  useQuery as useQuery22
} from "@tanstack/react-query";
var withQueryKey22 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var signaturesControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/signature-requests`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getSignaturesControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/signature-requests`,
    ...params ? [params] : []
  ];
};
var getSignaturesControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSignaturesControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => signaturesControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useSignaturesControllerList(orgId, params, options, queryClient) {
  const queryOptions = getSignaturesControllerListQueryOptions(orgId, params, options);
  const query = useQuery22(queryOptions, queryClient);
  return withQueryKey22(query, queryOptions.queryKey);
}
var signaturesControllerCreate = (orgId, createSignatureRequestDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/signature-requests`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createSignatureRequestDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSignaturesControllerCreateMutationKey = () => ["signaturesControllerCreate"];
var getSignaturesControllerCreateMutationOptions = (options) => {
  const mutationKey = getSignaturesControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return signaturesControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSignaturesControllerCreate = (options, queryClient) => {
  return useMutation20(getSignaturesControllerCreateMutationOptions(options), queryClient);
};
var signaturesControllerGet = (orgId, requestId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/signature-requests/${requestId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getSignaturesControllerGetQueryKey = (orgId, requestId) => {
  return [
    `/api/v1/orgs/${orgId}/signature-requests/${requestId}`
  ];
};
var getSignaturesControllerGetQueryOptions = (orgId, requestId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSignaturesControllerGetQueryKey(orgId, requestId);
  const queryFn = ({ signal }) => signaturesControllerGet(orgId, requestId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && requestId !== null && requestId !== void 0, ...queryOptions };
};
function useSignaturesControllerGet(orgId, requestId, options, queryClient) {
  const queryOptions = getSignaturesControllerGetQueryOptions(orgId, requestId, options);
  const query = useQuery22(queryOptions, queryClient);
  return withQueryKey22(query, queryOptions.queryKey);
}
var signaturesControllerSendCode = (orgId, requestId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/signature-requests/${requestId}/code`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getSignaturesControllerSendCodeMutationKey = () => ["signaturesControllerSendCode"];
var getSignaturesControllerSendCodeMutationOptions = (options) => {
  const mutationKey = getSignaturesControllerSendCodeMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, requestId } = props ?? {};
    return signaturesControllerSendCode(orgId, requestId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSignaturesControllerSendCode = (options, queryClient) => {
  return useMutation20(getSignaturesControllerSendCodeMutationOptions(options), queryClient);
};
var signaturesControllerSign = (orgId, requestId, signSignatureRequestDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/signature-requests/${requestId}/sign`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: signSignatureRequestDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSignaturesControllerSignMutationKey = () => ["signaturesControllerSign"];
var getSignaturesControllerSignMutationOptions = (options) => {
  const mutationKey = getSignaturesControllerSignMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, requestId, data } = props ?? {};
    return signaturesControllerSign(orgId, requestId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSignaturesControllerSign = (options, queryClient) => {
  return useMutation20(getSignaturesControllerSignMutationOptions(options), queryClient);
};
var signaturesControllerDecline = (orgId, requestId, declineSignatureDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/signature-requests/${requestId}/decline`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: declineSignatureDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSignaturesControllerDeclineMutationKey = () => ["signaturesControllerDecline"];
var getSignaturesControllerDeclineMutationOptions = (options) => {
  const mutationKey = getSignaturesControllerDeclineMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, requestId, data } = props ?? {};
    return signaturesControllerDecline(orgId, requestId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSignaturesControllerDecline = (options, queryClient) => {
  return useMutation20(getSignaturesControllerDeclineMutationOptions(options), queryClient);
};
var signaturesControllerCancel = (orgId, requestId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/signature-requests/${requestId}/cancel`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getSignaturesControllerCancelMutationKey = () => ["signaturesControllerCancel"];
var getSignaturesControllerCancelMutationOptions = (options) => {
  const mutationKey = getSignaturesControllerCancelMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, requestId } = props ?? {};
    return signaturesControllerCancel(orgId, requestId);
  };
  return { mutationFn, ...mutationOptions };
};
var useSignaturesControllerCancel = (options, queryClient) => {
  return useMutation20(getSignaturesControllerCancelMutationOptions(options), queryClient);
};
var signaturesControllerVerify = (orgId, requestId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/signature-requests/${requestId}/verify`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getSignaturesControllerVerifyQueryKey = (orgId, requestId) => {
  return [
    `/api/v1/orgs/${orgId}/signature-requests/${requestId}/verify`
  ];
};
var getSignaturesControllerVerifyQueryOptions = (orgId, requestId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSignaturesControllerVerifyQueryKey(orgId, requestId);
  const queryFn = ({ signal }) => signaturesControllerVerify(orgId, requestId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && requestId !== null && requestId !== void 0, ...queryOptions };
};
function useSignaturesControllerVerify(orgId, requestId, options, queryClient) {
  const queryOptions = getSignaturesControllerVerifyQueryOptions(orgId, requestId, options);
  const query = useQuery22(queryOptions, queryClient);
  return withQueryKey22(query, queryOptions.queryKey);
}
var signaturesControllerEvidenceUrl = (orgId, requestId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/signature-requests/${requestId}/evidence-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getSignaturesControllerEvidenceUrlQueryKey = (orgId, requestId) => {
  return [
    `/api/v1/orgs/${orgId}/signature-requests/${requestId}/evidence-url`
  ];
};
var getSignaturesControllerEvidenceUrlQueryOptions = (orgId, requestId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSignaturesControllerEvidenceUrlQueryKey(orgId, requestId);
  const queryFn = ({ signal }) => signaturesControllerEvidenceUrl(orgId, requestId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && requestId !== null && requestId !== void 0, ...queryOptions };
};
function useSignaturesControllerEvidenceUrl(orgId, requestId, options, queryClient) {
  const queryOptions = getSignaturesControllerEvidenceUrlQueryOptions(orgId, requestId, options);
  const query = useQuery22(queryOptions, queryClient);
  return withQueryKey22(query, queryOptions.queryKey);
}

// src/generated/endpoints/spaces/spaces.ts
import {
  useMutation as useMutation21,
  useQuery as useQuery23
} from "@tanstack/react-query";
var withQueryKey23 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var responsibilitiesControllerMatrix = (spaceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/responsibilities`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getResponsibilitiesControllerMatrixQueryKey = (spaceId) => {
  return [
    `/api/v1/spaces/${spaceId}/responsibilities`
  ];
};
var getResponsibilitiesControllerMatrixQueryOptions = (spaceId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getResponsibilitiesControllerMatrixQueryKey(spaceId);
  const queryFn = ({ signal }) => responsibilitiesControllerMatrix(spaceId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useResponsibilitiesControllerMatrix(spaceId, options, queryClient) {
  const queryOptions = getResponsibilitiesControllerMatrixQueryOptions(spaceId, options);
  const query = useQuery23(queryOptions, queryClient);
  return withQueryKey23(query, queryOptions.queryKey);
}
var responsibilitiesControllerUpdate = (spaceId, updateResponsibilityMatrixDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/responsibilities`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateResponsibilityMatrixDto,
      ...signal ? { signal } : {}
    }
  );
};
var getResponsibilitiesControllerUpdateMutationKey = () => ["responsibilitiesControllerUpdate"];
var getResponsibilitiesControllerUpdateMutationOptions = (options) => {
  const mutationKey = getResponsibilitiesControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return responsibilitiesControllerUpdate(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useResponsibilitiesControllerUpdate = (options, queryClient) => {
  return useMutation21(getResponsibilitiesControllerUpdateMutationOptions(options), queryClient);
};
var responsibilitiesControllerSynthesis = (spaceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/synthesis`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getResponsibilitiesControllerSynthesisQueryKey = (spaceId) => {
  return [
    `/api/v1/spaces/${spaceId}/synthesis`
  ];
};
var getResponsibilitiesControllerSynthesisQueryOptions = (spaceId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getResponsibilitiesControllerSynthesisQueryKey(spaceId);
  const queryFn = ({ signal }) => responsibilitiesControllerSynthesis(spaceId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useResponsibilitiesControllerSynthesis(spaceId, options, queryClient) {
  const queryOptions = getResponsibilitiesControllerSynthesisQueryOptions(spaceId, options);
  const query = useQuery23(queryOptions, queryClient);
  return withQueryKey23(query, queryOptions.queryKey);
}
var groupementControllerGet = (spaceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/groupement`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getGroupementControllerGetQueryKey = (spaceId) => {
  return [
    `/api/v1/spaces/${spaceId}/groupement`
  ];
};
var getGroupementControllerGetQueryOptions = (spaceId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGroupementControllerGetQueryKey(spaceId);
  const queryFn = ({ signal }) => groupementControllerGet(spaceId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useGroupementControllerGet(spaceId, options, queryClient) {
  const queryOptions = getGroupementControllerGetQueryOptions(spaceId, options);
  const query = useQuery23(queryOptions, queryClient);
  return withQueryKey23(query, queryOptions.queryKey);
}
var groupementControllerSave = (spaceId, saveGroupementDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/groupement`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: saveGroupementDto,
      ...signal ? { signal } : {}
    }
  );
};
var getGroupementControllerSaveMutationKey = () => ["groupementControllerSave"];
var getGroupementControllerSaveMutationOptions = (options) => {
  const mutationKey = getGroupementControllerSaveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return groupementControllerSave(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useGroupementControllerSave = (options, queryClient) => {
  return useMutation21(getGroupementControllerSaveMutationOptions(options), queryClient);
};
var groupementControllerAddPayment = (spaceId, createGroupementPaymentDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/groupement/payments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createGroupementPaymentDto,
      ...signal ? { signal } : {}
    }
  );
};
var getGroupementControllerAddPaymentMutationKey = () => ["groupementControllerAddPayment"];
var getGroupementControllerAddPaymentMutationOptions = (options) => {
  const mutationKey = getGroupementControllerAddPaymentMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return groupementControllerAddPayment(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useGroupementControllerAddPayment = (options, queryClient) => {
  return useMutation21(getGroupementControllerAddPaymentMutationOptions(options), queryClient);
};
var groupementControllerDeletePayment = (spaceId, paymentId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}/groupement/payments/${paymentId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getGroupementControllerDeletePaymentMutationKey = () => ["groupementControllerDeletePayment"];
var getGroupementControllerDeletePaymentMutationOptions = (options) => {
  const mutationKey = getGroupementControllerDeletePaymentMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, paymentId } = props ?? {};
    return groupementControllerDeletePayment(spaceId, paymentId);
  };
  return { mutationFn, ...mutationOptions };
};
var useGroupementControllerDeletePayment = (options, queryClient) => {
  return useMutation21(getGroupementControllerDeletePaymentMutationOptions(options), queryClient);
};
var exitExportsControllerClosed = (orgId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/closed-partnerships`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getExitExportsControllerClosedQueryKey = (orgId) => {
  return [
    `/api/v1/orgs/${orgId}/closed-partnerships`
  ];
};
var getExitExportsControllerClosedQueryOptions = (orgId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getExitExportsControllerClosedQueryKey(orgId);
  const queryFn = ({ signal }) => exitExportsControllerClosed(orgId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useExitExportsControllerClosed(orgId, options, queryClient) {
  const queryOptions = getExitExportsControllerClosedQueryOptions(orgId, options);
  const query = useQuery23(queryOptions, queryClient);
  return withQueryKey23(query, queryOptions.queryKey);
}
var exitExportsControllerRequest = (orgId, spaceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/closed-partnerships/${spaceId}/exit-exports`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getExitExportsControllerRequestMutationKey = () => ["exitExportsControllerRequest"];
var getExitExportsControllerRequestMutationOptions = (options) => {
  const mutationKey = getExitExportsControllerRequestMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, spaceId } = props ?? {};
    return exitExportsControllerRequest(orgId, spaceId);
  };
  return { mutationFn, ...mutationOptions };
};
var useExitExportsControllerRequest = (options, queryClient) => {
  return useMutation21(getExitExportsControllerRequestMutationOptions(options), queryClient);
};
var exitExportsControllerDownloadUrl = (orgId, exportId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/exit-exports/${exportId}/download-url`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getExitExportsControllerDownloadUrlQueryKey = (orgId, exportId) => {
  return [
    `/api/v1/orgs/${orgId}/exit-exports/${exportId}/download-url`
  ];
};
var getExitExportsControllerDownloadUrlQueryOptions = (orgId, exportId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getExitExportsControllerDownloadUrlQueryKey(orgId, exportId);
  const queryFn = ({ signal }) => exitExportsControllerDownloadUrl(orgId, exportId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && exportId !== null && exportId !== void 0, ...queryOptions };
};
function useExitExportsControllerDownloadUrl(orgId, exportId, options, queryClient) {
  const queryOptions = getExitExportsControllerDownloadUrlQueryOptions(orgId, exportId, options);
  const query = useQuery23(queryOptions, queryClient);
  return withQueryKey23(query, queryOptions.queryKey);
}
var orgSpacesControllerCreate = (orgId, createSpaceDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/spaces`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createSpaceDto,
      ...signal ? { signal } : {}
    }
  );
};
var getOrgSpacesControllerCreateMutationKey = () => ["orgSpacesControllerCreate"];
var getOrgSpacesControllerCreateMutationOptions = (options) => {
  const mutationKey = getOrgSpacesControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return orgSpacesControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useOrgSpacesControllerCreate = (options, queryClient) => {
  return useMutation21(getOrgSpacesControllerCreateMutationOptions(options), queryClient);
};
var mySpacesControllerList = (signal) => {
  return apiRequest(
    {
      url: `/api/v1/me/spaces`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getMySpacesControllerListQueryKey = () => {
  return [
    `/api/v1/me/spaces`
  ];
};
var getMySpacesControllerListQueryOptions = (options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMySpacesControllerListQueryKey();
  const queryFn = ({ signal }) => mySpacesControllerList(signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useMySpacesControllerList(options, queryClient) {
  const queryOptions = getMySpacesControllerListQueryOptions(options);
  const query = useQuery23(queryOptions, queryClient);
  return withQueryKey23(query, queryOptions.queryKey);
}
var spacesControllerGet = (spaceId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getSpacesControllerGetQueryKey = (spaceId) => {
  return [
    `/api/v1/spaces/${spaceId}`
  ];
};
var getSpacesControllerGetQueryOptions = (spaceId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSpacesControllerGetQueryKey(spaceId);
  const queryFn = ({ signal }) => spacesControllerGet(spaceId, signal);
  return { queryKey, queryFn, enabled: spaceId !== null && spaceId !== void 0, ...queryOptions };
};
function useSpacesControllerGet(spaceId, options, queryClient) {
  const queryOptions = getSpacesControllerGetQueryOptions(spaceId, options);
  const query = useQuery23(queryOptions, queryClient);
  return withQueryKey23(query, queryOptions.queryKey);
}
var spacesControllerUpdate = (spaceId, updateSpaceDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/spaces/${spaceId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateSpaceDto,
      ...signal ? { signal } : {}
    }
  );
};
var getSpacesControllerUpdateMutationKey = () => ["spacesControllerUpdate"];
var getSpacesControllerUpdateMutationOptions = (options) => {
  const mutationKey = getSpacesControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { spaceId, data } = props ?? {};
    return spacesControllerUpdate(spaceId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useSpacesControllerUpdate = (options, queryClient) => {
  return useMutation21(getSpacesControllerUpdateMutationOptions(options), queryClient);
};

// src/generated/endpoints/tasks/tasks.ts
import {
  useMutation as useMutation22,
  useQuery as useQuery24
} from "@tanstack/react-query";
var withQueryKey24 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var tasksControllerList = (orgId, projectId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/tasks`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getTasksControllerListQueryKey = (orgId, projectId, params) => {
  return [
    `/api/v1/orgs/${orgId}/projects/${projectId}/tasks`,
    ...params ? [params] : []
  ];
};
var getTasksControllerListQueryOptions = (orgId, projectId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTasksControllerListQueryKey(orgId, projectId, params);
  const queryFn = ({ signal }) => tasksControllerList(orgId, projectId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && projectId !== null && projectId !== void 0, ...queryOptions };
};
function useTasksControllerList(orgId, projectId, params, options, queryClient) {
  const queryOptions = getTasksControllerListQueryOptions(orgId, projectId, params, options);
  const query = useQuery24(queryOptions, queryClient);
  return withQueryKey24(query, queryOptions.queryKey);
}
var tasksControllerCreate = (orgId, projectId, createTaskDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/projects/${projectId}/tasks`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createTaskDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTasksControllerCreateMutationKey = () => ["tasksControllerCreate"];
var getTasksControllerCreateMutationOptions = (options) => {
  const mutationKey = getTasksControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, projectId, data } = props ?? {};
    return tasksControllerCreate(orgId, projectId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTasksControllerCreate = (options, queryClient) => {
  return useMutation22(getTasksControllerCreateMutationOptions(options), queryClient);
};
var tasksControllerGet = (orgId, taskId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tasks/${taskId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getTasksControllerGetQueryKey = (orgId, taskId) => {
  return [
    `/api/v1/orgs/${orgId}/tasks/${taskId}`
  ];
};
var getTasksControllerGetQueryOptions = (orgId, taskId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTasksControllerGetQueryKey(orgId, taskId);
  const queryFn = ({ signal }) => tasksControllerGet(orgId, taskId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && taskId !== null && taskId !== void 0, ...queryOptions };
};
function useTasksControllerGet(orgId, taskId, options, queryClient) {
  const queryOptions = getTasksControllerGetQueryOptions(orgId, taskId, options);
  const query = useQuery24(queryOptions, queryClient);
  return withQueryKey24(query, queryOptions.queryKey);
}
var tasksControllerUpdate = (orgId, taskId, updateTaskDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tasks/${taskId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateTaskDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTasksControllerUpdateMutationKey = () => ["tasksControllerUpdate"];
var getTasksControllerUpdateMutationOptions = (options) => {
  const mutationKey = getTasksControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, taskId, data } = props ?? {};
    return tasksControllerUpdate(orgId, taskId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTasksControllerUpdate = (options, queryClient) => {
  return useMutation22(getTasksControllerUpdateMutationOptions(options), queryClient);
};
var tasksControllerRemove = (orgId, taskId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tasks/${taskId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getTasksControllerRemoveMutationKey = () => ["tasksControllerRemove"];
var getTasksControllerRemoveMutationOptions = (options) => {
  const mutationKey = getTasksControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, taskId } = props ?? {};
    return tasksControllerRemove(orgId, taskId);
  };
  return { mutationFn, ...mutationOptions };
};
var useTasksControllerRemove = (options, queryClient) => {
  return useMutation22(getTasksControllerRemoveMutationOptions(options), queryClient);
};
var tasksControllerMove = (orgId, taskId, moveTaskDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tasks/${taskId}/move`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: moveTaskDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTasksControllerMoveMutationKey = () => ["tasksControllerMove"];
var getTasksControllerMoveMutationOptions = (options) => {
  const mutationKey = getTasksControllerMoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, taskId, data } = props ?? {};
    return tasksControllerMove(orgId, taskId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTasksControllerMove = (options, queryClient) => {
  return useMutation22(getTasksControllerMoveMutationOptions(options), queryClient);
};
var tasksControllerAddDependency = (orgId, taskId, addTaskDependencyDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tasks/${taskId}/dependencies`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: addTaskDependencyDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTasksControllerAddDependencyMutationKey = () => ["tasksControllerAddDependency"];
var getTasksControllerAddDependencyMutationOptions = (options) => {
  const mutationKey = getTasksControllerAddDependencyMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, taskId, data } = props ?? {};
    return tasksControllerAddDependency(orgId, taskId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTasksControllerAddDependency = (options, queryClient) => {
  return useMutation22(getTasksControllerAddDependencyMutationOptions(options), queryClient);
};
var tasksControllerRemoveDependency = (orgId, taskId, dependsOnTaskId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tasks/${taskId}/dependencies/${dependsOnTaskId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getTasksControllerRemoveDependencyMutationKey = () => ["tasksControllerRemoveDependency"];
var getTasksControllerRemoveDependencyMutationOptions = (options) => {
  const mutationKey = getTasksControllerRemoveDependencyMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, taskId, dependsOnTaskId } = props ?? {};
    return tasksControllerRemoveDependency(orgId, taskId, dependsOnTaskId);
  };
  return { mutationFn, ...mutationOptions };
};
var useTasksControllerRemoveDependency = (options, queryClient) => {
  return useMutation22(getTasksControllerRemoveDependencyMutationOptions(options), queryClient);
};
var tasksControllerAddChecklistItem = (orgId, taskId, createChecklistItemDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tasks/${taskId}/checklist`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createChecklistItemDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTasksControllerAddChecklistItemMutationKey = () => ["tasksControllerAddChecklistItem"];
var getTasksControllerAddChecklistItemMutationOptions = (options) => {
  const mutationKey = getTasksControllerAddChecklistItemMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, taskId, data } = props ?? {};
    return tasksControllerAddChecklistItem(orgId, taskId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTasksControllerAddChecklistItem = (options, queryClient) => {
  return useMutation22(getTasksControllerAddChecklistItemMutationOptions(options), queryClient);
};
var tasksControllerUpdateChecklistItem = (orgId, taskId, itemId, updateChecklistItemDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tasks/${taskId}/checklist/${itemId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateChecklistItemDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTasksControllerUpdateChecklistItemMutationKey = () => ["tasksControllerUpdateChecklistItem"];
var getTasksControllerUpdateChecklistItemMutationOptions = (options) => {
  const mutationKey = getTasksControllerUpdateChecklistItemMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, taskId, itemId, data } = props ?? {};
    return tasksControllerUpdateChecklistItem(orgId, taskId, itemId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTasksControllerUpdateChecklistItem = (options, queryClient) => {
  return useMutation22(getTasksControllerUpdateChecklistItemMutationOptions(options), queryClient);
};
var tasksControllerRemoveChecklistItem = (orgId, taskId, itemId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tasks/${taskId}/checklist/${itemId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getTasksControllerRemoveChecklistItemMutationKey = () => ["tasksControllerRemoveChecklistItem"];
var getTasksControllerRemoveChecklistItemMutationOptions = (options) => {
  const mutationKey = getTasksControllerRemoveChecklistItemMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, taskId, itemId } = props ?? {};
    return tasksControllerRemoveChecklistItem(orgId, taskId, itemId);
  };
  return { mutationFn, ...mutationOptions };
};
var useTasksControllerRemoveChecklistItem = (options, queryClient) => {
  return useMutation22(getTasksControllerRemoveChecklistItemMutationOptions(options), queryClient);
};
var tasksControllerListComments = (orgId, taskId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tasks/${taskId}/comments`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getTasksControllerListCommentsQueryKey = (orgId, taskId, params) => {
  return [
    `/api/v1/orgs/${orgId}/tasks/${taskId}/comments`,
    ...params ? [params] : []
  ];
};
var getTasksControllerListCommentsQueryOptions = (orgId, taskId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTasksControllerListCommentsQueryKey(orgId, taskId, params);
  const queryFn = ({ signal }) => tasksControllerListComments(orgId, taskId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && taskId !== null && taskId !== void 0, ...queryOptions };
};
function useTasksControllerListComments(orgId, taskId, params, options, queryClient) {
  const queryOptions = getTasksControllerListCommentsQueryOptions(orgId, taskId, params, options);
  const query = useQuery24(queryOptions, queryClient);
  return withQueryKey24(query, queryOptions.queryKey);
}
var tasksControllerCreateComment = (orgId, taskId, createCommentDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tasks/${taskId}/comments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCommentDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTasksControllerCreateCommentMutationKey = () => ["tasksControllerCreateComment"];
var getTasksControllerCreateCommentMutationOptions = (options) => {
  const mutationKey = getTasksControllerCreateCommentMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, taskId, data } = props ?? {};
    return tasksControllerCreateComment(orgId, taskId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTasksControllerCreateComment = (options, queryClient) => {
  return useMutation22(getTasksControllerCreateCommentMutationOptions(options), queryClient);
};
var tasksControllerUpdateComment = (orgId, taskId, commentId, updateCommentDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tasks/${taskId}/comments/${commentId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateCommentDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTasksControllerUpdateCommentMutationKey = () => ["tasksControllerUpdateComment"];
var getTasksControllerUpdateCommentMutationOptions = (options) => {
  const mutationKey = getTasksControllerUpdateCommentMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, taskId, commentId, data } = props ?? {};
    return tasksControllerUpdateComment(orgId, taskId, commentId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTasksControllerUpdateComment = (options, queryClient) => {
  return useMutation22(getTasksControllerUpdateCommentMutationOptions(options), queryClient);
};
var tasksControllerRemoveComment = (orgId, taskId, commentId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tasks/${taskId}/comments/${commentId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getTasksControllerRemoveCommentMutationKey = () => ["tasksControllerRemoveComment"];
var getTasksControllerRemoveCommentMutationOptions = (options) => {
  const mutationKey = getTasksControllerRemoveCommentMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, taskId, commentId } = props ?? {};
    return tasksControllerRemoveComment(orgId, taskId, commentId);
  };
  return { mutationFn, ...mutationOptions };
};
var useTasksControllerRemoveComment = (options, queryClient) => {
  return useMutation22(getTasksControllerRemoveCommentMutationOptions(options), queryClient);
};

// src/generated/endpoints/tenders/tenders.ts
import {
  useMutation as useMutation23,
  useQuery as useQuery25
} from "@tanstack/react-query";
var withQueryKey25 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var tendersControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tenders`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getTendersControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/tenders`,
    ...params ? [params] : []
  ];
};
var getTendersControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTendersControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => tendersControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useTendersControllerList(orgId, params, options, queryClient) {
  const queryOptions = getTendersControllerListQueryOptions(orgId, params, options);
  const query = useQuery25(queryOptions, queryClient);
  return withQueryKey25(query, queryOptions.queryKey);
}
var tendersControllerCreate = (orgId, createTenderDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tenders`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createTenderDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTendersControllerCreateMutationKey = () => ["tendersControllerCreate"];
var getTendersControllerCreateMutationOptions = (options) => {
  const mutationKey = getTendersControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return tendersControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTendersControllerCreate = (options, queryClient) => {
  return useMutation23(getTendersControllerCreateMutationOptions(options), queryClient);
};
var tendersControllerGet = (orgId, tenderId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tenders/${tenderId}`,
      method: "GET",
      ...signal ? { signal } : {}
    }
  );
};
var getTendersControllerGetQueryKey = (orgId, tenderId) => {
  return [
    `/api/v1/orgs/${orgId}/tenders/${tenderId}`
  ];
};
var getTendersControllerGetQueryOptions = (orgId, tenderId, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTendersControllerGetQueryKey(orgId, tenderId);
  const queryFn = ({ signal }) => tendersControllerGet(orgId, tenderId, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0 && tenderId !== null && tenderId !== void 0, ...queryOptions };
};
function useTendersControllerGet(orgId, tenderId, options, queryClient) {
  const queryOptions = getTendersControllerGetQueryOptions(orgId, tenderId, options);
  const query = useQuery25(queryOptions, queryClient);
  return withQueryKey25(query, queryOptions.queryKey);
}
var tendersControllerUpdate = (orgId, tenderId, updateTenderDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tenders/${tenderId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateTenderDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTendersControllerUpdateMutationKey = () => ["tendersControllerUpdate"];
var getTendersControllerUpdateMutationOptions = (options) => {
  const mutationKey = getTendersControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, tenderId, data } = props ?? {};
    return tendersControllerUpdate(orgId, tenderId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTendersControllerUpdate = (options, queryClient) => {
  return useMutation23(getTendersControllerUpdateMutationOptions(options), queryClient);
};
var tendersControllerRemove = (orgId, tenderId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tenders/${tenderId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getTendersControllerRemoveMutationKey = () => ["tendersControllerRemove"];
var getTendersControllerRemoveMutationOptions = (options) => {
  const mutationKey = getTendersControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, tenderId } = props ?? {};
    return tendersControllerRemove(orgId, tenderId);
  };
  return { mutationFn, ...mutationOptions };
};
var useTendersControllerRemove = (options, queryClient) => {
  return useMutation23(getTendersControllerRemoveMutationOptions(options), queryClient);
};
var tendersControllerChangeStatus = (orgId, tenderId, changeTenderStatusDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tenders/${tenderId}/status`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changeTenderStatusDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTendersControllerChangeStatusMutationKey = () => ["tendersControllerChangeStatus"];
var getTendersControllerChangeStatusMutationOptions = (options) => {
  const mutationKey = getTendersControllerChangeStatusMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, tenderId, data } = props ?? {};
    return tendersControllerChangeStatus(orgId, tenderId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTendersControllerChangeStatus = (options, queryClient) => {
  return useMutation23(getTendersControllerChangeStatusMutationOptions(options), queryClient);
};
var tendersControllerAddRequirement = (orgId, tenderId, createTenderRequirementDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tenders/${tenderId}/requirements`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createTenderRequirementDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTendersControllerAddRequirementMutationKey = () => ["tendersControllerAddRequirement"];
var getTendersControllerAddRequirementMutationOptions = (options) => {
  const mutationKey = getTendersControllerAddRequirementMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, tenderId, data } = props ?? {};
    return tendersControllerAddRequirement(orgId, tenderId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTendersControllerAddRequirement = (options, queryClient) => {
  return useMutation23(getTendersControllerAddRequirementMutationOptions(options), queryClient);
};
var tendersControllerUpdateRequirement = (orgId, tenderId, requirementId, updateTenderRequirementDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tenders/${tenderId}/requirements/${requirementId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateTenderRequirementDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTendersControllerUpdateRequirementMutationKey = () => ["tendersControllerUpdateRequirement"];
var getTendersControllerUpdateRequirementMutationOptions = (options) => {
  const mutationKey = getTendersControllerUpdateRequirementMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, tenderId, requirementId, data } = props ?? {};
    return tendersControllerUpdateRequirement(orgId, tenderId, requirementId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTendersControllerUpdateRequirement = (options, queryClient) => {
  return useMutation23(getTendersControllerUpdateRequirementMutationOptions(options), queryClient);
};
var tendersControllerRemoveRequirement = (orgId, tenderId, requirementId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tenders/${tenderId}/requirements/${requirementId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getTendersControllerRemoveRequirementMutationKey = () => ["tendersControllerRemoveRequirement"];
var getTendersControllerRemoveRequirementMutationOptions = (options) => {
  const mutationKey = getTendersControllerRemoveRequirementMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, tenderId, requirementId } = props ?? {};
    return tendersControllerRemoveRequirement(orgId, tenderId, requirementId);
  };
  return { mutationFn, ...mutationOptions };
};
var useTendersControllerRemoveRequirement = (options, queryClient) => {
  return useMutation23(getTendersControllerRemoveRequirementMutationOptions(options), queryClient);
};
var tendersControllerConvert = (orgId, tenderId, convertTenderDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/tenders/${tenderId}/convert`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: convertTenderDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTendersControllerConvertMutationKey = () => ["tendersControllerConvert"];
var getTendersControllerConvertMutationOptions = (options) => {
  const mutationKey = getTendersControllerConvertMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, tenderId, data } = props ?? {};
    return tendersControllerConvert(orgId, tenderId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTendersControllerConvert = (options, queryClient) => {
  return useMutation23(getTendersControllerConvertMutationOptions(options), queryClient);
};
var vaultDocumentsControllerList = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/vault-documents`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getVaultDocumentsControllerListQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/vault-documents`,
    ...params ? [params] : []
  ];
};
var getVaultDocumentsControllerListQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getVaultDocumentsControllerListQueryKey(orgId, params);
  const queryFn = ({ signal }) => vaultDocumentsControllerList(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useVaultDocumentsControllerList(orgId, params, options, queryClient) {
  const queryOptions = getVaultDocumentsControllerListQueryOptions(orgId, params, options);
  const query = useQuery25(queryOptions, queryClient);
  return withQueryKey25(query, queryOptions.queryKey);
}
var vaultDocumentsControllerCreate = (orgId, createVaultDocumentDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/vault-documents`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createVaultDocumentDto,
      ...signal ? { signal } : {}
    }
  );
};
var getVaultDocumentsControllerCreateMutationKey = () => ["vaultDocumentsControllerCreate"];
var getVaultDocumentsControllerCreateMutationOptions = (options) => {
  const mutationKey = getVaultDocumentsControllerCreateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return vaultDocumentsControllerCreate(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useVaultDocumentsControllerCreate = (options, queryClient) => {
  return useMutation23(getVaultDocumentsControllerCreateMutationOptions(options), queryClient);
};
var vaultDocumentsControllerUpdate = (orgId, vaultDocumentId, updateVaultDocumentDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/vault-documents/${vaultDocumentId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateVaultDocumentDto,
      ...signal ? { signal } : {}
    }
  );
};
var getVaultDocumentsControllerUpdateMutationKey = () => ["vaultDocumentsControllerUpdate"];
var getVaultDocumentsControllerUpdateMutationOptions = (options) => {
  const mutationKey = getVaultDocumentsControllerUpdateMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, vaultDocumentId, data } = props ?? {};
    return vaultDocumentsControllerUpdate(orgId, vaultDocumentId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useVaultDocumentsControllerUpdate = (options, queryClient) => {
  return useMutation23(getVaultDocumentsControllerUpdateMutationOptions(options), queryClient);
};
var vaultDocumentsControllerRemove = (orgId, vaultDocumentId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/vault-documents/${vaultDocumentId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getVaultDocumentsControllerRemoveMutationKey = () => ["vaultDocumentsControllerRemove"];
var getVaultDocumentsControllerRemoveMutationOptions = (options) => {
  const mutationKey = getVaultDocumentsControllerRemoveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, vaultDocumentId } = props ?? {};
    return vaultDocumentsControllerRemove(orgId, vaultDocumentId);
  };
  return { mutationFn, ...mutationOptions };
};
var useVaultDocumentsControllerRemove = (options, queryClient) => {
  return useMutation23(getVaultDocumentsControllerRemoveMutationOptions(options), queryClient);
};

// src/generated/endpoints/time/time.ts
import {
  useMutation as useMutation24,
  useQuery as useQuery26
} from "@tanstack/react-query";
var withQueryKey26 = (query, queryKey) => {
  const result = { queryKey };
  for (const key of Object.keys(query)) {
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => query[key]
    });
  }
  return result;
};
var timesheetsControllerMyWeek = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/timesheets/me`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getTimesheetsControllerMyWeekQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/timesheets/me`,
    ...params ? [params] : []
  ];
};
var getTimesheetsControllerMyWeekQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTimesheetsControllerMyWeekQueryKey(orgId, params);
  const queryFn = ({ signal }) => timesheetsControllerMyWeek(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useTimesheetsControllerMyWeek(orgId, params, options, queryClient) {
  const queryOptions = getTimesheetsControllerMyWeekQueryOptions(orgId, params, options);
  const query = useQuery26(queryOptions, queryClient);
  return withQueryKey26(query, queryOptions.queryKey);
}
var timesheetsControllerCreateEntry = (orgId, createTimeEntryDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/timesheets/entries`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createTimeEntryDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTimesheetsControllerCreateEntryMutationKey = () => ["timesheetsControllerCreateEntry"];
var getTimesheetsControllerCreateEntryMutationOptions = (options) => {
  const mutationKey = getTimesheetsControllerCreateEntryMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return timesheetsControllerCreateEntry(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTimesheetsControllerCreateEntry = (options, queryClient) => {
  return useMutation24(getTimesheetsControllerCreateEntryMutationOptions(options), queryClient);
};
var timesheetsControllerUpdateEntry = (orgId, entryId, updateTimeEntryDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/timesheets/entries/${entryId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateTimeEntryDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTimesheetsControllerUpdateEntryMutationKey = () => ["timesheetsControllerUpdateEntry"];
var getTimesheetsControllerUpdateEntryMutationOptions = (options) => {
  const mutationKey = getTimesheetsControllerUpdateEntryMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, entryId, data } = props ?? {};
    return timesheetsControllerUpdateEntry(orgId, entryId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTimesheetsControllerUpdateEntry = (options, queryClient) => {
  return useMutation24(getTimesheetsControllerUpdateEntryMutationOptions(options), queryClient);
};
var timesheetsControllerDeleteEntry = (orgId, entryId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/timesheets/entries/${entryId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getTimesheetsControllerDeleteEntryMutationKey = () => ["timesheetsControllerDeleteEntry"];
var getTimesheetsControllerDeleteEntryMutationOptions = (options) => {
  const mutationKey = getTimesheetsControllerDeleteEntryMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, entryId } = props ?? {};
    return timesheetsControllerDeleteEntry(orgId, entryId);
  };
  return { mutationFn, ...mutationOptions };
};
var useTimesheetsControllerDeleteEntry = (options, queryClient) => {
  return useMutation24(getTimesheetsControllerDeleteEntryMutationOptions(options), queryClient);
};
var timesheetsControllerSubmit = (orgId, weekStart, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/timesheets/weeks/${weekStart}/submit`,
      method: "POST",
      ...signal ? { signal } : {}
    }
  );
};
var getTimesheetsControllerSubmitMutationKey = () => ["timesheetsControllerSubmit"];
var getTimesheetsControllerSubmitMutationOptions = (options) => {
  const mutationKey = getTimesheetsControllerSubmitMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, weekStart } = props ?? {};
    return timesheetsControllerSubmit(orgId, weekStart);
  };
  return { mutationFn, ...mutationOptions };
};
var useTimesheetsControllerSubmit = (options, queryClient) => {
  return useMutation24(getTimesheetsControllerSubmitMutationOptions(options), queryClient);
};
var timesheetsControllerApprovals = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/timesheets/approvals`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getTimesheetsControllerApprovalsQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/timesheets/approvals`,
    ...params ? [params] : []
  ];
};
var getTimesheetsControllerApprovalsQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTimesheetsControllerApprovalsQueryKey(orgId, params);
  const queryFn = ({ signal }) => timesheetsControllerApprovals(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useTimesheetsControllerApprovals(orgId, params, options, queryClient) {
  const queryOptions = getTimesheetsControllerApprovalsQueryOptions(orgId, params, options);
  const query = useQuery26(queryOptions, queryClient);
  return withQueryKey26(query, queryOptions.queryKey);
}
var timesheetsControllerDecide = (orgId, decideTimeEntriesDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/timesheets/approvals`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: decideTimeEntriesDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTimesheetsControllerDecideMutationKey = () => ["timesheetsControllerDecide"];
var getTimesheetsControllerDecideMutationOptions = (options) => {
  const mutationKey = getTimesheetsControllerDecideMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return timesheetsControllerDecide(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTimesheetsControllerDecide = (options, queryClient) => {
  return useMutation24(getTimesheetsControllerDecideMutationOptions(options), queryClient);
};
var timesheetsControllerListLeave = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/leave-entries`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getTimesheetsControllerListLeaveQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/leave-entries`,
    ...params ? [params] : []
  ];
};
var getTimesheetsControllerListLeaveQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTimesheetsControllerListLeaveQueryKey(orgId, params);
  const queryFn = ({ signal }) => timesheetsControllerListLeave(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useTimesheetsControllerListLeave(orgId, params, options, queryClient) {
  const queryOptions = getTimesheetsControllerListLeaveQueryOptions(orgId, params, options);
  const query = useQuery26(queryOptions, queryClient);
  return withQueryKey26(query, queryOptions.queryKey);
}
var timesheetsControllerCreateLeave = (orgId, createLeaveDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/leave-entries`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createLeaveDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTimesheetsControllerCreateLeaveMutationKey = () => ["timesheetsControllerCreateLeave"];
var getTimesheetsControllerCreateLeaveMutationOptions = (options) => {
  const mutationKey = getTimesheetsControllerCreateLeaveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, data } = props ?? {};
    return timesheetsControllerCreateLeave(orgId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTimesheetsControllerCreateLeave = (options, queryClient) => {
  return useMutation24(getTimesheetsControllerCreateLeaveMutationOptions(options), queryClient);
};
var timesheetsControllerDeleteLeave = (orgId, leaveId, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/leave-entries/${leaveId}`,
      method: "DELETE",
      ...signal ? { signal } : {}
    }
  );
};
var getTimesheetsControllerDeleteLeaveMutationKey = () => ["timesheetsControllerDeleteLeave"];
var getTimesheetsControllerDeleteLeaveMutationOptions = (options) => {
  const mutationKey = getTimesheetsControllerDeleteLeaveMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, leaveId } = props ?? {};
    return timesheetsControllerDeleteLeave(orgId, leaveId);
  };
  return { mutationFn, ...mutationOptions };
};
var useTimesheetsControllerDeleteLeave = (options, queryClient) => {
  return useMutation24(getTimesheetsControllerDeleteLeaveMutationOptions(options), queryClient);
};
var timesheetsControllerCapacity = (orgId, params, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/capacity`,
      method: "GET",
      params,
      ...signal ? { signal } : {}
    }
  );
};
var getTimesheetsControllerCapacityQueryKey = (orgId, params) => {
  return [
    `/api/v1/orgs/${orgId}/capacity`,
    ...params ? [params] : []
  ];
};
var getTimesheetsControllerCapacityQueryOptions = (orgId, params, options) => {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTimesheetsControllerCapacityQueryKey(orgId, params);
  const queryFn = ({ signal }) => timesheetsControllerCapacity(orgId, params, signal);
  return { queryKey, queryFn, enabled: orgId !== null && orgId !== void 0, ...queryOptions };
};
function useTimesheetsControllerCapacity(orgId, params, options, queryClient) {
  const queryOptions = getTimesheetsControllerCapacityQueryOptions(orgId, params, options);
  const query = useQuery26(queryOptions, queryClient);
  return withQueryKey26(query, queryOptions.queryKey);
}
var timesheetsControllerWorkingTime = (orgId, memberId, workingTimeRequestDto, signal) => {
  return apiRequest(
    {
      url: `/api/v1/orgs/${orgId}/members/${memberId}/working-time`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: workingTimeRequestDto,
      ...signal ? { signal } : {}
    }
  );
};
var getTimesheetsControllerWorkingTimeMutationKey = () => ["timesheetsControllerWorkingTime"];
var getTimesheetsControllerWorkingTimeMutationOptions = (options) => {
  const mutationKey = getTimesheetsControllerWorkingTimeMutationKey();
  const { mutation: mutationOptions } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : { ...options, mutation: { ...options.mutation, mutationKey } } : { mutation: { mutationKey } };
  const mutationFn = (props) => {
    const { orgId, memberId, data } = props ?? {};
    return timesheetsControllerWorkingTime(orgId, memberId, data);
  };
  return { mutationFn, ...mutationOptions };
};
var useTimesheetsControllerWorkingTime = (options, queryClient) => {
  return useMutation24(getTimesheetsControllerWorkingTimeMutationOptions(options), queryClient);
};

// src/generated/model/_annotationDtoOutputPermissionsItem.ts
var _AnnotationDtoOutputPermissionsItem = {
  can_edit: "can_edit",
  can_resolve: "can_resolve",
  can_delete: "can_delete"
};

// src/generated/model/_annotationListDtoOutputItemsItemPermissionsItem.ts
var _AnnotationListDtoOutputItemsItemPermissionsItem = {
  can_edit: "can_edit",
  can_resolve: "can_resolve",
  can_delete: "can_delete"
};

// src/generated/model/_channelDtoOutputPermissionsItem.ts
var _ChannelDtoOutputPermissionsItem = {
  can_post: "can_post",
  moderator: "moderator"
};

// src/generated/model/_channelListDtoOutputItemsItemPermissionsItem.ts
var _ChannelListDtoOutputItemsItemPermissionsItem = {
  can_post: "can_post",
  moderator: "moderator"
};

// src/generated/model/_checklistDtoOutputPermissionsItem.ts
var _ChecklistDtoOutputPermissionsItem = {
  can_contribute: "can_contribute"
};

// src/generated/model/_checklistListDtoOutputItemsItemPermissionsItem.ts
var _ChecklistListDtoOutputItemsItemPermissionsItem = {
  can_contribute: "can_contribute"
};

// src/generated/model/_closedSpaceDtoOutputPermissionsItem.ts
var _ClosedSpaceDtoOutputPermissionsItem = {
  can_view: "can_view",
  can_contribute: "can_contribute",
  can_manage: "can_manage",
  can_delegate: "can_delegate"
};

// src/generated/model/_documentDetailDtoOutputPermissionsItem.ts
var _DocumentDetailDtoOutputPermissionsItem = {
  can_view: "can_view",
  can_comment: "can_comment",
  can_edit: "can_edit",
  can_request_approval: "can_request_approval",
  can_share: "can_share",
  can_delete: "can_delete"
};

// src/generated/model/_documentListDtoOutputItemsItemPermissionsItem.ts
var _DocumentListDtoOutputItemsItemPermissionsItem = {
  can_view: "can_view",
  can_comment: "can_comment",
  can_edit: "can_edit",
  can_request_approval: "can_request_approval",
  can_share: "can_share",
  can_delete: "can_delete"
};

// src/generated/model/_flowDtoOutputPermissionsItem.ts
var _FlowDtoOutputPermissionsItem = {
  can_decide: "can_decide",
  can_cancel: "can_cancel"
};

// src/generated/model/_flowListDtoOutputItemsItemPermissionsItem.ts
var _FlowListDtoOutputItemsItemPermissionsItem = {
  can_decide: "can_decide",
  can_cancel: "can_cancel"
};

// src/generated/model/_folderDetailDtoOutputPermissionsItem.ts
var _FolderDetailDtoOutputPermissionsItem = {
  can_read: "can_read",
  can_write: "can_write",
  can_manage: "can_manage"
};

// src/generated/model/_folderDtoOutputPermissionsItem.ts
var _FolderDtoOutputPermissionsItem = {
  can_read: "can_read",
  can_write: "can_write",
  can_manage: "can_manage"
};

// src/generated/model/_folderListDtoOutputItemsItemPermissionsItem.ts
var _FolderListDtoOutputItemsItemPermissionsItem = {
  can_read: "can_read",
  can_write: "can_write",
  can_manage: "can_manage"
};

// src/generated/model/_ganttDtoOutputPermissionsItem.ts
var _GanttDtoOutputPermissionsItem = {
  can_contribute: "can_contribute",
  can_manage: "can_manage"
};

// src/generated/model/_meetingDtoOutputPermissionsItem.ts
var _MeetingDtoOutputPermissionsItem = {
  can_invite: "can_invite"
};

// src/generated/model/_meetingMinutesDtoOutputPermissionsItem.ts
var _MeetingMinutesDtoOutputPermissionsItem = {
  can_edit: "can_edit",
  can_publish: "can_publish"
};

// src/generated/model/_memberDtoOutputPermissionsItem.ts
var _MemberDtoOutputPermissionsItem = {
  change_role: "change_role",
  deactivate: "deactivate",
  transfer_ownership: "transfer_ownership"
};

// src/generated/model/_memberListDtoOutputItemsItemPermissionsItem.ts
var _MemberListDtoOutputItemsItemPermissionsItem = {
  change_role: "change_role",
  deactivate: "deactivate",
  transfer_ownership: "transfer_ownership"
};

// src/generated/model/_observationDtoOutputPermissionsItem.ts
var _ObservationDtoOutputPermissionsItem = {
  can_edit: "can_edit",
  can_resolve: "can_resolve",
  can_delete: "can_delete"
};

// src/generated/model/_observationListDtoOutputItemsItemPermissionsItem.ts
var _ObservationListDtoOutputItemsItemPermissionsItem = {
  can_edit: "can_edit",
  can_resolve: "can_resolve",
  can_delete: "can_delete"
};

// src/generated/model/_orgTemplateDtoOutputPermissionsItem.ts
var _OrgTemplateDtoOutputPermissionsItem = {
  can_use: "can_use",
  can_edit: "can_edit"
};

// src/generated/model/_orgTemplateListDtoOutputItemsItemPermissionsItem.ts
var _OrgTemplateListDtoOutputItemsItemPermissionsItem = {
  can_use: "can_use",
  can_edit: "can_edit"
};

// src/generated/model/_projectDtoOutputPermissionsItem.ts
var _ProjectDtoOutputPermissionsItem = {
  can_view: "can_view",
  can_contribute: "can_contribute",
  can_manage: "can_manage"
};

// src/generated/model/_projectListDtoOutputItemsItemPermissionsItem.ts
var _ProjectListDtoOutputItemsItemPermissionsItem = {
  can_view: "can_view",
  can_contribute: "can_contribute",
  can_manage: "can_manage"
};

// src/generated/model/_roleDtoOutputPermissionsItem.ts
var _RoleDtoOutputPermissionsItem = {
  can_edit: "can_edit",
  can_delete: "can_delete"
};

// src/generated/model/_roleListDtoOutputItemsItemPermissionsItem.ts
var _RoleListDtoOutputItemsItemPermissionsItem = {
  can_edit: "can_edit",
  can_delete: "can_delete"
};

// src/generated/model/_spaceDtoOutputPermissionsItem.ts
var _SpaceDtoOutputPermissionsItem = {
  can_view: "can_view",
  can_contribute: "can_contribute",
  can_manage: "can_manage",
  can_delegate: "can_delegate"
};

// src/generated/model/_spaceMemberDtoOutputPermissionsItem.ts
var _SpaceMemberDtoOutputPermissionsItem = {
  can_revoke: "can_revoke"
};

// src/generated/model/_spaceMemberListDtoOutputItemsItemPermissionsItem.ts
var _SpaceMemberListDtoOutputItemsItemPermissionsItem = {
  can_revoke: "can_revoke"
};

// src/generated/model/_taskDetailDtoOutputPermissionsItem.ts
var _TaskDetailDtoOutputPermissionsItem = {
  can_view: "can_view",
  can_contribute: "can_contribute"
};

// src/generated/model/_taskDetailDtoOutputSubtasksItemPermissionsItem.ts
var _TaskDetailDtoOutputSubtasksItemPermissionsItem = {
  can_view: "can_view",
  can_contribute: "can_contribute"
};

// src/generated/model/_taskDtoOutputPermissionsItem.ts
var _TaskDtoOutputPermissionsItem = {
  can_view: "can_view",
  can_contribute: "can_contribute"
};

// src/generated/model/_taskListDtoOutputItemsItemPermissionsItem.ts
var _TaskListDtoOutputItemsItemPermissionsItem = {
  can_view: "can_view",
  can_contribute: "can_contribute"
};

// src/generated/model/_trashListDtoOutputItemsItemPermissionsItem.ts
var _TrashListDtoOutputItemsItemPermissionsItem = {
  can_restore: "can_restore",
  can_purge: "can_purge"
};

// src/generated/model/accountingExportDtoOutputFormat.ts
var AccountingExportDtoOutputFormat = {
  csv: "csv",
  xlsx: "xlsx"
};

// src/generated/model/accountingExportDtoOutputJournal.ts
var AccountingExportDtoOutputJournal = {
  sales: "sales",
  purchases: "purchases",
  treasury: "treasury",
  vat_summary: "vat_summary",
  withholding_summary: "withholding_summary"
};

// src/generated/model/accountingExportDtoOutputPreset.ts
var AccountingExportDtoOutputPreset = {
  generic: "generic",
  sage100: "sage100",
  ciel: "ciel"
};

// src/generated/model/accountingExportDtoOutputStatus.ts
var AccountingExportDtoOutputStatus = {
  pending: "pending",
  ready: "ready",
  failed: "failed"
};

// src/generated/model/accountingExportListDtoOutputItemsItemFormat.ts
var AccountingExportListDtoOutputItemsItemFormat = {
  csv: "csv",
  xlsx: "xlsx"
};

// src/generated/model/accountingExportListDtoOutputItemsItemJournal.ts
var AccountingExportListDtoOutputItemsItemJournal = {
  sales: "sales",
  purchases: "purchases",
  treasury: "treasury",
  vat_summary: "vat_summary",
  withholding_summary: "withholding_summary"
};

// src/generated/model/accountingExportListDtoOutputItemsItemPreset.ts
var AccountingExportListDtoOutputItemsItemPreset = {
  generic: "generic",
  sage100: "sage100",
  ciel: "ciel"
};

// src/generated/model/accountingExportListDtoOutputItemsItemStatus.ts
var AccountingExportListDtoOutputItemsItemStatus = {
  pending: "pending",
  ready: "ready",
  failed: "failed"
};

// src/generated/model/accountSecurityDtoOutputAuthenticatorsItemKind.ts
var AccountSecurityDtoOutputAuthenticatorsItemKind = {
  totp: "totp",
  security_key: "security_key"
};

// src/generated/model/activityPageDtoOutputItemsItemType.ts
var ActivityPageDtoOutputItemsItemType = {
  mention: "mention",
  reply: "reply",
  task_assigned: "task_assigned",
  task_due: "task_due",
  task_overdue: "task_overdue",
  phase_due: "phase_due",
  phase_overdue: "phase_overdue",
  approval_requested: "approval_requested",
  approval_decided: "approval_decided",
  space_invitation: "space_invitation",
  partnership_request: "partnership_request",
  access_revoked: "access_revoked",
  einvoice_status: "einvoice_status",
  payment_received: "payment_received",
  plan_limit: "plan_limit",
  event_reminder: "event_reminder",
  quote_accepted: "quote_accepted",
  invoice_suggested: "invoice_suggested",
  bond_release_due: "bond_release_due",
  expense_submitted: "expense_submitted",
  expense_decided: "expense_decided",
  subscription_status: "subscription_status",
  data_export: "data_export",
  organization_deletion: "organization_deletion",
  meeting_started: "meeting_started",
  meeting_invited: "meeting_invited",
  call_missed: "call_missed",
  minutes_published: "minutes_published",
  timesheet_reminder: "timesheet_reminder",
  phase_deadline: "phase_deadline",
  vault_expiring: "vault_expiring",
  time_budget: "time_budget",
  signature_requested: "signature_requested",
  signature_update: "signature_update"
};

// src/generated/model/addReactionDtoEmoji.ts
var AddReactionDtoEmoji = {
  "\u{1F44D}": "\u{1F44D}",
  "\u2705": "\u2705",
  "\u2764\uFE0F": "\u2764\uFE0F",
  "\u{1F602}": "\u{1F602}",
  "\u{1F62E}": "\u{1F62E}",
  "\u{1F64F}": "\u{1F64F}",
  "\u{1F440}": "\u{1F440}",
  "\u{1F389}": "\u{1F389}"
};

// src/generated/model/annotationsControllerListResolved.ts
var AnnotationsControllerListResolved = {
  true: "true",
  false: "false",
  all: "all"
};

// src/generated/model/approvalsControllerListStatus.ts
var ApprovalsControllerListStatus = {
  in_progress: "in_progress",
  approved: "approved",
  approved_with_comments: "approved_with_comments",
  rejected: "rejected",
  cancelled: "cancelled"
};

// src/generated/model/approvalsControllerListToDecide.ts
var ApprovalsControllerListToDecide = {
  true: "true",
  false: "false"
};

// src/generated/model/auditChainVerificationDtoClassOutputReason.ts
var AuditChainVerificationDtoClassOutputReason = {
  content_modified: "content_modified",
  sequence_gap: "sequence_gap",
  link_broken: "link_broken"
};

// src/generated/model/auditEventListDtoOutputItemsItemActorType.ts
var AuditEventListDtoOutputItemsItemActorType = {
  user: "user",
  system: "system",
  platform_admin: "platform_admin"
};

// src/generated/model/authControllerSignInEnrol.ts
var AuthControllerSignInEnrol = {
  totp: "totp"
};

// src/generated/model/authControllerSignInFresh.ts
var AuthControllerSignInFresh = {
  NUMBER_1: "1"
};

// src/generated/model/authControllerSignInLocale.ts
var AuthControllerSignInLocale = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/authControllerStepUpReauth.ts
var AuthControllerStepUpReauth = {
  NUMBER_1: "1"
};

// src/generated/model/billingInvoiceListDtoOutputItemsItemPurpose.ts
var BillingInvoiceListDtoOutputItemsItemPurpose = {
  start: "start",
  upgrade: "upgrade",
  restart: "restart",
  renewal: "renewal",
  resume: "resume"
};

// src/generated/model/billingInvoiceListDtoOutputItemsItemStatus.ts
var BillingInvoiceListDtoOutputItemsItemStatus = {
  open: "open",
  paid: "paid",
  void: "void"
};

// src/generated/model/breakGlassCreateDtoBasis.ts
var BreakGlassCreateDtoBasis = {
  owner_consent: "owner_consent",
  legal_requisition: "legal_requisition"
};

// src/generated/model/breakGlassListDtoOutputItemsItemBasis.ts
var BreakGlassListDtoOutputItemsItemBasis = {
  owner_consent: "owner_consent",
  legal_requisition: "legal_requisition"
};

// src/generated/model/breakGlassListDtoOutputItemsItemStatus.ts
var BreakGlassListDtoOutputItemsItemStatus = {
  pending: "pending",
  active: "active",
  rejected: "rejected",
  cancelled: "cancelled",
  expired: "expired",
  revoked: "revoked"
};

// src/generated/model/breakGlassRequestDtoOutputBasis.ts
var BreakGlassRequestDtoOutputBasis = {
  owner_consent: "owner_consent",
  legal_requisition: "legal_requisition"
};

// src/generated/model/breakGlassRequestDtoOutputStatus.ts
var BreakGlassRequestDtoOutputStatus = {
  pending: "pending",
  active: "active",
  rejected: "rejected",
  cancelled: "cancelled",
  expired: "expired",
  revoked: "revoked"
};

// src/generated/model/calendarEventDtoOutputAttendeesItemResponse.ts
var CalendarEventDtoOutputAttendeesItemResponse = {
  needs_action: "needs_action",
  accepted: "accepted",
  declined: "declined",
  tentative: "tentative"
};

// src/generated/model/calendarEventDtoOutputKind.ts
var CalendarEventDtoOutputKind = {
  meeting: "meeting",
  site_visit: "site_visit",
  deadline: "deadline",
  other: "other"
};

// src/generated/model/calendarEventDtoOutputMyResponse.ts
var CalendarEventDtoOutputMyResponse = {
  needs_action: "needs_action",
  accepted: "accepted",
  declined: "declined",
  tentative: "tentative"
};

// src/generated/model/calendarEventDtoOutputSource.ts
var CalendarEventDtoOutputSource = {
  manual: "manual",
  task: "task",
  phase: "phase",
  approval: "approval"
};

// src/generated/model/calendarEventListDtoOutputItemsItemAttendeesItemResponse.ts
var CalendarEventListDtoOutputItemsItemAttendeesItemResponse = {
  needs_action: "needs_action",
  accepted: "accepted",
  declined: "declined",
  tentative: "tentative"
};

// src/generated/model/calendarEventListDtoOutputItemsItemKind.ts
var CalendarEventListDtoOutputItemsItemKind = {
  meeting: "meeting",
  site_visit: "site_visit",
  deadline: "deadline",
  other: "other"
};

// src/generated/model/calendarEventListDtoOutputItemsItemMyResponse.ts
var CalendarEventListDtoOutputItemsItemMyResponse = {
  needs_action: "needs_action",
  accepted: "accepted",
  declined: "declined",
  tentative: "tentative"
};

// src/generated/model/calendarEventListDtoOutputItemsItemSource.ts
var CalendarEventListDtoOutputItemsItemSource = {
  manual: "manual",
  task: "task",
  phase: "phase",
  approval: "approval"
};

// src/generated/model/changeTenderStatusDtoStatus.ts
var ChangeTenderStatusDtoStatus = {
  watch: "watch",
  go: "go",
  no_go: "no_go",
  preparing: "preparing",
  submitted: "submitted",
  won: "won",
  lost: "lost"
};

// src/generated/model/channelDtoOutputDiscipline.ts
var ChannelDtoOutputDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/channelDtoOutputKind.ts
var ChannelDtoOutputKind = {
  general: "general",
  discipline: "discipline",
  private: "private",
  direct: "direct",
  group: "group"
};

// src/generated/model/channelListDtoOutputItemsItemDiscipline.ts
var ChannelListDtoOutputItemsItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/channelListDtoOutputItemsItemKind.ts
var ChannelListDtoOutputItemsItemKind = {
  general: "general",
  discipline: "discipline",
  private: "private",
  direct: "direct",
  group: "group"
};

// src/generated/model/channelMeetingsControllerListHasMinutes.ts
var ChannelMeetingsControllerListHasMinutes = {
  true: "true",
  false: "false"
};

// src/generated/model/channelMeetingsControllerListKind.ts
var ChannelMeetingsControllerListKind = {
  meeting: "meeting",
  call: "call"
};

// src/generated/model/channelMeetingsControllerListStatus.ts
var ChannelMeetingsControllerListStatus = {
  live: "live",
  scheduled: "scheduled",
  ended: "ended"
};

// src/generated/model/checklistDtoOutputItemsItemState.ts
var ChecklistDtoOutputItemsItemState = {
  todo: "todo",
  done: "done",
  not_applicable: "not_applicable"
};

// src/generated/model/checklistListDtoOutputItemsItemItemsItemState.ts
var ChecklistListDtoOutputItemsItemItemsItemState = {
  todo: "todo",
  done: "done",
  not_applicable: "not_applicable"
};

// src/generated/model/clientDtoOutputKind.ts
var ClientDtoOutputKind = {
  public_entity: "public_entity",
  private_company: "private_company",
  individual: "individual",
  foreign: "foreign"
};

// src/generated/model/clientDtoOutputVatRegime.ts
var ClientDtoOutputVatRegime = {
  subject: "subject",
  exempt: "exempt",
  suspended: "suspended",
  export: "export"
};

// src/generated/model/clientErrorReportDtoKind.ts
var ClientErrorReportDtoKind = {
  error: "error",
  unhandledrejection: "unhandledrejection",
  boundary: "boundary"
};

// src/generated/model/clientListDtoOutputItemsItemKind.ts
var ClientListDtoOutputItemsItemKind = {
  public_entity: "public_entity",
  private_company: "private_company",
  individual: "individual",
  foreign: "foreign"
};

// src/generated/model/clientListDtoOutputItemsItemVatRegime.ts
var ClientListDtoOutputItemsItemVatRegime = {
  subject: "subject",
  exempt: "exempt",
  suspended: "suspended",
  export: "export"
};

// src/generated/model/clientsControllerListArchived.ts
var ClientsControllerListArchived = {
  true: "true",
  false: "false"
};

// src/generated/model/clientsControllerListKind.ts
var ClientsControllerListKind = {
  public_entity: "public_entity",
  private_company: "private_company",
  individual: "individual",
  foreign: "foreign"
};

// src/generated/model/closedPartnershipListDtoOutputItemsItemLastExportStatus.ts
var ClosedPartnershipListDtoOutputItemsItemLastExportStatus = {
  queued: "queued",
  running: "running",
  ready: "ready",
  failed: "failed",
  expired: "expired"
};

// src/generated/model/closedSpaceDtoOutputAccessRights.ts
var ClosedSpaceDtoOutputAccessRights = {
  read: "read",
  write: "write",
  approve: "approve"
};

// src/generated/model/closedSpaceDtoOutputAccessVia.ts
var ClosedSpaceDtoOutputAccessVia = {
  host_member: "host_member",
  partner_delegation: "partner_delegation",
  direct_invite: "direct_invite",
  guest: "guest",
  partner_admin: "partner_admin"
};

// src/generated/model/closedSpaceDtoOutputKind.ts
var ClosedSpaceDtoOutputKind = {
  organization: "organization",
  internal: "internal",
  shared: "shared",
  group: "group"
};

// src/generated/model/closedSpaceDtoOutputStatus.ts
var ClosedSpaceDtoOutputStatus = {
  active: "active",
  closed: "closed"
};

// src/generated/model/closedSpaceDtoOutputTabsItem.ts
var ClosedSpaceDtoOutputTabsItem = {
  documents: "documents",
  synthesis: "synthesis",
  groupement: "groupement",
  chat: "chat",
  calendar: "calendar",
  meetings: "meetings",
  people: "people",
  partners: "partners",
  delegates: "delegates",
  settings: "settings",
  audit: "audit"
};

// src/generated/model/commentDtoOutputSubjectType.ts
var CommentDtoOutputSubjectType = {
  task: "task",
  document: "document",
  deliverable: "deliverable",
  annotation: "annotation"
};

// src/generated/model/commentListDtoOutputItemsItemSubjectType.ts
var CommentListDtoOutputItemsItemSubjectType = {
  task: "task",
  document: "document",
  deliverable: "deliverable",
  annotation: "annotation"
};

// src/generated/model/completedUploadDtoOutputStatus.ts
var CompletedUploadDtoOutputStatus = {
  uploading: "uploading",
  scanning: "scanning",
  available: "available",
  rejected: "rejected"
};

// src/generated/model/contractDtoOutputClientKind.ts
var ContractDtoOutputClientKind = {
  public_entity: "public_entity",
  private_company: "private_company",
  individual: "individual",
  foreign: "foreign"
};

// src/generated/model/contractDtoOutputCurrency.ts
var ContractDtoOutputCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/contractDtoOutputKind.ts
var ContractDtoOutputKind = {
  private_agreement: "private_agreement",
  public_market: "public_market"
};

// src/generated/model/contractDtoOutputRetentionBase.ts
var ContractDtoOutputRetentionBase = {
  ht: "ht",
  ttc: "ttc"
};

// src/generated/model/contractDtoOutputWarningsItemCode.ts
var ContractDtoOutputWarningsItemCode = {
  RETENTION_ABOVE_LIMIT: "RETENTION_ABOVE_LIMIT",
  PERFORMANCE_BOND_ABOVE_LIMIT: "PERFORMANCE_BOND_ABOVE_LIMIT",
  RETENTION_PLUS_BOND_ABOVE_LIMIT: "RETENTION_PLUS_BOND_ABOVE_LIMIT",
  PENALTY_CAP_ABOVE_LIMIT: "PENALTY_CAP_ABOVE_LIMIT",
  ADVANCE_ABOVE_LIMIT: "ADVANCE_ABOVE_LIMIT"
};

// src/generated/model/contractListDtoOutputItemsItemCurrency.ts
var ContractListDtoOutputItemsItemCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/contractListDtoOutputItemsItemKind.ts
var ContractListDtoOutputItemsItemKind = {
  private_agreement: "private_agreement",
  public_market: "public_market"
};

// src/generated/model/contractsControllerListKind.ts
var ContractsControllerListKind = {
  private_agreement: "private_agreement",
  public_market: "public_market"
};

// src/generated/model/convertQuoteDtoMissionType.ts
var ConvertQuoteDtoMissionType = {
  public_building: "public_building",
  collective_housing: "collective_housing",
  villa: "villa",
  industrial: "industrial",
  facility: "facility",
  subdivision_vrd: "subdivision_vrd",
  expertise: "expertise"
};

// src/generated/model/convertTenderDtoMissionType.ts
var ConvertTenderDtoMissionType = {
  public_building: "public_building",
  collective_housing: "collective_housing",
  villa: "villa",
  industrial: "industrial",
  facility: "facility",
  subdivision_vrd: "subdivision_vrd",
  expertise: "expertise"
};

// src/generated/model/createAccountingExportDtoFormat.ts
var CreateAccountingExportDtoFormat = {
  csv: "csv",
  xlsx: "xlsx"
};

// src/generated/model/createAccountingExportDtoJournal.ts
var CreateAccountingExportDtoJournal = {
  sales: "sales",
  purchases: "purchases",
  treasury: "treasury",
  vat_summary: "vat_summary",
  withholding_summary: "withholding_summary"
};

// src/generated/model/createAccountingExportDtoPreset.ts
var CreateAccountingExportDtoPreset = {
  generic: "generic",
  sage100: "sage100",
  ciel: "ciel"
};

// src/generated/model/createClientDtoKind.ts
var CreateClientDtoKind = {
  public_entity: "public_entity",
  private_company: "private_company",
  individual: "individual",
  foreign: "foreign"
};

// src/generated/model/createClientDtoVatRegime.ts
var CreateClientDtoVatRegime = {
  subject: "subject",
  exempt: "exempt",
  suspended: "suspended",
  export: "export"
};

// src/generated/model/createContractDtoCurrency.ts
var CreateContractDtoCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/createContractDtoKind.ts
var CreateContractDtoKind = {
  private_agreement: "private_agreement",
  public_market: "public_market"
};

// src/generated/model/createContractDtoRetentionBase.ts
var CreateContractDtoRetentionBase = {
  ht: "ht",
  ttc: "ttc"
};

// src/generated/model/createCredentialDtoKind.ts
var CreateCredentialDtoKind = {
  seal: "seal",
  test: "test"
};

// src/generated/model/createCreditNoteDtoLinesItemRole.ts
var CreateCreditNoteDtoLinesItemRole = {
  service: "service",
  advance_recovery: "advance_recovery",
  retention: "retention",
  retention_release: "retention_release"
};

// src/generated/model/createDeliverableDtoDeliverableType.ts
var CreateDeliverableDtoDeliverableType = {
  drawing: "drawing",
  calculation_note: "calculation_note",
  report: "report",
  specification: "specification",
  bill_of_quantities: "bill_of_quantities",
  estimate: "estimate",
  other: "other"
};

// src/generated/model/createDeliverableDtoDiscipline.ts
var CreateDeliverableDtoDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/createdIcsFeedDtoOutputScope.ts
var CreatedIcsFeedDtoOutputScope = {
  visible: "visible",
  mine: "mine"
};

// src/generated/model/createdShareLinkDtoOutputLinkStatus.ts
var CreatedShareLinkDtoOutputLinkStatus = {
  active: "active",
  expired: "expired",
  revoked: "revoked",
  exhausted: "exhausted"
};

// src/generated/model/createEventDtoKind.ts
var CreateEventDtoKind = {
  meeting: "meeting",
  site_visit: "site_visit",
  deadline: "deadline",
  other: "other"
};

// src/generated/model/createExpenseDtoCategory.ts
var CreateExpenseDtoCategory = {
  transport: "transport",
  fuel: "fuel",
  accommodation: "accommodation",
  meals: "meals",
  supplies: "supplies",
  printing: "printing",
  software: "software",
  telecom: "telecom",
  training: "training",
  permit_fees: "permit_fees",
  other: "other"
};

// src/generated/model/createFiscalProfileDtoTaxRegime.ts
var CreateFiscalProfileDtoTaxRegime = {
  real: "real",
  flat_rate: "flat_rate"
};

// src/generated/model/createFiscalProfileDtoWithholdingStatus.ts
var CreateFiscalProfileDtoWithholdingStatus = {
  legal_entity: "legal_entity",
  real_regime: "real_regime",
  other: "other"
};

// src/generated/model/createGroupementPaymentDtoKind.ts
var CreateGroupementPaymentDtoKind = {
  received: "received",
  redistributed: "redistributed"
};

// src/generated/model/createIcsFeedDtoScope.ts
var CreateIcsFeedDtoScope = {
  visible: "visible",
  mine: "mine"
};

// src/generated/model/createInvitationDtoLocale.ts
var CreateInvitationDtoLocale = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/createInvoiceDtoCurrency.ts
var CreateInvoiceDtoCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/createInvoiceDtoKind.ts
var CreateInvoiceDtoKind = {
  advance: "advance",
  deposit: "deposit",
  progress: "progress",
  final: "final"
};

// src/generated/model/createInvoiceDtoLanguage.ts
var CreateInvoiceDtoLanguage = {
  fr: "fr",
  ar: "ar",
  bilingual: "bilingual"
};

// src/generated/model/createInvoiceDtoLinesItemRole.ts
var CreateInvoiceDtoLinesItemRole = {
  service: "service",
  advance_recovery: "advance_recovery",
  retention: "retention",
  retention_release: "retention_release"
};

// src/generated/model/createInvoiceDtoVatTreatment.ts
var CreateInvoiceDtoVatTreatment = {
  standard: "standard",
  suspended: "suspended",
  export: "export"
};

// src/generated/model/createLeaveDtoKind.ts
var CreateLeaveDtoKind = {
  leave: "leave",
  sick: "sick",
  training: "training",
  other: "other"
};

// src/generated/model/createMinutesDtoLanguage.ts
var CreateMinutesDtoLanguage = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/createMinutesDtoTemplate.ts
var CreateMinutesDtoTemplate = {
  coordination: "coordination",
  moa: "moa",
  site_meeting: "site_meeting",
  site_visit: "site_visit"
};

// src/generated/model/createObservationDtoKind.ts
var CreateObservationDtoKind = {
  observation: "observation",
  reserve: "reserve"
};

// src/generated/model/createOrderDtoKind.ts
var CreateOrderDtoKind = {
  start: "start",
  stop: "stop",
  resume: "resume"
};

// src/generated/model/createOrganizationDtoDefaultLocale.ts
var CreateOrganizationDtoDefaultLocale = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/createOrganizationDtoDisciplinesItem.ts
var CreateOrganizationDtoDisciplinesItem = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/createOrganizationDtoGovernorate.ts
var CreateOrganizationDtoGovernorate = {
  tunis: "tunis",
  ariana: "ariana",
  ben_arous: "ben_arous",
  manouba: "manouba",
  nabeul: "nabeul",
  zaghouan: "zaghouan",
  bizerte: "bizerte",
  beja: "beja",
  jendouba: "jendouba",
  kef: "kef",
  siliana: "siliana",
  kairouan: "kairouan",
  kasserine: "kasserine",
  sidi_bouzid: "sidi_bouzid",
  sousse: "sousse",
  monastir: "monastir",
  mahdia: "mahdia",
  sfax: "sfax",
  gafsa: "gafsa",
  tozeur: "tozeur",
  kebili: "kebili",
  gabes: "gabes",
  medenine: "medenine",
  tataouine: "tataouine"
};

// src/generated/model/createOrganizationDtoLegalForm.ts
var CreateOrganizationDtoLegalForm = {
  individual: "individual",
  suarl: "suarl",
  sarl: "sarl",
  sa: "sa",
  snc: "snc",
  scs: "scs",
  gie: "gie",
  other: "other"
};

// src/generated/model/createOrgChannelDtoKind.ts
var CreateOrgChannelDtoKind = {
  general: "general",
  direct: "direct",
  group: "group"
};

// src/generated/model/createOrgDataExportDtoScope.ts
var CreateOrgDataExportDtoScope = {
  organization: "organization",
  finance: "finance"
};

// src/generated/model/createOrgTemplateDtoDefinitionChannelsItemDiscipline.ts
var CreateOrgTemplateDtoDefinitionChannelsItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/createOrgTemplateDtoDefinitionChannelsItemKind.ts
var CreateOrgTemplateDtoDefinitionChannelsItemKind = {
  general: "general",
  discipline: "discipline"
};

// src/generated/model/createOrgTemplateDtoDefinitionPhasesItemPhaseType.ts
var CreateOrgTemplateDtoDefinitionPhasesItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/createOrgTemplateDtoDefinitionTasksItemDiscipline.ts
var CreateOrgTemplateDtoDefinitionTasksItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/createOrgTemplateDtoDefinitionTasksItemPhaseType.ts
var CreateOrgTemplateDtoDefinitionTasksItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/createPaymentDtoMethod.ts
var CreatePaymentDtoMethod = {
  transfer: "transfer",
  cheque: "cheque",
  bill: "bill",
  cash: "cash",
  online: "online"
};

// src/generated/model/createPhaseDtoPhaseType.ts
var CreatePhaseDtoPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/createProjectDtoFeeMode.ts
var CreateProjectDtoFeeMode = {
  lump_sum: "lump_sum",
  works_percentage: "works_percentage",
  time_based: "time_based"
};

// src/generated/model/createProjectDtoGovernorate.ts
var CreateProjectDtoGovernorate = {
  tunis: "tunis",
  ariana: "ariana",
  ben_arous: "ben_arous",
  manouba: "manouba",
  nabeul: "nabeul",
  zaghouan: "zaghouan",
  bizerte: "bizerte",
  beja: "beja",
  jendouba: "jendouba",
  kef: "kef",
  siliana: "siliana",
  kairouan: "kairouan",
  kasserine: "kasserine",
  sidi_bouzid: "sidi_bouzid",
  sousse: "sousse",
  monastir: "monastir",
  mahdia: "mahdia",
  sfax: "sfax",
  gafsa: "gafsa",
  tozeur: "tozeur",
  kebili: "kebili",
  gabes: "gabes",
  medenine: "medenine",
  tataouine: "tataouine"
};

// src/generated/model/createProjectDtoMissionType.ts
var CreateProjectDtoMissionType = {
  public_building: "public_building",
  collective_housing: "collective_housing",
  villa: "villa",
  industrial: "industrial",
  facility: "facility",
  subdivision_vrd: "subdivision_vrd",
  expertise: "expertise"
};

// src/generated/model/createQuoteDtoCurrency.ts
var CreateQuoteDtoCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/createQuoteDtoFeeMode.ts
var CreateQuoteDtoFeeMode = {
  lump_sum: "lump_sum",
  percentage_of_works: "percentage_of_works",
  time_based: "time_based",
  mixed: "mixed"
};

// src/generated/model/createQuoteDtoLanguage.ts
var CreateQuoteDtoLanguage = {
  fr: "fr",
  ar: "ar",
  bilingual: "bilingual"
};

// src/generated/model/createQuoteDtoLinesItemPhaseType.ts
var CreateQuoteDtoLinesItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/createReceptionReportDtoLanguage.ts
var CreateReceptionReportDtoLanguage = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/createRoleDtoBasedOn.ts
var CreateRoleDtoBasedOn = {
  admin: "admin",
  project_manager: "project_manager",
  engineer: "engineer",
  draftsman: "draftsman",
  accountant: "accountant"
};

// src/generated/model/createSignatureRequestDtoLevel.ts
var CreateSignatureRequestDtoLevel = {
  simple: "simple",
  qualified: "qualified"
};

// src/generated/model/createSpaceChannelDtoDiscipline.ts
var CreateSpaceChannelDtoDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/createSpaceChannelDtoKind.ts
var CreateSpaceChannelDtoKind = {
  general: "general",
  discipline: "discipline",
  private: "private"
};

// src/generated/model/createSpaceDtoKind.ts
var CreateSpaceDtoKind = {
  shared: "shared",
  group: "group"
};

// src/generated/model/createSpaceInvitationDtoKind.ts
var CreateSpaceInvitationDtoKind = {
  nominative: "nominative",
  guest: "guest"
};

// src/generated/model/createSpaceInvitationDtoLocale.ts
var CreateSpaceInvitationDtoLocale = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/createSpaceInvitationDtoRights.ts
var CreateSpaceInvitationDtoRights = {
  read: "read",
  write: "write",
  approve: "approve"
};

// src/generated/model/createSupplierDtoKind.ts
var CreateSupplierDtoKind = {
  company: "company",
  individual: "individual",
  non_resident: "non_resident"
};

// src/generated/model/createSupplierDtoWithholdingProfile.ts
var CreateSupplierDtoWithholdingProfile = {
  fees_legal_entity: "fees_legal_entity",
  fees_other: "fees_other",
  fees_non_resident: "fees_non_resident",
  purchases: "purchases",
  none: "none"
};

// src/generated/model/createSupplierPaymentDtoMethod.ts
var CreateSupplierPaymentDtoMethod = {
  transfer: "transfer",
  cheque: "cheque",
  bill: "bill",
  cash: "cash",
  online: "online"
};

// src/generated/model/createTaskDtoDiscipline.ts
var CreateTaskDtoDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/createTaskDtoPriority.ts
var CreateTaskDtoPriority = {
  low: "low",
  normal: "normal",
  high: "high",
  urgent: "urgent"
};

// src/generated/model/createTaskDtoStatus.ts
var CreateTaskDtoStatus = {
  todo: "todo",
  in_progress: "in_progress",
  blocked: "blocked",
  done: "done"
};

// src/generated/model/createTejExportDtoAdapter.ts
var CreateTejExportDtoAdapter = {
  "tej-csv-20261": "tej-csv-2026.1"
};

// src/generated/model/createTemplateDtoStepsItemMode.ts
var CreateTemplateDtoStepsItemMode = {
  sequential: "sequential",
  parallel: "parallel"
};

// src/generated/model/createTenderDtoSource.ts
var CreateTenderDtoSource = {
  tuneps: "tuneps",
  press: "press",
  client_site: "client_site",
  other: "other"
};

// src/generated/model/createTimeEntryDtoCategory.ts
var CreateTimeEntryDtoCategory = {
  studies: "studies",
  site: "site",
  meeting: "meeting",
  travel: "travel",
  admin: "admin",
  other: "other"
};

// src/generated/model/createTransmittalDtoLanguage.ts
var CreateTransmittalDtoLanguage = {
  fr: "fr",
  ar: "ar"
};

// src/generated/model/createUploadDtoMetadataDiscipline.ts
var CreateUploadDtoMetadataDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/createUploadDtoMetadataDocType.ts
var CreateUploadDtoMetadataDocType = {
  drawing: "drawing",
  calculation_note: "calculation_note",
  report: "report",
  specification: "specification",
  bill_of_quantities: "bill_of_quantities",
  estimate: "estimate",
  minutes: "minutes",
  correspondence: "correspondence",
  photo: "photo",
  other: "other"
};

// src/generated/model/createUploadDtoMetadataPhaseType.ts
var CreateUploadDtoMetadataPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/createVaultDocumentDtoKind.ts
var CreateVaultDocumentDtoKind = {
  tax_certificate: "tax_certificate",
  cnss_certificate: "cnss_certificate",
  rne: "rne",
  agreement: "agreement",
  order_registration: "order_registration",
  insurance: "insurance",
  cv: "cv",
  reference: "reference"
};

// src/generated/model/credentialDtoOutputKeyAlgorithm.ts
var CredentialDtoOutputKeyAlgorithm = {
  RSA: "RSA",
  ECDSA: "ECDSA"
};

// src/generated/model/credentialDtoOutputKind.ts
var CredentialDtoOutputKind = {
  seal: "seal",
  test: "test",
  digigo: "digigo"
};

// src/generated/model/credentialDtoOutputStatus.ts
var CredentialDtoOutputStatus = {
  active: "active",
  replaced: "replaced",
  revoked: "revoked"
};

// src/generated/model/credentialListDtoOutputItemsItemKeyAlgorithm.ts
var CredentialListDtoOutputItemsItemKeyAlgorithm = {
  RSA: "RSA",
  ECDSA: "ECDSA"
};

// src/generated/model/credentialListDtoOutputItemsItemKind.ts
var CredentialListDtoOutputItemsItemKind = {
  seal: "seal",
  test: "test",
  digigo: "digigo"
};

// src/generated/model/credentialListDtoOutputItemsItemStatus.ts
var CredentialListDtoOutputItemsItemStatus = {
  active: "active",
  replaced: "replaced",
  revoked: "revoked"
};

// src/generated/model/decideDtoDecision.ts
var DecideDtoDecision = {
  vso: "vso",
  vao: "vao",
  ref: "ref"
};

// src/generated/model/decideTimeEntriesDtoDecision.ts
var DecideTimeEntriesDtoDecision = {
  approve: "approve",
  reject: "reject"
};

// src/generated/model/delegateMemberDtoRights.ts
var DelegateMemberDtoRights = {
  read: "read",
  write: "write",
  approve: "approve"
};

// src/generated/model/deletionRequestDtoOutputReason.ts
var DeletionRequestDtoOutputReason = {
  unpaid: "unpaid",
  trial_expired: "trial_expired",
  cancelled: "cancelled",
  owner_request: "owner_request",
  platform_admin: "platform_admin"
};

// src/generated/model/deletionRequestDtoOutputStatus.ts
var DeletionRequestDtoOutputStatus = {
  scheduled: "scheduled",
  running: "running",
  cancelled: "cancelled",
  done: "done"
};

// src/generated/model/deletionStatusDtoOutputRequestReason.ts
var DeletionStatusDtoOutputRequestReason = {
  unpaid: "unpaid",
  trial_expired: "trial_expired",
  cancelled: "cancelled",
  owner_request: "owner_request",
  platform_admin: "platform_admin"
};

// src/generated/model/deletionStatusDtoOutputRequestStatus.ts
var DeletionStatusDtoOutputRequestStatus = {
  scheduled: "scheduled",
  running: "running",
  cancelled: "cancelled",
  done: "done"
};

// src/generated/model/deliverableDtoOutputDeliverableType.ts
var DeliverableDtoOutputDeliverableType = {
  drawing: "drawing",
  calculation_note: "calculation_note",
  report: "report",
  specification: "specification",
  bill_of_quantities: "bill_of_quantities",
  estimate: "estimate",
  other: "other"
};

// src/generated/model/deliverableDtoOutputDiscipline.ts
var DeliverableDtoOutputDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/deliverableDtoOutputStatus.ts
var DeliverableDtoOutputStatus = {
  to_produce: "to_produce",
  in_progress: "in_progress",
  in_review: "in_review",
  approved: "approved",
  transmitted: "transmitted"
};

// src/generated/model/deliverableListDtoOutputItemsItemDeliverableType.ts
var DeliverableListDtoOutputItemsItemDeliverableType = {
  drawing: "drawing",
  calculation_note: "calculation_note",
  report: "report",
  specification: "specification",
  bill_of_quantities: "bill_of_quantities",
  estimate: "estimate",
  other: "other"
};

// src/generated/model/deliverableListDtoOutputItemsItemDiscipline.ts
var DeliverableListDtoOutputItemsItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/deliverableListDtoOutputItemsItemStatus.ts
var DeliverableListDtoOutputItemsItemStatus = {
  to_produce: "to_produce",
  in_progress: "in_progress",
  in_review: "in_review",
  approved: "approved",
  transmitted: "transmitted"
};

// src/generated/model/deliverablesControllerListStatus.ts
var DeliverablesControllerListStatus = {
  to_produce: "to_produce",
  in_progress: "in_progress",
  in_review: "in_review",
  approved: "approved",
  transmitted: "transmitted"
};

// src/generated/model/diffusionHistoryDtoOutputItemsItemRecipientsItemAcknowledgedVia.ts
var DiffusionHistoryDtoOutputItemsItemRecipientsItemAcknowledgedVia = {
  app: "app",
  link: "link"
};

// src/generated/model/diffusionHistoryDtoOutputItemsItemRecipientsItemKind.ts
var DiffusionHistoryDtoOutputItemsItemRecipientsItemKind = {
  user: "user",
  email: "email"
};

// src/generated/model/directoryContactResponseDtoOutput.ts
var DirectoryContactResponseDtoOutputValue = {
  sent: true
};

// src/generated/model/directoryControllerSearchDiscipline.ts
var DirectoryControllerSearchDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/directoryControllerSearchGovernorate.ts
var DirectoryControllerSearchGovernorate = {
  tunis: "tunis",
  ariana: "ariana",
  ben_arous: "ben_arous",
  manouba: "manouba",
  nabeul: "nabeul",
  zaghouan: "zaghouan",
  bizerte: "bizerte",
  beja: "beja",
  jendouba: "jendouba",
  kef: "kef",
  siliana: "siliana",
  kairouan: "kairouan",
  kasserine: "kasserine",
  sidi_bouzid: "sidi_bouzid",
  sousse: "sousse",
  monastir: "monastir",
  mahdia: "mahdia",
  sfax: "sfax",
  gafsa: "gafsa",
  tozeur: "tozeur",
  kebili: "kebili",
  gabes: "gabes",
  medenine: "medenine",
  tataouine: "tataouine"
};

// src/generated/model/documentDetailDtoOutputDiscipline.ts
var DocumentDetailDtoOutputDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/documentDetailDtoOutputDocType.ts
var DocumentDetailDtoOutputDocType = {
  drawing: "drawing",
  calculation_note: "calculation_note",
  report: "report",
  specification: "specification",
  bill_of_quantities: "bill_of_quantities",
  estimate: "estimate",
  minutes: "minutes",
  correspondence: "correspondence",
  photo: "photo",
  other: "other"
};

// src/generated/model/documentDetailDtoOutputLatestVersionStatus.ts
var DocumentDetailDtoOutputLatestVersionStatus = {
  uploading: "uploading",
  scanning: "scanning",
  available: "available",
  rejected: "rejected"
};

// src/generated/model/documentDetailDtoOutputMissingMetadataItem.ts
var DocumentDetailDtoOutputMissingMetadataItem = {
  discipline: "discipline",
  phaseType: "phaseType",
  docType: "docType",
  zone: "zone"
};

// src/generated/model/documentDetailDtoOutputPhaseType.ts
var DocumentDetailDtoOutputPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/documentListDtoOutputItemsItemDiscipline.ts
var DocumentListDtoOutputItemsItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/documentListDtoOutputItemsItemDocType.ts
var DocumentListDtoOutputItemsItemDocType = {
  drawing: "drawing",
  calculation_note: "calculation_note",
  report: "report",
  specification: "specification",
  bill_of_quantities: "bill_of_quantities",
  estimate: "estimate",
  minutes: "minutes",
  correspondence: "correspondence",
  photo: "photo",
  other: "other"
};

// src/generated/model/documentListDtoOutputItemsItemLatestVersionStatus.ts
var DocumentListDtoOutputItemsItemLatestVersionStatus = {
  uploading: "uploading",
  scanning: "scanning",
  available: "available",
  rejected: "rejected"
};

// src/generated/model/documentListDtoOutputItemsItemPhaseType.ts
var DocumentListDtoOutputItemsItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/documentsControllerListDiscipline.ts
var DocumentsControllerListDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/documentsControllerListDocType.ts
var DocumentsControllerListDocType = {
  drawing: "drawing",
  calculation_note: "calculation_note",
  report: "report",
  specification: "specification",
  bill_of_quantities: "bill_of_quantities",
  estimate: "estimate",
  minutes: "minutes",
  correspondence: "correspondence",
  photo: "photo",
  other: "other"
};

// src/generated/model/documentsControllerListOrder.ts
var DocumentsControllerListOrder = {
  asc: "asc",
  desc: "desc"
};

// src/generated/model/documentsControllerListPhaseType.ts
var DocumentsControllerListPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/documentsControllerListSort.ts
var DocumentsControllerListSort = {
  code: "code",
  title: "title",
  updatedAt: "updatedAt"
};

// src/generated/model/documentSettingsDtoIndexStyle.ts
var DocumentSettingsDtoIndexStyle = {
  letters: "letters",
  numbers: "numbers"
};

// src/generated/model/documentSettingsDtoOutputIndexStyle.ts
var DocumentSettingsDtoOutputIndexStyle = {
  letters: "letters",
  numbers: "numbers"
};

// src/generated/model/documentVersionDtoOutputRejectionReason.ts
var DocumentVersionDtoOutputRejectionReason = {
  infected: "infected",
  scan_limits: "scan_limits",
  type_mismatch: "type_mismatch",
  html_content: "html_content",
  size_mismatch: "size_mismatch",
  sha256_mismatch: "sha256_mismatch"
};

// src/generated/model/documentVersionDtoOutputStatus.ts
var DocumentVersionDtoOutputStatus = {
  uploading: "uploading",
  scanning: "scanning",
  available: "available",
  rejected: "rejected"
};

// src/generated/model/documentVersionListDtoOutputItemsItemRejectionReason.ts
var DocumentVersionListDtoOutputItemsItemRejectionReason = {
  infected: "infected",
  scan_limits: "scan_limits",
  type_mismatch: "type_mismatch",
  html_content: "html_content",
  size_mismatch: "size_mismatch",
  sha256_mismatch: "sha256_mismatch"
};

// src/generated/model/documentVersionListDtoOutputItemsItemStatus.ts
var DocumentVersionListDtoOutputItemsItemStatus = {
  uploading: "uploading",
  scanning: "scanning",
  available: "available",
  rejected: "rejected"
};

// src/generated/model/downloadUrlDtoOutputStatus.ts
var DownloadUrlDtoOutputStatus = {
  ready: "ready",
  preparing: "preparing"
};

// src/generated/model/entryDtoOutputCategory.ts
var EntryDtoOutputCategory = {
  studies: "studies",
  site: "site",
  meeting: "meeting",
  travel: "travel",
  admin: "admin",
  other: "other"
};

// src/generated/model/entryDtoOutputStatus.ts
var EntryDtoOutputStatus = {
  draft: "draft",
  submitted: "submitted",
  approved: "approved",
  rejected: "rejected"
};

// src/generated/model/eventResponseDtoResponse.ts
var EventResponseDtoResponse = {
  accepted: "accepted",
  declined: "declined",
  tentative: "tentative"
};

// src/generated/model/exitExportDtoOutputStatus.ts
var ExitExportDtoOutputStatus = {
  queued: "queued",
  running: "running",
  ready: "ready",
  failed: "failed",
  expired: "expired"
};

// src/generated/model/expenseDtoOutputCategory.ts
var ExpenseDtoOutputCategory = {
  transport: "transport",
  fuel: "fuel",
  accommodation: "accommodation",
  meals: "meals",
  supplies: "supplies",
  printing: "printing",
  software: "software",
  telecom: "telecom",
  training: "training",
  permit_fees: "permit_fees",
  other: "other"
};

// src/generated/model/expenseDtoOutputStatus.ts
var ExpenseDtoOutputStatus = {
  submitted: "submitted",
  approved: "approved",
  rejected: "rejected",
  reimbursed: "reimbursed"
};

// src/generated/model/expenseListDtoOutputItemsItemCategory.ts
var ExpenseListDtoOutputItemsItemCategory = {
  transport: "transport",
  fuel: "fuel",
  accommodation: "accommodation",
  meals: "meals",
  supplies: "supplies",
  printing: "printing",
  software: "software",
  telecom: "telecom",
  training: "training",
  permit_fees: "permit_fees",
  other: "other"
};

// src/generated/model/expenseListDtoOutputItemsItemStatus.ts
var ExpenseListDtoOutputItemsItemStatus = {
  submitted: "submitted",
  approved: "approved",
  rejected: "rejected",
  reimbursed: "reimbursed"
};

// src/generated/model/expensesControllerListCategory.ts
var ExpensesControllerListCategory = {
  transport: "transport",
  fuel: "fuel",
  accommodation: "accommodation",
  meals: "meals",
  supplies: "supplies",
  printing: "printing",
  software: "software",
  telecom: "telecom",
  training: "training",
  permit_fees: "permit_fees",
  other: "other"
};

// src/generated/model/expensesControllerListStatus.ts
var ExpensesControllerListStatus = {
  submitted: "submitted",
  approved: "approved",
  rejected: "rejected",
  reimbursed: "reimbursed"
};

// src/generated/model/expensesControllerMineStatus.ts
var ExpensesControllerMineStatus = {
  submitted: "submitted",
  approved: "approved",
  rejected: "rejected",
  reimbursed: "reimbursed"
};

// src/generated/model/feeScaleDtoOutputSource.ts
var FeeScaleDtoOutputSource = {
  decree_78_71: "decree_78_71",
  oat: "oat",
  oit_2026: "oit_2026",
  custom: "custom"
};

// src/generated/model/feeScaleListDtoOutputItemsItemSource.ts
var FeeScaleListDtoOutputItemsItemSource = {
  decree_78_71: "decree_78_71",
  oat: "oat",
  oit_2026: "oit_2026",
  custom: "custom"
};

// src/generated/model/financeDashboardDtoOutputScope.ts
var FinanceDashboardDtoOutputScope = {
  organization: "organization",
  projects: "projects"
};

// src/generated/model/financePreviewDtoOutputComputationCurrency.ts
var FinancePreviewDtoOutputComputationCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/financePreviewDtoOutputComputationKind.ts
var FinancePreviewDtoOutputComputationKind = {
  advance: "advance",
  deposit: "deposit",
  progress: "progress",
  final: "final",
  credit_note: "credit_note"
};

// src/generated/model/financePreviewDtoOutputComputationLinesItemRole.ts
var FinancePreviewDtoOutputComputationLinesItemRole = {
  service: "service",
  advance_recovery: "advance_recovery",
  retention: "retention",
  retention_release: "retention_release"
};

// src/generated/model/financePreviewDtoOutputComputationStepsItemKey.ts
var FinancePreviewDtoOutputComputationStepsItemKey = {
  subtotal_ht: "subtotal_ht",
  vat: "vat",
  stamp: "stamp",
  total_ttc: "total_ttc",
  withholding: "withholding",
  vat_withholding: "vat_withholding",
  net_payable: "net_payable"
};

// src/generated/model/financePreviewDtoOutputComputationStepsItemNote.ts
var FinancePreviewDtoOutputComputationStepsItemNote = {
  vat_suspended: "vat_suspended",
  vat_export: "vat_export",
  stamp_exempt_treatment: "stamp_exempt_treatment",
  stamp_exempt_public_buyer: "stamp_exempt_public_buyer",
  stamp_not_reversed: "stamp_not_reversed",
  not_applicable: "not_applicable",
  below_threshold: "below_threshold"
};

// src/generated/model/financePreviewDtoOutputComputationStepsItemToVerifyItem.ts
var FinancePreviewDtoOutputComputationStepsItemToVerifyItem = {
  stampexemptPublicBuyers: "stamp.exemptPublicBuyers",
  withholdingbase: "withholding.base",
  withholdingpurchases: "withholding.purchases",
  vatWithholdingthresholdBase: "vatWithholding.thresholdBase",
  contractretentionBase: "contract.retentionBase",
  lateInterest: "lateInterest"
};

// src/generated/model/financePreviewDtoOutputComputationTreatmentMentionTreatment.ts
var FinancePreviewDtoOutputComputationTreatmentMentionTreatment = {
  suspended: "suspended",
  export: "export"
};

// src/generated/model/financePreviewDtoOutputComputationUsedToVerifyRulesItem.ts
var FinancePreviewDtoOutputComputationUsedToVerifyRulesItem = {
  stampexemptPublicBuyers: "stamp.exemptPublicBuyers",
  withholdingbase: "withholding.base",
  withholdingpurchases: "withholding.purchases",
  vatWithholdingthresholdBase: "vatWithholding.thresholdBase",
  contractretentionBase: "contract.retentionBase",
  lateInterest: "lateInterest"
};

// src/generated/model/financePreviewDtoOutputComputationVatTreatment.ts
var FinancePreviewDtoOutputComputationVatTreatment = {
  standard: "standard",
  suspended: "suspended",
  export: "export"
};

// src/generated/model/financePreviewDtoOutputRuleSetVerificationStatus.ts
var FinancePreviewDtoOutputRuleSetVerificationStatus = {
  verified: "verified",
  to_verify: "to_verify"
};

// src/generated/model/financePreviewRequestDtoCurrency.ts
var FinancePreviewRequestDtoCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/financePreviewRequestDtoKind.ts
var FinancePreviewRequestDtoKind = {
  advance: "advance",
  deposit: "deposit",
  progress: "progress",
  final: "final",
  credit_note: "credit_note"
};

// src/generated/model/financePreviewRequestDtoLinesItemRole.ts
var FinancePreviewRequestDtoLinesItemRole = {
  service: "service",
  advance_recovery: "advance_recovery",
  retention: "retention",
  retention_release: "retention_release"
};

// src/generated/model/financePreviewRequestDtoVatTreatment.ts
var FinancePreviewRequestDtoVatTreatment = {
  standard: "standard",
  suspended: "suspended",
  export: "export"
};

// src/generated/model/financeSettingsDtoOutputRevenueRecognition.ts
var FinanceSettingsDtoOutputRevenueRecognition = {
  invoiced: "invoiced",
  completion: "completion"
};

// src/generated/model/financeTaxRuleSetDtoOutputToVerifyItem.ts
var FinanceTaxRuleSetDtoOutputToVerifyItem = {
  stampexemptPublicBuyers: "stamp.exemptPublicBuyers",
  withholdingbase: "withholding.base",
  withholdingpurchases: "withholding.purchases",
  vatWithholdingthresholdBase: "vatWithholding.thresholdBase",
  contractretentionBase: "contract.retentionBase",
  lateInterest: "lateInterest"
};

// src/generated/model/financeTaxRuleSetDtoOutputVerificationStatus.ts
var FinanceTaxRuleSetDtoOutputVerificationStatus = {
  verified: "verified",
  to_verify: "to_verify"
};

// src/generated/model/fiscalProfileDtoOutputTaxRegime.ts
var FiscalProfileDtoOutputTaxRegime = {
  real: "real",
  flat_rate: "flat_rate"
};

// src/generated/model/fiscalProfileDtoOutputWithholdingStatus.ts
var FiscalProfileDtoOutputWithholdingStatus = {
  legal_entity: "legal_entity",
  real_regime: "real_regime",
  other: "other"
};

// src/generated/model/fiscalProfileListDtoOutputItemsItemTaxRegime.ts
var FiscalProfileListDtoOutputItemsItemTaxRegime = {
  real: "real",
  flat_rate: "flat_rate"
};

// src/generated/model/fiscalProfileListDtoOutputItemsItemWithholdingStatus.ts
var FiscalProfileListDtoOutputItemsItemWithholdingStatus = {
  legal_entity: "legal_entity",
  real_regime: "real_regime",
  other: "other"
};

// src/generated/model/flowDtoOutputStatus.ts
var FlowDtoOutputStatus = {
  in_progress: "in_progress",
  approved: "approved",
  approved_with_comments: "approved_with_comments",
  rejected: "rejected",
  cancelled: "cancelled"
};

// src/generated/model/flowDtoOutputStepsItemDecisionsItemDecision.ts
var FlowDtoOutputStepsItemDecisionsItemDecision = {
  vso: "vso",
  vao: "vao",
  ref: "ref"
};

// src/generated/model/flowDtoOutputStepsItemMode.ts
var FlowDtoOutputStepsItemMode = {
  sequential: "sequential",
  parallel: "parallel"
};

// src/generated/model/flowDtoOutputStepsItemOutcome.ts
var FlowDtoOutputStepsItemOutcome = {
  vso: "vso",
  vao: "vao",
  ref: "ref"
};

// src/generated/model/flowDtoOutputStepsItemStatus.ts
var FlowDtoOutputStepsItemStatus = {
  waiting: "waiting",
  active: "active",
  decided: "decided",
  cancelled: "cancelled"
};

// src/generated/model/flowListDtoOutputItemsItemStatus.ts
var FlowListDtoOutputItemsItemStatus = {
  in_progress: "in_progress",
  approved: "approved",
  approved_with_comments: "approved_with_comments",
  rejected: "rejected",
  cancelled: "cancelled"
};

// src/generated/model/flowListDtoOutputItemsItemStepsItemDecisionsItemDecision.ts
var FlowListDtoOutputItemsItemStepsItemDecisionsItemDecision = {
  vso: "vso",
  vao: "vao",
  ref: "ref"
};

// src/generated/model/flowListDtoOutputItemsItemStepsItemMode.ts
var FlowListDtoOutputItemsItemStepsItemMode = {
  sequential: "sequential",
  parallel: "parallel"
};

// src/generated/model/flowListDtoOutputItemsItemStepsItemOutcome.ts
var FlowListDtoOutputItemsItemStepsItemOutcome = {
  vso: "vso",
  vao: "vao",
  ref: "ref"
};

// src/generated/model/flowListDtoOutputItemsItemStepsItemStatus.ts
var FlowListDtoOutputItemsItemStepsItemStatus = {
  waiting: "waiting",
  active: "active",
  decided: "decided",
  cancelled: "cancelled"
};

// src/generated/model/folderAclDtoOutputEntriesItemRelation.ts
var FolderAclDtoOutputEntriesItemRelation = {
  reader: "reader",
  writer: "writer"
};

// src/generated/model/folderAclDtoOutputEntriesItemSubjectType.ts
var FolderAclDtoOutputEntriesItemSubjectType = {
  user: "user",
  organization_members: "organization_members"
};

// src/generated/model/folderAclDtoOutputMode.ts
var FolderAclDtoOutputMode = {
  inherit: "inherit",
  custom: "custom"
};

// src/generated/model/folderDetailDtoOutputAclMode.ts
var FolderDetailDtoOutputAclMode = {
  inherit: "inherit",
  custom: "custom"
};

// src/generated/model/folderDtoOutputAclMode.ts
var FolderDtoOutputAclMode = {
  inherit: "inherit",
  custom: "custom"
};

// src/generated/model/folderListDtoOutputItemsItemAclMode.ts
var FolderListDtoOutputItemsItemAclMode = {
  inherit: "inherit",
  custom: "custom"
};

// src/generated/model/ganttDtoOutputPhasesItemDeadlineAlert.ts
var GanttDtoOutputPhasesItemDeadlineAlert = {
  none: "none",
  warning: "warning",
  overdue: "overdue"
};

// src/generated/model/ganttDtoOutputPhasesItemPhaseType.ts
var GanttDtoOutputPhasesItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/ganttDtoOutputPhasesItemStatus.ts
var GanttDtoOutputPhasesItemStatus = {
  not_started: "not_started",
  in_progress: "in_progress",
  in_review: "in_review",
  closed: "closed"
};

// src/generated/model/ganttDtoOutputTasksItemStatus.ts
var GanttDtoOutputTasksItemStatus = {
  todo: "todo",
  in_progress: "in_progress",
  blocked: "blocked",
  done: "done"
};

// src/generated/model/groupementDtoOutputBillingMode.ts
var GroupementDtoOutputBillingMode = {
  lead_only: "lead_only",
  separate: "separate"
};

// src/generated/model/groupementDtoOutputMembersItemRole.ts
var GroupementDtoOutputMembersItemRole = {
  lead: "lead",
  co_contractor: "co_contractor"
};

// src/generated/model/groupementDtoOutputPaymentsItemKind.ts
var GroupementDtoOutputPaymentsItemKind = {
  received: "received",
  redistributed: "redistributed"
};

// src/generated/model/groupementDtoOutputPhasesItemPhaseType.ts
var GroupementDtoOutputPhasesItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/groupementPaymentDtoOutputKind.ts
var GroupementPaymentDtoOutputKind = {
  received: "received",
  redistributed: "redistributed"
};

// src/generated/model/healthStatusDtoOutputStatus.ts
var HealthStatusDtoOutputStatus = {
  ok: "ok",
  unavailable: "unavailable"
};

// src/generated/model/icsFeedListDtoOutputItemsItemScope.ts
var IcsFeedListDtoOutputItemsItemScope = {
  visible: "visible",
  mine: "mine"
};

// src/generated/model/incomingSpaceInvitationListDtoOutputItemsItemKind.ts
var IncomingSpaceInvitationListDtoOutputItemsItemKind = {
  organization: "organization",
  nominative: "nominative",
  guest: "guest"
};

// src/generated/model/incomingSpaceInvitationListDtoOutputItemsItemRights.ts
var IncomingSpaceInvitationListDtoOutputItemsItemRights = {
  read: "read",
  write: "write",
  approve: "approve"
};

// src/generated/model/invitationDtoOutputStatus.ts
var InvitationDtoOutputStatus = {
  pending: "pending",
  accepted: "accepted",
  revoked: "revoked",
  expired: "expired"
};

// src/generated/model/invitationListDtoOutputItemsItemStatus.ts
var InvitationListDtoOutputItemsItemStatus = {
  pending: "pending",
  accepted: "accepted",
  revoked: "revoked",
  expired: "expired"
};

// src/generated/model/invitationPreviewDtoOutputStatus.ts
var InvitationPreviewDtoOutputStatus = {
  pending: "pending",
  accepted: "accepted",
  revoked: "revoked",
  expired: "expired"
};

// src/generated/model/invitePartnerDtoRights.ts
var InvitePartnerDtoRights = {
  read: "read",
  write: "write",
  approve: "approve"
};

// src/generated/model/invoiceDtoOutputClientKind.ts
var InvoiceDtoOutputClientKind = {
  public_entity: "public_entity",
  private_company: "private_company",
  individual: "individual",
  foreign: "foreign"
};

// src/generated/model/invoiceDtoOutputComputationCurrency.ts
var InvoiceDtoOutputComputationCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/invoiceDtoOutputComputationKind.ts
var InvoiceDtoOutputComputationKind = {
  advance: "advance",
  deposit: "deposit",
  progress: "progress",
  final: "final",
  credit_note: "credit_note"
};

// src/generated/model/invoiceDtoOutputComputationLinesItemRole.ts
var InvoiceDtoOutputComputationLinesItemRole = {
  service: "service",
  advance_recovery: "advance_recovery",
  retention: "retention",
  retention_release: "retention_release"
};

// src/generated/model/invoiceDtoOutputComputationStepsItemKey.ts
var InvoiceDtoOutputComputationStepsItemKey = {
  subtotal_ht: "subtotal_ht",
  vat: "vat",
  stamp: "stamp",
  total_ttc: "total_ttc",
  withholding: "withholding",
  vat_withholding: "vat_withholding",
  net_payable: "net_payable"
};

// src/generated/model/invoiceDtoOutputComputationStepsItemNote.ts
var InvoiceDtoOutputComputationStepsItemNote = {
  vat_suspended: "vat_suspended",
  vat_export: "vat_export",
  stamp_exempt_treatment: "stamp_exempt_treatment",
  stamp_exempt_public_buyer: "stamp_exempt_public_buyer",
  stamp_not_reversed: "stamp_not_reversed",
  not_applicable: "not_applicable",
  below_threshold: "below_threshold"
};

// src/generated/model/invoiceDtoOutputComputationStepsItemToVerifyItem.ts
var InvoiceDtoOutputComputationStepsItemToVerifyItem = {
  stampexemptPublicBuyers: "stamp.exemptPublicBuyers",
  withholdingbase: "withholding.base",
  withholdingpurchases: "withholding.purchases",
  vatWithholdingthresholdBase: "vatWithholding.thresholdBase",
  contractretentionBase: "contract.retentionBase",
  lateInterest: "lateInterest"
};

// src/generated/model/invoiceDtoOutputComputationTreatmentMentionTreatment.ts
var InvoiceDtoOutputComputationTreatmentMentionTreatment = {
  suspended: "suspended",
  export: "export"
};

// src/generated/model/invoiceDtoOutputComputationUsedToVerifyRulesItem.ts
var InvoiceDtoOutputComputationUsedToVerifyRulesItem = {
  stampexemptPublicBuyers: "stamp.exemptPublicBuyers",
  withholdingbase: "withholding.base",
  withholdingpurchases: "withholding.purchases",
  vatWithholdingthresholdBase: "vatWithholding.thresholdBase",
  contractretentionBase: "contract.retentionBase",
  lateInterest: "lateInterest"
};

// src/generated/model/invoiceDtoOutputComputationVatTreatment.ts
var InvoiceDtoOutputComputationVatTreatment = {
  standard: "standard",
  suspended: "suspended",
  export: "export"
};

// src/generated/model/invoiceDtoOutputCurrency.ts
var InvoiceDtoOutputCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/invoiceDtoOutputEinvoiceStatus.ts
var InvoiceDtoOutputEinvoiceStatus = {
  not_required: "not_required",
  pending: "pending",
  submitted: "submitted",
  submitted_manually: "submitted_manually",
  accepted: "accepted",
  rejected: "rejected"
};

// src/generated/model/invoiceDtoOutputKind.ts
var InvoiceDtoOutputKind = {
  advance: "advance",
  deposit: "deposit",
  progress: "progress",
  final: "final",
  credit_note: "credit_note"
};

// src/generated/model/invoiceDtoOutputLanguage.ts
var InvoiceDtoOutputLanguage = {
  fr: "fr",
  ar: "ar",
  bilingual: "bilingual"
};

// src/generated/model/invoiceDtoOutputLinesItemRole.ts
var InvoiceDtoOutputLinesItemRole = {
  service: "service",
  advance_recovery: "advance_recovery",
  retention: "retention",
  retention_release: "retention_release"
};

// src/generated/model/invoiceDtoOutputPaymentStatus.ts
var InvoiceDtoOutputPaymentStatus = {
  unpaid: "unpaid",
  partially_paid: "partially_paid",
  paid: "paid"
};

// src/generated/model/invoiceDtoOutputStatus.ts
var InvoiceDtoOutputStatus = {
  draft: "draft",
  issued: "issued",
  credited: "credited"
};

// src/generated/model/invoiceDtoOutputVatTreatment.ts
var InvoiceDtoOutputVatTreatment = {
  standard: "standard",
  suspended: "suspended",
  export: "export"
};

// src/generated/model/invoiceEinvoiceDtoOutputEinvoiceStatus.ts
var InvoiceEinvoiceDtoOutputEinvoiceStatus = {
  not_required: "not_required",
  pending: "pending",
  submitted: "submitted",
  submitted_manually: "submitted_manually",
  accepted: "accepted",
  rejected: "rejected"
};

// src/generated/model/invoiceEinvoiceDtoOutputMode.ts
var InvoiceEinvoiceDtoOutputMode = {
  required: "required",
  optional: "optional",
  disabled: "disabled"
};

// src/generated/model/invoiceEinvoiceDtoOutputNextStep.ts
var InvoiceEinvoiceDtoOutputNextStep = {
  wait: "wait",
  resubmit: "resubmit",
  credit_note: "credit_note",
  manual: "manual",
  none: "none"
};

// src/generated/model/invoiceEinvoiceDtoOutputSubmissionsItemFailureCode.ts
var InvoiceEinvoiceDtoOutputSubmissionsItemFailureCode = {
  NO_CREDENTIAL: "NO_CREDENTIAL",
  CREDENTIAL_EXPIRED: "CREDENTIAL_EXPIRED",
  TEIF_INVALID: "TEIF_INVALID",
  SIGNING_FAILED: "SIGNING_FAILED",
  TTN_UNREACHABLE: "TTN_UNREACHABLE",
  TTN_REFUSED: "TTN_REFUSED",
  TTN_NO_ANSWER: "TTN_NO_ANSWER"
};

// src/generated/model/invoiceEinvoiceDtoOutputSubmissionsItemRejectionKind.ts
var InvoiceEinvoiceDtoOutputSubmissionsItemRejectionKind = {
  technical: "technical",
  content: "content"
};

// src/generated/model/invoiceEinvoiceDtoOutputSubmissionsItemStatus.ts
var InvoiceEinvoiceDtoOutputSubmissionsItemStatus = {
  awaiting_signature: "awaiting_signature",
  signed: "signed",
  submitted: "submitted",
  accepted: "accepted",
  rejected: "rejected",
  failed: "failed",
  manual: "manual"
};

// src/generated/model/invoiceListDtoOutputItemsItemCurrency.ts
var InvoiceListDtoOutputItemsItemCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/invoiceListDtoOutputItemsItemEinvoiceStatus.ts
var InvoiceListDtoOutputItemsItemEinvoiceStatus = {
  not_required: "not_required",
  pending: "pending",
  submitted: "submitted",
  submitted_manually: "submitted_manually",
  accepted: "accepted",
  rejected: "rejected"
};

// src/generated/model/invoiceListDtoOutputItemsItemKind.ts
var InvoiceListDtoOutputItemsItemKind = {
  advance: "advance",
  deposit: "deposit",
  progress: "progress",
  final: "final",
  credit_note: "credit_note"
};

// src/generated/model/invoiceListDtoOutputItemsItemPaymentStatus.ts
var InvoiceListDtoOutputItemsItemPaymentStatus = {
  unpaid: "unpaid",
  partially_paid: "partially_paid",
  paid: "paid"
};

// src/generated/model/invoiceListDtoOutputItemsItemStatus.ts
var InvoiceListDtoOutputItemsItemStatus = {
  draft: "draft",
  issued: "issued",
  credited: "credited"
};

// src/generated/model/invoicesControllerListKind.ts
var InvoicesControllerListKind = {
  advance: "advance",
  deposit: "deposit",
  progress: "progress",
  final: "final",
  credit_note: "credit_note"
};

// src/generated/model/invoicesControllerListPaymentStatus.ts
var InvoicesControllerListPaymentStatus = {
  unpaid: "unpaid",
  partially_paid: "partially_paid",
  paid: "paid"
};

// src/generated/model/invoicesControllerListStatus.ts
var InvoicesControllerListStatus = {
  draft: "draft",
  issued: "issued",
  credited: "credited"
};

// src/generated/model/lateInterestDtoOutputReason.ts
var LateInterestDtoOutputReason = {
  not_public_buyer: "not_public_buyer",
  not_issued: "not_issued",
  credit_note: "credit_note",
  foreign_currency: "foreign_currency",
  paid: "paid"
};

// src/generated/model/lateInterestDtoOutputToVerifyItem.ts
var LateInterestDtoOutputToVerifyItem = {
  stampexemptPublicBuyers: "stamp.exemptPublicBuyers",
  withholdingbase: "withholding.base",
  withholdingpurchases: "withholding.purchases",
  vatWithholdingthresholdBase: "vatWithholding.thresholdBase",
  contractretentionBase: "contract.retentionBase",
  lateInterest: "lateInterest"
};

// src/generated/model/leaveDtoOutputKind.ts
var LeaveDtoOutputKind = {
  leave: "leave",
  sick: "sick",
  training: "training",
  other: "other"
};

// src/generated/model/leaveListDtoOutputItemsItemKind.ts
var LeaveListDtoOutputItemsItemKind = {
  leave: "leave",
  sick: "sick",
  training: "training",
  other: "other"
};

// src/generated/model/managementDashboardDtoOutputMarginRevenueRecognition.ts
var ManagementDashboardDtoOutputMarginRevenueRecognition = {
  invoiced: "invoiced",
  completion: "completion"
};

// src/generated/model/managementDashboardDtoOutputScope.ts
var ManagementDashboardDtoOutputScope = {
  organization: "organization",
  projects: "projects"
};

// src/generated/model/managementDashboardDtoOutputTendersByStageItemStage.ts
var ManagementDashboardDtoOutputTendersByStageItemStage = {
  watch: "watch",
  go: "go",
  preparing: "preparing",
  submitted: "submitted"
};

// src/generated/model/manualPaymentRequestDtoMethod.ts
var ManualPaymentRequestDtoMethod = {
  transfer: "transfer",
  cheque: "cheque"
};

// src/generated/model/meetingDtoOutputKind.ts
var MeetingDtoOutputKind = {
  meeting: "meeting",
  call: "call"
};

// src/generated/model/meetingDtoOutputStatus.ts
var MeetingDtoOutputStatus = {
  scheduled: "scheduled",
  live: "live",
  ended: "ended"
};

// src/generated/model/meetingListDtoOutputItemsItemKind.ts
var MeetingListDtoOutputItemsItemKind = {
  meeting: "meeting",
  call: "call"
};

// src/generated/model/meetingListDtoOutputItemsItemMinutesStatus.ts
var MeetingListDtoOutputItemsItemMinutesStatus = {
  draft: "draft",
  published: "published"
};

// src/generated/model/meetingListDtoOutputItemsItemStatus.ts
var MeetingListDtoOutputItemsItemStatus = {
  scheduled: "scheduled",
  live: "live",
  ended: "ended"
};

// src/generated/model/meetingMinutesDtoOutputItemsItemKind.ts
var MeetingMinutesDtoOutputItemsItemKind = {
  point: "point",
  decision: "decision",
  action: "action"
};

// src/generated/model/meetingMinutesDtoOutputLanguage.ts
var MeetingMinutesDtoOutputLanguage = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/meetingMinutesDtoOutputStatus.ts
var MeetingMinutesDtoOutputStatus = {
  draft: "draft",
  published: "published"
};

// src/generated/model/meetingMinutesDtoOutputTemplate.ts
var MeetingMinutesDtoOutputTemplate = {
  coordination: "coordination",
  moa: "moa",
  site_meeting: "site_meeting",
  site_visit: "site_visit"
};

// src/generated/model/memberDtoOutputStatus.ts
var MemberDtoOutputStatus = {
  invited: "invited",
  active: "active",
  suspended: "suspended",
  deactivated: "deactivated"
};

// src/generated/model/memberListDtoOutputItemsItemStatus.ts
var MemberListDtoOutputItemsItemStatus = {
  invited: "invited",
  active: "active",
  suspended: "suspended",
  deactivated: "deactivated"
};

// src/generated/model/membersControllerListStatus.ts
var MembersControllerListStatus = {
  invited: "invited",
  active: "active",
  suspended: "suspended",
  deactivated: "deactivated"
};

// src/generated/model/meResponseDtoOutputMembershipsItemOrganizationStatus.ts
var MeResponseDtoOutputMembershipsItemOrganizationStatus = {
  trial: "trial",
  active: "active",
  read_only: "read_only",
  suspended: "suspended",
  closed: "closed"
};

// src/generated/model/meResponseDtoOutputUserDigitStyle.ts
var MeResponseDtoOutputUserDigitStyle = {
  latn: "latn",
  arab: "arab"
};

// src/generated/model/meResponseDtoOutputUserLocale.ts
var MeResponseDtoOutputUserLocale = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/messageDtoOutputReactionsItemEmoji.ts
var MessageDtoOutputReactionsItemEmoji = {
  "\u{1F44D}": "\u{1F44D}",
  "\u2705": "\u2705",
  "\u2764\uFE0F": "\u2764\uFE0F",
  "\u{1F602}": "\u{1F602}",
  "\u{1F62E}": "\u{1F62E}",
  "\u{1F64F}": "\u{1F64F}",
  "\u{1F440}": "\u{1F440}",
  "\u{1F389}": "\u{1F389}"
};

// src/generated/model/messageListDtoOutputItemsItemReactionsItemEmoji.ts
var MessageListDtoOutputItemsItemReactionsItemEmoji = {
  "\u{1F44D}": "\u{1F44D}",
  "\u2705": "\u2705",
  "\u2764\uFE0F": "\u2764\uFE0F",
  "\u{1F602}": "\u{1F602}",
  "\u{1F62E}": "\u{1F62E}",
  "\u{1F64F}": "\u{1F64F}",
  "\u{1F440}": "\u{1F440}",
  "\u{1F389}": "\u{1F389}"
};

// src/generated/model/minutesControllerListStatus.ts
var MinutesControllerListStatus = {
  draft: "draft",
  published: "published"
};

// src/generated/model/minutesListDtoOutputItemsItemStatus.ts
var MinutesListDtoOutputItemsItemStatus = {
  draft: "draft",
  published: "published"
};

// src/generated/model/minutesListDtoOutputItemsItemTemplate.ts
var MinutesListDtoOutputItemsItemTemplate = {
  coordination: "coordination",
  moa: "moa",
  site_meeting: "site_meeting",
  site_visit: "site_visit"
};

// src/generated/model/moveTaskDtoStatus.ts
var MoveTaskDtoStatus = {
  todo: "todo",
  in_progress: "in_progress",
  blocked: "blocked",
  done: "done"
};

// src/generated/model/mySpaceListDtoOutputItemsItemKind.ts
var MySpaceListDtoOutputItemsItemKind = {
  organization: "organization",
  internal: "internal",
  shared: "shared",
  group: "group"
};

// src/generated/model/mySpaceListDtoOutputItemsItemRights.ts
var MySpaceListDtoOutputItemsItemRights = {
  read: "read",
  write: "write",
  approve: "approve"
};

// src/generated/model/mySpaceListDtoOutputItemsItemStatus.ts
var MySpaceListDtoOutputItemsItemStatus = {
  active: "active",
  closed: "closed"
};

// src/generated/model/mySpaceListDtoOutputItemsItemVia.ts
var MySpaceListDtoOutputItemsItemVia = {
  host_member: "host_member",
  partner_delegation: "partner_delegation",
  direct_invite: "direct_invite",
  guest: "guest",
  partner_admin: "partner_admin"
};

// src/generated/model/myWeekDtoOutputEntriesItemCategory.ts
var MyWeekDtoOutputEntriesItemCategory = {
  studies: "studies",
  site: "site",
  meeting: "meeting",
  travel: "travel",
  admin: "admin",
  other: "other"
};

// src/generated/model/myWeekDtoOutputEntriesItemStatus.ts
var MyWeekDtoOutputEntriesItemStatus = {
  draft: "draft",
  submitted: "submitted",
  approved: "approved",
  rejected: "rejected"
};

// src/generated/model/notificationPageDtoOutputItemsItemType.ts
var NotificationPageDtoOutputItemsItemType = {
  mention: "mention",
  reply: "reply",
  task_assigned: "task_assigned",
  task_due: "task_due",
  task_overdue: "task_overdue",
  phase_due: "phase_due",
  phase_overdue: "phase_overdue",
  approval_requested: "approval_requested",
  approval_decided: "approval_decided",
  space_invitation: "space_invitation",
  partnership_request: "partnership_request",
  access_revoked: "access_revoked",
  einvoice_status: "einvoice_status",
  payment_received: "payment_received",
  plan_limit: "plan_limit",
  event_reminder: "event_reminder",
  quote_accepted: "quote_accepted",
  invoice_suggested: "invoice_suggested",
  bond_release_due: "bond_release_due",
  expense_submitted: "expense_submitted",
  expense_decided: "expense_decided",
  subscription_status: "subscription_status",
  data_export: "data_export",
  organization_deletion: "organization_deletion",
  meeting_started: "meeting_started",
  meeting_invited: "meeting_invited",
  call_missed: "call_missed",
  minutes_published: "minutes_published",
  timesheet_reminder: "timesheet_reminder",
  phase_deadline: "phase_deadline",
  vault_expiring: "vault_expiring",
  time_budget: "time_budget",
  signature_requested: "signature_requested",
  signature_update: "signature_update"
};

// src/generated/model/notificationPreferencesBodyDtoDigest.ts
var NotificationPreferencesBodyDtoDigest = {
  off: "off",
  hourly: "hourly",
  daily: "daily"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixAccessRevokedEmail.ts
var NotificationPreferencesBodyDtoMatrixAccessRevokedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixApprovalDecidedEmail.ts
var NotificationPreferencesBodyDtoMatrixApprovalDecidedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixApprovalRequestedEmail.ts
var NotificationPreferencesBodyDtoMatrixApprovalRequestedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixBondReleaseDueEmail.ts
var NotificationPreferencesBodyDtoMatrixBondReleaseDueEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixCallMissedEmail.ts
var NotificationPreferencesBodyDtoMatrixCallMissedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixDataExportEmail.ts
var NotificationPreferencesBodyDtoMatrixDataExportEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixEinvoiceStatusEmail.ts
var NotificationPreferencesBodyDtoMatrixEinvoiceStatusEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixEventReminderEmail.ts
var NotificationPreferencesBodyDtoMatrixEventReminderEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixExpenseDecidedEmail.ts
var NotificationPreferencesBodyDtoMatrixExpenseDecidedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixExpenseSubmittedEmail.ts
var NotificationPreferencesBodyDtoMatrixExpenseSubmittedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixInvoiceSuggestedEmail.ts
var NotificationPreferencesBodyDtoMatrixInvoiceSuggestedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixMeetingInvitedEmail.ts
var NotificationPreferencesBodyDtoMatrixMeetingInvitedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixMeetingStartedEmail.ts
var NotificationPreferencesBodyDtoMatrixMeetingStartedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixMentionEmail.ts
var NotificationPreferencesBodyDtoMatrixMentionEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixMinutesPublishedEmail.ts
var NotificationPreferencesBodyDtoMatrixMinutesPublishedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixOrganizationDeletionEmail.ts
var NotificationPreferencesBodyDtoMatrixOrganizationDeletionEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixPartnershipRequestEmail.ts
var NotificationPreferencesBodyDtoMatrixPartnershipRequestEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixPaymentReceivedEmail.ts
var NotificationPreferencesBodyDtoMatrixPaymentReceivedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixPhaseDeadlineEmail.ts
var NotificationPreferencesBodyDtoMatrixPhaseDeadlineEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixPhaseDueEmail.ts
var NotificationPreferencesBodyDtoMatrixPhaseDueEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixPhaseOverdueEmail.ts
var NotificationPreferencesBodyDtoMatrixPhaseOverdueEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixPlanLimitEmail.ts
var NotificationPreferencesBodyDtoMatrixPlanLimitEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixQuoteAcceptedEmail.ts
var NotificationPreferencesBodyDtoMatrixQuoteAcceptedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixReplyEmail.ts
var NotificationPreferencesBodyDtoMatrixReplyEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixSignatureRequestedEmail.ts
var NotificationPreferencesBodyDtoMatrixSignatureRequestedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixSignatureUpdateEmail.ts
var NotificationPreferencesBodyDtoMatrixSignatureUpdateEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixSpaceInvitationEmail.ts
var NotificationPreferencesBodyDtoMatrixSpaceInvitationEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixSubscriptionStatusEmail.ts
var NotificationPreferencesBodyDtoMatrixSubscriptionStatusEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixTaskAssignedEmail.ts
var NotificationPreferencesBodyDtoMatrixTaskAssignedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixTaskDueEmail.ts
var NotificationPreferencesBodyDtoMatrixTaskDueEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixTaskOverdueEmail.ts
var NotificationPreferencesBodyDtoMatrixTaskOverdueEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixTimeBudgetEmail.ts
var NotificationPreferencesBodyDtoMatrixTimeBudgetEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixTimesheetReminderEmail.ts
var NotificationPreferencesBodyDtoMatrixTimesheetReminderEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesBodyDtoMatrixVaultExpiringEmail.ts
var NotificationPreferencesBodyDtoMatrixVaultExpiringEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputDigest.ts
var NotificationPreferencesDtoOutputDigest = {
  off: "off",
  hourly: "hourly",
  daily: "daily"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixAccessRevokedEmail.ts
var NotificationPreferencesDtoOutputMatrixAccessRevokedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixApprovalDecidedEmail.ts
var NotificationPreferencesDtoOutputMatrixApprovalDecidedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixApprovalRequestedEmail.ts
var NotificationPreferencesDtoOutputMatrixApprovalRequestedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixBondReleaseDueEmail.ts
var NotificationPreferencesDtoOutputMatrixBondReleaseDueEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixCallMissedEmail.ts
var NotificationPreferencesDtoOutputMatrixCallMissedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixDataExportEmail.ts
var NotificationPreferencesDtoOutputMatrixDataExportEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixEinvoiceStatusEmail.ts
var NotificationPreferencesDtoOutputMatrixEinvoiceStatusEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixEventReminderEmail.ts
var NotificationPreferencesDtoOutputMatrixEventReminderEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixExpenseDecidedEmail.ts
var NotificationPreferencesDtoOutputMatrixExpenseDecidedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixExpenseSubmittedEmail.ts
var NotificationPreferencesDtoOutputMatrixExpenseSubmittedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixInvoiceSuggestedEmail.ts
var NotificationPreferencesDtoOutputMatrixInvoiceSuggestedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixMeetingInvitedEmail.ts
var NotificationPreferencesDtoOutputMatrixMeetingInvitedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixMeetingStartedEmail.ts
var NotificationPreferencesDtoOutputMatrixMeetingStartedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixMentionEmail.ts
var NotificationPreferencesDtoOutputMatrixMentionEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixMinutesPublishedEmail.ts
var NotificationPreferencesDtoOutputMatrixMinutesPublishedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixOrganizationDeletionEmail.ts
var NotificationPreferencesDtoOutputMatrixOrganizationDeletionEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixPartnershipRequestEmail.ts
var NotificationPreferencesDtoOutputMatrixPartnershipRequestEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixPaymentReceivedEmail.ts
var NotificationPreferencesDtoOutputMatrixPaymentReceivedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixPhaseDeadlineEmail.ts
var NotificationPreferencesDtoOutputMatrixPhaseDeadlineEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixPhaseDueEmail.ts
var NotificationPreferencesDtoOutputMatrixPhaseDueEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixPhaseOverdueEmail.ts
var NotificationPreferencesDtoOutputMatrixPhaseOverdueEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixPlanLimitEmail.ts
var NotificationPreferencesDtoOutputMatrixPlanLimitEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixQuoteAcceptedEmail.ts
var NotificationPreferencesDtoOutputMatrixQuoteAcceptedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixReplyEmail.ts
var NotificationPreferencesDtoOutputMatrixReplyEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixSignatureRequestedEmail.ts
var NotificationPreferencesDtoOutputMatrixSignatureRequestedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixSignatureUpdateEmail.ts
var NotificationPreferencesDtoOutputMatrixSignatureUpdateEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixSpaceInvitationEmail.ts
var NotificationPreferencesDtoOutputMatrixSpaceInvitationEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixSubscriptionStatusEmail.ts
var NotificationPreferencesDtoOutputMatrixSubscriptionStatusEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixTaskAssignedEmail.ts
var NotificationPreferencesDtoOutputMatrixTaskAssignedEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixTaskDueEmail.ts
var NotificationPreferencesDtoOutputMatrixTaskDueEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixTaskOverdueEmail.ts
var NotificationPreferencesDtoOutputMatrixTaskOverdueEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixTimeBudgetEmail.ts
var NotificationPreferencesDtoOutputMatrixTimeBudgetEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixTimesheetReminderEmail.ts
var NotificationPreferencesDtoOutputMatrixTimesheetReminderEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationPreferencesDtoOutputMatrixVaultExpiringEmail.ts
var NotificationPreferencesDtoOutputMatrixVaultExpiringEmail = {
  off: "off",
  immediate: "immediate",
  digest: "digest"
};

// src/generated/model/notificationsControllerActivityFilter.ts
var NotificationsControllerActivityFilter = {
  all: "all",
  mentions: "mentions",
  assignments: "assignments",
  approvals: "approvals"
};

// src/generated/model/observationDtoOutputKind.ts
var ObservationDtoOutputKind = {
  observation: "observation",
  reserve: "reserve"
};

// src/generated/model/observationDtoOutputStatus.ts
var ObservationDtoOutputStatus = {
  open: "open",
  resolved: "resolved"
};

// src/generated/model/observationListDtoOutputItemsItemKind.ts
var ObservationListDtoOutputItemsItemKind = {
  observation: "observation",
  reserve: "reserve"
};

// src/generated/model/observationListDtoOutputItemsItemStatus.ts
var ObservationListDtoOutputItemsItemStatus = {
  open: "open",
  resolved: "resolved"
};

// src/generated/model/observationsControllerListKind.ts
var ObservationsControllerListKind = {
  observation: "observation",
  reserve: "reserve"
};

// src/generated/model/observationsControllerListOverdue.ts
var ObservationsControllerListOverdue = {
  true: "true",
  false: "false"
};

// src/generated/model/observationsControllerListStatus.ts
var ObservationsControllerListStatus = {
  open: "open",
  resolved: "resolved"
};

// src/generated/model/orderDtoOutputKind.ts
var OrderDtoOutputKind = {
  start: "start",
  stop: "stop",
  resume: "resume"
};

// src/generated/model/orderListDtoOutputItemsItemKind.ts
var OrderListDtoOutputItemsItemKind = {
  start: "start",
  stop: "stop",
  resume: "resume"
};

// src/generated/model/organizationDtoOutputDefaultLocale.ts
var OrganizationDtoOutputDefaultLocale = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/organizationDtoOutputDisciplinesItem.ts
var OrganizationDtoOutputDisciplinesItem = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/organizationDtoOutputGovernorate.ts
var OrganizationDtoOutputGovernorate = {
  tunis: "tunis",
  ariana: "ariana",
  ben_arous: "ben_arous",
  manouba: "manouba",
  nabeul: "nabeul",
  zaghouan: "zaghouan",
  bizerte: "bizerte",
  beja: "beja",
  jendouba: "jendouba",
  kef: "kef",
  siliana: "siliana",
  kairouan: "kairouan",
  kasserine: "kasserine",
  sidi_bouzid: "sidi_bouzid",
  sousse: "sousse",
  monastir: "monastir",
  mahdia: "mahdia",
  sfax: "sfax",
  gafsa: "gafsa",
  tozeur: "tozeur",
  kebili: "kebili",
  gabes: "gabes",
  medenine: "medenine",
  tataouine: "tataouine"
};

// src/generated/model/organizationDtoOutputLegalForm.ts
var OrganizationDtoOutputLegalForm = {
  individual: "individual",
  suarl: "suarl",
  sarl: "sarl",
  sa: "sa",
  snc: "snc",
  scs: "scs",
  gie: "gie",
  other: "other"
};

// src/generated/model/organizationDtoOutputStatus.ts
var OrganizationDtoOutputStatus = {
  trial: "trial",
  active: "active",
  read_only: "read_only",
  suspended: "suspended",
  closed: "closed",
  deleted: "deleted"
};

// src/generated/model/organizationEntitlementsDtoClassOutputPlan.ts
var OrganizationEntitlementsDtoClassOutputPlan = {
  solo: "solo",
  starter: "starter",
  pro: "pro",
  business: "business",
  enterprise: "enterprise"
};

// src/generated/model/organizationEntitlementsDtoClassOutputSubscriptionStatus.ts
var OrganizationEntitlementsDtoClassOutputSubscriptionStatus = {
  trialing: "trialing",
  active: "active",
  past_due: "past_due",
  read_only: "read_only",
  suspended: "suspended",
  paused: "paused",
  cancelled: "cancelled"
};

// src/generated/model/orgDataExportDtoOutputScope.ts
var OrgDataExportDtoOutputScope = {
  organization: "organization",
  finance: "finance"
};

// src/generated/model/orgDataExportDtoOutputStatus.ts
var OrgDataExportDtoOutputStatus = {
  queued: "queued",
  running: "running",
  ready: "ready",
  failed: "failed",
  expired: "expired"
};

// src/generated/model/orgDataExportPageDtoOutputItemsItemScope.ts
var OrgDataExportPageDtoOutputItemsItemScope = {
  organization: "organization",
  finance: "finance"
};

// src/generated/model/orgDataExportPageDtoOutputItemsItemStatus.ts
var OrgDataExportPageDtoOutputItemsItemStatus = {
  queued: "queued",
  running: "running",
  ready: "ready",
  failed: "failed",
  expired: "expired"
};

// src/generated/model/orgMeetingsControllerListHasMinutes.ts
var OrgMeetingsControllerListHasMinutes = {
  true: "true",
  false: "false"
};

// src/generated/model/orgMeetingsControllerListKind.ts
var OrgMeetingsControllerListKind = {
  meeting: "meeting",
  call: "call"
};

// src/generated/model/orgMeetingsControllerListStatus.ts
var OrgMeetingsControllerListStatus = {
  live: "live",
  scheduled: "scheduled",
  ended: "ended"
};

// src/generated/model/orgPartnershipListDtoOutputItemsItemRights.ts
var OrgPartnershipListDtoOutputItemsItemRights = {
  read: "read",
  write: "write",
  approve: "approve"
};

// src/generated/model/orgPartnershipListDtoOutputItemsItemScopeItemsItemKind.ts
var OrgPartnershipListDtoOutputItemsItemScopeItemsItemKind = {
  folder: "folder",
  channel: "channel"
};

// src/generated/model/orgPartnershipListDtoOutputItemsItemStatus.ts
var OrgPartnershipListDtoOutputItemsItemStatus = {
  pending: "pending",
  active: "active",
  declined: "declined",
  expired: "expired",
  revoked: "revoked"
};

// src/generated/model/orgTemplateDtoOutputDefinitionChannelsItemDiscipline.ts
var OrgTemplateDtoOutputDefinitionChannelsItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/orgTemplateDtoOutputDefinitionChannelsItemKind.ts
var OrgTemplateDtoOutputDefinitionChannelsItemKind = {
  general: "general",
  discipline: "discipline"
};

// src/generated/model/orgTemplateDtoOutputDefinitionPhasesItemPhaseType.ts
var OrgTemplateDtoOutputDefinitionPhasesItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/orgTemplateDtoOutputDefinitionTasksItemDiscipline.ts
var OrgTemplateDtoOutputDefinitionTasksItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/orgTemplateDtoOutputDefinitionTasksItemPhaseType.ts
var OrgTemplateDtoOutputDefinitionTasksItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/orgTemplateListDtoOutputItemsItemDefinitionChannelsItemDiscipline.ts
var OrgTemplateListDtoOutputItemsItemDefinitionChannelsItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/orgTemplateListDtoOutputItemsItemDefinitionChannelsItemKind.ts
var OrgTemplateListDtoOutputItemsItemDefinitionChannelsItemKind = {
  general: "general",
  discipline: "discipline"
};

// src/generated/model/orgTemplateListDtoOutputItemsItemDefinitionPhasesItemPhaseType.ts
var OrgTemplateListDtoOutputItemsItemDefinitionPhasesItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/orgTemplateListDtoOutputItemsItemDefinitionTasksItemDiscipline.ts
var OrgTemplateListDtoOutputItemsItemDefinitionTasksItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/orgTemplateListDtoOutputItemsItemDefinitionTasksItemPhaseType.ts
var OrgTemplateListDtoOutputItemsItemDefinitionTasksItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/orgTemplatesControllerListArchived.ts
var OrgTemplatesControllerListArchived = {
  true: "true",
  false: "false"
};

// src/generated/model/ownerTransferDtoOutputStatus.ts
var OwnerTransferDtoOutputStatus = {
  pending: "pending",
  accepted: "accepted",
  cancelled: "cancelled",
  expired: "expired"
};

// src/generated/model/ownerTransferStateDtoOutputTransferStatus.ts
var OwnerTransferStateDtoOutputTransferStatus = {
  pending: "pending",
  accepted: "accepted",
  cancelled: "cancelled",
  expired: "expired"
};

// src/generated/model/paymentDtoOutputInvoicePaymentStatus.ts
var PaymentDtoOutputInvoicePaymentStatus = {
  unpaid: "unpaid",
  partially_paid: "partially_paid",
  paid: "paid"
};

// src/generated/model/paymentDtoOutputMethod.ts
var PaymentDtoOutputMethod = {
  transfer: "transfer",
  cheque: "cheque",
  bill: "bill",
  cash: "cash",
  online: "online"
};

// src/generated/model/paymentDtoOutputWarningsItem.ts
var PaymentDtoOutputWarningsItem = {
  cash_not_deductible: "cash_not_deductible",
  cheque_expires_soon: "cheque_expires_soon"
};

// src/generated/model/paymentListDtoOutputItemsItemInvoicePaymentStatus.ts
var PaymentListDtoOutputItemsItemInvoicePaymentStatus = {
  unpaid: "unpaid",
  partially_paid: "partially_paid",
  paid: "paid"
};

// src/generated/model/paymentListDtoOutputItemsItemMethod.ts
var PaymentListDtoOutputItemsItemMethod = {
  transfer: "transfer",
  cheque: "cheque",
  bill: "bill",
  cash: "cash",
  online: "online"
};

// src/generated/model/paymentListDtoOutputItemsItemWarningsItem.ts
var PaymentListDtoOutputItemsItemWarningsItem = {
  cash_not_deductible: "cash_not_deductible",
  cheque_expires_soon: "cheque_expires_soon"
};

// src/generated/model/phaseDtoOutputPhaseType.ts
var PhaseDtoOutputPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/phaseDtoOutputScheduleState.ts
var PhaseDtoOutputScheduleState = {
  not_planned: "not_planned",
  on_track: "on_track",
  late_start: "late_start",
  overdue: "overdue",
  done: "done",
  done_late: "done_late"
};

// src/generated/model/phaseDtoOutputStatus.ts
var PhaseDtoOutputStatus = {
  not_started: "not_started",
  in_progress: "in_progress",
  in_review: "in_review",
  closed: "closed"
};

// src/generated/model/phaseListDtoOutputItemsItemPhaseType.ts
var PhaseListDtoOutputItemsItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/phaseListDtoOutputItemsItemScheduleState.ts
var PhaseListDtoOutputItemsItemScheduleState = {
  not_planned: "not_planned",
  on_track: "on_track",
  late_start: "late_start",
  overdue: "overdue",
  done: "done",
  done_late: "done_late"
};

// src/generated/model/phaseListDtoOutputItemsItemStatus.ts
var PhaseListDtoOutputItemsItemStatus = {
  not_started: "not_started",
  in_progress: "in_progress",
  in_review: "in_review",
  closed: "closed"
};

// src/generated/model/pinnedMessageDtoOutputMessageReactionsItemEmoji.ts
var PinnedMessageDtoOutputMessageReactionsItemEmoji = {
  "\u{1F44D}": "\u{1F44D}",
  "\u2705": "\u2705",
  "\u2764\uFE0F": "\u2764\uFE0F",
  "\u{1F602}": "\u{1F602}",
  "\u{1F62E}": "\u{1F62E}",
  "\u{1F64F}": "\u{1F64F}",
  "\u{1F440}": "\u{1F440}",
  "\u{1F389}": "\u{1F389}"
};

// src/generated/model/pinnedMessageListDtoOutputItemsItemMessageReactionsItemEmoji.ts
var PinnedMessageListDtoOutputItemsItemMessageReactionsItemEmoji = {
  "\u{1F44D}": "\u{1F44D}",
  "\u2705": "\u2705",
  "\u2764\uFE0F": "\u2764\uFE0F",
  "\u{1F602}": "\u{1F602}",
  "\u{1F62E}": "\u{1F62E}",
  "\u{1F64F}": "\u{1F64F}",
  "\u{1F440}": "\u{1F440}",
  "\u{1F389}": "\u{1F389}"
};

// src/generated/model/planListDtoOutputItemsItemAnnualPriceCurrency.ts
var PlanListDtoOutputItemsItemAnnualPriceCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/planListDtoOutputItemsItemCode.ts
var PlanListDtoOutputItemsItemCode = {
  solo: "solo",
  starter: "starter",
  pro: "pro",
  business: "business",
  enterprise: "enterprise"
};

// src/generated/model/planListDtoOutputItemsItemExtraSeatMonthlyPriceCurrency.ts
var PlanListDtoOutputItemsItemExtraSeatMonthlyPriceCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/planListDtoOutputItemsItemMonthlyPriceCurrency.ts
var PlanListDtoOutputItemsItemMonthlyPriceCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/platformAccountDetailDtoOutputAccountStatus.ts
var PlatformAccountDetailDtoOutputAccountStatus = {
  active: "active",
  disabled: "disabled"
};

// src/generated/model/platformAccountDetailDtoOutputDeletionBlocker.ts
var PlatformAccountDetailDtoOutputDeletionBlocker = {
  owner: "owner",
  support_identity: "support_identity"
};

// src/generated/model/platformAccountDetailDtoOutputMembershipsItemOrganizationStatus.ts
var PlatformAccountDetailDtoOutputMembershipsItemOrganizationStatus = {
  trial: "trial",
  active: "active",
  read_only: "read_only",
  suspended: "suspended",
  closed: "closed",
  deleted: "deleted"
};

// src/generated/model/platformAccountDetailDtoOutputMembershipsItemStatus.ts
var PlatformAccountDetailDtoOutputMembershipsItemStatus = {
  invited: "invited",
  active: "active",
  suspended: "suspended",
  deactivated: "deactivated"
};

// src/generated/model/platformBreakGlassControllerListStatus.ts
var PlatformBreakGlassControllerListStatus = {
  pending: "pending",
  active: "active",
  rejected: "rejected",
  cancelled: "cancelled",
  expired: "expired",
  revoked: "revoked"
};

// src/generated/model/platformDeadLetterListDtoOutputItemsItemQueue.ts
var PlatformDeadLetterListDtoOutputItemsItemQueue = {
  system: "system",
  files: "files",
  "dead-letter": "dead-letter",
  "identity-events": "identity-events",
  "authz-sync-0": "authz-sync-0",
  "authz-sync-1": "authz-sync-1",
  "authz-sync-2": "authz-sync-2",
  "authz-sync-3": "authz-sync-3",
  notifications: "notifications",
  "notification-emails": "notification-emails",
  "notification-digest": "notification-digest",
  reminders: "reminders",
  maintenance: "maintenance",
  trash: "trash",
  realtime: "realtime",
  sharing: "sharing",
  pdf: "pdf",
  einvoicing: "einvoicing",
  "einvoicing-jobs": "einvoicing-jobs",
  billing: "billing",
  exports: "exports",
  privacy: "privacy",
  search: "search"
};

// src/generated/model/platformDeletionListDtoOutputItemsItemExecutionStatus.ts
var PlatformDeletionListDtoOutputItemsItemExecutionStatus = {
  scheduled: "scheduled",
  running: "running",
  cancelled: "cancelled",
  done: "done"
};

// src/generated/model/platformDeletionListDtoOutputItemsItemOrganizationStatus.ts
var PlatformDeletionListDtoOutputItemsItemOrganizationStatus = {
  trial: "trial",
  active: "active",
  read_only: "read_only",
  suspended: "suspended",
  closed: "closed",
  deleted: "deleted"
};

// src/generated/model/platformDeletionListDtoOutputItemsItemPreviousStatus.ts
var PlatformDeletionListDtoOutputItemsItemPreviousStatus = {
  trial: "trial",
  active: "active",
  read_only: "read_only",
  suspended: "suspended",
  closed: "closed",
  deleted: "deleted"
};

// src/generated/model/platformDeletionListDtoOutputItemsItemStatus.ts
var PlatformDeletionListDtoOutputItemsItemStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  cancelled: "cancelled"
};

// src/generated/model/platformDeletionRequestDtoOutputExecutionStatus.ts
var PlatformDeletionRequestDtoOutputExecutionStatus = {
  scheduled: "scheduled",
  running: "running",
  cancelled: "cancelled",
  done: "done"
};

// src/generated/model/platformDeletionRequestDtoOutputOrganizationStatus.ts
var PlatformDeletionRequestDtoOutputOrganizationStatus = {
  trial: "trial",
  active: "active",
  read_only: "read_only",
  suspended: "suspended",
  closed: "closed",
  deleted: "deleted"
};

// src/generated/model/platformDeletionRequestDtoOutputPreviousStatus.ts
var PlatformDeletionRequestDtoOutputPreviousStatus = {
  trial: "trial",
  active: "active",
  read_only: "read_only",
  suspended: "suspended",
  closed: "closed",
  deleted: "deleted"
};

// src/generated/model/platformDeletionRequestDtoOutputStatus.ts
var PlatformDeletionRequestDtoOutputStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  cancelled: "cancelled"
};

// src/generated/model/platformDeletionsControllerListStatus.ts
var PlatformDeletionsControllerListStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  cancelled: "cancelled"
};

// src/generated/model/platformMemberDtoOutputStatus.ts
var PlatformMemberDtoOutputStatus = {
  invited: "invited",
  active: "active",
  suspended: "suspended",
  deactivated: "deactivated"
};

// src/generated/model/platformMemberDtoOutputUserStatus.ts
var PlatformMemberDtoOutputUserStatus = {
  active: "active",
  disabled: "disabled"
};

// src/generated/model/platformMemberListDtoOutputItemsItemStatus.ts
var PlatformMemberListDtoOutputItemsItemStatus = {
  invited: "invited",
  active: "active",
  suspended: "suspended",
  deactivated: "deactivated"
};

// src/generated/model/platformMemberListDtoOutputItemsItemUserStatus.ts
var PlatformMemberListDtoOutputItemsItemUserStatus = {
  active: "active",
  disabled: "disabled"
};

// src/generated/model/platformOrganizationDetailDtoOutputDeletionStatus.ts
var PlatformOrganizationDetailDtoOutputDeletionStatus = {
  scheduled: "scheduled",
  running: "running",
  cancelled: "cancelled",
  done: "done"
};

// src/generated/model/platformOrganizationDetailDtoOutputInvoicesItemPurpose.ts
var PlatformOrganizationDetailDtoOutputInvoicesItemPurpose = {
  start: "start",
  upgrade: "upgrade",
  restart: "restart",
  renewal: "renewal",
  resume: "resume"
};

// src/generated/model/platformOrganizationDetailDtoOutputInvoicesItemStatus.ts
var PlatformOrganizationDetailDtoOutputInvoicesItemStatus = {
  open: "open",
  paid: "paid",
  void: "void"
};

// src/generated/model/platformOrganizationDetailDtoOutputOrganizationPlanCode.ts
var PlatformOrganizationDetailDtoOutputOrganizationPlanCode = {
  solo: "solo",
  starter: "starter",
  pro: "pro",
  business: "business",
  enterprise: "enterprise"
};

// src/generated/model/platformOrganizationDetailDtoOutputOrganizationStatus.ts
var PlatformOrganizationDetailDtoOutputOrganizationStatus = {
  trial: "trial",
  active: "active",
  read_only: "read_only",
  suspended: "suspended",
  closed: "closed",
  deleted: "deleted"
};

// src/generated/model/platformOrganizationDetailDtoOutputOrganizationSubscriptionStatus.ts
var PlatformOrganizationDetailDtoOutputOrganizationSubscriptionStatus = {
  trialing: "trialing",
  active: "active",
  past_due: "past_due",
  read_only: "read_only",
  suspended: "suspended",
  paused: "paused",
  cancelled: "cancelled"
};

// src/generated/model/platformOrganizationDetailDtoOutputPlatformDeletionExecutionStatus.ts
var PlatformOrganizationDetailDtoOutputPlatformDeletionExecutionStatus = {
  scheduled: "scheduled",
  running: "running",
  cancelled: "cancelled",
  done: "done"
};

// src/generated/model/platformOrganizationDetailDtoOutputPlatformDeletionOrganizationStatus.ts
var PlatformOrganizationDetailDtoOutputPlatformDeletionOrganizationStatus = {
  trial: "trial",
  active: "active",
  read_only: "read_only",
  suspended: "suspended",
  closed: "closed",
  deleted: "deleted"
};

// src/generated/model/platformOrganizationDetailDtoOutputPlatformDeletionPreviousStatus.ts
var PlatformOrganizationDetailDtoOutputPlatformDeletionPreviousStatus = {
  trial: "trial",
  active: "active",
  read_only: "read_only",
  suspended: "suspended",
  closed: "closed",
  deleted: "deleted"
};

// src/generated/model/platformOrganizationDetailDtoOutputPlatformDeletionStatus.ts
var PlatformOrganizationDetailDtoOutputPlatformDeletionStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  cancelled: "cancelled"
};

// src/generated/model/platformOrganizationDetailDtoOutputSubscriptionCycle.ts
var PlatformOrganizationDetailDtoOutputSubscriptionCycle = {
  monthly: "monthly",
  annual: "annual"
};

// src/generated/model/platformOrganizationDetailDtoOutputSubscriptionPlanCode.ts
var PlatformOrganizationDetailDtoOutputSubscriptionPlanCode = {
  solo: "solo",
  starter: "starter",
  pro: "pro",
  business: "business",
  enterprise: "enterprise"
};

// src/generated/model/platformOrganizationDetailDtoOutputSubscriptionStatus.ts
var PlatformOrganizationDetailDtoOutputSubscriptionStatus = {
  trialing: "trialing",
  active: "active",
  past_due: "past_due",
  read_only: "read_only",
  suspended: "suspended",
  paused: "paused",
  cancelled: "cancelled"
};

// src/generated/model/platformOrganizationListDtoOutputItemsItemPlanCode.ts
var PlatformOrganizationListDtoOutputItemsItemPlanCode = {
  solo: "solo",
  starter: "starter",
  pro: "pro",
  business: "business",
  enterprise: "enterprise"
};

// src/generated/model/platformOrganizationListDtoOutputItemsItemStatus.ts
var PlatformOrganizationListDtoOutputItemsItemStatus = {
  trial: "trial",
  active: "active",
  read_only: "read_only",
  suspended: "suspended",
  closed: "closed",
  deleted: "deleted"
};

// src/generated/model/platformOrganizationListDtoOutputItemsItemSubscriptionStatus.ts
var PlatformOrganizationListDtoOutputItemsItemSubscriptionStatus = {
  trialing: "trialing",
  active: "active",
  past_due: "past_due",
  read_only: "read_only",
  suspended: "suspended",
  paused: "paused",
  cancelled: "cancelled"
};

// src/generated/model/platformOrganizationsControllerListStatus.ts
var PlatformOrganizationsControllerListStatus = {
  trial: "trial",
  active: "active",
  read_only: "read_only",
  suspended: "suspended",
  closed: "closed",
  deleted: "deleted"
};

// src/generated/model/platformSecuritySignalsDtoOutputFailuresItemRealm.ts
var PlatformSecuritySignalsDtoOutputFailuresItemRealm = {
  batiflow: "batiflow",
  "batiflow-platform": "batiflow-platform"
};

// src/generated/model/platformUsersControllerMembersStatus.ts
var PlatformUsersControllerMembersStatus = {
  invited: "invited",
  active: "active",
  suspended: "suspended",
  deactivated: "deactivated"
};

// src/generated/model/previewUrlDtoOutputKind.ts
var PreviewUrlDtoOutputKind = {
  pdf: "pdf",
  image: "image",
  cad: "cad"
};

// src/generated/model/previewUrlDtoOutputStatus.ts
var PreviewUrlDtoOutputStatus = {
  ready: "ready",
  preparing: "preparing",
  none: "none",
  failed: "failed"
};

// src/generated/model/problemDetailsCode.ts
var ProblemDetailsCode = {
  BAD_REQUEST: "BAD_REQUEST",
  VALIDATION_FAILED: "VALIDATION_FAILED",
  NOT_FOUND: "NOT_FOUND",
  PAYLOAD_TOO_LARGE: "PAYLOAD_TOO_LARGE",
  UNSUPPORTED_MEDIA_TYPE: "UNSUPPORTED_MEDIA_TYPE",
  RATE_LIMITED: "RATE_LIMITED",
  INTERNAL_ERROR: "INTERNAL_ERROR",
  SERVICE_UNAVAILABLE: "SERVICE_UNAVAILABLE",
  SESSION_EXPIRED: "SESSION_EXPIRED",
  CSRF_INVALID: "CSRF_INVALID",
  MFA_REQUIRED: "MFA_REQUIRED",
  STEP_UP_REQUIRED: "STEP_UP_REQUIRED",
  FORBIDDEN: "FORBIDDEN",
  PLAN_LIMIT_REACHED: "PLAN_LIMIT_REACHED",
  ORGANIZATION_READ_ONLY: "ORGANIZATION_READ_ONLY",
  STALE_VERSION: "STALE_VERSION",
  PRECONDITION_REQUIRED: "PRECONDITION_REQUIRED",
  IDEMPOTENCY_KEY_REUSED: "IDEMPOTENCY_KEY_REUSED",
  FILE_TYPE_NOT_ALLOWED: "FILE_TYPE_NOT_ALLOWED",
  FILE_TOO_LARGE: "FILE_TOO_LARGE",
  QUOTA_EXCEEDED: "QUOTA_EXCEEDED",
  PHASE_HAS_UNAPPROVED_DELIVERABLES: "PHASE_HAS_UNAPPROVED_DELIVERABLES",
  INVOICE_ALREADY_ISSUED: "INVOICE_ALREADY_ISSUED",
  COMPUTATION_CHANGED: "COMPUTATION_CHANGED",
  DOCUMENT_LOCKED: "DOCUMENT_LOCKED",
  LEGAL_HOLD: "LEGAL_HOLD",
  DEPENDENCY_CYCLE: "DEPENDENCY_CYCLE",
  TAX_ID_ALREADY_REGISTERED: "TAX_ID_ALREADY_REGISTERED",
  ALREADY_A_MEMBER: "ALREADY_A_MEMBER",
  INVITATION_ALREADY_PENDING: "INVITATION_ALREADY_PENDING",
  INVITATION_NO_LONGER_VALID: "INVITATION_NO_LONGER_VALID",
  ROLE_ESCALATION: "ROLE_ESCALATION",
  ROLE_IN_USE: "ROLE_IN_USE",
  TIMESHEET_LOCKED: "TIMESHEET_LOCKED",
  INVITATION_EMAIL_MISMATCH: "INVITATION_EMAIL_MISMATCH",
  EMAIL_NOT_VERIFIED: "EMAIL_NOT_VERIFIED",
  PROJECT_CODE_TAKEN: "PROJECT_CODE_TAKEN",
  PHASE_CLOSED: "PHASE_CLOSED",
  PROJECT_ARCHIVED: "PROJECT_ARCHIVED",
  PROJECT_TEMPLATE_INVALID: "PROJECT_TEMPLATE_INVALID",
  FOLDER_NAME_TAKEN: "FOLDER_NAME_TAKEN",
  UPLOAD_EXPIRED: "UPLOAD_EXPIRED",
  DOWNLOAD_NOT_ALLOWED: "DOWNLOAD_NOT_ALLOWED",
  SHARE_LINKS_DISABLED: "SHARE_LINKS_DISABLED",
  SHARE_LINK_POLICY: "SHARE_LINK_POLICY",
  SHARE_LINK_PASSWORD_INVALID: "SHARE_LINK_PASSWORD_INVALID",
  SHARE_LINK_LOCKED: "SHARE_LINK_LOCKED",
  SHARE_LINK_DOWNLOAD_LIMIT: "SHARE_LINK_DOWNLOAD_LIMIT",
  SPACE_WITHOUT_PROJECT: "SPACE_WITHOUT_PROJECT",
  GROUPEMENT_SHARES_EXCEED: "GROUPEMENT_SHARES_EXCEED",
  EXIT_EXPORT_UNAVAILABLE: "EXIT_EXPORT_UNAVAILABLE",
  APPROVAL_ORG_HAS_NO_REVIEWER: "APPROVAL_ORG_HAS_NO_REVIEWER",
  ANNOTATION_RESOLVED: "ANNOTATION_RESOLVED",
  APPROVAL_CLOSED: "APPROVAL_CLOSED",
  APPROVAL_NOT_YOUR_TURN: "APPROVAL_NOT_YOUR_TURN",
  PARENT_IN_TRASH: "PARENT_IN_TRASH",
  CHANNEL_ARCHIVED: "CHANNEL_ARCHIVED",
  CHANNEL_NAME_TAKEN: "CHANNEL_NAME_TAKEN",
  EVENT_READ_ONLY: "EVENT_READ_ONLY",
  MEETING_ENDED: "MEETING_ENDED",
  MINUTES_EXIST: "MINUTES_EXIST",
  MINUTES_NOT_FOR_CALLS: "MINUTES_NOT_FOR_CALLS",
  MINUTES_PUBLISHED: "MINUTES_PUBLISHED",
  SPACE_CLOSED: "SPACE_CLOSED",
  PARTNERSHIP_ALREADY_EXISTS: "PARTNERSHIP_ALREADY_EXISTS",
  MEMBER_CAP_REACHED: "MEMBER_CAP_REACHED",
  SCOPE_EXCEEDS_PARTNERSHIP: "SCOPE_EXCEEDS_PARTNERSHIP",
  RIGHTS_EXCEED_PARTNERSHIP: "RIGHTS_EXCEED_PARTNERSHIP",
  DELEGATE_NOT_A_MEMBER: "DELEGATE_NOT_A_MEMBER",
  ALREADY_SPACE_MEMBER: "ALREADY_SPACE_MEMBER",
  GUEST_DOMAIN_NOT_ALLOWED: "GUEST_DOMAIN_NOT_ALLOWED",
  QUOTE_LOCKED: "QUOTE_LOCKED",
  QUOTE_EXPIRED: "QUOTE_EXPIRED",
  QUOTE_NOT_ACCEPTED: "QUOTE_NOT_ACCEPTED",
  CONTRACT_REFERENCE_TAKEN: "CONTRACT_REFERENCE_TAKEN",
  CONTRACT_EXISTS_FOR_QUOTE: "CONTRACT_EXISTS_FOR_QUOTE",
  PDF_NOT_READY: "PDF_NOT_READY",
  INVOICE_NOT_ISSUED: "INVOICE_NOT_ISSUED",
  CREDIT_EXCEEDS_INVOICE: "CREDIT_EXCEEDS_INVOICE",
  OVERPAYMENT: "OVERPAYMENT",
  EXPENSE_INVALID_TRANSITION: "EXPENSE_INVALID_TRANSITION",
  EXPENSE_SELF_APPROVAL: "EXPENSE_SELF_APPROVAL",
  RECEIPT_NOT_READY: "RECEIPT_NOT_READY",
  SIGNING_CREDENTIAL_INVALID: "SIGNING_CREDENTIAL_INVALID",
  SIGNING_KEY_MISMATCH: "SIGNING_KEY_MISMATCH",
  SIGNING_CREDENTIAL_EXPIRED: "SIGNING_CREDENTIAL_EXPIRED",
  SIGNING_CREDENTIAL_DUPLICATE: "SIGNING_CREDENTIAL_DUPLICATE",
  EINVOICE_NOT_RESUBMITTABLE: "EINVOICE_NOT_RESUBMITTABLE",
  EINVOICE_ALREADY_FINAL: "EINVOICE_ALREADY_FINAL",
  EINVOICE_NOT_REQUIRED: "EINVOICE_NOT_REQUIRED",
  TEIF_NOT_READY: "TEIF_NOT_READY",
  PLAN_ON_QUOTE: "PLAN_ON_QUOTE",
  SUBSCRIPTION_DOWNGRADE_BLOCKED: "SUBSCRIPTION_DOWNGRADE_BLOCKED",
  SUBSCRIPTION_INVALID_STATE: "SUBSCRIPTION_INVALID_STATE",
  SUBSCRIPTION_INVOICE_PENDING: "SUBSCRIPTION_INVOICE_PENDING",
  PAUSE_LIMIT_REACHED: "PAUSE_LIMIT_REACHED",
  BILLING_INVOICE_NOT_OPEN: "BILLING_INVOICE_NOT_OPEN",
  PAYMENT_PROVIDER_UNAVAILABLE: "PAYMENT_PROVIDER_UNAVAILABLE",
  WEBHOOK_SIGNATURE_INVALID: "WEBHOOK_SIGNATURE_INVALID",
  WEBAUTHN_REQUIRED: "WEBAUTHN_REQUIRED",
  BREAK_GLASS_SELF_APPROVAL: "BREAK_GLASS_SELF_APPROVAL",
  BREAK_GLASS_INVALID_STATE: "BREAK_GLASS_INVALID_STATE",
  SUPPORT_IDENTITY_MISSING: "SUPPORT_IDENTITY_MISSING",
  PAYMENT_ALREADY_CONFIRMED: "PAYMENT_ALREADY_CONFIRMED",
  ORGANIZATION_CLOSED: "ORGANIZATION_CLOSED",
  EXPORT_REQUIRED: "EXPORT_REQUIRED",
  EXPORT_NOT_READY: "EXPORT_NOT_READY",
  EXPORT_IN_PROGRESS: "EXPORT_IN_PROGRESS",
  DELETION_ALREADY_SCHEDULED: "DELETION_ALREADY_SCHEDULED",
  DELETION_NOT_SCHEDULED: "DELETION_NOT_SCHEDULED",
  CONFIRMATION_MISMATCH: "CONFIRMATION_MISMATCH",
  CHECKLIST_ARCHIVED: "CHECKLIST_ARCHIVED",
  CHECKLIST_TEMPLATE_RETIRED: "CHECKLIST_TEMPLATE_RETIRED",
  CHECKLIST_TEMPLATE_KEY_TAKEN: "CHECKLIST_TEMPLATE_KEY_TAKEN",
  TENDER_STATUS_TRANSITION: "TENDER_STATUS_TRANSITION",
  TENDER_NOT_DELETABLE: "TENDER_NOT_DELETABLE",
  TENDER_NOT_WON: "TENDER_NOT_WON",
  VAULT_DOCUMENT_UNKNOWN: "VAULT_DOCUMENT_UNKNOWN",
  VAULT_DOCUMENT_FILE_INVALID: "VAULT_DOCUMENT_FILE_INVALID",
  VAULT_DOCUMENT_IN_USE: "VAULT_DOCUMENT_IN_USE",
  OBSERVATION_ID_TAKEN: "OBSERVATION_ID_TAKEN",
  OBSERVATION_ANCHOR_INVALID: "OBSERVATION_ANCHOR_INVALID",
  OBSERVATION_PHOTO_INVALID: "OBSERVATION_PHOTO_INVALID",
  OBSERVATION_NOT_OPEN: "OBSERVATION_NOT_OPEN",
  OBSERVATION_NOT_RESOLVED: "OBSERVATION_NOT_RESOLVED",
  OBSERVATION_IN_REPORT: "OBSERVATION_IN_REPORT",
  SUPPLIER_TAX_ID_TAKEN: "SUPPLIER_TAX_ID_TAKEN",
  SUPPLIER_ARCHIVED: "SUPPLIER_ARCHIVED",
  SUPPLIER_INVOICE_NUMBER_TAKEN: "SUPPLIER_INVOICE_NUMBER_TAKEN",
  SUPPLIER_INVOICE_NOT_PAYABLE: "SUPPLIER_INVOICE_NOT_PAYABLE",
  SUPPLIER_INVOICE_HAS_PAYMENTS: "SUPPLIER_INVOICE_HAS_PAYMENTS",
  SUPPLIER_PAYMENT_EXCEEDS: "SUPPLIER_PAYMENT_EXCEEDS",
  SUPPLIER_PAYMENT_EXPORTED: "SUPPLIER_PAYMENT_EXPORTED",
  SUPPLIER_DOCUMENT_INVALID: "SUPPLIER_DOCUMENT_INVALID",
  TEJ_NOTHING_TO_EXPORT: "TEJ_NOTHING_TO_EXPORT",
  PERIOD_CLOSED: "PERIOD_CLOSED",
  COST_RATE_DATE_TAKEN: "COST_RATE_DATE_TAKEN",
  ACCOUNTING_EXPORT_NOT_READY: "ACCOUNTING_EXPORT_NOT_READY",
  PERIOD_IN_FUTURE: "PERIOD_IN_FUTURE",
  SIGNATURE_NOT_PENDING: "SIGNATURE_NOT_PENDING",
  SIGNATURE_EXPIRED: "SIGNATURE_EXPIRED",
  SIGNATURE_CODE_INVALID: "SIGNATURE_CODE_INVALID",
  SIGNATURE_CODE_LOCKED: "SIGNATURE_CODE_LOCKED",
  SIGNATURE_CODE_TOO_SOON: "SIGNATURE_CODE_TOO_SOON",
  SIGNATURE_DOCUMENT_NOT_READY: "SIGNATURE_DOCUMENT_NOT_READY",
  SIGNATURE_SIGNER_INVALID: "SIGNATURE_SIGNER_INVALID",
  SIGNATURE_EVIDENCE_NOT_READY: "SIGNATURE_EVIDENCE_NOT_READY",
  SIGNATURE_PROVIDER_FAILED: "SIGNATURE_PROVIDER_FAILED",
  DIGIGO_NOTHING_TO_SIGN: "DIGIGO_NOTHING_TO_SIGN",
  DIGIGO_NO_CREDENTIAL: "DIGIGO_NO_CREDENTIAL",
  SIGNING_BATCH_NOT_PENDING: "SIGNING_BATCH_NOT_PENDING",
  RECEPTION_REPORT_NOT_READY: "RECEPTION_REPORT_NOT_READY",
  MEMBERSHIP_SUSPENDED: "MEMBERSHIP_SUSPENDED",
  MEMBER_STATE_INVALID: "MEMBER_STATE_INVALID",
  OWNER_PROTECTED: "OWNER_PROTECTED",
  ACCOUNT_NOT_DELETABLE: "ACCOUNT_NOT_DELETABLE",
  PLATFORM_ORGANIZATION_PROTECTED: "PLATFORM_ORGANIZATION_PROTECTED",
  DELETION_ALREADY_REQUESTED: "DELETION_ALREADY_REQUESTED",
  DELETION_SELF_APPROVAL: "DELETION_SELF_APPROVAL",
  DELETION_INVALID_STATE: "DELETION_INVALID_STATE",
  DELETION_PENDING: "DELETION_PENDING",
  REAUTH_REQUIRED: "REAUTH_REQUIRED",
  PASSWORD_POLICY: "PASSWORD_POLICY",
  LAST_SECOND_FACTOR: "LAST_SECOND_FACTOR"
};

// src/generated/model/problemDetailsSuggestion.ts
var ProblemDetailsSuggestion = {
  upgrade_plan: "upgrade_plan",
  add_seat: "add_seat"
};

// src/generated/model/profitabilityControllerOverviewStatus.ts
var ProfitabilityControllerOverviewStatus = {
  active: "active",
  all: "all"
};

// src/generated/model/profitabilityOverviewDtoOutputRevenueRecognition.ts
var ProfitabilityOverviewDtoOutputRevenueRecognition = {
  invoiced: "invoiced",
  completion: "completion"
};

// src/generated/model/progressInvoiceDtoOutputClientKind.ts
var ProgressInvoiceDtoOutputClientKind = {
  public_entity: "public_entity",
  private_company: "private_company",
  individual: "individual",
  foreign: "foreign"
};

// src/generated/model/progressInvoiceDtoOutputComputationCurrency.ts
var ProgressInvoiceDtoOutputComputationCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/progressInvoiceDtoOutputComputationKind.ts
var ProgressInvoiceDtoOutputComputationKind = {
  advance: "advance",
  deposit: "deposit",
  progress: "progress",
  final: "final",
  credit_note: "credit_note"
};

// src/generated/model/progressInvoiceDtoOutputComputationLinesItemRole.ts
var ProgressInvoiceDtoOutputComputationLinesItemRole = {
  service: "service",
  advance_recovery: "advance_recovery",
  retention: "retention",
  retention_release: "retention_release"
};

// src/generated/model/progressInvoiceDtoOutputComputationStepsItemKey.ts
var ProgressInvoiceDtoOutputComputationStepsItemKey = {
  subtotal_ht: "subtotal_ht",
  vat: "vat",
  stamp: "stamp",
  total_ttc: "total_ttc",
  withholding: "withholding",
  vat_withholding: "vat_withholding",
  net_payable: "net_payable"
};

// src/generated/model/progressInvoiceDtoOutputComputationStepsItemNote.ts
var ProgressInvoiceDtoOutputComputationStepsItemNote = {
  vat_suspended: "vat_suspended",
  vat_export: "vat_export",
  stamp_exempt_treatment: "stamp_exempt_treatment",
  stamp_exempt_public_buyer: "stamp_exempt_public_buyer",
  stamp_not_reversed: "stamp_not_reversed",
  not_applicable: "not_applicable",
  below_threshold: "below_threshold"
};

// src/generated/model/progressInvoiceDtoOutputComputationStepsItemToVerifyItem.ts
var ProgressInvoiceDtoOutputComputationStepsItemToVerifyItem = {
  stampexemptPublicBuyers: "stamp.exemptPublicBuyers",
  withholdingbase: "withholding.base",
  withholdingpurchases: "withholding.purchases",
  vatWithholdingthresholdBase: "vatWithholding.thresholdBase",
  contractretentionBase: "contract.retentionBase",
  lateInterest: "lateInterest"
};

// src/generated/model/progressInvoiceDtoOutputComputationTreatmentMentionTreatment.ts
var ProgressInvoiceDtoOutputComputationTreatmentMentionTreatment = {
  suspended: "suspended",
  export: "export"
};

// src/generated/model/progressInvoiceDtoOutputComputationUsedToVerifyRulesItem.ts
var ProgressInvoiceDtoOutputComputationUsedToVerifyRulesItem = {
  stampexemptPublicBuyers: "stamp.exemptPublicBuyers",
  withholdingbase: "withholding.base",
  withholdingpurchases: "withholding.purchases",
  vatWithholdingthresholdBase: "vatWithholding.thresholdBase",
  contractretentionBase: "contract.retentionBase",
  lateInterest: "lateInterest"
};

// src/generated/model/progressInvoiceDtoOutputComputationVatTreatment.ts
var ProgressInvoiceDtoOutputComputationVatTreatment = {
  standard: "standard",
  suspended: "suspended",
  export: "export"
};

// src/generated/model/progressInvoiceDtoOutputCurrency.ts
var ProgressInvoiceDtoOutputCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/progressInvoiceDtoOutputEinvoiceStatus.ts
var ProgressInvoiceDtoOutputEinvoiceStatus = {
  not_required: "not_required",
  pending: "pending",
  submitted: "submitted",
  submitted_manually: "submitted_manually",
  accepted: "accepted",
  rejected: "rejected"
};

// src/generated/model/progressInvoiceDtoOutputKind.ts
var ProgressInvoiceDtoOutputKind = {
  advance: "advance",
  deposit: "deposit",
  progress: "progress",
  final: "final",
  credit_note: "credit_note"
};

// src/generated/model/progressInvoiceDtoOutputLanguage.ts
var ProgressInvoiceDtoOutputLanguage = {
  fr: "fr",
  ar: "ar",
  bilingual: "bilingual"
};

// src/generated/model/progressInvoiceDtoOutputLinesItemRole.ts
var ProgressInvoiceDtoOutputLinesItemRole = {
  service: "service",
  advance_recovery: "advance_recovery",
  retention: "retention",
  retention_release: "retention_release"
};

// src/generated/model/progressInvoiceDtoOutputPaymentStatus.ts
var ProgressInvoiceDtoOutputPaymentStatus = {
  unpaid: "unpaid",
  partially_paid: "partially_paid",
  paid: "paid"
};

// src/generated/model/progressInvoiceDtoOutputStatus.ts
var ProgressInvoiceDtoOutputStatus = {
  draft: "draft",
  issued: "issued",
  credited: "credited"
};

// src/generated/model/progressInvoiceDtoOutputVatTreatment.ts
var ProgressInvoiceDtoOutputVatTreatment = {
  standard: "standard",
  suspended: "suspended",
  export: "export"
};

// src/generated/model/progressInvoiceRequestDtoLanguage.ts
var ProgressInvoiceRequestDtoLanguage = {
  fr: "fr",
  ar: "ar",
  bilingual: "bilingual"
};

// src/generated/model/projectDtoOutputFeesAmountCurrency.ts
var ProjectDtoOutputFeesAmountCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/projectDtoOutputFeesMode.ts
var ProjectDtoOutputFeesMode = {
  lump_sum: "lump_sum",
  works_percentage: "works_percentage",
  time_based: "time_based"
};

// src/generated/model/projectDtoOutputGovernorate.ts
var ProjectDtoOutputGovernorate = {
  tunis: "tunis",
  ariana: "ariana",
  ben_arous: "ben_arous",
  manouba: "manouba",
  nabeul: "nabeul",
  zaghouan: "zaghouan",
  bizerte: "bizerte",
  beja: "beja",
  jendouba: "jendouba",
  kef: "kef",
  siliana: "siliana",
  kairouan: "kairouan",
  kasserine: "kasserine",
  sidi_bouzid: "sidi_bouzid",
  sousse: "sousse",
  monastir: "monastir",
  mahdia: "mahdia",
  sfax: "sfax",
  gafsa: "gafsa",
  tozeur: "tozeur",
  kebili: "kebili",
  gabes: "gabes",
  medenine: "medenine",
  tataouine: "tataouine"
};

// src/generated/model/projectDtoOutputMissionType.ts
var ProjectDtoOutputMissionType = {
  public_building: "public_building",
  collective_housing: "collective_housing",
  villa: "villa",
  industrial: "industrial",
  facility: "facility",
  subdivision_vrd: "subdivision_vrd",
  expertise: "expertise"
};

// src/generated/model/projectDtoOutputMyRole.ts
var ProjectDtoOutputMyRole = {
  manager: "manager",
  member: "member"
};

// src/generated/model/projectDtoOutputPhaseProgressCurrentPhaseType.ts
var ProjectDtoOutputPhaseProgressCurrentPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/projectDtoOutputStatus.ts
var ProjectDtoOutputStatus = {
  draft: "draft",
  active: "active",
  on_hold: "on_hold",
  closed: "closed",
  archived: "archived"
};

// src/generated/model/projectDtoOutputWorksCostEstimateCurrency.ts
var ProjectDtoOutputWorksCostEstimateCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/projectListDtoOutputItemsItemFeesAmountCurrency.ts
var ProjectListDtoOutputItemsItemFeesAmountCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/projectListDtoOutputItemsItemFeesMode.ts
var ProjectListDtoOutputItemsItemFeesMode = {
  lump_sum: "lump_sum",
  works_percentage: "works_percentage",
  time_based: "time_based"
};

// src/generated/model/projectListDtoOutputItemsItemGovernorate.ts
var ProjectListDtoOutputItemsItemGovernorate = {
  tunis: "tunis",
  ariana: "ariana",
  ben_arous: "ben_arous",
  manouba: "manouba",
  nabeul: "nabeul",
  zaghouan: "zaghouan",
  bizerte: "bizerte",
  beja: "beja",
  jendouba: "jendouba",
  kef: "kef",
  siliana: "siliana",
  kairouan: "kairouan",
  kasserine: "kasserine",
  sidi_bouzid: "sidi_bouzid",
  sousse: "sousse",
  monastir: "monastir",
  mahdia: "mahdia",
  sfax: "sfax",
  gafsa: "gafsa",
  tozeur: "tozeur",
  kebili: "kebili",
  gabes: "gabes",
  medenine: "medenine",
  tataouine: "tataouine"
};

// src/generated/model/projectListDtoOutputItemsItemMissionType.ts
var ProjectListDtoOutputItemsItemMissionType = {
  public_building: "public_building",
  collective_housing: "collective_housing",
  villa: "villa",
  industrial: "industrial",
  facility: "facility",
  subdivision_vrd: "subdivision_vrd",
  expertise: "expertise"
};

// src/generated/model/projectListDtoOutputItemsItemMyRole.ts
var ProjectListDtoOutputItemsItemMyRole = {
  manager: "manager",
  member: "member"
};

// src/generated/model/projectListDtoOutputItemsItemPhaseProgressCurrentPhaseType.ts
var ProjectListDtoOutputItemsItemPhaseProgressCurrentPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/projectListDtoOutputItemsItemStatus.ts
var ProjectListDtoOutputItemsItemStatus = {
  draft: "draft",
  active: "active",
  on_hold: "on_hold",
  closed: "closed",
  archived: "archived"
};

// src/generated/model/projectListDtoOutputItemsItemWorksCostEstimateCurrency.ts
var ProjectListDtoOutputItemsItemWorksCostEstimateCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/projectMemberListDtoOutputItemsItemProjectRole.ts
var ProjectMemberListDtoOutputItemsItemProjectRole = {
  manager: "manager",
  member: "member"
};

// src/generated/model/projectProfitabilityDtoOutputRevenueRecognition.ts
var ProjectProfitabilityDtoOutputRevenueRecognition = {
  invoiced: "invoiced",
  completion: "completion"
};

// src/generated/model/projectsControllerListMine.ts
var ProjectsControllerListMine = {
  true: "true",
  false: "false"
};

// src/generated/model/projectsControllerListMissionType.ts
var ProjectsControllerListMissionType = {
  public_building: "public_building",
  collective_housing: "collective_housing",
  villa: "villa",
  industrial: "industrial",
  facility: "facility",
  subdivision_vrd: "subdivision_vrd",
  expertise: "expertise"
};

// src/generated/model/projectsControllerListStatus.ts
var ProjectsControllerListStatus = {
  draft: "draft",
  active: "active",
  on_hold: "on_hold",
  closed: "closed",
  archived: "archived"
};

// src/generated/model/projectTemplateListDtoOutputItemsItemKey.ts
var ProjectTemplateListDtoOutputItemsItemKey = {
  public_building: "public_building",
  collective_housing: "collective_housing",
  villa: "villa",
  industrial: "industrial",
  facility: "facility",
  subdivision_vrd: "subdivision_vrd",
  expertise: "expertise"
};

// src/generated/model/projectTemplateListDtoOutputItemsItemPhasesItemPhaseType.ts
var ProjectTemplateListDtoOutputItemsItemPhasesItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/publicQuoteDtoOutputComputationCurrency.ts
var PublicQuoteDtoOutputComputationCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/publicQuoteDtoOutputComputationKind.ts
var PublicQuoteDtoOutputComputationKind = {
  advance: "advance",
  deposit: "deposit",
  progress: "progress",
  final: "final",
  credit_note: "credit_note"
};

// src/generated/model/publicQuoteDtoOutputComputationLinesItemRole.ts
var PublicQuoteDtoOutputComputationLinesItemRole = {
  service: "service",
  advance_recovery: "advance_recovery",
  retention: "retention",
  retention_release: "retention_release"
};

// src/generated/model/publicQuoteDtoOutputComputationStepsItemKey.ts
var PublicQuoteDtoOutputComputationStepsItemKey = {
  subtotal_ht: "subtotal_ht",
  vat: "vat",
  stamp: "stamp",
  total_ttc: "total_ttc",
  withholding: "withholding",
  vat_withholding: "vat_withholding",
  net_payable: "net_payable"
};

// src/generated/model/publicQuoteDtoOutputComputationStepsItemNote.ts
var PublicQuoteDtoOutputComputationStepsItemNote = {
  vat_suspended: "vat_suspended",
  vat_export: "vat_export",
  stamp_exempt_treatment: "stamp_exempt_treatment",
  stamp_exempt_public_buyer: "stamp_exempt_public_buyer",
  stamp_not_reversed: "stamp_not_reversed",
  not_applicable: "not_applicable",
  below_threshold: "below_threshold"
};

// src/generated/model/publicQuoteDtoOutputComputationStepsItemToVerifyItem.ts
var PublicQuoteDtoOutputComputationStepsItemToVerifyItem = {
  stampexemptPublicBuyers: "stamp.exemptPublicBuyers",
  withholdingbase: "withholding.base",
  withholdingpurchases: "withholding.purchases",
  vatWithholdingthresholdBase: "vatWithholding.thresholdBase",
  contractretentionBase: "contract.retentionBase",
  lateInterest: "lateInterest"
};

// src/generated/model/publicQuoteDtoOutputComputationTreatmentMentionTreatment.ts
var PublicQuoteDtoOutputComputationTreatmentMentionTreatment = {
  suspended: "suspended",
  export: "export"
};

// src/generated/model/publicQuoteDtoOutputComputationUsedToVerifyRulesItem.ts
var PublicQuoteDtoOutputComputationUsedToVerifyRulesItem = {
  stampexemptPublicBuyers: "stamp.exemptPublicBuyers",
  withholdingbase: "withholding.base",
  withholdingpurchases: "withholding.purchases",
  vatWithholdingthresholdBase: "vatWithholding.thresholdBase",
  contractretentionBase: "contract.retentionBase",
  lateInterest: "lateInterest"
};

// src/generated/model/publicQuoteDtoOutputComputationVatTreatment.ts
var PublicQuoteDtoOutputComputationVatTreatment = {
  standard: "standard",
  suspended: "suspended",
  export: "export"
};

// src/generated/model/publicQuoteDtoOutputCurrency.ts
var PublicQuoteDtoOutputCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/publicQuoteDtoOutputLanguage.ts
var PublicQuoteDtoOutputLanguage = {
  fr: "fr",
  ar: "ar",
  bilingual: "bilingual"
};

// src/generated/model/publicQuoteDtoOutputStatus.ts
var PublicQuoteDtoOutputStatus = {
  sent: "sent",
  accepted: "accepted",
  rejected: "rejected",
  expired: "expired"
};

// src/generated/model/publicShareDownloadUrlDtoOutputStatus.ts
var PublicShareDownloadUrlDtoOutputStatus = {
  ready: "ready",
  preparing: "preparing"
};

// src/generated/model/publicShareLinkDtoOutputTargetType.ts
var PublicShareLinkDtoOutputTargetType = {
  document: "document",
  folder: "folder"
};

// src/generated/model/publicSharePreviewUrlDtoOutputKind.ts
var PublicSharePreviewUrlDtoOutputKind = {
  pdf: "pdf",
  image: "image",
  cad: "cad"
};

// src/generated/model/publicSharePreviewUrlDtoOutputStatus.ts
var PublicSharePreviewUrlDtoOutputStatus = {
  ready: "ready",
  preparing: "preparing",
  none: "none",
  failed: "failed"
};

// src/generated/model/publicTransmittalDownloadUrlDtoOutputStatus.ts
var PublicTransmittalDownloadUrlDtoOutputStatus = {
  ready: "ready",
  preparing: "preparing"
};

// src/generated/model/publicTransmittalDtoOutputLanguage.ts
var PublicTransmittalDtoOutputLanguage = {
  fr: "fr",
  ar: "ar"
};

// src/generated/model/publicTransmittalPreviewUrlDtoOutputKind.ts
var PublicTransmittalPreviewUrlDtoOutputKind = {
  pdf: "pdf",
  image: "image",
  cad: "cad"
};

// src/generated/model/publicTransmittalPreviewUrlDtoOutputStatus.ts
var PublicTransmittalPreviewUrlDtoOutputStatus = {
  ready: "ready",
  preparing: "preparing",
  none: "none",
  failed: "failed"
};

// src/generated/model/purgeRequestDtoKind.ts
var PurgeRequestDtoKind = {
  folder: "folder",
  document: "document"
};

// src/generated/model/putFolderAclDtoEntriesItemRelation.ts
var PutFolderAclDtoEntriesItemRelation = {
  reader: "reader",
  writer: "writer"
};

// src/generated/model/putFolderAclDtoEntriesItemSubjectType.ts
var PutFolderAclDtoEntriesItemSubjectType = {
  user: "user",
  organization_members: "organization_members"
};

// src/generated/model/putFolderAclDtoMode.ts
var PutFolderAclDtoMode = {
  inherit: "inherit",
  custom: "custom"
};

// src/generated/model/putProjectMembersDtoMembersItemProjectRole.ts
var PutProjectMembersDtoMembersItemProjectRole = {
  manager: "manager",
  member: "member"
};

// src/generated/model/queueDtoOutputEntriesItemCategory.ts
var QueueDtoOutputEntriesItemCategory = {
  studies: "studies",
  site: "site",
  meeting: "meeting",
  travel: "travel",
  admin: "admin",
  other: "other"
};

// src/generated/model/queueDtoOutputEntriesItemStatus.ts
var QueueDtoOutputEntriesItemStatus = {
  draft: "draft",
  submitted: "submitted",
  approved: "approved",
  rejected: "rejected"
};

// src/generated/model/quoteDtoOutputClientKind.ts
var QuoteDtoOutputClientKind = {
  public_entity: "public_entity",
  private_company: "private_company",
  individual: "individual",
  foreign: "foreign"
};

// src/generated/model/quoteDtoOutputComputationCurrency.ts
var QuoteDtoOutputComputationCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/quoteDtoOutputComputationKind.ts
var QuoteDtoOutputComputationKind = {
  advance: "advance",
  deposit: "deposit",
  progress: "progress",
  final: "final",
  credit_note: "credit_note"
};

// src/generated/model/quoteDtoOutputComputationLinesItemRole.ts
var QuoteDtoOutputComputationLinesItemRole = {
  service: "service",
  advance_recovery: "advance_recovery",
  retention: "retention",
  retention_release: "retention_release"
};

// src/generated/model/quoteDtoOutputComputationStepsItemKey.ts
var QuoteDtoOutputComputationStepsItemKey = {
  subtotal_ht: "subtotal_ht",
  vat: "vat",
  stamp: "stamp",
  total_ttc: "total_ttc",
  withholding: "withholding",
  vat_withholding: "vat_withholding",
  net_payable: "net_payable"
};

// src/generated/model/quoteDtoOutputComputationStepsItemNote.ts
var QuoteDtoOutputComputationStepsItemNote = {
  vat_suspended: "vat_suspended",
  vat_export: "vat_export",
  stamp_exempt_treatment: "stamp_exempt_treatment",
  stamp_exempt_public_buyer: "stamp_exempt_public_buyer",
  stamp_not_reversed: "stamp_not_reversed",
  not_applicable: "not_applicable",
  below_threshold: "below_threshold"
};

// src/generated/model/quoteDtoOutputComputationStepsItemToVerifyItem.ts
var QuoteDtoOutputComputationStepsItemToVerifyItem = {
  stampexemptPublicBuyers: "stamp.exemptPublicBuyers",
  withholdingbase: "withholding.base",
  withholdingpurchases: "withholding.purchases",
  vatWithholdingthresholdBase: "vatWithholding.thresholdBase",
  contractretentionBase: "contract.retentionBase",
  lateInterest: "lateInterest"
};

// src/generated/model/quoteDtoOutputComputationTreatmentMentionTreatment.ts
var QuoteDtoOutputComputationTreatmentMentionTreatment = {
  suspended: "suspended",
  export: "export"
};

// src/generated/model/quoteDtoOutputComputationUsedToVerifyRulesItem.ts
var QuoteDtoOutputComputationUsedToVerifyRulesItem = {
  stampexemptPublicBuyers: "stamp.exemptPublicBuyers",
  withholdingbase: "withholding.base",
  withholdingpurchases: "withholding.purchases",
  vatWithholdingthresholdBase: "vatWithholding.thresholdBase",
  contractretentionBase: "contract.retentionBase",
  lateInterest: "lateInterest"
};

// src/generated/model/quoteDtoOutputComputationVatTreatment.ts
var QuoteDtoOutputComputationVatTreatment = {
  standard: "standard",
  suspended: "suspended",
  export: "export"
};

// src/generated/model/quoteDtoOutputCurrency.ts
var QuoteDtoOutputCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/quoteDtoOutputFeeMode.ts
var QuoteDtoOutputFeeMode = {
  lump_sum: "lump_sum",
  percentage_of_works: "percentage_of_works",
  time_based: "time_based",
  mixed: "mixed"
};

// src/generated/model/quoteDtoOutputLanguage.ts
var QuoteDtoOutputLanguage = {
  fr: "fr",
  ar: "ar",
  bilingual: "bilingual"
};

// src/generated/model/quoteDtoOutputLinesItemPhaseType.ts
var QuoteDtoOutputLinesItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/quoteDtoOutputStatus.ts
var QuoteDtoOutputStatus = {
  draft: "draft",
  sent: "sent",
  accepted: "accepted",
  rejected: "rejected",
  expired: "expired"
};

// src/generated/model/quoteListDtoOutputItemsItemCurrency.ts
var QuoteListDtoOutputItemsItemCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/quoteListDtoOutputItemsItemStatus.ts
var QuoteListDtoOutputItemsItemStatus = {
  draft: "draft",
  sent: "sent",
  accepted: "accepted",
  rejected: "rejected",
  expired: "expired"
};

// src/generated/model/quotesControllerListStatus.ts
var QuotesControllerListStatus = {
  draft: "draft",
  sent: "sent",
  accepted: "accepted",
  rejected: "rejected",
  expired: "expired"
};

// src/generated/model/reactionStateDtoOutputReactionsItemEmoji.ts
var ReactionStateDtoOutputReactionsItemEmoji = {
  "\u{1F44D}": "\u{1F44D}",
  "\u2705": "\u2705",
  "\u2764\uFE0F": "\u2764\uFE0F",
  "\u{1F602}": "\u{1F602}",
  "\u{1F62E}": "\u{1F62E}",
  "\u{1F64F}": "\u{1F64F}",
  "\u{1F440}": "\u{1F440}",
  "\u{1F389}": "\u{1F389}"
};

// src/generated/model/recentDocumentListDtoOutputItemsItemSpaceKind.ts
var RecentDocumentListDtoOutputItemsItemSpaceKind = {
  organization: "organization",
  internal: "internal",
  shared: "shared",
  group: "group"
};

// src/generated/model/receptionReportDtoOutputLanguage.ts
var ReceptionReportDtoOutputLanguage = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/receptionReportDtoOutputPdfStatus.ts
var ReceptionReportDtoOutputPdfStatus = {
  pending: "pending",
  ready: "ready"
};

// src/generated/model/receptionReportListDtoOutputItemsItemLanguage.ts
var ReceptionReportListDtoOutputItemsItemLanguage = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/receptionReportListDtoOutputItemsItemPdfStatus.ts
var ReceptionReportListDtoOutputItemsItemPdfStatus = {
  pending: "pending",
  ready: "ready"
};

// src/generated/model/registerControllerGetDiscipline.ts
var RegisterControllerGetDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/registerControllerGetDocType.ts
var RegisterControllerGetDocType = {
  drawing: "drawing",
  all: "all"
};

// src/generated/model/registerControllerGetPhaseType.ts
var RegisterControllerGetPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/registerDtoOutputDocType.ts
var RegisterDtoOutputDocType = {
  drawing: "drawing",
  all: "all"
};

// src/generated/model/registerDtoOutputItemsItemApprovalStatus.ts
var RegisterDtoOutputItemsItemApprovalStatus = {
  in_progress: "in_progress",
  approved: "approved",
  approved_with_comments: "approved_with_comments",
  rejected: "rejected"
};

// src/generated/model/registerDtoOutputItemsItemDiscipline.ts
var RegisterDtoOutputItemsItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/registerDtoOutputItemsItemDocType.ts
var RegisterDtoOutputItemsItemDocType = {
  drawing: "drawing",
  calculation_note: "calculation_note",
  report: "report",
  specification: "specification",
  bill_of_quantities: "bill_of_quantities",
  estimate: "estimate",
  minutes: "minutes",
  correspondence: "correspondence",
  photo: "photo",
  other: "other"
};

// src/generated/model/registerDtoOutputItemsItemPhaseType.ts
var RegisterDtoOutputItemsItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/registerExportAcceptedDtoOutputFormat.ts
var RegisterExportAcceptedDtoOutputFormat = {
  pdf: "pdf",
  xlsx: "xlsx"
};

// src/generated/model/registerExportDtoOutputFormat.ts
var RegisterExportDtoOutputFormat = {
  pdf: "pdf",
  xlsx: "xlsx"
};

// src/generated/model/registerExportDtoOutputStatus.ts
var RegisterExportDtoOutputStatus = {
  pending: "pending",
  ready: "ready",
  failed: "failed"
};

// src/generated/model/registerExportRequestDtoDiscipline.ts
var RegisterExportRequestDtoDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/registerExportRequestDtoDocType.ts
var RegisterExportRequestDtoDocType = {
  drawing: "drawing",
  all: "all"
};

// src/generated/model/registerExportRequestDtoFormat.ts
var RegisterExportRequestDtoFormat = {
  pdf: "pdf",
  xlsx: "xlsx"
};

// src/generated/model/registerExportRequestDtoLanguage.ts
var RegisterExportRequestDtoLanguage = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/registerExportRequestDtoPhaseType.ts
var RegisterExportRequestDtoPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/responsibilityMatrixDtoOutputDeliverablesItemDeliverableType.ts
var ResponsibilityMatrixDtoOutputDeliverablesItemDeliverableType = {
  drawing: "drawing",
  calculation_note: "calculation_note",
  report: "report",
  specification: "specification",
  bill_of_quantities: "bill_of_quantities",
  estimate: "estimate",
  other: "other"
};

// src/generated/model/responsibilityMatrixDtoOutputDeliverablesItemDiscipline.ts
var ResponsibilityMatrixDtoOutputDeliverablesItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/responsibilityMatrixDtoOutputDeliverablesItemPhasePhaseType.ts
var ResponsibilityMatrixDtoOutputDeliverablesItemPhasePhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/responsibilityMatrixDtoOutputDeliverablesItemSource.ts
var ResponsibilityMatrixDtoOutputDeliverablesItemSource = {
  deliverable: "deliverable",
  discipline: "discipline",
  host: "host"
};

// src/generated/model/responsibilityMatrixDtoOutputDeliverablesItemStatus.ts
var ResponsibilityMatrixDtoOutputDeliverablesItemStatus = {
  to_produce: "to_produce",
  in_progress: "in_progress",
  in_review: "in_review",
  approved: "approved",
  transmitted: "transmitted"
};

// src/generated/model/responsibilityMatrixDtoOutputDisciplinesItemDiscipline.ts
var ResponsibilityMatrixDtoOutputDisciplinesItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/responsibilityMatrixDtoOutputOfficesItemRole.ts
var ResponsibilityMatrixDtoOutputOfficesItemRole = {
  host: "host",
  partner: "partner"
};

// src/generated/model/responsibilityMatrixDtoOutputScope.ts
var ResponsibilityMatrixDtoOutputScope = {
  all: "all",
  own: "own"
};

// src/generated/model/roleDtoOutputBasedOn.ts
var RoleDtoOutputBasedOn = {
  admin: "admin",
  project_manager: "project_manager",
  engineer: "engineer",
  draftsman: "draftsman",
  accountant: "accountant"
};

// src/generated/model/roleListDtoOutputItemsItemBasedOn.ts
var RoleListDtoOutputItemsItemBasedOn = {
  admin: "admin",
  project_manager: "project_manager",
  engineer: "engineer",
  draftsman: "draftsman",
  accountant: "accountant"
};

// src/generated/model/saveGroupementDtoBillingMode.ts
var SaveGroupementDtoBillingMode = {
  lead_only: "lead_only",
  separate: "separate"
};

// src/generated/model/searchControllerFindScope.ts
var SearchControllerFindScope = {
  all: "all",
  projects: "projects",
  clients: "clients",
  documents: "documents",
  tasks: "tasks",
  messages: "messages"
};

// src/generated/model/searchResultDtoOutputGroupsItemItemsItemKind.ts
var SearchResultDtoOutputGroupsItemItemsItemKind = {
  projects: "projects",
  clients: "clients",
  documents: "documents",
  tasks: "tasks",
  messages: "messages"
};

// src/generated/model/searchResultDtoOutputGroupsItemKind.ts
var SearchResultDtoOutputGroupsItemKind = {
  projects: "projects",
  clients: "clients",
  documents: "documents",
  tasks: "tasks",
  messages: "messages"
};

// src/generated/model/setChecklistItemDtoState.ts
var SetChecklistItemDtoState = {
  todo: "todo",
  done: "done",
  not_applicable: "not_applicable"
};

// src/generated/model/settingsDtoOutputMode.ts
var SettingsDtoOutputMode = {
  required: "required",
  optional: "optional",
  disabled: "disabled"
};

// src/generated/model/shareLinkDtoOutputStatus.ts
var ShareLinkDtoOutputStatus = {
  active: "active",
  expired: "expired",
  revoked: "revoked",
  exhausted: "exhausted"
};

// src/generated/model/shareLinkListDtoOutputItemsItemStatus.ts
var ShareLinkListDtoOutputItemsItemStatus = {
  active: "active",
  expired: "expired",
  revoked: "revoked",
  exhausted: "exhausted"
};

// src/generated/model/signatureCodeSentDtoOutputChannel.ts
var SignatureCodeSentDtoOutputChannel = {
  email: "email",
  sms: "sms",
  app: "app"
};

// src/generated/model/signatureRequestDtoOutputEvidenceStatus.ts
var SignatureRequestDtoOutputEvidenceStatus = {
  none: "none",
  pending: "pending",
  ready: "ready",
  failed: "failed"
};

// src/generated/model/signatureRequestDtoOutputLevel.ts
var SignatureRequestDtoOutputLevel = {
  simple: "simple",
  qualified: "qualified"
};

// src/generated/model/signatureRequestDtoOutputSignersItemStatus.ts
var SignatureRequestDtoOutputSignersItemStatus = {
  pending: "pending",
  signed: "signed",
  declined: "declined"
};

// src/generated/model/signatureRequestDtoOutputStatus.ts
var SignatureRequestDtoOutputStatus = {
  pending: "pending",
  completed: "completed",
  declined: "declined",
  cancelled: "cancelled",
  expired: "expired"
};

// src/generated/model/signatureRequestListDtoOutputItemsItemEvidenceStatus.ts
var SignatureRequestListDtoOutputItemsItemEvidenceStatus = {
  none: "none",
  pending: "pending",
  ready: "ready",
  failed: "failed"
};

// src/generated/model/signatureRequestListDtoOutputItemsItemLevel.ts
var SignatureRequestListDtoOutputItemsItemLevel = {
  simple: "simple",
  qualified: "qualified"
};

// src/generated/model/signatureRequestListDtoOutputItemsItemSignersItemStatus.ts
var SignatureRequestListDtoOutputItemsItemSignersItemStatus = {
  pending: "pending",
  signed: "signed",
  declined: "declined"
};

// src/generated/model/signatureRequestListDtoOutputItemsItemStatus.ts
var SignatureRequestListDtoOutputItemsItemStatus = {
  pending: "pending",
  completed: "completed",
  declined: "declined",
  cancelled: "cancelled",
  expired: "expired"
};

// src/generated/model/signaturesControllerListBox.ts
var SignaturesControllerListBox = {
  to_sign: "to_sign",
  sent: "sent",
  all: "all"
};

// src/generated/model/signaturesControllerListStatus.ts
var SignaturesControllerListStatus = {
  pending: "pending",
  completed: "completed",
  declined: "declined",
  cancelled: "cancelled",
  expired: "expired"
};

// src/generated/model/signingBatchDtoOutputChannel.ts
var SigningBatchDtoOutputChannel = {
  email: "email",
  sms: "sms",
  app: "app"
};

// src/generated/model/signingBatchDtoOutputStatus.ts
var SigningBatchDtoOutputStatus = {
  awaiting_code: "awaiting_code",
  signed: "signed",
  failed: "failed",
  expired: "expired"
};

// src/generated/model/signingBatchResultDtoOutputStatus.ts
var SigningBatchResultDtoOutputStatus = {
  awaiting_code: "awaiting_code",
  signed: "signed",
  failed: "failed",
  expired: "expired"
};

// src/generated/model/spaceApprovalListDtoOutputItemsItemKind.ts
var SpaceApprovalListDtoOutputItemsItemKind = {
  organization: "organization",
  nominative: "nominative",
  guest: "guest"
};

// src/generated/model/spaceApprovalListDtoOutputItemsItemRights.ts
var SpaceApprovalListDtoOutputItemsItemRights = {
  read: "read",
  write: "write",
  approve: "approve"
};

// src/generated/model/spaceDtoOutputAccessRights.ts
var SpaceDtoOutputAccessRights = {
  read: "read",
  write: "write",
  approve: "approve"
};

// src/generated/model/spaceDtoOutputAccessVia.ts
var SpaceDtoOutputAccessVia = {
  host_member: "host_member",
  partner_delegation: "partner_delegation",
  direct_invite: "direct_invite",
  guest: "guest",
  partner_admin: "partner_admin"
};

// src/generated/model/spaceDtoOutputKind.ts
var SpaceDtoOutputKind = {
  organization: "organization",
  internal: "internal",
  shared: "shared",
  group: "group"
};

// src/generated/model/spaceDtoOutputStatus.ts
var SpaceDtoOutputStatus = {
  active: "active",
  closed: "closed"
};

// src/generated/model/spaceDtoOutputTabsItem.ts
var SpaceDtoOutputTabsItem = {
  documents: "documents",
  synthesis: "synthesis",
  groupement: "groupement",
  chat: "chat",
  calendar: "calendar",
  meetings: "meetings",
  people: "people",
  partners: "partners",
  delegates: "delegates",
  settings: "settings",
  audit: "audit"
};

// src/generated/model/spaceInvitationDtoOutputKind.ts
var SpaceInvitationDtoOutputKind = {
  organization: "organization",
  nominative: "nominative",
  guest: "guest"
};

// src/generated/model/spaceInvitationDtoOutputRights.ts
var SpaceInvitationDtoOutputRights = {
  read: "read",
  write: "write",
  approve: "approve"
};

// src/generated/model/spaceInvitationDtoOutputStatus.ts
var SpaceInvitationDtoOutputStatus = {
  pending_approval: "pending_approval",
  pending: "pending",
  accepted: "accepted",
  declined: "declined",
  expired: "expired",
  revoked: "revoked"
};

// src/generated/model/spaceInvitationListDtoOutputItemsItemKind.ts
var SpaceInvitationListDtoOutputItemsItemKind = {
  organization: "organization",
  nominative: "nominative",
  guest: "guest"
};

// src/generated/model/spaceInvitationListDtoOutputItemsItemRights.ts
var SpaceInvitationListDtoOutputItemsItemRights = {
  read: "read",
  write: "write",
  approve: "approve"
};

// src/generated/model/spaceInvitationListDtoOutputItemsItemStatus.ts
var SpaceInvitationListDtoOutputItemsItemStatus = {
  pending_approval: "pending_approval",
  pending: "pending",
  accepted: "accepted",
  declined: "declined",
  expired: "expired",
  revoked: "revoked"
};

// src/generated/model/spaceMeetingsControllerListHasMinutes.ts
var SpaceMeetingsControllerListHasMinutes = {
  true: "true",
  false: "false"
};

// src/generated/model/spaceMeetingsControllerListKind.ts
var SpaceMeetingsControllerListKind = {
  meeting: "meeting",
  call: "call"
};

// src/generated/model/spaceMeetingsControllerListStatus.ts
var SpaceMeetingsControllerListStatus = {
  live: "live",
  scheduled: "scheduled",
  ended: "ended"
};

// src/generated/model/spaceMemberDtoOutputRights.ts
var SpaceMemberDtoOutputRights = {
  read: "read",
  write: "write",
  approve: "approve"
};

// src/generated/model/spaceMemberDtoOutputVia.ts
var SpaceMemberDtoOutputVia = {
  host_member: "host_member",
  partner_delegation: "partner_delegation",
  direct_invite: "direct_invite",
  guest: "guest"
};

// src/generated/model/spaceMemberListDtoOutputItemsItemRights.ts
var SpaceMemberListDtoOutputItemsItemRights = {
  read: "read",
  write: "write",
  approve: "approve"
};

// src/generated/model/spaceMemberListDtoOutputItemsItemVia.ts
var SpaceMemberListDtoOutputItemsItemVia = {
  host_member: "host_member",
  partner_delegation: "partner_delegation",
  direct_invite: "direct_invite",
  guest: "guest"
};

// src/generated/model/spacePartnerDtoOutputRights.ts
var SpacePartnerDtoOutputRights = {
  read: "read",
  write: "write",
  approve: "approve"
};

// src/generated/model/spacePartnerDtoOutputStatus.ts
var SpacePartnerDtoOutputStatus = {
  pending: "pending",
  active: "active",
  declined: "declined",
  expired: "expired",
  revoked: "revoked"
};

// src/generated/model/spacePartnerListDtoOutputItemsItemRights.ts
var SpacePartnerListDtoOutputItemsItemRights = {
  read: "read",
  write: "write",
  approve: "approve"
};

// src/generated/model/spacePartnerListDtoOutputItemsItemStatus.ts
var SpacePartnerListDtoOutputItemsItemStatus = {
  pending: "pending",
  active: "active",
  declined: "declined",
  expired: "expired",
  revoked: "revoked"
};

// src/generated/model/spaceSynthesisDtoOutputOfficesItemOfficeRole.ts
var SpaceSynthesisDtoOutputOfficesItemOfficeRole = {
  host: "host",
  partner: "partner"
};

// src/generated/model/spaceSynthesisDtoOutputOverdueDeliverablesItemDeliverableType.ts
var SpaceSynthesisDtoOutputOverdueDeliverablesItemDeliverableType = {
  drawing: "drawing",
  calculation_note: "calculation_note",
  report: "report",
  specification: "specification",
  bill_of_quantities: "bill_of_quantities",
  estimate: "estimate",
  other: "other"
};

// src/generated/model/spaceSynthesisDtoOutputOverdueDeliverablesItemDiscipline.ts
var SpaceSynthesisDtoOutputOverdueDeliverablesItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/spaceSynthesisDtoOutputOverdueDeliverablesItemPhasePhaseType.ts
var SpaceSynthesisDtoOutputOverdueDeliverablesItemPhasePhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/spaceSynthesisDtoOutputOverdueDeliverablesItemSource.ts
var SpaceSynthesisDtoOutputOverdueDeliverablesItemSource = {
  deliverable: "deliverable",
  discipline: "discipline",
  host: "host"
};

// src/generated/model/spaceSynthesisDtoOutputOverdueDeliverablesItemStatus.ts
var SpaceSynthesisDtoOutputOverdueDeliverablesItemStatus = {
  to_produce: "to_produce",
  in_progress: "in_progress",
  in_review: "in_review",
  approved: "approved",
  transmitted: "transmitted"
};

// src/generated/model/spaceSynthesisDtoOutputScope.ts
var SpaceSynthesisDtoOutputScope = {
  all: "all",
  own: "own"
};

// src/generated/model/startDtoStepsItemMode.ts
var StartDtoStepsItemMode = {
  sequential: "sequential",
  parallel: "parallel"
};

// src/generated/model/subscriptionChangeResultDtoOutputSubscriptionPendingChangeKind.ts
var SubscriptionChangeResultDtoOutputSubscriptionPendingChangeKind = {
  scheduled: "scheduled",
  pause: "pause",
  cancel: "cancel"
};

// src/generated/model/subscriptionChangeResultDtoOutputSubscriptionPendingChangeShapeCycle.ts
var SubscriptionChangeResultDtoOutputSubscriptionPendingChangeShapeCycle = {
  monthly: "monthly",
  annual: "annual"
};

// src/generated/model/subscriptionChangeResultDtoOutputSubscriptionPendingChangeShapePlanCode.ts
var SubscriptionChangeResultDtoOutputSubscriptionPendingChangeShapePlanCode = {
  solo: "solo",
  starter: "starter",
  pro: "pro",
  business: "business",
  enterprise: "enterprise"
};

// src/generated/model/subscriptionChangeResultDtoOutputSubscriptionShapeCycle.ts
var SubscriptionChangeResultDtoOutputSubscriptionShapeCycle = {
  monthly: "monthly",
  annual: "annual"
};

// src/generated/model/subscriptionChangeResultDtoOutputSubscriptionShapePlanCode.ts
var SubscriptionChangeResultDtoOutputSubscriptionShapePlanCode = {
  solo: "solo",
  starter: "starter",
  pro: "pro",
  business: "business",
  enterprise: "enterprise"
};

// src/generated/model/subscriptionChangeResultDtoOutputSubscriptionStatus.ts
var SubscriptionChangeResultDtoOutputSubscriptionStatus = {
  trialing: "trialing",
  active: "active",
  past_due: "past_due",
  read_only: "read_only",
  suspended: "suspended",
  paused: "paused",
  cancelled: "cancelled"
};

// src/generated/model/subscriptionDtoOutputPendingChangeKind.ts
var SubscriptionDtoOutputPendingChangeKind = {
  scheduled: "scheduled",
  pause: "pause",
  cancel: "cancel"
};

// src/generated/model/subscriptionDtoOutputPendingChangeShapeCycle.ts
var SubscriptionDtoOutputPendingChangeShapeCycle = {
  monthly: "monthly",
  annual: "annual"
};

// src/generated/model/subscriptionDtoOutputPendingChangeShapePlanCode.ts
var SubscriptionDtoOutputPendingChangeShapePlanCode = {
  solo: "solo",
  starter: "starter",
  pro: "pro",
  business: "business",
  enterprise: "enterprise"
};

// src/generated/model/subscriptionDtoOutputShapeCycle.ts
var SubscriptionDtoOutputShapeCycle = {
  monthly: "monthly",
  annual: "annual"
};

// src/generated/model/subscriptionDtoOutputShapePlanCode.ts
var SubscriptionDtoOutputShapePlanCode = {
  solo: "solo",
  starter: "starter",
  pro: "pro",
  business: "business",
  enterprise: "enterprise"
};

// src/generated/model/subscriptionDtoOutputStatus.ts
var SubscriptionDtoOutputStatus = {
  trialing: "trialing",
  active: "active",
  past_due: "past_due",
  read_only: "read_only",
  suspended: "suspended",
  paused: "paused",
  cancelled: "cancelled"
};

// src/generated/model/subscriptionOverrideRequestDtoStatus.ts
var SubscriptionOverrideRequestDtoStatus = {
  trialing: "trialing",
  active: "active",
  past_due: "past_due",
  read_only: "read_only",
  suspended: "suspended",
  paused: "paused",
  cancelled: "cancelled"
};

// src/generated/model/subscriptionQuoteDtoOutputBlockersItemMetric.ts
var SubscriptionQuoteDtoOutputBlockersItemMetric = {
  seats: "seats",
  storage: "storage",
  hosted_spaces: "hosted_spaces"
};

// src/generated/model/subscriptionQuoteDtoOutputKind.ts
var SubscriptionQuoteDtoOutputKind = {
  start: "start",
  upgrade: "upgrade",
  restart: "restart",
  scheduled: "scheduled",
  none: "none"
};

// src/generated/model/subscriptionQuoteDtoOutputLinesItemAddon.ts
var SubscriptionQuoteDtoOutputLinesItemAddon = {
  storage_100gb: "storage_100gb",
  storage_1tb: "storage_1tb"
};

// src/generated/model/subscriptionQuoteDtoOutputLinesItemCode.ts
var SubscriptionQuoteDtoOutputLinesItemCode = {
  plan: "plan",
  extra_seats: "extra_seats",
  addon: "addon",
  proration: "proration",
  credit_unused: "credit_unused",
  pause: "pause",
  fair_billing: "fair_billing"
};

// src/generated/model/subscriptionShapeDtoCycle.ts
var SubscriptionShapeDtoCycle = {
  monthly: "monthly",
  annual: "annual"
};

// src/generated/model/subscriptionShapeDtoPlanCode.ts
var SubscriptionShapeDtoPlanCode = {
  solo: "solo",
  starter: "starter",
  pro: "pro",
  business: "business",
  enterprise: "enterprise"
};

// src/generated/model/supplierDtoOutputKind.ts
var SupplierDtoOutputKind = {
  company: "company",
  individual: "individual",
  non_resident: "non_resident"
};

// src/generated/model/supplierDtoOutputWithholdingProfile.ts
var SupplierDtoOutputWithholdingProfile = {
  fees_legal_entity: "fees_legal_entity",
  fees_other: "fees_other",
  fees_non_resident: "fees_non_resident",
  purchases: "purchases",
  none: "none"
};

// src/generated/model/supplierInvoiceDtoOutputPaymentsItemMethod.ts
var SupplierInvoiceDtoOutputPaymentsItemMethod = {
  transfer: "transfer",
  cheque: "cheque",
  bill: "bill",
  cash: "cash",
  online: "online"
};

// src/generated/model/supplierInvoiceDtoOutputStatus.ts
var SupplierInvoiceDtoOutputStatus = {
  open: "open",
  partially_paid: "partially_paid",
  paid: "paid",
  cancelled: "cancelled"
};

// src/generated/model/supplierInvoiceDtoOutputWithholdingProfile.ts
var SupplierInvoiceDtoOutputWithholdingProfile = {
  fees_legal_entity: "fees_legal_entity",
  fees_other: "fees_other",
  fees_non_resident: "fees_non_resident",
  purchases: "purchases",
  none: "none"
};

// src/generated/model/supplierInvoiceDtoOutputWithholdingToVerifyItem.ts
var SupplierInvoiceDtoOutputWithholdingToVerifyItem = {
  stampexemptPublicBuyers: "stamp.exemptPublicBuyers",
  withholdingbase: "withholding.base",
  withholdingpurchases: "withholding.purchases",
  vatWithholdingthresholdBase: "vatWithholding.thresholdBase",
  contractretentionBase: "contract.retentionBase",
  lateInterest: "lateInterest"
};

// src/generated/model/supplierInvoiceListDtoOutputItemsItemPaymentsItemMethod.ts
var SupplierInvoiceListDtoOutputItemsItemPaymentsItemMethod = {
  transfer: "transfer",
  cheque: "cheque",
  bill: "bill",
  cash: "cash",
  online: "online"
};

// src/generated/model/supplierInvoiceListDtoOutputItemsItemStatus.ts
var SupplierInvoiceListDtoOutputItemsItemStatus = {
  open: "open",
  partially_paid: "partially_paid",
  paid: "paid",
  cancelled: "cancelled"
};

// src/generated/model/supplierInvoiceListDtoOutputItemsItemWithholdingProfile.ts
var SupplierInvoiceListDtoOutputItemsItemWithholdingProfile = {
  fees_legal_entity: "fees_legal_entity",
  fees_other: "fees_other",
  fees_non_resident: "fees_non_resident",
  purchases: "purchases",
  none: "none"
};

// src/generated/model/supplierInvoiceListDtoOutputItemsItemWithholdingToVerifyItem.ts
var SupplierInvoiceListDtoOutputItemsItemWithholdingToVerifyItem = {
  stampexemptPublicBuyers: "stamp.exemptPublicBuyers",
  withholdingbase: "withholding.base",
  withholdingpurchases: "withholding.purchases",
  vatWithholdingthresholdBase: "vatWithholding.thresholdBase",
  contractretentionBase: "contract.retentionBase",
  lateInterest: "lateInterest"
};

// src/generated/model/supplierListDtoOutputItemsItemKind.ts
var SupplierListDtoOutputItemsItemKind = {
  company: "company",
  individual: "individual",
  non_resident: "non_resident"
};

// src/generated/model/supplierListDtoOutputItemsItemWithholdingProfile.ts
var SupplierListDtoOutputItemsItemWithholdingProfile = {
  fees_legal_entity: "fees_legal_entity",
  fees_other: "fees_other",
  fees_non_resident: "fees_non_resident",
  purchases: "purchases",
  none: "none"
};

// src/generated/model/suppliersControllerListInvoicesOverdue.ts
var SuppliersControllerListInvoicesOverdue = {
  true: "true",
  false: "false"
};

// src/generated/model/suppliersControllerListInvoicesStatus.ts
var SuppliersControllerListInvoicesStatus = {
  open: "open",
  partially_paid: "partially_paid",
  paid: "paid",
  cancelled: "cancelled"
};

// src/generated/model/suppliersControllerListSuppliersArchived.ts
var SuppliersControllerListSuppliersArchived = {
  true: "true",
  false: "false"
};

// src/generated/model/taskDetailDtoOutputDiscipline.ts
var TaskDetailDtoOutputDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/taskDetailDtoOutputPriority.ts
var TaskDetailDtoOutputPriority = {
  low: "low",
  normal: "normal",
  high: "high",
  urgent: "urgent"
};

// src/generated/model/taskDetailDtoOutputStatus.ts
var TaskDetailDtoOutputStatus = {
  todo: "todo",
  in_progress: "in_progress",
  blocked: "blocked",
  done: "done"
};

// src/generated/model/taskDetailDtoOutputSubtasksItemDiscipline.ts
var TaskDetailDtoOutputSubtasksItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/taskDetailDtoOutputSubtasksItemPriority.ts
var TaskDetailDtoOutputSubtasksItemPriority = {
  low: "low",
  normal: "normal",
  high: "high",
  urgent: "urgent"
};

// src/generated/model/taskDetailDtoOutputSubtasksItemStatus.ts
var TaskDetailDtoOutputSubtasksItemStatus = {
  todo: "todo",
  in_progress: "in_progress",
  blocked: "blocked",
  done: "done"
};

// src/generated/model/taskDtoOutputDiscipline.ts
var TaskDtoOutputDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/taskDtoOutputPriority.ts
var TaskDtoOutputPriority = {
  low: "low",
  normal: "normal",
  high: "high",
  urgent: "urgent"
};

// src/generated/model/taskDtoOutputStatus.ts
var TaskDtoOutputStatus = {
  todo: "todo",
  in_progress: "in_progress",
  blocked: "blocked",
  done: "done"
};

// src/generated/model/taskListDtoOutputItemsItemDiscipline.ts
var TaskListDtoOutputItemsItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/taskListDtoOutputItemsItemPriority.ts
var TaskListDtoOutputItemsItemPriority = {
  low: "low",
  normal: "normal",
  high: "high",
  urgent: "urgent"
};

// src/generated/model/taskListDtoOutputItemsItemStatus.ts
var TaskListDtoOutputItemsItemStatus = {
  todo: "todo",
  in_progress: "in_progress",
  blocked: "blocked",
  done: "done"
};

// src/generated/model/tasksControllerListDiscipline.ts
var TasksControllerListDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/tasksControllerListStatus.ts
var TasksControllerListStatus = {
  todo: "todo",
  in_progress: "in_progress",
  blocked: "blocked",
  done: "done"
};

// src/generated/model/tejExportDtoOutputAdapter.ts
var TejExportDtoOutputAdapter = {
  "tej-csv-20261": "tej-csv-2026.1"
};

// src/generated/model/tejExportListDtoOutputItemsItemAdapter.ts
var TejExportListDtoOutputItemsItemAdapter = {
  "tej-csv-20261": "tej-csv-2026.1"
};

// src/generated/model/templateDtoOutputStepsItemMode.ts
var TemplateDtoOutputStepsItemMode = {
  sequential: "sequential",
  parallel: "parallel"
};

// src/generated/model/templateListDtoOutputItemsItemStepsItemMode.ts
var TemplateListDtoOutputItemsItemStepsItemMode = {
  sequential: "sequential",
  parallel: "parallel"
};

// src/generated/model/tenderDetailDtoOutputRequirementsItemVaultDocumentKind.ts
var TenderDetailDtoOutputRequirementsItemVaultDocumentKind = {
  tax_certificate: "tax_certificate",
  cnss_certificate: "cnss_certificate",
  rne: "rne",
  agreement: "agreement",
  order_registration: "order_registration",
  insurance: "insurance",
  cv: "cv",
  reference: "reference"
};

// src/generated/model/tenderDetailDtoOutputRequirementsItemVaultDocumentState.ts
var TenderDetailDtoOutputRequirementsItemVaultDocumentState = {
  valid: "valid",
  expiring: "expiring",
  expired: "expired",
  no_expiry: "no_expiry"
};

// src/generated/model/tenderDetailDtoOutputSource.ts
var TenderDetailDtoOutputSource = {
  tuneps: "tuneps",
  press: "press",
  client_site: "client_site",
  other: "other"
};

// src/generated/model/tenderDetailDtoOutputStatus.ts
var TenderDetailDtoOutputStatus = {
  watch: "watch",
  go: "go",
  no_go: "no_go",
  preparing: "preparing",
  submitted: "submitted",
  won: "won",
  lost: "lost"
};

// src/generated/model/tenderDtoOutputSource.ts
var TenderDtoOutputSource = {
  tuneps: "tuneps",
  press: "press",
  client_site: "client_site",
  other: "other"
};

// src/generated/model/tenderDtoOutputStatus.ts
var TenderDtoOutputStatus = {
  watch: "watch",
  go: "go",
  no_go: "no_go",
  preparing: "preparing",
  submitted: "submitted",
  won: "won",
  lost: "lost"
};

// src/generated/model/tenderListDtoOutputItemsItemSource.ts
var TenderListDtoOutputItemsItemSource = {
  tuneps: "tuneps",
  press: "press",
  client_site: "client_site",
  other: "other"
};

// src/generated/model/tenderListDtoOutputItemsItemStatus.ts
var TenderListDtoOutputItemsItemStatus = {
  watch: "watch",
  go: "go",
  no_go: "no_go",
  preparing: "preparing",
  submitted: "submitted",
  won: "won",
  lost: "lost"
};

// src/generated/model/tenderRequirementDtoOutputVaultDocumentKind.ts
var TenderRequirementDtoOutputVaultDocumentKind = {
  tax_certificate: "tax_certificate",
  cnss_certificate: "cnss_certificate",
  rne: "rne",
  agreement: "agreement",
  order_registration: "order_registration",
  insurance: "insurance",
  cv: "cv",
  reference: "reference"
};

// src/generated/model/tenderRequirementDtoOutputVaultDocumentState.ts
var TenderRequirementDtoOutputVaultDocumentState = {
  valid: "valid",
  expiring: "expiring",
  expired: "expired",
  no_expiry: "no_expiry"
};

// src/generated/model/transmittalDtoOutputLanguage.ts
var TransmittalDtoOutputLanguage = {
  fr: "fr",
  ar: "ar"
};

// src/generated/model/transmittalDtoOutputPdfStatus.ts
var TransmittalDtoOutputPdfStatus = {
  ready: "ready",
  preparing: "preparing"
};

// src/generated/model/transmittalDtoOutputRecipientsItemAcknowledgedVia.ts
var TransmittalDtoOutputRecipientsItemAcknowledgedVia = {
  app: "app",
  link: "link"
};

// src/generated/model/transmittalDtoOutputRecipientsItemKind.ts
var TransmittalDtoOutputRecipientsItemKind = {
  user: "user",
  email: "email"
};

// src/generated/model/transmittalPdfUrlDtoOutputStatus.ts
var TransmittalPdfUrlDtoOutputStatus = {
  ready: "ready",
  preparing: "preparing"
};

// src/generated/model/trashListDtoOutputItemsItemKind.ts
var TrashListDtoOutputItemsItemKind = {
  folder: "folder",
  document: "document"
};

// src/generated/model/trashTargetDtoKind.ts
var TrashTargetDtoKind = {
  folder: "folder",
  document: "document"
};

// src/generated/model/treasuryForecastDtoOutputScope.ts
var TreasuryForecastDtoOutputScope = {
  organization: "organization",
  projects: "projects"
};

// src/generated/model/updateClientDtoKind.ts
var UpdateClientDtoKind = {
  public_entity: "public_entity",
  private_company: "private_company",
  individual: "individual",
  foreign: "foreign"
};

// src/generated/model/updateClientDtoVatRegime.ts
var UpdateClientDtoVatRegime = {
  subject: "subject",
  exempt: "exempt",
  suspended: "suspended",
  export: "export"
};

// src/generated/model/updateContractDtoCurrency.ts
var UpdateContractDtoCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/updateContractDtoKind.ts
var UpdateContractDtoKind = {
  private_agreement: "private_agreement",
  public_market: "public_market"
};

// src/generated/model/updateContractDtoRetentionBase.ts
var UpdateContractDtoRetentionBase = {
  ht: "ht",
  ttc: "ttc"
};

// src/generated/model/updateDeliverableDtoDeliverableType.ts
var UpdateDeliverableDtoDeliverableType = {
  drawing: "drawing",
  calculation_note: "calculation_note",
  report: "report",
  specification: "specification",
  bill_of_quantities: "bill_of_quantities",
  estimate: "estimate",
  other: "other"
};

// src/generated/model/updateDeliverableDtoDiscipline.ts
var UpdateDeliverableDtoDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/updateDeliverableDtoStatus.ts
var UpdateDeliverableDtoStatus = {
  to_produce: "to_produce",
  in_progress: "in_progress",
  in_review: "in_review",
  approved: "approved",
  transmitted: "transmitted"
};

// src/generated/model/updateDocumentDtoDiscipline.ts
var UpdateDocumentDtoDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/updateDocumentDtoDocType.ts
var UpdateDocumentDtoDocType = {
  drawing: "drawing",
  calculation_note: "calculation_note",
  report: "report",
  specification: "specification",
  bill_of_quantities: "bill_of_quantities",
  estimate: "estimate",
  minutes: "minutes",
  correspondence: "correspondence",
  photo: "photo",
  other: "other"
};

// src/generated/model/updateDocumentDtoPhaseType.ts
var UpdateDocumentDtoPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/updateEventDtoKind.ts
var UpdateEventDtoKind = {
  meeting: "meeting",
  site_visit: "site_visit",
  deadline: "deadline",
  other: "other"
};

// src/generated/model/updateFinanceSettingsDtoRevenueRecognition.ts
var UpdateFinanceSettingsDtoRevenueRecognition = {
  invoiced: "invoiced",
  completion: "completion"
};

// src/generated/model/updateInvoiceDtoCurrency.ts
var UpdateInvoiceDtoCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/updateInvoiceDtoKind.ts
var UpdateInvoiceDtoKind = {
  advance: "advance",
  deposit: "deposit",
  progress: "progress",
  final: "final"
};

// src/generated/model/updateInvoiceDtoLanguage.ts
var UpdateInvoiceDtoLanguage = {
  fr: "fr",
  ar: "ar",
  bilingual: "bilingual"
};

// src/generated/model/updateInvoiceDtoLinesItemRole.ts
var UpdateInvoiceDtoLinesItemRole = {
  service: "service",
  advance_recovery: "advance_recovery",
  retention: "retention",
  retention_release: "retention_release"
};

// src/generated/model/updateInvoiceDtoVatTreatment.ts
var UpdateInvoiceDtoVatTreatment = {
  standard: "standard",
  suspended: "suspended",
  export: "export"
};

// src/generated/model/updateMinutesDtoItemsItemKind.ts
var UpdateMinutesDtoItemsItemKind = {
  point: "point",
  decision: "decision",
  action: "action"
};

// src/generated/model/updateMinutesDtoLanguage.ts
var UpdateMinutesDtoLanguage = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/updateMinutesDtoTemplate.ts
var UpdateMinutesDtoTemplate = {
  coordination: "coordination",
  moa: "moa",
  site_meeting: "site_meeting",
  site_visit: "site_visit"
};

// src/generated/model/updateObservationDtoKind.ts
var UpdateObservationDtoKind = {
  observation: "observation",
  reserve: "reserve"
};

// src/generated/model/updateOrganizationDtoDefaultLocale.ts
var UpdateOrganizationDtoDefaultLocale = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/updateOrganizationDtoDisciplinesItem.ts
var UpdateOrganizationDtoDisciplinesItem = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/updateOrganizationDtoGovernorate.ts
var UpdateOrganizationDtoGovernorate = {
  tunis: "tunis",
  ariana: "ariana",
  ben_arous: "ben_arous",
  manouba: "manouba",
  nabeul: "nabeul",
  zaghouan: "zaghouan",
  bizerte: "bizerte",
  beja: "beja",
  jendouba: "jendouba",
  kef: "kef",
  siliana: "siliana",
  kairouan: "kairouan",
  kasserine: "kasserine",
  sidi_bouzid: "sidi_bouzid",
  sousse: "sousse",
  monastir: "monastir",
  mahdia: "mahdia",
  sfax: "sfax",
  gafsa: "gafsa",
  tozeur: "tozeur",
  kebili: "kebili",
  gabes: "gabes",
  medenine: "medenine",
  tataouine: "tataouine"
};

// src/generated/model/updateOrganizationDtoLegalForm.ts
var UpdateOrganizationDtoLegalForm = {
  individual: "individual",
  suarl: "suarl",
  sarl: "sarl",
  sa: "sa",
  snc: "snc",
  scs: "scs",
  gie: "gie",
  other: "other"
};

// src/generated/model/updatePhaseDtoStatus.ts
var UpdatePhaseDtoStatus = {
  not_started: "not_started",
  in_progress: "in_progress",
  in_review: "in_review",
  closed: "closed"
};

// src/generated/model/updateProfileDtoDigitStyle.ts
var UpdateProfileDtoDigitStyle = {
  latn: "latn",
  arab: "arab"
};

// src/generated/model/updateProfileDtoLocale.ts
var UpdateProfileDtoLocale = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/updateProjectDtoFeeMode.ts
var UpdateProjectDtoFeeMode = {
  lump_sum: "lump_sum",
  works_percentage: "works_percentage",
  time_based: "time_based"
};

// src/generated/model/updateProjectDtoGovernorate.ts
var UpdateProjectDtoGovernorate = {
  tunis: "tunis",
  ariana: "ariana",
  ben_arous: "ben_arous",
  manouba: "manouba",
  nabeul: "nabeul",
  zaghouan: "zaghouan",
  bizerte: "bizerte",
  beja: "beja",
  jendouba: "jendouba",
  kef: "kef",
  siliana: "siliana",
  kairouan: "kairouan",
  kasserine: "kasserine",
  sidi_bouzid: "sidi_bouzid",
  sousse: "sousse",
  monastir: "monastir",
  mahdia: "mahdia",
  sfax: "sfax",
  gafsa: "gafsa",
  tozeur: "tozeur",
  kebili: "kebili",
  gabes: "gabes",
  medenine: "medenine",
  tataouine: "tataouine"
};

// src/generated/model/updateProjectDtoMissionType.ts
var UpdateProjectDtoMissionType = {
  public_building: "public_building",
  collective_housing: "collective_housing",
  villa: "villa",
  industrial: "industrial",
  facility: "facility",
  subdivision_vrd: "subdivision_vrd",
  expertise: "expertise"
};

// src/generated/model/updateProjectDtoStatus.ts
var UpdateProjectDtoStatus = {
  draft: "draft",
  active: "active",
  on_hold: "on_hold",
  closed: "closed",
  archived: "archived"
};

// src/generated/model/updateQuoteDtoCurrency.ts
var UpdateQuoteDtoCurrency = {
  TND: "TND",
  EUR: "EUR",
  USD: "USD"
};

// src/generated/model/updateQuoteDtoFeeMode.ts
var UpdateQuoteDtoFeeMode = {
  lump_sum: "lump_sum",
  percentage_of_works: "percentage_of_works",
  time_based: "time_based",
  mixed: "mixed"
};

// src/generated/model/updateQuoteDtoLanguage.ts
var UpdateQuoteDtoLanguage = {
  fr: "fr",
  ar: "ar",
  bilingual: "bilingual"
};

// src/generated/model/updateQuoteDtoLinesItemPhaseType.ts
var UpdateQuoteDtoLinesItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/updateResponsibilityMatrixDtoDisciplinesItemDiscipline.ts
var UpdateResponsibilityMatrixDtoDisciplinesItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/updateSettingsDtoMode.ts
var UpdateSettingsDtoMode = {
  required: "required",
  optional: "optional",
  disabled: "disabled"
};

// src/generated/model/updateSupplierDtoKind.ts
var UpdateSupplierDtoKind = {
  company: "company",
  individual: "individual",
  non_resident: "non_resident"
};

// src/generated/model/updateSupplierDtoWithholdingProfile.ts
var UpdateSupplierDtoWithholdingProfile = {
  fees_legal_entity: "fees_legal_entity",
  fees_other: "fees_other",
  fees_non_resident: "fees_non_resident",
  purchases: "purchases",
  none: "none"
};

// src/generated/model/updateTaskDtoDiscipline.ts
var UpdateTaskDtoDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/updateTaskDtoPriority.ts
var UpdateTaskDtoPriority = {
  low: "low",
  normal: "normal",
  high: "high",
  urgent: "urgent"
};

// src/generated/model/updateTaskDtoStatus.ts
var UpdateTaskDtoStatus = {
  todo: "todo",
  in_progress: "in_progress",
  blocked: "blocked",
  done: "done"
};

// src/generated/model/updateTemplateDtoDefinitionChannelsItemDiscipline.ts
var UpdateTemplateDtoDefinitionChannelsItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/updateTemplateDtoDefinitionChannelsItemKind.ts
var UpdateTemplateDtoDefinitionChannelsItemKind = {
  general: "general",
  discipline: "discipline"
};

// src/generated/model/updateTemplateDtoDefinitionPhasesItemPhaseType.ts
var UpdateTemplateDtoDefinitionPhasesItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/updateTemplateDtoDefinitionTasksItemDiscipline.ts
var UpdateTemplateDtoDefinitionTasksItemDiscipline = {
  architecture: "architecture",
  structure: "structure",
  vrd: "vrd",
  fluides: "fluides",
  electricite: "electricite",
  topographie: "topographie",
  geotechnique: "geotechnique",
  opc: "opc"
};

// src/generated/model/updateTemplateDtoDefinitionTasksItemPhaseType.ts
var UpdateTemplateDtoDefinitionTasksItemPhaseType = {
  esq: "esq",
  aps: "aps",
  apd: "apd",
  pro: "pro",
  dce: "dce",
  act: "act",
  det: "det",
  aor_provisional: "aor_provisional",
  aor_final: "aor_final",
  custom: "custom"
};

// src/generated/model/updateTenderDtoSource.ts
var UpdateTenderDtoSource = {
  tuneps: "tuneps",
  press: "press",
  client_site: "client_site",
  other: "other"
};

// src/generated/model/updateTimeEntryDtoCategory.ts
var UpdateTimeEntryDtoCategory = {
  studies: "studies",
  site: "site",
  meeting: "meeting",
  travel: "travel",
  admin: "admin",
  other: "other"
};

// src/generated/model/updateVaultDocumentDtoKind.ts
var UpdateVaultDocumentDtoKind = {
  tax_certificate: "tax_certificate",
  cnss_certificate: "cnss_certificate",
  rne: "rne",
  agreement: "agreement",
  order_registration: "order_registration",
  insurance: "insurance",
  cv: "cv",
  reference: "reference"
};

// src/generated/model/uploadStatusDtoOutputRejectionReason.ts
var UploadStatusDtoOutputRejectionReason = {
  infected: "infected",
  scan_limits: "scan_limits",
  type_mismatch: "type_mismatch",
  html_content: "html_content",
  size_mismatch: "size_mismatch",
  sha256_mismatch: "sha256_mismatch"
};

// src/generated/model/uploadStatusDtoOutputStatus.ts
var UploadStatusDtoOutputStatus = {
  open: "open",
  completed: "completed",
  aborted: "aborted"
};

// src/generated/model/uploadStatusDtoOutputVersionStatus.ts
var UploadStatusDtoOutputVersionStatus = {
  uploading: "uploading",
  scanning: "scanning",
  available: "available",
  rejected: "rejected"
};

// src/generated/model/userDataExportDtoOutputStatus.ts
var UserDataExportDtoOutputStatus = {
  queued: "queued",
  running: "running",
  ready: "ready",
  failed: "failed",
  expired: "expired"
};

// src/generated/model/userDataExportPageDtoOutputItemsItemStatus.ts
var UserDataExportPageDtoOutputItemsItemStatus = {
  queued: "queued",
  running: "running",
  ready: "ready",
  failed: "failed",
  expired: "expired"
};

// src/generated/model/userProfileDtoOutputDigitStyle.ts
var UserProfileDtoOutputDigitStyle = {
  latn: "latn",
  arab: "arab"
};

// src/generated/model/userProfileDtoOutputLocale.ts
var UserProfileDtoOutputLocale = {
  fr: "fr",
  ar: "ar",
  en: "en"
};

// src/generated/model/vaultDocumentDtoOutputKind.ts
var VaultDocumentDtoOutputKind = {
  tax_certificate: "tax_certificate",
  cnss_certificate: "cnss_certificate",
  rne: "rne",
  agreement: "agreement",
  order_registration: "order_registration",
  insurance: "insurance",
  cv: "cv",
  reference: "reference"
};

// src/generated/model/vaultDocumentDtoOutputState.ts
var VaultDocumentDtoOutputState = {
  valid: "valid",
  expiring: "expiring",
  expired: "expired",
  no_expiry: "no_expiry"
};

// src/generated/model/vaultDocumentListDtoOutputItemsItemKind.ts
var VaultDocumentListDtoOutputItemsItemKind = {
  tax_certificate: "tax_certificate",
  cnss_certificate: "cnss_certificate",
  rne: "rne",
  agreement: "agreement",
  order_registration: "order_registration",
  insurance: "insurance",
  cv: "cv",
  reference: "reference"
};

// src/generated/model/vaultDocumentListDtoOutputItemsItemState.ts
var VaultDocumentListDtoOutputItemsItemState = {
  valid: "valid",
  expiring: "expiring",
  expired: "expired",
  no_expiry: "no_expiry"
};

// src/generated/model/vaultDocumentsControllerListKind.ts
var VaultDocumentsControllerListKind = {
  tax_certificate: "tax_certificate",
  cnss_certificate: "cnss_certificate",
  rne: "rne",
  agreement: "agreement",
  order_registration: "order_registration",
  insurance: "insurance",
  cv: "cv",
  reference: "reference"
};

// src/generated/model/vaultDocumentsControllerListState.ts
var VaultDocumentsControllerListState = {
  valid: "valid",
  expiring: "expiring",
  expired: "expired",
  no_expiry: "no_expiry"
};

// src/generated/model/withholdingSummaryDtoOutputToVerifyItem.ts
var WithholdingSummaryDtoOutputToVerifyItem = {
  stampexemptPublicBuyers: "stamp.exemptPublicBuyers",
  withholdingbase: "withholding.base",
  withholdingpurchases: "withholding.purchases",
  vatWithholdingthresholdBase: "vatWithholding.thresholdBase",
  contractretentionBase: "contract.retentionBase",
  lateInterest: "lateInterest"
};
export {
  AccountSecurityDtoOutputAuthenticatorsItemKind,
  AccountingExportDtoOutputFormat,
  AccountingExportDtoOutputJournal,
  AccountingExportDtoOutputPreset,
  AccountingExportDtoOutputStatus,
  AccountingExportListDtoOutputItemsItemFormat,
  AccountingExportListDtoOutputItemsItemJournal,
  AccountingExportListDtoOutputItemsItemPreset,
  AccountingExportListDtoOutputItemsItemStatus,
  ActivityPageDtoOutputItemsItemType,
  AddReactionDtoEmoji,
  AnnotationsControllerListResolved,
  ApprovalsControllerListStatus,
  ApprovalsControllerListToDecide,
  AuditChainVerificationDtoClassOutputReason,
  AuditEventListDtoOutputItemsItemActorType,
  AuthControllerSignInEnrol,
  AuthControllerSignInFresh,
  AuthControllerSignInLocale,
  AuthControllerStepUpReauth,
  BillingInvoiceListDtoOutputItemsItemPurpose,
  BillingInvoiceListDtoOutputItemsItemStatus,
  BreakGlassCreateDtoBasis,
  BreakGlassListDtoOutputItemsItemBasis,
  BreakGlassListDtoOutputItemsItemStatus,
  BreakGlassRequestDtoOutputBasis,
  BreakGlassRequestDtoOutputStatus,
  CalendarEventDtoOutputAttendeesItemResponse,
  CalendarEventDtoOutputKind,
  CalendarEventDtoOutputMyResponse,
  CalendarEventDtoOutputSource,
  CalendarEventListDtoOutputItemsItemAttendeesItemResponse,
  CalendarEventListDtoOutputItemsItemKind,
  CalendarEventListDtoOutputItemsItemMyResponse,
  CalendarEventListDtoOutputItemsItemSource,
  ChangeTenderStatusDtoStatus,
  ChannelDtoOutputDiscipline,
  ChannelDtoOutputKind,
  ChannelListDtoOutputItemsItemDiscipline,
  ChannelListDtoOutputItemsItemKind,
  ChannelMeetingsControllerListHasMinutes,
  ChannelMeetingsControllerListKind,
  ChannelMeetingsControllerListStatus,
  ChecklistDtoOutputItemsItemState,
  ChecklistListDtoOutputItemsItemItemsItemState,
  ClientDtoOutputKind,
  ClientDtoOutputVatRegime,
  ClientErrorReportDtoKind,
  ClientListDtoOutputItemsItemKind,
  ClientListDtoOutputItemsItemVatRegime,
  ClientsControllerListArchived,
  ClientsControllerListKind,
  ClosedPartnershipListDtoOutputItemsItemLastExportStatus,
  ClosedSpaceDtoOutputAccessRights,
  ClosedSpaceDtoOutputAccessVia,
  ClosedSpaceDtoOutputKind,
  ClosedSpaceDtoOutputStatus,
  ClosedSpaceDtoOutputTabsItem,
  CommentDtoOutputSubjectType,
  CommentListDtoOutputItemsItemSubjectType,
  CompletedUploadDtoOutputStatus,
  ContractDtoOutputClientKind,
  ContractDtoOutputCurrency,
  ContractDtoOutputKind,
  ContractDtoOutputRetentionBase,
  ContractDtoOutputWarningsItemCode,
  ContractListDtoOutputItemsItemCurrency,
  ContractListDtoOutputItemsItemKind,
  ContractsControllerListKind,
  ConvertQuoteDtoMissionType,
  ConvertTenderDtoMissionType,
  CreateAccountingExportDtoFormat,
  CreateAccountingExportDtoJournal,
  CreateAccountingExportDtoPreset,
  CreateClientDtoKind,
  CreateClientDtoVatRegime,
  CreateContractDtoCurrency,
  CreateContractDtoKind,
  CreateContractDtoRetentionBase,
  CreateCredentialDtoKind,
  CreateCreditNoteDtoLinesItemRole,
  CreateDeliverableDtoDeliverableType,
  CreateDeliverableDtoDiscipline,
  CreateEventDtoKind,
  CreateExpenseDtoCategory,
  CreateFiscalProfileDtoTaxRegime,
  CreateFiscalProfileDtoWithholdingStatus,
  CreateGroupementPaymentDtoKind,
  CreateIcsFeedDtoScope,
  CreateInvitationDtoLocale,
  CreateInvoiceDtoCurrency,
  CreateInvoiceDtoKind,
  CreateInvoiceDtoLanguage,
  CreateInvoiceDtoLinesItemRole,
  CreateInvoiceDtoVatTreatment,
  CreateLeaveDtoKind,
  CreateMinutesDtoLanguage,
  CreateMinutesDtoTemplate,
  CreateObservationDtoKind,
  CreateOrderDtoKind,
  CreateOrgChannelDtoKind,
  CreateOrgDataExportDtoScope,
  CreateOrgTemplateDtoDefinitionChannelsItemDiscipline,
  CreateOrgTemplateDtoDefinitionChannelsItemKind,
  CreateOrgTemplateDtoDefinitionPhasesItemPhaseType,
  CreateOrgTemplateDtoDefinitionTasksItemDiscipline,
  CreateOrgTemplateDtoDefinitionTasksItemPhaseType,
  CreateOrganizationDtoDefaultLocale,
  CreateOrganizationDtoDisciplinesItem,
  CreateOrganizationDtoGovernorate,
  CreateOrganizationDtoLegalForm,
  CreatePaymentDtoMethod,
  CreatePhaseDtoPhaseType,
  CreateProjectDtoFeeMode,
  CreateProjectDtoGovernorate,
  CreateProjectDtoMissionType,
  CreateQuoteDtoCurrency,
  CreateQuoteDtoFeeMode,
  CreateQuoteDtoLanguage,
  CreateQuoteDtoLinesItemPhaseType,
  CreateReceptionReportDtoLanguage,
  CreateRoleDtoBasedOn,
  CreateSignatureRequestDtoLevel,
  CreateSpaceChannelDtoDiscipline,
  CreateSpaceChannelDtoKind,
  CreateSpaceDtoKind,
  CreateSpaceInvitationDtoKind,
  CreateSpaceInvitationDtoLocale,
  CreateSpaceInvitationDtoRights,
  CreateSupplierDtoKind,
  CreateSupplierDtoWithholdingProfile,
  CreateSupplierPaymentDtoMethod,
  CreateTaskDtoDiscipline,
  CreateTaskDtoPriority,
  CreateTaskDtoStatus,
  CreateTejExportDtoAdapter,
  CreateTemplateDtoStepsItemMode,
  CreateTenderDtoSource,
  CreateTimeEntryDtoCategory,
  CreateTransmittalDtoLanguage,
  CreateUploadDtoMetadataDiscipline,
  CreateUploadDtoMetadataDocType,
  CreateUploadDtoMetadataPhaseType,
  CreateVaultDocumentDtoKind,
  CreatedIcsFeedDtoOutputScope,
  CreatedShareLinkDtoOutputLinkStatus,
  CredentialDtoOutputKeyAlgorithm,
  CredentialDtoOutputKind,
  CredentialDtoOutputStatus,
  CredentialListDtoOutputItemsItemKeyAlgorithm,
  CredentialListDtoOutputItemsItemKind,
  CredentialListDtoOutputItemsItemStatus,
  DecideDtoDecision,
  DecideTimeEntriesDtoDecision,
  DelegateMemberDtoRights,
  DeletionRequestDtoOutputReason,
  DeletionRequestDtoOutputStatus,
  DeletionStatusDtoOutputRequestReason,
  DeletionStatusDtoOutputRequestStatus,
  DeliverableDtoOutputDeliverableType,
  DeliverableDtoOutputDiscipline,
  DeliverableDtoOutputStatus,
  DeliverableListDtoOutputItemsItemDeliverableType,
  DeliverableListDtoOutputItemsItemDiscipline,
  DeliverableListDtoOutputItemsItemStatus,
  DeliverablesControllerListStatus,
  DiffusionHistoryDtoOutputItemsItemRecipientsItemAcknowledgedVia,
  DiffusionHistoryDtoOutputItemsItemRecipientsItemKind,
  DirectoryContactResponseDtoOutputValue,
  DirectoryControllerSearchDiscipline,
  DirectoryControllerSearchGovernorate,
  DocumentDetailDtoOutputDiscipline,
  DocumentDetailDtoOutputDocType,
  DocumentDetailDtoOutputLatestVersionStatus,
  DocumentDetailDtoOutputMissingMetadataItem,
  DocumentDetailDtoOutputPhaseType,
  DocumentListDtoOutputItemsItemDiscipline,
  DocumentListDtoOutputItemsItemDocType,
  DocumentListDtoOutputItemsItemLatestVersionStatus,
  DocumentListDtoOutputItemsItemPhaseType,
  DocumentSettingsDtoIndexStyle,
  DocumentSettingsDtoOutputIndexStyle,
  DocumentVersionDtoOutputRejectionReason,
  DocumentVersionDtoOutputStatus,
  DocumentVersionListDtoOutputItemsItemRejectionReason,
  DocumentVersionListDtoOutputItemsItemStatus,
  DocumentsControllerListDiscipline,
  DocumentsControllerListDocType,
  DocumentsControllerListOrder,
  DocumentsControllerListPhaseType,
  DocumentsControllerListSort,
  DownloadUrlDtoOutputStatus,
  EntryDtoOutputCategory,
  EntryDtoOutputStatus,
  EventResponseDtoResponse,
  ExitExportDtoOutputStatus,
  ExpenseDtoOutputCategory,
  ExpenseDtoOutputStatus,
  ExpenseListDtoOutputItemsItemCategory,
  ExpenseListDtoOutputItemsItemStatus,
  ExpensesControllerListCategory,
  ExpensesControllerListStatus,
  ExpensesControllerMineStatus,
  FeeScaleDtoOutputSource,
  FeeScaleListDtoOutputItemsItemSource,
  FinanceDashboardDtoOutputScope,
  FinancePreviewDtoOutputComputationCurrency,
  FinancePreviewDtoOutputComputationKind,
  FinancePreviewDtoOutputComputationLinesItemRole,
  FinancePreviewDtoOutputComputationStepsItemKey,
  FinancePreviewDtoOutputComputationStepsItemNote,
  FinancePreviewDtoOutputComputationStepsItemToVerifyItem,
  FinancePreviewDtoOutputComputationTreatmentMentionTreatment,
  FinancePreviewDtoOutputComputationUsedToVerifyRulesItem,
  FinancePreviewDtoOutputComputationVatTreatment,
  FinancePreviewDtoOutputRuleSetVerificationStatus,
  FinancePreviewRequestDtoCurrency,
  FinancePreviewRequestDtoKind,
  FinancePreviewRequestDtoLinesItemRole,
  FinancePreviewRequestDtoVatTreatment,
  FinanceSettingsDtoOutputRevenueRecognition,
  FinanceTaxRuleSetDtoOutputToVerifyItem,
  FinanceTaxRuleSetDtoOutputVerificationStatus,
  FiscalProfileDtoOutputTaxRegime,
  FiscalProfileDtoOutputWithholdingStatus,
  FiscalProfileListDtoOutputItemsItemTaxRegime,
  FiscalProfileListDtoOutputItemsItemWithholdingStatus,
  FlowDtoOutputStatus,
  FlowDtoOutputStepsItemDecisionsItemDecision,
  FlowDtoOutputStepsItemMode,
  FlowDtoOutputStepsItemOutcome,
  FlowDtoOutputStepsItemStatus,
  FlowListDtoOutputItemsItemStatus,
  FlowListDtoOutputItemsItemStepsItemDecisionsItemDecision,
  FlowListDtoOutputItemsItemStepsItemMode,
  FlowListDtoOutputItemsItemStepsItemOutcome,
  FlowListDtoOutputItemsItemStepsItemStatus,
  FolderAclDtoOutputEntriesItemRelation,
  FolderAclDtoOutputEntriesItemSubjectType,
  FolderAclDtoOutputMode,
  FolderDetailDtoOutputAclMode,
  FolderDtoOutputAclMode,
  FolderListDtoOutputItemsItemAclMode,
  GanttDtoOutputPhasesItemDeadlineAlert,
  GanttDtoOutputPhasesItemPhaseType,
  GanttDtoOutputPhasesItemStatus,
  GanttDtoOutputTasksItemStatus,
  GroupementDtoOutputBillingMode,
  GroupementDtoOutputMembersItemRole,
  GroupementDtoOutputPaymentsItemKind,
  GroupementDtoOutputPhasesItemPhaseType,
  GroupementPaymentDtoOutputKind,
  HealthStatusDtoOutputStatus,
  IcsFeedListDtoOutputItemsItemScope,
  IncomingSpaceInvitationListDtoOutputItemsItemKind,
  IncomingSpaceInvitationListDtoOutputItemsItemRights,
  InvitationDtoOutputStatus,
  InvitationListDtoOutputItemsItemStatus,
  InvitationPreviewDtoOutputStatus,
  InvitePartnerDtoRights,
  InvoiceDtoOutputClientKind,
  InvoiceDtoOutputComputationCurrency,
  InvoiceDtoOutputComputationKind,
  InvoiceDtoOutputComputationLinesItemRole,
  InvoiceDtoOutputComputationStepsItemKey,
  InvoiceDtoOutputComputationStepsItemNote,
  InvoiceDtoOutputComputationStepsItemToVerifyItem,
  InvoiceDtoOutputComputationTreatmentMentionTreatment,
  InvoiceDtoOutputComputationUsedToVerifyRulesItem,
  InvoiceDtoOutputComputationVatTreatment,
  InvoiceDtoOutputCurrency,
  InvoiceDtoOutputEinvoiceStatus,
  InvoiceDtoOutputKind,
  InvoiceDtoOutputLanguage,
  InvoiceDtoOutputLinesItemRole,
  InvoiceDtoOutputPaymentStatus,
  InvoiceDtoOutputStatus,
  InvoiceDtoOutputVatTreatment,
  InvoiceEinvoiceDtoOutputEinvoiceStatus,
  InvoiceEinvoiceDtoOutputMode,
  InvoiceEinvoiceDtoOutputNextStep,
  InvoiceEinvoiceDtoOutputSubmissionsItemFailureCode,
  InvoiceEinvoiceDtoOutputSubmissionsItemRejectionKind,
  InvoiceEinvoiceDtoOutputSubmissionsItemStatus,
  InvoiceListDtoOutputItemsItemCurrency,
  InvoiceListDtoOutputItemsItemEinvoiceStatus,
  InvoiceListDtoOutputItemsItemKind,
  InvoiceListDtoOutputItemsItemPaymentStatus,
  InvoiceListDtoOutputItemsItemStatus,
  InvoicesControllerListKind,
  InvoicesControllerListPaymentStatus,
  InvoicesControllerListStatus,
  LateInterestDtoOutputReason,
  LateInterestDtoOutputToVerifyItem,
  LeaveDtoOutputKind,
  LeaveListDtoOutputItemsItemKind,
  ManagementDashboardDtoOutputMarginRevenueRecognition,
  ManagementDashboardDtoOutputScope,
  ManagementDashboardDtoOutputTendersByStageItemStage,
  ManualPaymentRequestDtoMethod,
  MeResponseDtoOutputMembershipsItemOrganizationStatus,
  MeResponseDtoOutputUserDigitStyle,
  MeResponseDtoOutputUserLocale,
  MeetingDtoOutputKind,
  MeetingDtoOutputStatus,
  MeetingListDtoOutputItemsItemKind,
  MeetingListDtoOutputItemsItemMinutesStatus,
  MeetingListDtoOutputItemsItemStatus,
  MeetingMinutesDtoOutputItemsItemKind,
  MeetingMinutesDtoOutputLanguage,
  MeetingMinutesDtoOutputStatus,
  MeetingMinutesDtoOutputTemplate,
  MemberDtoOutputStatus,
  MemberListDtoOutputItemsItemStatus,
  MembersControllerListStatus,
  MessageDtoOutputReactionsItemEmoji,
  MessageListDtoOutputItemsItemReactionsItemEmoji,
  MinutesControllerListStatus,
  MinutesListDtoOutputItemsItemStatus,
  MinutesListDtoOutputItemsItemTemplate,
  MoveTaskDtoStatus,
  MySpaceListDtoOutputItemsItemKind,
  MySpaceListDtoOutputItemsItemRights,
  MySpaceListDtoOutputItemsItemStatus,
  MySpaceListDtoOutputItemsItemVia,
  MyWeekDtoOutputEntriesItemCategory,
  MyWeekDtoOutputEntriesItemStatus,
  NotificationPageDtoOutputItemsItemType,
  NotificationPreferencesBodyDtoDigest,
  NotificationPreferencesBodyDtoMatrixAccessRevokedEmail,
  NotificationPreferencesBodyDtoMatrixApprovalDecidedEmail,
  NotificationPreferencesBodyDtoMatrixApprovalRequestedEmail,
  NotificationPreferencesBodyDtoMatrixBondReleaseDueEmail,
  NotificationPreferencesBodyDtoMatrixCallMissedEmail,
  NotificationPreferencesBodyDtoMatrixDataExportEmail,
  NotificationPreferencesBodyDtoMatrixEinvoiceStatusEmail,
  NotificationPreferencesBodyDtoMatrixEventReminderEmail,
  NotificationPreferencesBodyDtoMatrixExpenseDecidedEmail,
  NotificationPreferencesBodyDtoMatrixExpenseSubmittedEmail,
  NotificationPreferencesBodyDtoMatrixInvoiceSuggestedEmail,
  NotificationPreferencesBodyDtoMatrixMeetingInvitedEmail,
  NotificationPreferencesBodyDtoMatrixMeetingStartedEmail,
  NotificationPreferencesBodyDtoMatrixMentionEmail,
  NotificationPreferencesBodyDtoMatrixMinutesPublishedEmail,
  NotificationPreferencesBodyDtoMatrixOrganizationDeletionEmail,
  NotificationPreferencesBodyDtoMatrixPartnershipRequestEmail,
  NotificationPreferencesBodyDtoMatrixPaymentReceivedEmail,
  NotificationPreferencesBodyDtoMatrixPhaseDeadlineEmail,
  NotificationPreferencesBodyDtoMatrixPhaseDueEmail,
  NotificationPreferencesBodyDtoMatrixPhaseOverdueEmail,
  NotificationPreferencesBodyDtoMatrixPlanLimitEmail,
  NotificationPreferencesBodyDtoMatrixQuoteAcceptedEmail,
  NotificationPreferencesBodyDtoMatrixReplyEmail,
  NotificationPreferencesBodyDtoMatrixSignatureRequestedEmail,
  NotificationPreferencesBodyDtoMatrixSignatureUpdateEmail,
  NotificationPreferencesBodyDtoMatrixSpaceInvitationEmail,
  NotificationPreferencesBodyDtoMatrixSubscriptionStatusEmail,
  NotificationPreferencesBodyDtoMatrixTaskAssignedEmail,
  NotificationPreferencesBodyDtoMatrixTaskDueEmail,
  NotificationPreferencesBodyDtoMatrixTaskOverdueEmail,
  NotificationPreferencesBodyDtoMatrixTimeBudgetEmail,
  NotificationPreferencesBodyDtoMatrixTimesheetReminderEmail,
  NotificationPreferencesBodyDtoMatrixVaultExpiringEmail,
  NotificationPreferencesDtoOutputDigest,
  NotificationPreferencesDtoOutputMatrixAccessRevokedEmail,
  NotificationPreferencesDtoOutputMatrixApprovalDecidedEmail,
  NotificationPreferencesDtoOutputMatrixApprovalRequestedEmail,
  NotificationPreferencesDtoOutputMatrixBondReleaseDueEmail,
  NotificationPreferencesDtoOutputMatrixCallMissedEmail,
  NotificationPreferencesDtoOutputMatrixDataExportEmail,
  NotificationPreferencesDtoOutputMatrixEinvoiceStatusEmail,
  NotificationPreferencesDtoOutputMatrixEventReminderEmail,
  NotificationPreferencesDtoOutputMatrixExpenseDecidedEmail,
  NotificationPreferencesDtoOutputMatrixExpenseSubmittedEmail,
  NotificationPreferencesDtoOutputMatrixInvoiceSuggestedEmail,
  NotificationPreferencesDtoOutputMatrixMeetingInvitedEmail,
  NotificationPreferencesDtoOutputMatrixMeetingStartedEmail,
  NotificationPreferencesDtoOutputMatrixMentionEmail,
  NotificationPreferencesDtoOutputMatrixMinutesPublishedEmail,
  NotificationPreferencesDtoOutputMatrixOrganizationDeletionEmail,
  NotificationPreferencesDtoOutputMatrixPartnershipRequestEmail,
  NotificationPreferencesDtoOutputMatrixPaymentReceivedEmail,
  NotificationPreferencesDtoOutputMatrixPhaseDeadlineEmail,
  NotificationPreferencesDtoOutputMatrixPhaseDueEmail,
  NotificationPreferencesDtoOutputMatrixPhaseOverdueEmail,
  NotificationPreferencesDtoOutputMatrixPlanLimitEmail,
  NotificationPreferencesDtoOutputMatrixQuoteAcceptedEmail,
  NotificationPreferencesDtoOutputMatrixReplyEmail,
  NotificationPreferencesDtoOutputMatrixSignatureRequestedEmail,
  NotificationPreferencesDtoOutputMatrixSignatureUpdateEmail,
  NotificationPreferencesDtoOutputMatrixSpaceInvitationEmail,
  NotificationPreferencesDtoOutputMatrixSubscriptionStatusEmail,
  NotificationPreferencesDtoOutputMatrixTaskAssignedEmail,
  NotificationPreferencesDtoOutputMatrixTaskDueEmail,
  NotificationPreferencesDtoOutputMatrixTaskOverdueEmail,
  NotificationPreferencesDtoOutputMatrixTimeBudgetEmail,
  NotificationPreferencesDtoOutputMatrixTimesheetReminderEmail,
  NotificationPreferencesDtoOutputMatrixVaultExpiringEmail,
  NotificationsControllerActivityFilter,
  ObservationDtoOutputKind,
  ObservationDtoOutputStatus,
  ObservationListDtoOutputItemsItemKind,
  ObservationListDtoOutputItemsItemStatus,
  ObservationsControllerListKind,
  ObservationsControllerListOverdue,
  ObservationsControllerListStatus,
  OrderDtoOutputKind,
  OrderListDtoOutputItemsItemKind,
  OrgDataExportDtoOutputScope,
  OrgDataExportDtoOutputStatus,
  OrgDataExportPageDtoOutputItemsItemScope,
  OrgDataExportPageDtoOutputItemsItemStatus,
  OrgMeetingsControllerListHasMinutes,
  OrgMeetingsControllerListKind,
  OrgMeetingsControllerListStatus,
  OrgPartnershipListDtoOutputItemsItemRights,
  OrgPartnershipListDtoOutputItemsItemScopeItemsItemKind,
  OrgPartnershipListDtoOutputItemsItemStatus,
  OrgTemplateDtoOutputDefinitionChannelsItemDiscipline,
  OrgTemplateDtoOutputDefinitionChannelsItemKind,
  OrgTemplateDtoOutputDefinitionPhasesItemPhaseType,
  OrgTemplateDtoOutputDefinitionTasksItemDiscipline,
  OrgTemplateDtoOutputDefinitionTasksItemPhaseType,
  OrgTemplateListDtoOutputItemsItemDefinitionChannelsItemDiscipline,
  OrgTemplateListDtoOutputItemsItemDefinitionChannelsItemKind,
  OrgTemplateListDtoOutputItemsItemDefinitionPhasesItemPhaseType,
  OrgTemplateListDtoOutputItemsItemDefinitionTasksItemDiscipline,
  OrgTemplateListDtoOutputItemsItemDefinitionTasksItemPhaseType,
  OrgTemplatesControllerListArchived,
  OrganizationDtoOutputDefaultLocale,
  OrganizationDtoOutputDisciplinesItem,
  OrganizationDtoOutputGovernorate,
  OrganizationDtoOutputLegalForm,
  OrganizationDtoOutputStatus,
  OrganizationEntitlementsDtoClassOutputPlan,
  OrganizationEntitlementsDtoClassOutputSubscriptionStatus,
  OwnerTransferDtoOutputStatus,
  OwnerTransferStateDtoOutputTransferStatus,
  PaymentDtoOutputInvoicePaymentStatus,
  PaymentDtoOutputMethod,
  PaymentDtoOutputWarningsItem,
  PaymentListDtoOutputItemsItemInvoicePaymentStatus,
  PaymentListDtoOutputItemsItemMethod,
  PaymentListDtoOutputItemsItemWarningsItem,
  PhaseDtoOutputPhaseType,
  PhaseDtoOutputScheduleState,
  PhaseDtoOutputStatus,
  PhaseListDtoOutputItemsItemPhaseType,
  PhaseListDtoOutputItemsItemScheduleState,
  PhaseListDtoOutputItemsItemStatus,
  PinnedMessageDtoOutputMessageReactionsItemEmoji,
  PinnedMessageListDtoOutputItemsItemMessageReactionsItemEmoji,
  PlanListDtoOutputItemsItemAnnualPriceCurrency,
  PlanListDtoOutputItemsItemCode,
  PlanListDtoOutputItemsItemExtraSeatMonthlyPriceCurrency,
  PlanListDtoOutputItemsItemMonthlyPriceCurrency,
  PlatformAccountDetailDtoOutputAccountStatus,
  PlatformAccountDetailDtoOutputDeletionBlocker,
  PlatformAccountDetailDtoOutputMembershipsItemOrganizationStatus,
  PlatformAccountDetailDtoOutputMembershipsItemStatus,
  PlatformBreakGlassControllerListStatus,
  PlatformDeadLetterListDtoOutputItemsItemQueue,
  PlatformDeletionListDtoOutputItemsItemExecutionStatus,
  PlatformDeletionListDtoOutputItemsItemOrganizationStatus,
  PlatformDeletionListDtoOutputItemsItemPreviousStatus,
  PlatformDeletionListDtoOutputItemsItemStatus,
  PlatformDeletionRequestDtoOutputExecutionStatus,
  PlatformDeletionRequestDtoOutputOrganizationStatus,
  PlatformDeletionRequestDtoOutputPreviousStatus,
  PlatformDeletionRequestDtoOutputStatus,
  PlatformDeletionsControllerListStatus,
  PlatformMemberDtoOutputStatus,
  PlatformMemberDtoOutputUserStatus,
  PlatformMemberListDtoOutputItemsItemStatus,
  PlatformMemberListDtoOutputItemsItemUserStatus,
  PlatformOrganizationDetailDtoOutputDeletionStatus,
  PlatformOrganizationDetailDtoOutputInvoicesItemPurpose,
  PlatformOrganizationDetailDtoOutputInvoicesItemStatus,
  PlatformOrganizationDetailDtoOutputOrganizationPlanCode,
  PlatformOrganizationDetailDtoOutputOrganizationStatus,
  PlatformOrganizationDetailDtoOutputOrganizationSubscriptionStatus,
  PlatformOrganizationDetailDtoOutputPlatformDeletionExecutionStatus,
  PlatformOrganizationDetailDtoOutputPlatformDeletionOrganizationStatus,
  PlatformOrganizationDetailDtoOutputPlatformDeletionPreviousStatus,
  PlatformOrganizationDetailDtoOutputPlatformDeletionStatus,
  PlatformOrganizationDetailDtoOutputSubscriptionCycle,
  PlatformOrganizationDetailDtoOutputSubscriptionPlanCode,
  PlatformOrganizationDetailDtoOutputSubscriptionStatus,
  PlatformOrganizationListDtoOutputItemsItemPlanCode,
  PlatformOrganizationListDtoOutputItemsItemStatus,
  PlatformOrganizationListDtoOutputItemsItemSubscriptionStatus,
  PlatformOrganizationsControllerListStatus,
  PlatformSecuritySignalsDtoOutputFailuresItemRealm,
  PlatformUsersControllerMembersStatus,
  PreviewUrlDtoOutputKind,
  PreviewUrlDtoOutputStatus,
  ProblemDetailsCode,
  ProblemDetailsSuggestion,
  ProfitabilityControllerOverviewStatus,
  ProfitabilityOverviewDtoOutputRevenueRecognition,
  ProgressInvoiceDtoOutputClientKind,
  ProgressInvoiceDtoOutputComputationCurrency,
  ProgressInvoiceDtoOutputComputationKind,
  ProgressInvoiceDtoOutputComputationLinesItemRole,
  ProgressInvoiceDtoOutputComputationStepsItemKey,
  ProgressInvoiceDtoOutputComputationStepsItemNote,
  ProgressInvoiceDtoOutputComputationStepsItemToVerifyItem,
  ProgressInvoiceDtoOutputComputationTreatmentMentionTreatment,
  ProgressInvoiceDtoOutputComputationUsedToVerifyRulesItem,
  ProgressInvoiceDtoOutputComputationVatTreatment,
  ProgressInvoiceDtoOutputCurrency,
  ProgressInvoiceDtoOutputEinvoiceStatus,
  ProgressInvoiceDtoOutputKind,
  ProgressInvoiceDtoOutputLanguage,
  ProgressInvoiceDtoOutputLinesItemRole,
  ProgressInvoiceDtoOutputPaymentStatus,
  ProgressInvoiceDtoOutputStatus,
  ProgressInvoiceDtoOutputVatTreatment,
  ProgressInvoiceRequestDtoLanguage,
  ProjectDtoOutputFeesAmountCurrency,
  ProjectDtoOutputFeesMode,
  ProjectDtoOutputGovernorate,
  ProjectDtoOutputMissionType,
  ProjectDtoOutputMyRole,
  ProjectDtoOutputPhaseProgressCurrentPhaseType,
  ProjectDtoOutputStatus,
  ProjectDtoOutputWorksCostEstimateCurrency,
  ProjectListDtoOutputItemsItemFeesAmountCurrency,
  ProjectListDtoOutputItemsItemFeesMode,
  ProjectListDtoOutputItemsItemGovernorate,
  ProjectListDtoOutputItemsItemMissionType,
  ProjectListDtoOutputItemsItemMyRole,
  ProjectListDtoOutputItemsItemPhaseProgressCurrentPhaseType,
  ProjectListDtoOutputItemsItemStatus,
  ProjectListDtoOutputItemsItemWorksCostEstimateCurrency,
  ProjectMemberListDtoOutputItemsItemProjectRole,
  ProjectProfitabilityDtoOutputRevenueRecognition,
  ProjectTemplateListDtoOutputItemsItemKey,
  ProjectTemplateListDtoOutputItemsItemPhasesItemPhaseType,
  ProjectsControllerListMine,
  ProjectsControllerListMissionType,
  ProjectsControllerListStatus,
  PublicQuoteDtoOutputComputationCurrency,
  PublicQuoteDtoOutputComputationKind,
  PublicQuoteDtoOutputComputationLinesItemRole,
  PublicQuoteDtoOutputComputationStepsItemKey,
  PublicQuoteDtoOutputComputationStepsItemNote,
  PublicQuoteDtoOutputComputationStepsItemToVerifyItem,
  PublicQuoteDtoOutputComputationTreatmentMentionTreatment,
  PublicQuoteDtoOutputComputationUsedToVerifyRulesItem,
  PublicQuoteDtoOutputComputationVatTreatment,
  PublicQuoteDtoOutputCurrency,
  PublicQuoteDtoOutputLanguage,
  PublicQuoteDtoOutputStatus,
  PublicShareDownloadUrlDtoOutputStatus,
  PublicShareLinkDtoOutputTargetType,
  PublicSharePreviewUrlDtoOutputKind,
  PublicSharePreviewUrlDtoOutputStatus,
  PublicTransmittalDownloadUrlDtoOutputStatus,
  PublicTransmittalDtoOutputLanguage,
  PublicTransmittalPreviewUrlDtoOutputKind,
  PublicTransmittalPreviewUrlDtoOutputStatus,
  PurgeRequestDtoKind,
  PutFolderAclDtoEntriesItemRelation,
  PutFolderAclDtoEntriesItemSubjectType,
  PutFolderAclDtoMode,
  PutProjectMembersDtoMembersItemProjectRole,
  QueueDtoOutputEntriesItemCategory,
  QueueDtoOutputEntriesItemStatus,
  QuoteDtoOutputClientKind,
  QuoteDtoOutputComputationCurrency,
  QuoteDtoOutputComputationKind,
  QuoteDtoOutputComputationLinesItemRole,
  QuoteDtoOutputComputationStepsItemKey,
  QuoteDtoOutputComputationStepsItemNote,
  QuoteDtoOutputComputationStepsItemToVerifyItem,
  QuoteDtoOutputComputationTreatmentMentionTreatment,
  QuoteDtoOutputComputationUsedToVerifyRulesItem,
  QuoteDtoOutputComputationVatTreatment,
  QuoteDtoOutputCurrency,
  QuoteDtoOutputFeeMode,
  QuoteDtoOutputLanguage,
  QuoteDtoOutputLinesItemPhaseType,
  QuoteDtoOutputStatus,
  QuoteListDtoOutputItemsItemCurrency,
  QuoteListDtoOutputItemsItemStatus,
  QuotesControllerListStatus,
  ReactionStateDtoOutputReactionsItemEmoji,
  RecentDocumentListDtoOutputItemsItemSpaceKind,
  ReceptionReportDtoOutputLanguage,
  ReceptionReportDtoOutputPdfStatus,
  ReceptionReportListDtoOutputItemsItemLanguage,
  ReceptionReportListDtoOutputItemsItemPdfStatus,
  RegisterControllerGetDiscipline,
  RegisterControllerGetDocType,
  RegisterControllerGetPhaseType,
  RegisterDtoOutputDocType,
  RegisterDtoOutputItemsItemApprovalStatus,
  RegisterDtoOutputItemsItemDiscipline,
  RegisterDtoOutputItemsItemDocType,
  RegisterDtoOutputItemsItemPhaseType,
  RegisterExportAcceptedDtoOutputFormat,
  RegisterExportDtoOutputFormat,
  RegisterExportDtoOutputStatus,
  RegisterExportRequestDtoDiscipline,
  RegisterExportRequestDtoDocType,
  RegisterExportRequestDtoFormat,
  RegisterExportRequestDtoLanguage,
  RegisterExportRequestDtoPhaseType,
  ResponsibilityMatrixDtoOutputDeliverablesItemDeliverableType,
  ResponsibilityMatrixDtoOutputDeliverablesItemDiscipline,
  ResponsibilityMatrixDtoOutputDeliverablesItemPhasePhaseType,
  ResponsibilityMatrixDtoOutputDeliverablesItemSource,
  ResponsibilityMatrixDtoOutputDeliverablesItemStatus,
  ResponsibilityMatrixDtoOutputDisciplinesItemDiscipline,
  ResponsibilityMatrixDtoOutputOfficesItemRole,
  ResponsibilityMatrixDtoOutputScope,
  RoleDtoOutputBasedOn,
  RoleListDtoOutputItemsItemBasedOn,
  SaveGroupementDtoBillingMode,
  SearchControllerFindScope,
  SearchResultDtoOutputGroupsItemItemsItemKind,
  SearchResultDtoOutputGroupsItemKind,
  SetChecklistItemDtoState,
  SettingsDtoOutputMode,
  ShareLinkDtoOutputStatus,
  ShareLinkListDtoOutputItemsItemStatus,
  SignatureCodeSentDtoOutputChannel,
  SignatureRequestDtoOutputEvidenceStatus,
  SignatureRequestDtoOutputLevel,
  SignatureRequestDtoOutputSignersItemStatus,
  SignatureRequestDtoOutputStatus,
  SignatureRequestListDtoOutputItemsItemEvidenceStatus,
  SignatureRequestListDtoOutputItemsItemLevel,
  SignatureRequestListDtoOutputItemsItemSignersItemStatus,
  SignatureRequestListDtoOutputItemsItemStatus,
  SignaturesControllerListBox,
  SignaturesControllerListStatus,
  SigningBatchDtoOutputChannel,
  SigningBatchDtoOutputStatus,
  SigningBatchResultDtoOutputStatus,
  SpaceApprovalListDtoOutputItemsItemKind,
  SpaceApprovalListDtoOutputItemsItemRights,
  SpaceDtoOutputAccessRights,
  SpaceDtoOutputAccessVia,
  SpaceDtoOutputKind,
  SpaceDtoOutputStatus,
  SpaceDtoOutputTabsItem,
  SpaceInvitationDtoOutputKind,
  SpaceInvitationDtoOutputRights,
  SpaceInvitationDtoOutputStatus,
  SpaceInvitationListDtoOutputItemsItemKind,
  SpaceInvitationListDtoOutputItemsItemRights,
  SpaceInvitationListDtoOutputItemsItemStatus,
  SpaceMeetingsControllerListHasMinutes,
  SpaceMeetingsControllerListKind,
  SpaceMeetingsControllerListStatus,
  SpaceMemberDtoOutputRights,
  SpaceMemberDtoOutputVia,
  SpaceMemberListDtoOutputItemsItemRights,
  SpaceMemberListDtoOutputItemsItemVia,
  SpacePartnerDtoOutputRights,
  SpacePartnerDtoOutputStatus,
  SpacePartnerListDtoOutputItemsItemRights,
  SpacePartnerListDtoOutputItemsItemStatus,
  SpaceSynthesisDtoOutputOfficesItemOfficeRole,
  SpaceSynthesisDtoOutputOverdueDeliverablesItemDeliverableType,
  SpaceSynthesisDtoOutputOverdueDeliverablesItemDiscipline,
  SpaceSynthesisDtoOutputOverdueDeliverablesItemPhasePhaseType,
  SpaceSynthesisDtoOutputOverdueDeliverablesItemSource,
  SpaceSynthesisDtoOutputOverdueDeliverablesItemStatus,
  SpaceSynthesisDtoOutputScope,
  StartDtoStepsItemMode,
  SubscriptionChangeResultDtoOutputSubscriptionPendingChangeKind,
  SubscriptionChangeResultDtoOutputSubscriptionPendingChangeShapeCycle,
  SubscriptionChangeResultDtoOutputSubscriptionPendingChangeShapePlanCode,
  SubscriptionChangeResultDtoOutputSubscriptionShapeCycle,
  SubscriptionChangeResultDtoOutputSubscriptionShapePlanCode,
  SubscriptionChangeResultDtoOutputSubscriptionStatus,
  SubscriptionDtoOutputPendingChangeKind,
  SubscriptionDtoOutputPendingChangeShapeCycle,
  SubscriptionDtoOutputPendingChangeShapePlanCode,
  SubscriptionDtoOutputShapeCycle,
  SubscriptionDtoOutputShapePlanCode,
  SubscriptionDtoOutputStatus,
  SubscriptionOverrideRequestDtoStatus,
  SubscriptionQuoteDtoOutputBlockersItemMetric,
  SubscriptionQuoteDtoOutputKind,
  SubscriptionQuoteDtoOutputLinesItemAddon,
  SubscriptionQuoteDtoOutputLinesItemCode,
  SubscriptionShapeDtoCycle,
  SubscriptionShapeDtoPlanCode,
  SupplierDtoOutputKind,
  SupplierDtoOutputWithholdingProfile,
  SupplierInvoiceDtoOutputPaymentsItemMethod,
  SupplierInvoiceDtoOutputStatus,
  SupplierInvoiceDtoOutputWithholdingProfile,
  SupplierInvoiceDtoOutputWithholdingToVerifyItem,
  SupplierInvoiceListDtoOutputItemsItemPaymentsItemMethod,
  SupplierInvoiceListDtoOutputItemsItemStatus,
  SupplierInvoiceListDtoOutputItemsItemWithholdingProfile,
  SupplierInvoiceListDtoOutputItemsItemWithholdingToVerifyItem,
  SupplierListDtoOutputItemsItemKind,
  SupplierListDtoOutputItemsItemWithholdingProfile,
  SuppliersControllerListInvoicesOverdue,
  SuppliersControllerListInvoicesStatus,
  SuppliersControllerListSuppliersArchived,
  TaskDetailDtoOutputDiscipline,
  TaskDetailDtoOutputPriority,
  TaskDetailDtoOutputStatus,
  TaskDetailDtoOutputSubtasksItemDiscipline,
  TaskDetailDtoOutputSubtasksItemPriority,
  TaskDetailDtoOutputSubtasksItemStatus,
  TaskDtoOutputDiscipline,
  TaskDtoOutputPriority,
  TaskDtoOutputStatus,
  TaskListDtoOutputItemsItemDiscipline,
  TaskListDtoOutputItemsItemPriority,
  TaskListDtoOutputItemsItemStatus,
  TasksControllerListDiscipline,
  TasksControllerListStatus,
  TejExportDtoOutputAdapter,
  TejExportListDtoOutputItemsItemAdapter,
  TemplateDtoOutputStepsItemMode,
  TemplateListDtoOutputItemsItemStepsItemMode,
  TenderDetailDtoOutputRequirementsItemVaultDocumentKind,
  TenderDetailDtoOutputRequirementsItemVaultDocumentState,
  TenderDetailDtoOutputSource,
  TenderDetailDtoOutputStatus,
  TenderDtoOutputSource,
  TenderDtoOutputStatus,
  TenderListDtoOutputItemsItemSource,
  TenderListDtoOutputItemsItemStatus,
  TenderRequirementDtoOutputVaultDocumentKind,
  TenderRequirementDtoOutputVaultDocumentState,
  TransmittalDtoOutputLanguage,
  TransmittalDtoOutputPdfStatus,
  TransmittalDtoOutputRecipientsItemAcknowledgedVia,
  TransmittalDtoOutputRecipientsItemKind,
  TransmittalPdfUrlDtoOutputStatus,
  TrashListDtoOutputItemsItemKind,
  TrashTargetDtoKind,
  TreasuryForecastDtoOutputScope,
  UpdateClientDtoKind,
  UpdateClientDtoVatRegime,
  UpdateContractDtoCurrency,
  UpdateContractDtoKind,
  UpdateContractDtoRetentionBase,
  UpdateDeliverableDtoDeliverableType,
  UpdateDeliverableDtoDiscipline,
  UpdateDeliverableDtoStatus,
  UpdateDocumentDtoDiscipline,
  UpdateDocumentDtoDocType,
  UpdateDocumentDtoPhaseType,
  UpdateEventDtoKind,
  UpdateFinanceSettingsDtoRevenueRecognition,
  UpdateInvoiceDtoCurrency,
  UpdateInvoiceDtoKind,
  UpdateInvoiceDtoLanguage,
  UpdateInvoiceDtoLinesItemRole,
  UpdateInvoiceDtoVatTreatment,
  UpdateMinutesDtoItemsItemKind,
  UpdateMinutesDtoLanguage,
  UpdateMinutesDtoTemplate,
  UpdateObservationDtoKind,
  UpdateOrganizationDtoDefaultLocale,
  UpdateOrganizationDtoDisciplinesItem,
  UpdateOrganizationDtoGovernorate,
  UpdateOrganizationDtoLegalForm,
  UpdatePhaseDtoStatus,
  UpdateProfileDtoDigitStyle,
  UpdateProfileDtoLocale,
  UpdateProjectDtoFeeMode,
  UpdateProjectDtoGovernorate,
  UpdateProjectDtoMissionType,
  UpdateProjectDtoStatus,
  UpdateQuoteDtoCurrency,
  UpdateQuoteDtoFeeMode,
  UpdateQuoteDtoLanguage,
  UpdateQuoteDtoLinesItemPhaseType,
  UpdateResponsibilityMatrixDtoDisciplinesItemDiscipline,
  UpdateSettingsDtoMode,
  UpdateSupplierDtoKind,
  UpdateSupplierDtoWithholdingProfile,
  UpdateTaskDtoDiscipline,
  UpdateTaskDtoPriority,
  UpdateTaskDtoStatus,
  UpdateTemplateDtoDefinitionChannelsItemDiscipline,
  UpdateTemplateDtoDefinitionChannelsItemKind,
  UpdateTemplateDtoDefinitionPhasesItemPhaseType,
  UpdateTemplateDtoDefinitionTasksItemDiscipline,
  UpdateTemplateDtoDefinitionTasksItemPhaseType,
  UpdateTenderDtoSource,
  UpdateTimeEntryDtoCategory,
  UpdateVaultDocumentDtoKind,
  UploadStatusDtoOutputRejectionReason,
  UploadStatusDtoOutputStatus,
  UploadStatusDtoOutputVersionStatus,
  UserDataExportDtoOutputStatus,
  UserDataExportPageDtoOutputItemsItemStatus,
  UserProfileDtoOutputDigitStyle,
  UserProfileDtoOutputLocale,
  VaultDocumentDtoOutputKind,
  VaultDocumentDtoOutputState,
  VaultDocumentListDtoOutputItemsItemKind,
  VaultDocumentListDtoOutputItemsItemState,
  VaultDocumentsControllerListKind,
  VaultDocumentsControllerListState,
  WithholdingSummaryDtoOutputToVerifyItem,
  _AnnotationDtoOutputPermissionsItem,
  _AnnotationListDtoOutputItemsItemPermissionsItem,
  _ChannelDtoOutputPermissionsItem,
  _ChannelListDtoOutputItemsItemPermissionsItem,
  _ChecklistDtoOutputPermissionsItem,
  _ChecklistListDtoOutputItemsItemPermissionsItem,
  _ClosedSpaceDtoOutputPermissionsItem,
  _DocumentDetailDtoOutputPermissionsItem,
  _DocumentListDtoOutputItemsItemPermissionsItem,
  _FlowDtoOutputPermissionsItem,
  _FlowListDtoOutputItemsItemPermissionsItem,
  _FolderDetailDtoOutputPermissionsItem,
  _FolderDtoOutputPermissionsItem,
  _FolderListDtoOutputItemsItemPermissionsItem,
  _GanttDtoOutputPermissionsItem,
  _MeetingDtoOutputPermissionsItem,
  _MeetingMinutesDtoOutputPermissionsItem,
  _MemberDtoOutputPermissionsItem,
  _MemberListDtoOutputItemsItemPermissionsItem,
  _ObservationDtoOutputPermissionsItem,
  _ObservationListDtoOutputItemsItemPermissionsItem,
  _OrgTemplateDtoOutputPermissionsItem,
  _OrgTemplateListDtoOutputItemsItemPermissionsItem,
  _ProjectDtoOutputPermissionsItem,
  _ProjectListDtoOutputItemsItemPermissionsItem,
  _RoleDtoOutputPermissionsItem,
  _RoleListDtoOutputItemsItemPermissionsItem,
  _SpaceDtoOutputPermissionsItem,
  _SpaceMemberDtoOutputPermissionsItem,
  _SpaceMemberListDtoOutputItemsItemPermissionsItem,
  _TaskDetailDtoOutputPermissionsItem,
  _TaskDetailDtoOutputSubtasksItemPermissionsItem,
  _TaskDtoOutputPermissionsItem,
  _TaskListDtoOutputItemsItemPermissionsItem,
  _TrashListDtoOutputItemsItemPermissionsItem,
  accountSecurityControllerChangePassword,
  accountSecurityControllerRemoveAuthenticator,
  accountSecurityControllerView,
  accountingControllerClose,
  accountingControllerClosedPeriods,
  accountingControllerCreate,
  accountingControllerDownloadUrl,
  accountingControllerList,
  accountingControllerReopen,
  accountingControllerSettings,
  accountingControllerUpdateSettings,
  annotationsControllerAddComment,
  annotationsControllerComments,
  annotationsControllerCreate,
  annotationsControllerList,
  annotationsControllerRemove,
  annotationsControllerReopen,
  annotationsControllerResolve,
  annotationsControllerUpdate,
  approvalTemplatesControllerCreate,
  approvalTemplatesControllerList,
  approvalTemplatesControllerRemove,
  approvalsControllerCancel,
  approvalsControllerDecide,
  approvalsControllerGet,
  approvalsControllerList,
  approvalsControllerListForDocument,
  approvalsControllerStart,
  auditControllerList,
  auditControllerVerify,
  authControllerBackchannelLogout,
  authControllerCallback,
  authControllerLogout,
  authControllerSignIn,
  authControllerStepUp,
  channelControllerAttachmentsFolder,
  channelControllerGet,
  channelControllerMarkRead,
  channelControllerUpdate,
  channelMeetingsControllerList,
  channelMessagesControllerCreate,
  channelMessagesControllerList,
  channelPinsControllerList,
  channelPinsControllerPin,
  channelPinsControllerUnpin,
  checklistTemplatesControllerCreate,
  checklistTemplatesControllerList,
  checklistTemplatesControllerRetire,
  checklistTemplatesControllerUpdate,
  checklistsControllerArchive,
  checklistsControllerCreate,
  checklistsControllerGet,
  checklistsControllerList,
  checklistsControllerSetItem,
  clientErrorsControllerReport,
  clientsControllerArchive,
  clientsControllerCreate,
  clientsControllerCreateContact,
  clientsControllerDeleteContact,
  clientsControllerGet,
  clientsControllerList,
  clientsControllerListContacts,
  clientsControllerUpdate,
  clientsControllerUpdateContact,
  configureApiClient,
  contractsControllerAddAmendment,
  contractsControllerAmendments,
  contractsControllerCreate,
  contractsControllerGet,
  contractsControllerList,
  contractsControllerUpdate,
  deliverablesControllerClosePhase,
  deliverablesControllerCreate,
  deliverablesControllerList,
  deliverablesControllerUpdate,
  directoryControllerContact,
  directoryControllerSearch,
  directoryProfileControllerGet,
  directoryProfileControllerUpdate,
  documentSettingsControllerGet,
  documentSettingsControllerPut,
  documentsControllerDownloadUrl,
  documentsControllerGet,
  documentsControllerList,
  documentsControllerPreviewUrl,
  documentsControllerRemove,
  documentsControllerRestore,
  documentsControllerUpdate,
  documentsControllerVersions,
  einvoicingControllerCreate,
  einvoicingControllerList,
  einvoicingControllerRevoke,
  einvoicingControllerSettings,
  einvoicingControllerUpdateSettings,
  entitlementsControllerGet,
  eventControllerGet,
  eventControllerRemove,
  eventControllerRespond,
  eventControllerUpdate,
  exitExportsControllerClosed,
  exitExportsControllerDownloadUrl,
  exitExportsControllerRequest,
  expensesControllerApprove,
  expensesControllerGet,
  expensesControllerList,
  expensesControllerMine,
  expensesControllerReceiptFolder,
  expensesControllerReceiptUrl,
  expensesControllerReimbursed,
  expensesControllerReject,
  expensesControllerSubmit,
  financeControllerCurrentRuleSet,
  financeControllerPreview,
  financeDashboardControllerGet,
  fiscalSettingsControllerCreateProfile,
  fiscalSettingsControllerCreateSeries,
  fiscalSettingsControllerDeleteSeries,
  fiscalSettingsControllerListProfiles,
  fiscalSettingsControllerListSeries,
  fiscalSettingsControllerRevealBankDetails,
  fiscalSettingsControllerUpdateSeries,
  foldersControllerAcl,
  foldersControllerCreate,
  foldersControllerGet,
  foldersControllerItems,
  foldersControllerList,
  foldersControllerRemove,
  foldersControllerReplaceAcl,
  foldersControllerUpdate,
  getAccountSecurityControllerChangePasswordMutationKey,
  getAccountSecurityControllerChangePasswordMutationOptions,
  getAccountSecurityControllerRemoveAuthenticatorMutationKey,
  getAccountSecurityControllerRemoveAuthenticatorMutationOptions,
  getAccountSecurityControllerViewQueryKey,
  getAccountSecurityControllerViewQueryOptions,
  getAccountingControllerCloseMutationKey,
  getAccountingControllerCloseMutationOptions,
  getAccountingControllerClosedPeriodsQueryKey,
  getAccountingControllerClosedPeriodsQueryOptions,
  getAccountingControllerCreateMutationKey,
  getAccountingControllerCreateMutationOptions,
  getAccountingControllerDownloadUrlQueryKey,
  getAccountingControllerDownloadUrlQueryOptions,
  getAccountingControllerListQueryKey,
  getAccountingControllerListQueryOptions,
  getAccountingControllerReopenMutationKey,
  getAccountingControllerReopenMutationOptions,
  getAccountingControllerSettingsQueryKey,
  getAccountingControllerSettingsQueryOptions,
  getAccountingControllerUpdateSettingsMutationKey,
  getAccountingControllerUpdateSettingsMutationOptions,
  getAnnotationsControllerAddCommentMutationKey,
  getAnnotationsControllerAddCommentMutationOptions,
  getAnnotationsControllerCommentsQueryKey,
  getAnnotationsControllerCommentsQueryOptions,
  getAnnotationsControllerCreateMutationKey,
  getAnnotationsControllerCreateMutationOptions,
  getAnnotationsControllerListQueryKey,
  getAnnotationsControllerListQueryOptions,
  getAnnotationsControllerRemoveMutationKey,
  getAnnotationsControllerRemoveMutationOptions,
  getAnnotationsControllerReopenMutationKey,
  getAnnotationsControllerReopenMutationOptions,
  getAnnotationsControllerResolveMutationKey,
  getAnnotationsControllerResolveMutationOptions,
  getAnnotationsControllerUpdateMutationKey,
  getAnnotationsControllerUpdateMutationOptions,
  getApprovalTemplatesControllerCreateMutationKey,
  getApprovalTemplatesControllerCreateMutationOptions,
  getApprovalTemplatesControllerListQueryKey,
  getApprovalTemplatesControllerListQueryOptions,
  getApprovalTemplatesControllerRemoveMutationKey,
  getApprovalTemplatesControllerRemoveMutationOptions,
  getApprovalsControllerCancelMutationKey,
  getApprovalsControllerCancelMutationOptions,
  getApprovalsControllerDecideMutationKey,
  getApprovalsControllerDecideMutationOptions,
  getApprovalsControllerGetQueryKey,
  getApprovalsControllerGetQueryOptions,
  getApprovalsControllerListForDocumentQueryKey,
  getApprovalsControllerListForDocumentQueryOptions,
  getApprovalsControllerListQueryKey,
  getApprovalsControllerListQueryOptions,
  getApprovalsControllerStartMutationKey,
  getApprovalsControllerStartMutationOptions,
  getAuditControllerListQueryKey,
  getAuditControllerListQueryOptions,
  getAuditControllerVerifyQueryKey,
  getAuditControllerVerifyQueryOptions,
  getAuthControllerBackchannelLogoutMutationKey,
  getAuthControllerBackchannelLogoutMutationOptions,
  getAuthControllerCallbackQueryKey,
  getAuthControllerCallbackQueryOptions,
  getAuthControllerLogoutMutationKey,
  getAuthControllerLogoutMutationOptions,
  getAuthControllerSignInQueryKey,
  getAuthControllerSignInQueryOptions,
  getAuthControllerStepUpQueryKey,
  getAuthControllerStepUpQueryOptions,
  getChannelControllerAttachmentsFolderMutationKey,
  getChannelControllerAttachmentsFolderMutationOptions,
  getChannelControllerGetQueryKey,
  getChannelControllerGetQueryOptions,
  getChannelControllerMarkReadMutationKey,
  getChannelControllerMarkReadMutationOptions,
  getChannelControllerUpdateMutationKey,
  getChannelControllerUpdateMutationOptions,
  getChannelMeetingsControllerListQueryKey,
  getChannelMeetingsControllerListQueryOptions,
  getChannelMessagesControllerCreateMutationKey,
  getChannelMessagesControllerCreateMutationOptions,
  getChannelMessagesControllerListQueryKey,
  getChannelMessagesControllerListQueryOptions,
  getChannelPinsControllerListQueryKey,
  getChannelPinsControllerListQueryOptions,
  getChannelPinsControllerPinMutationKey,
  getChannelPinsControllerPinMutationOptions,
  getChannelPinsControllerUnpinMutationKey,
  getChannelPinsControllerUnpinMutationOptions,
  getChecklistTemplatesControllerCreateMutationKey,
  getChecklistTemplatesControllerCreateMutationOptions,
  getChecklistTemplatesControllerListQueryKey,
  getChecklistTemplatesControllerListQueryOptions,
  getChecklistTemplatesControllerRetireMutationKey,
  getChecklistTemplatesControllerRetireMutationOptions,
  getChecklistTemplatesControllerUpdateMutationKey,
  getChecklistTemplatesControllerUpdateMutationOptions,
  getChecklistsControllerArchiveMutationKey,
  getChecklistsControllerArchiveMutationOptions,
  getChecklistsControllerCreateMutationKey,
  getChecklistsControllerCreateMutationOptions,
  getChecklistsControllerGetQueryKey,
  getChecklistsControllerGetQueryOptions,
  getChecklistsControllerListQueryKey,
  getChecklistsControllerListQueryOptions,
  getChecklistsControllerSetItemMutationKey,
  getChecklistsControllerSetItemMutationOptions,
  getClientErrorsControllerReportMutationKey,
  getClientErrorsControllerReportMutationOptions,
  getClientsControllerArchiveMutationKey,
  getClientsControllerArchiveMutationOptions,
  getClientsControllerCreateContactMutationKey,
  getClientsControllerCreateContactMutationOptions,
  getClientsControllerCreateMutationKey,
  getClientsControllerCreateMutationOptions,
  getClientsControllerDeleteContactMutationKey,
  getClientsControllerDeleteContactMutationOptions,
  getClientsControllerGetQueryKey,
  getClientsControllerGetQueryOptions,
  getClientsControllerListContactsQueryKey,
  getClientsControllerListContactsQueryOptions,
  getClientsControllerListQueryKey,
  getClientsControllerListQueryOptions,
  getClientsControllerUpdateContactMutationKey,
  getClientsControllerUpdateContactMutationOptions,
  getClientsControllerUpdateMutationKey,
  getClientsControllerUpdateMutationOptions,
  getContractsControllerAddAmendmentMutationKey,
  getContractsControllerAddAmendmentMutationOptions,
  getContractsControllerAmendmentsQueryKey,
  getContractsControllerAmendmentsQueryOptions,
  getContractsControllerCreateMutationKey,
  getContractsControllerCreateMutationOptions,
  getContractsControllerGetQueryKey,
  getContractsControllerGetQueryOptions,
  getContractsControllerListQueryKey,
  getContractsControllerListQueryOptions,
  getContractsControllerUpdateMutationKey,
  getContractsControllerUpdateMutationOptions,
  getDeliverablesControllerClosePhaseMutationKey,
  getDeliverablesControllerClosePhaseMutationOptions,
  getDeliverablesControllerCreateMutationKey,
  getDeliverablesControllerCreateMutationOptions,
  getDeliverablesControllerListQueryKey,
  getDeliverablesControllerListQueryOptions,
  getDeliverablesControllerUpdateMutationKey,
  getDeliverablesControllerUpdateMutationOptions,
  getDirectoryControllerContactMutationKey,
  getDirectoryControllerContactMutationOptions,
  getDirectoryControllerSearchQueryKey,
  getDirectoryControllerSearchQueryOptions,
  getDirectoryProfileControllerGetQueryKey,
  getDirectoryProfileControllerGetQueryOptions,
  getDirectoryProfileControllerUpdateMutationKey,
  getDirectoryProfileControllerUpdateMutationOptions,
  getDocumentSettingsControllerGetQueryKey,
  getDocumentSettingsControllerGetQueryOptions,
  getDocumentSettingsControllerPutMutationKey,
  getDocumentSettingsControllerPutMutationOptions,
  getDocumentsControllerDownloadUrlQueryKey,
  getDocumentsControllerDownloadUrlQueryOptions,
  getDocumentsControllerGetQueryKey,
  getDocumentsControllerGetQueryOptions,
  getDocumentsControllerListQueryKey,
  getDocumentsControllerListQueryOptions,
  getDocumentsControllerPreviewUrlQueryKey,
  getDocumentsControllerPreviewUrlQueryOptions,
  getDocumentsControllerRemoveMutationKey,
  getDocumentsControllerRemoveMutationOptions,
  getDocumentsControllerRestoreMutationKey,
  getDocumentsControllerRestoreMutationOptions,
  getDocumentsControllerUpdateMutationKey,
  getDocumentsControllerUpdateMutationOptions,
  getDocumentsControllerVersionsQueryKey,
  getDocumentsControllerVersionsQueryOptions,
  getEinvoicingControllerCreateMutationKey,
  getEinvoicingControllerCreateMutationOptions,
  getEinvoicingControllerListQueryKey,
  getEinvoicingControllerListQueryOptions,
  getEinvoicingControllerRevokeMutationKey,
  getEinvoicingControllerRevokeMutationOptions,
  getEinvoicingControllerSettingsQueryKey,
  getEinvoicingControllerSettingsQueryOptions,
  getEinvoicingControllerUpdateSettingsMutationKey,
  getEinvoicingControllerUpdateSettingsMutationOptions,
  getEntitlementsControllerGetQueryKey,
  getEntitlementsControllerGetQueryOptions,
  getEventControllerGetQueryKey,
  getEventControllerGetQueryOptions,
  getEventControllerRemoveMutationKey,
  getEventControllerRemoveMutationOptions,
  getEventControllerRespondMutationKey,
  getEventControllerRespondMutationOptions,
  getEventControllerUpdateMutationKey,
  getEventControllerUpdateMutationOptions,
  getExitExportsControllerClosedQueryKey,
  getExitExportsControllerClosedQueryOptions,
  getExitExportsControllerDownloadUrlQueryKey,
  getExitExportsControllerDownloadUrlQueryOptions,
  getExitExportsControllerRequestMutationKey,
  getExitExportsControllerRequestMutationOptions,
  getExpensesControllerApproveMutationKey,
  getExpensesControllerApproveMutationOptions,
  getExpensesControllerGetQueryKey,
  getExpensesControllerGetQueryOptions,
  getExpensesControllerListQueryKey,
  getExpensesControllerListQueryOptions,
  getExpensesControllerMineQueryKey,
  getExpensesControllerMineQueryOptions,
  getExpensesControllerReceiptFolderMutationKey,
  getExpensesControllerReceiptFolderMutationOptions,
  getExpensesControllerReceiptUrlQueryKey,
  getExpensesControllerReceiptUrlQueryOptions,
  getExpensesControllerReimbursedMutationKey,
  getExpensesControllerReimbursedMutationOptions,
  getExpensesControllerRejectMutationKey,
  getExpensesControllerRejectMutationOptions,
  getExpensesControllerSubmitMutationKey,
  getExpensesControllerSubmitMutationOptions,
  getFinanceControllerCurrentRuleSetQueryKey,
  getFinanceControllerCurrentRuleSetQueryOptions,
  getFinanceControllerPreviewMutationKey,
  getFinanceControllerPreviewMutationOptions,
  getFinanceDashboardControllerGetQueryKey,
  getFinanceDashboardControllerGetQueryOptions,
  getFiscalSettingsControllerCreateProfileMutationKey,
  getFiscalSettingsControllerCreateProfileMutationOptions,
  getFiscalSettingsControllerCreateSeriesMutationKey,
  getFiscalSettingsControllerCreateSeriesMutationOptions,
  getFiscalSettingsControllerDeleteSeriesMutationKey,
  getFiscalSettingsControllerDeleteSeriesMutationOptions,
  getFiscalSettingsControllerListProfilesQueryKey,
  getFiscalSettingsControllerListProfilesQueryOptions,
  getFiscalSettingsControllerListSeriesQueryKey,
  getFiscalSettingsControllerListSeriesQueryOptions,
  getFiscalSettingsControllerRevealBankDetailsQueryKey,
  getFiscalSettingsControllerRevealBankDetailsQueryOptions,
  getFiscalSettingsControllerUpdateSeriesMutationKey,
  getFiscalSettingsControllerUpdateSeriesMutationOptions,
  getFoldersControllerAclQueryKey,
  getFoldersControllerAclQueryOptions,
  getFoldersControllerCreateMutationKey,
  getFoldersControllerCreateMutationOptions,
  getFoldersControllerGetQueryKey,
  getFoldersControllerGetQueryOptions,
  getFoldersControllerItemsQueryKey,
  getFoldersControllerItemsQueryOptions,
  getFoldersControllerListQueryKey,
  getFoldersControllerListQueryOptions,
  getFoldersControllerRemoveMutationKey,
  getFoldersControllerRemoveMutationOptions,
  getFoldersControllerReplaceAclMutationKey,
  getFoldersControllerReplaceAclMutationOptions,
  getFoldersControllerUpdateMutationKey,
  getFoldersControllerUpdateMutationOptions,
  getGroupementControllerAddPaymentMutationKey,
  getGroupementControllerAddPaymentMutationOptions,
  getGroupementControllerDeletePaymentMutationKey,
  getGroupementControllerDeletePaymentMutationOptions,
  getGroupementControllerGetQueryKey,
  getGroupementControllerGetQueryOptions,
  getGroupementControllerSaveMutationKey,
  getGroupementControllerSaveMutationOptions,
  getHealthControllerLiveQueryKey,
  getHealthControllerLiveQueryOptions,
  getHealthControllerReadyQueryKey,
  getHealthControllerReadyQueryOptions,
  getIcsPublicControllerFeedQueryKey,
  getIcsPublicControllerFeedQueryOptions,
  getInvitationAcceptanceControllerAcceptMutationKey,
  getInvitationAcceptanceControllerAcceptMutationOptions,
  getInvitationAcceptanceControllerPreviewMutationKey,
  getInvitationAcceptanceControllerPreviewMutationOptions,
  getInvitationsControllerCreateMutationKey,
  getInvitationsControllerCreateMutationOptions,
  getInvitationsControllerListQueryKey,
  getInvitationsControllerListQueryOptions,
  getInvitationsControllerResendMutationKey,
  getInvitationsControllerResendMutationOptions,
  getInvitationsControllerRevokeMutationKey,
  getInvitationsControllerRevokeMutationOptions,
  getInvoiceEinvoiceControllerGetQueryKey,
  getInvoiceEinvoiceControllerGetQueryOptions,
  getInvoiceEinvoiceControllerManualMutationKey,
  getInvoiceEinvoiceControllerManualMutationOptions,
  getInvoiceEinvoiceControllerResubmitMutationKey,
  getInvoiceEinvoiceControllerResubmitMutationOptions,
  getInvoiceEinvoiceControllerTeifUrlQueryKey,
  getInvoiceEinvoiceControllerTeifUrlQueryOptions,
  getInvoicesControllerCreateMutationKey,
  getInvoicesControllerCreateMutationOptions,
  getInvoicesControllerCreditNoteMutationKey,
  getInvoicesControllerCreditNoteMutationOptions,
  getInvoicesControllerGetQueryKey,
  getInvoicesControllerGetQueryOptions,
  getInvoicesControllerIssueMutationKey,
  getInvoicesControllerIssueMutationOptions,
  getInvoicesControllerListQueryKey,
  getInvoicesControllerListQueryOptions,
  getInvoicesControllerPdfUrlQueryKey,
  getInvoicesControllerPdfUrlQueryOptions,
  getInvoicesControllerRemoveMutationKey,
  getInvoicesControllerRemoveMutationOptions,
  getInvoicesControllerRequestPdfMutationKey,
  getInvoicesControllerRequestPdfMutationOptions,
  getInvoicesControllerUpdateMutationKey,
  getInvoicesControllerUpdateMutationOptions,
  getLateInterestControllerDeleteRateMutationKey,
  getLateInterestControllerDeleteRateMutationOptions,
  getLateInterestControllerEstimateQueryKey,
  getLateInterestControllerEstimateQueryOptions,
  getLateInterestControllerRatesQueryKey,
  getLateInterestControllerRatesQueryOptions,
  getLateInterestControllerSetRateMutationKey,
  getLateInterestControllerSetRateMutationOptions,
  getLivekitWebhookControllerReceiveMutationKey,
  getLivekitWebhookControllerReceiveMutationOptions,
  getManagementControllerDashboardQueryKey,
  getManagementControllerDashboardQueryOptions,
  getManagementControllerForecastQueryKey,
  getManagementControllerForecastQueryOptions,
  getMeControllerCurrentQueryKey,
  getMeControllerCurrentQueryOptions,
  getMeControllerRevokeMutationKey,
  getMeControllerRevokeMutationOptions,
  getMeControllerRevokeOthersMutationKey,
  getMeControllerRevokeOthersMutationOptions,
  getMeControllerSessionsQueryKey,
  getMeControllerSessionsQueryOptions,
  getMeetingInvitationsControllerJoinMutationKey,
  getMeetingInvitationsControllerJoinMutationOptions,
  getMeetingInvitationsControllerPreviewMutationKey,
  getMeetingInvitationsControllerPreviewMutationOptions,
  getMeetingsControllerGetQueryKey,
  getMeetingsControllerGetQueryOptions,
  getMeetingsControllerInviteMembersMutationKey,
  getMeetingsControllerInviteMembersMutationOptions,
  getMeetingsControllerInviteMutationKey,
  getMeetingsControllerInviteMutationOptions,
  getMeetingsControllerTokenMutationKey,
  getMeetingsControllerTokenMutationOptions,
  getMembersControllerChangeRoleMutationKey,
  getMembersControllerChangeRoleMutationOptions,
  getMembersControllerDeactivateMutationKey,
  getMembersControllerDeactivateMutationOptions,
  getMembersControllerListQueryKey,
  getMembersControllerListQueryOptions,
  getMembersControllerTransferPlanQueryKey,
  getMembersControllerTransferPlanQueryOptions,
  getMessageControllerEditsQueryKey,
  getMessageControllerEditsQueryOptions,
  getMessageControllerGetQueryKey,
  getMessageControllerGetQueryOptions,
  getMessageControllerRemoveMutationKey,
  getMessageControllerRemoveMutationOptions,
  getMessageControllerUpdateMutationKey,
  getMessageControllerUpdateMutationOptions,
  getMessageReactionsControllerAddMutationKey,
  getMessageReactionsControllerAddMutationOptions,
  getMessageReactionsControllerRemoveMutationKey,
  getMessageReactionsControllerRemoveMutationOptions,
  getMinutesControllerCreateMutationKey,
  getMinutesControllerCreateMutationOptions,
  getMinutesControllerGetQueryKey,
  getMinutesControllerGetQueryOptions,
  getMinutesControllerListQueryKey,
  getMinutesControllerListQueryOptions,
  getMinutesControllerPdfQueryKey,
  getMinutesControllerPdfQueryOptions,
  getMinutesControllerPublishMutationKey,
  getMinutesControllerPublishMutationOptions,
  getMinutesControllerUpdateMutationKey,
  getMinutesControllerUpdateMutationOptions,
  getMyCalendarControllerCalendarOfQueryKey,
  getMyCalendarControllerCalendarOfQueryOptions,
  getMyCalendarControllerCreateFeedMutationKey,
  getMyCalendarControllerCreateFeedMutationOptions,
  getMyCalendarControllerListFeedsQueryKey,
  getMyCalendarControllerListFeedsQueryOptions,
  getMyCalendarControllerRevokeFeedMutationKey,
  getMyCalendarControllerRevokeFeedMutationOptions,
  getMyDataExportControllerDownloadUrlQueryKey,
  getMyDataExportControllerDownloadUrlQueryOptions,
  getMyDataExportControllerListQueryKey,
  getMyDataExportControllerListQueryOptions,
  getMyDataExportControllerRequestMutationKey,
  getMyDataExportControllerRequestMutationOptions,
  getMySpaceInvitationsControllerListQueryKey,
  getMySpaceInvitationsControllerListQueryOptions,
  getMySpacesControllerListQueryKey,
  getMySpacesControllerListQueryOptions,
  getNotificationsControllerActivityQueryKey,
  getNotificationsControllerActivityQueryOptions,
  getNotificationsControllerListQueryKey,
  getNotificationsControllerListQueryOptions,
  getNotificationsControllerMarkReadMutationKey,
  getNotificationsControllerMarkReadMutationOptions,
  getObservationsControllerCreateMutationKey,
  getObservationsControllerCreateMutationOptions,
  getObservationsControllerGetQueryKey,
  getObservationsControllerGetQueryOptions,
  getObservationsControllerListQueryKey,
  getObservationsControllerListQueryOptions,
  getObservationsControllerPhotoFolderMutationKey,
  getObservationsControllerPhotoFolderMutationOptions,
  getObservationsControllerRemoveMutationKey,
  getObservationsControllerRemoveMutationOptions,
  getObservationsControllerReopenMutationKey,
  getObservationsControllerReopenMutationOptions,
  getObservationsControllerResolveMutationKey,
  getObservationsControllerResolveMutationOptions,
  getObservationsControllerUpdateMutationKey,
  getObservationsControllerUpdateMutationOptions,
  getOrgCallsControllerStartMutationKey,
  getOrgCallsControllerStartMutationOptions,
  getOrgChannelsControllerCreateMutationKey,
  getOrgChannelsControllerCreateMutationOptions,
  getOrgChannelsControllerListQueryKey,
  getOrgChannelsControllerListQueryOptions,
  getOrgChannelsControllerUnreadQueryKey,
  getOrgChannelsControllerUnreadQueryOptions,
  getOrgMeetingsControllerListQueryKey,
  getOrgMeetingsControllerListQueryOptions,
  getOrgSharingControllerLookupQueryKey,
  getOrgSharingControllerLookupQueryOptions,
  getOrgSharingControllerPartnershipsQueryKey,
  getOrgSharingControllerPartnershipsQueryOptions,
  getOrgSpacesControllerCreateMutationKey,
  getOrgSpacesControllerCreateMutationOptions,
  getOrgTemplatesControllerCreateMutationKey,
  getOrgTemplatesControllerCreateMutationOptions,
  getOrgTemplatesControllerListQueryKey,
  getOrgTemplatesControllerListQueryOptions,
  getOrgTemplatesControllerRemoveMutationKey,
  getOrgTemplatesControllerRemoveMutationOptions,
  getOrgTemplatesControllerSaveAsTemplateMutationKey,
  getOrgTemplatesControllerSaveAsTemplateMutationOptions,
  getOrgTemplatesControllerUpdateMutationKey,
  getOrgTemplatesControllerUpdateMutationOptions,
  getOrganizationLogoControllerGetQueryKey,
  getOrganizationLogoControllerGetQueryOptions,
  getOrganizationLogoControllerRemoveMutationKey,
  getOrganizationLogoControllerRemoveMutationOptions,
  getOrganizationLogoControllerSetMutationKey,
  getOrganizationLogoControllerSetMutationOptions,
  getOrganizationLogoControllerUploadTargetMutationKey,
  getOrganizationLogoControllerUploadTargetMutationOptions,
  getOrganizationPrivacyControllerCancelDeletionMutationKey,
  getOrganizationPrivacyControllerCancelDeletionMutationOptions,
  getOrganizationPrivacyControllerDeletionQueryKey,
  getOrganizationPrivacyControllerDeletionQueryOptions,
  getOrganizationPrivacyControllerExportUrlQueryKey,
  getOrganizationPrivacyControllerExportUrlQueryOptions,
  getOrganizationPrivacyControllerListExportsQueryKey,
  getOrganizationPrivacyControllerListExportsQueryOptions,
  getOrganizationPrivacyControllerRequestDeletionMutationKey,
  getOrganizationPrivacyControllerRequestDeletionMutationOptions,
  getOrganizationPrivacyControllerRequestExportMutationKey,
  getOrganizationPrivacyControllerRequestExportMutationOptions,
  getOrganizationSettingsControllerPoliciesQueryKey,
  getOrganizationSettingsControllerPoliciesQueryOptions,
  getOrganizationSettingsControllerUpdatePoliciesMutationKey,
  getOrganizationSettingsControllerUpdatePoliciesMutationOptions,
  getOrganizationSettingsControllerUpdateProfileMutationKey,
  getOrganizationSettingsControllerUpdateProfileMutationOptions,
  getOrganizationsControllerCreateOrganizationMutationKey,
  getOrganizationsControllerCreateOrganizationMutationOptions,
  getOrganizationsControllerGetQueryKey,
  getOrganizationsControllerGetQueryOptions,
  getOwnerTransferControllerAcceptMutationKey,
  getOwnerTransferControllerAcceptMutationOptions,
  getOwnerTransferControllerCancelMutationKey,
  getOwnerTransferControllerCancelMutationOptions,
  getOwnerTransferControllerProposeMutationKey,
  getOwnerTransferControllerProposeMutationOptions,
  getOwnerTransferControllerStateQueryKey,
  getOwnerTransferControllerStateQueryOptions,
  getPartnerOfficesControllerListQueryKey,
  getPartnerOfficesControllerListQueryOptions,
  getPaymentWebhookControllerReceiveMutationKey,
  getPaymentWebhookControllerReceiveMutationOptions,
  getPaymentsControllerAgingQueryKey,
  getPaymentsControllerAgingQueryOptions,
  getPaymentsControllerAttachCertificateMutationKey,
  getPaymentsControllerAttachCertificateMutationOptions,
  getPaymentsControllerListQueryKey,
  getPaymentsControllerListQueryOptions,
  getPaymentsControllerRecordMutationKey,
  getPaymentsControllerRecordMutationOptions,
  getPaymentsControllerSettingsQueryKey,
  getPaymentsControllerSettingsQueryOptions,
  getPaymentsControllerUpdateSettingsMutationKey,
  getPaymentsControllerUpdateSettingsMutationOptions,
  getPhasesControllerCreateMutationKey,
  getPhasesControllerCreateMutationOptions,
  getPhasesControllerListQueryKey,
  getPhasesControllerListQueryOptions,
  getPhasesControllerReorderMutationKey,
  getPhasesControllerReorderMutationOptions,
  getPhasesControllerUpdateMutationKey,
  getPhasesControllerUpdateMutationOptions,
  getPlanningControllerCancelOrderMutationKey,
  getPlanningControllerCancelOrderMutationOptions,
  getPlanningControllerCreateOrderMutationKey,
  getPlanningControllerCreateOrderMutationOptions,
  getPlanningControllerGanttQueryKey,
  getPlanningControllerGanttQueryOptions,
  getPlanningControllerListOrdersQueryKey,
  getPlanningControllerListOrdersQueryOptions,
  getPlansControllerListQueryKey,
  getPlansControllerListQueryOptions,
  getPlatformAuditControllerListQueryKey,
  getPlatformAuditControllerListQueryOptions,
  getPlatformAuthControllerCallbackQueryKey,
  getPlatformAuthControllerCallbackQueryOptions,
  getPlatformAuthControllerLogoutMutationKey,
  getPlatformAuthControllerLogoutMutationOptions,
  getPlatformAuthControllerMeQueryKey,
  getPlatformAuthControllerMeQueryOptions,
  getPlatformAuthControllerSignInQueryKey,
  getPlatformAuthControllerSignInQueryOptions,
  getPlatformAuthControllerStepUpQueryKey,
  getPlatformAuthControllerStepUpQueryOptions,
  getPlatformBreakGlassControllerApproveMutationKey,
  getPlatformBreakGlassControllerApproveMutationOptions,
  getPlatformBreakGlassControllerCancelMutationKey,
  getPlatformBreakGlassControllerCancelMutationOptions,
  getPlatformBreakGlassControllerCreateMutationKey,
  getPlatformBreakGlassControllerCreateMutationOptions,
  getPlatformBreakGlassControllerListQueryKey,
  getPlatformBreakGlassControllerListQueryOptions,
  getPlatformBreakGlassControllerRejectMutationKey,
  getPlatformBreakGlassControllerRejectMutationOptions,
  getPlatformBreakGlassControllerRevokeMutationKey,
  getPlatformBreakGlassControllerRevokeMutationOptions,
  getPlatformDeletionsControllerApproveMutationKey,
  getPlatformDeletionsControllerApproveMutationOptions,
  getPlatformDeletionsControllerCancelMutationKey,
  getPlatformDeletionsControllerCancelMutationOptions,
  getPlatformDeletionsControllerCreateMutationKey,
  getPlatformDeletionsControllerCreateMutationOptions,
  getPlatformDeletionsControllerListQueryKey,
  getPlatformDeletionsControllerListQueryOptions,
  getPlatformDeletionsControllerRejectMutationKey,
  getPlatformDeletionsControllerRejectMutationOptions,
  getPlatformJobsControllerDiscardMutationKey,
  getPlatformJobsControllerDiscardMutationOptions,
  getPlatformJobsControllerListQueryKey,
  getPlatformJobsControllerListQueryOptions,
  getPlatformJobsControllerRetryMutationKey,
  getPlatformJobsControllerRetryMutationOptions,
  getPlatformOrganizationsControllerDetailQueryKey,
  getPlatformOrganizationsControllerDetailQueryOptions,
  getPlatformOrganizationsControllerListQueryKey,
  getPlatformOrganizationsControllerListQueryOptions,
  getPlatformOrganizationsControllerOverrideStatusMutationKey,
  getPlatformOrganizationsControllerOverrideStatusMutationOptions,
  getPlatformPaymentsControllerConfirmMutationKey,
  getPlatformPaymentsControllerConfirmMutationOptions,
  getPlatformSecurityControllerSignalsQueryKey,
  getPlatformSecurityControllerSignalsQueryOptions,
  getPlatformUsersControllerAccountQueryKey,
  getPlatformUsersControllerAccountQueryOptions,
  getPlatformUsersControllerDeleteMutationKey,
  getPlatformUsersControllerDeleteMutationOptions,
  getPlatformUsersControllerLockMutationKey,
  getPlatformUsersControllerLockMutationOptions,
  getPlatformUsersControllerMembersQueryKey,
  getPlatformUsersControllerMembersQueryOptions,
  getPlatformUsersControllerReactivateMutationKey,
  getPlatformUsersControllerReactivateMutationOptions,
  getPlatformUsersControllerRemoveMutationKey,
  getPlatformUsersControllerRemoveMutationOptions,
  getPlatformUsersControllerSuspendMutationKey,
  getPlatformUsersControllerSuspendMutationOptions,
  getPlatformUsersControllerUnlockMutationKey,
  getPlatformUsersControllerUnlockMutationOptions,
  getProfileControllerGetPreferencesQueryKey,
  getProfileControllerGetPreferencesQueryOptions,
  getProfileControllerPutPreferencesMutationKey,
  getProfileControllerPutPreferencesMutationOptions,
  getProfileControllerUpdateMutationKey,
  getProfileControllerUpdateMutationOptions,
  getProfitabilityControllerCreateRateMutationKey,
  getProfitabilityControllerCreateRateMutationOptions,
  getProfitabilityControllerListRatesQueryKey,
  getProfitabilityControllerListRatesQueryOptions,
  getProfitabilityControllerOverviewQueryKey,
  getProfitabilityControllerOverviewQueryOptions,
  getProfitabilityControllerProjectQueryKey,
  getProfitabilityControllerProjectQueryOptions,
  getProfitabilityControllerRemoveRateMutationKey,
  getProfitabilityControllerRemoveRateMutationOptions,
  getProgressInvoicesControllerCreateMutationKey,
  getProgressInvoicesControllerCreateMutationOptions,
  getProgressInvoicesControllerGetQueryKey,
  getProgressInvoicesControllerGetQueryOptions,
  getProjectTemplatesControllerListQueryKey,
  getProjectTemplatesControllerListQueryOptions,
  getProjectsControllerArchiveMutationKey,
  getProjectsControllerArchiveMutationOptions,
  getProjectsControllerCreateProjectMutationKey,
  getProjectsControllerCreateProjectMutationOptions,
  getProjectsControllerGetQueryKey,
  getProjectsControllerGetQueryOptions,
  getProjectsControllerListMembersQueryKey,
  getProjectsControllerListMembersQueryOptions,
  getProjectsControllerListQueryKey,
  getProjectsControllerListQueryOptions,
  getProjectsControllerReplaceMembersMutationKey,
  getProjectsControllerReplaceMembersMutationOptions,
  getProjectsControllerRestoreMutationKey,
  getProjectsControllerRestoreMutationOptions,
  getProjectsControllerUpdateMutationKey,
  getProjectsControllerUpdateMutationOptions,
  getPublicQuotesControllerAcceptMutationKey,
  getPublicQuotesControllerAcceptMutationOptions,
  getPublicQuotesControllerGetQueryKey,
  getPublicQuotesControllerGetQueryOptions,
  getPublicQuotesControllerPdfQueryKey,
  getPublicQuotesControllerPdfQueryOptions,
  getPublicShareLinksControllerDownloadUrlQueryKey,
  getPublicShareLinksControllerDownloadUrlQueryOptions,
  getPublicShareLinksControllerGetQueryKey,
  getPublicShareLinksControllerGetQueryOptions,
  getPublicShareLinksControllerPreviewUrlQueryKey,
  getPublicShareLinksControllerPreviewUrlQueryOptions,
  getPublicShareLinksControllerUnlockMutationKey,
  getPublicShareLinksControllerUnlockMutationOptions,
  getPublicTransmittalsControllerAcknowledgeMutationKey,
  getPublicTransmittalsControllerAcknowledgeMutationOptions,
  getPublicTransmittalsControllerDownloadUrlQueryKey,
  getPublicTransmittalsControllerDownloadUrlQueryOptions,
  getPublicTransmittalsControllerGetQueryKey,
  getPublicTransmittalsControllerGetQueryOptions,
  getPublicTransmittalsControllerPreviewUrlQueryKey,
  getPublicTransmittalsControllerPreviewUrlQueryOptions,
  getQuotesControllerConvertMutationKey,
  getQuotesControllerConvertMutationOptions,
  getQuotesControllerCreateFeeScaleMutationKey,
  getQuotesControllerCreateFeeScaleMutationOptions,
  getQuotesControllerCreateMutationKey,
  getQuotesControllerCreateMutationOptions,
  getQuotesControllerDeleteFeeScaleMutationKey,
  getQuotesControllerDeleteFeeScaleMutationOptions,
  getQuotesControllerFeeScalesQueryKey,
  getQuotesControllerFeeScalesQueryOptions,
  getQuotesControllerGetQueryKey,
  getQuotesControllerGetQueryOptions,
  getQuotesControllerListQueryKey,
  getQuotesControllerListQueryOptions,
  getQuotesControllerPdfUrlQueryKey,
  getQuotesControllerPdfUrlQueryOptions,
  getQuotesControllerRejectMutationKey,
  getQuotesControllerRejectMutationOptions,
  getQuotesControllerRemoveMutationKey,
  getQuotesControllerRemoveMutationOptions,
  getQuotesControllerRequestPdfMutationKey,
  getQuotesControllerRequestPdfMutationOptions,
  getQuotesControllerSendMutationKey,
  getQuotesControllerSendMutationOptions,
  getQuotesControllerUpdateMutationKey,
  getQuotesControllerUpdateMutationOptions,
  getRecentDocumentsControllerListQueryKey,
  getRecentDocumentsControllerListQueryOptions,
  getReceptionReportsControllerCreateMutationKey,
  getReceptionReportsControllerCreateMutationOptions,
  getReceptionReportsControllerDownloadUrlQueryKey,
  getReceptionReportsControllerDownloadUrlQueryOptions,
  getReceptionReportsControllerGetQueryKey,
  getReceptionReportsControllerGetQueryOptions,
  getReceptionReportsControllerListQueryKey,
  getReceptionReportsControllerListQueryOptions,
  getRegisterControllerGetExportQueryKey,
  getRegisterControllerGetExportQueryOptions,
  getRegisterControllerGetQueryKey,
  getRegisterControllerGetQueryOptions,
  getRegisterControllerRequestExportMutationKey,
  getRegisterControllerRequestExportMutationOptions,
  getResponsibilitiesControllerMatrixQueryKey,
  getResponsibilitiesControllerMatrixQueryOptions,
  getResponsibilitiesControllerSynthesisQueryKey,
  getResponsibilitiesControllerSynthesisQueryOptions,
  getResponsibilitiesControllerUpdateMutationKey,
  getResponsibilitiesControllerUpdateMutationOptions,
  getRevokeAccessControllerAuditQueryKey,
  getRevokeAccessControllerAuditQueryOptions,
  getRevokeAccessControllerCloseMutationKey,
  getRevokeAccessControllerCloseMutationOptions,
  getRevokeAccessControllerRemoveMemberMutationKey,
  getRevokeAccessControllerRemoveMemberMutationOptions,
  getRevokeAccessControllerRemovePartnerMutationKey,
  getRevokeAccessControllerRemovePartnerMutationOptions,
  getRolesControllerCreateMutationKey,
  getRolesControllerCreateMutationOptions,
  getRolesControllerListQueryKey,
  getRolesControllerListQueryOptions,
  getRolesControllerRemoveMutationKey,
  getRolesControllerRemoveMutationOptions,
  getRolesControllerUpdateMutationKey,
  getRolesControllerUpdateMutationOptions,
  getSearchControllerFindQueryKey,
  getSearchControllerFindQueryOptions,
  getShareLinksControllerCreateMutationKey,
  getShareLinksControllerCreateMutationOptions,
  getShareLinksControllerListQueryKey,
  getShareLinksControllerListQueryOptions,
  getShareLinksControllerRevokeMutationKey,
  getShareLinksControllerRevokeMutationOptions,
  getSignaturesControllerCancelMutationKey,
  getSignaturesControllerCancelMutationOptions,
  getSignaturesControllerCreateMutationKey,
  getSignaturesControllerCreateMutationOptions,
  getSignaturesControllerDeclineMutationKey,
  getSignaturesControllerDeclineMutationOptions,
  getSignaturesControllerEvidenceUrlQueryKey,
  getSignaturesControllerEvidenceUrlQueryOptions,
  getSignaturesControllerGetQueryKey,
  getSignaturesControllerGetQueryOptions,
  getSignaturesControllerListQueryKey,
  getSignaturesControllerListQueryOptions,
  getSignaturesControllerSendCodeMutationKey,
  getSignaturesControllerSendCodeMutationOptions,
  getSignaturesControllerSignMutationKey,
  getSignaturesControllerSignMutationOptions,
  getSignaturesControllerVerifyQueryKey,
  getSignaturesControllerVerifyQueryOptions,
  getSigningBatchesControllerConfirmMutationKey,
  getSigningBatchesControllerConfirmMutationOptions,
  getSigningBatchesControllerPendingQueryKey,
  getSigningBatchesControllerPendingQueryOptions,
  getSigningBatchesControllerStartMutationKey,
  getSigningBatchesControllerStartMutationOptions,
  getSpaceApprovalsControllerApproveMutationKey,
  getSpaceApprovalsControllerApproveMutationOptions,
  getSpaceApprovalsControllerDeclineMutationKey,
  getSpaceApprovalsControllerDeclineMutationOptions,
  getSpaceApprovalsControllerListQueryKey,
  getSpaceApprovalsControllerListQueryOptions,
  getSpaceChannelsControllerCreateMutationKey,
  getSpaceChannelsControllerCreateMutationOptions,
  getSpaceChannelsControllerListQueryKey,
  getSpaceChannelsControllerListQueryOptions,
  getSpaceEventsControllerCreateMutationKey,
  getSpaceEventsControllerCreateMutationOptions,
  getSpaceEventsControllerListQueryKey,
  getSpaceEventsControllerListQueryOptions,
  getSpaceInvitationAnswersControllerAcceptMutationKey,
  getSpaceInvitationAnswersControllerAcceptMutationOptions,
  getSpaceInvitationAnswersControllerDeclineMutationKey,
  getSpaceInvitationAnswersControllerDeclineMutationOptions,
  getSpaceInvitationsControllerCreateMutationKey,
  getSpaceInvitationsControllerCreateMutationOptions,
  getSpaceInvitationsControllerExtendMutationKey,
  getSpaceInvitationsControllerExtendMutationOptions,
  getSpaceInvitationsControllerListQueryKey,
  getSpaceInvitationsControllerListQueryOptions,
  getSpaceInvitationsControllerRevokeMutationKey,
  getSpaceInvitationsControllerRevokeMutationOptions,
  getSpaceMeetingsControllerCreateMutationKey,
  getSpaceMeetingsControllerCreateMutationOptions,
  getSpaceMeetingsControllerListQueryKey,
  getSpaceMeetingsControllerListQueryOptions,
  getSpacePartnersControllerDelegateMutationKey,
  getSpacePartnersControllerDelegateMutationOptions,
  getSpacePartnersControllerInviteMutationKey,
  getSpacePartnersControllerInviteMutationOptions,
  getSpacePartnersControllerListQueryKey,
  getSpacePartnersControllerListQueryOptions,
  getSpacePartnersControllerMembersQueryKey,
  getSpacePartnersControllerMembersQueryOptions,
  getSpacesControllerGetQueryKey,
  getSpacesControllerGetQueryOptions,
  getSpacesControllerUpdateMutationKey,
  getSpacesControllerUpdateMutationOptions,
  getStorageControllerReportQueryKey,
  getStorageControllerReportQueryOptions,
  getSubscriptionControllerCancelMutationKey,
  getSubscriptionControllerCancelMutationOptions,
  getSubscriptionControllerChangeMutationKey,
  getSubscriptionControllerChangeMutationOptions,
  getSubscriptionControllerGetQueryKey,
  getSubscriptionControllerGetQueryOptions,
  getSubscriptionControllerInvoicesQueryKey,
  getSubscriptionControllerInvoicesQueryOptions,
  getSubscriptionControllerPauseMutationKey,
  getSubscriptionControllerPauseMutationOptions,
  getSubscriptionControllerPaymentLinkMutationKey,
  getSubscriptionControllerPaymentLinkMutationOptions,
  getSubscriptionControllerPdfUrlQueryKey,
  getSubscriptionControllerPdfUrlQueryOptions,
  getSubscriptionControllerQuoteMutationKey,
  getSubscriptionControllerQuoteMutationOptions,
  getSubscriptionControllerRenewMutationKey,
  getSubscriptionControllerRenewMutationOptions,
  getSubscriptionControllerResumeMutationKey,
  getSubscriptionControllerResumeMutationOptions,
  getSubscriptionControllerWithdrawMutationKey,
  getSubscriptionControllerWithdrawMutationOptions,
  getSuppliersControllerCancelInvoiceMutationKey,
  getSuppliersControllerCancelInvoiceMutationOptions,
  getSuppliersControllerCancelPaymentMutationKey,
  getSuppliersControllerCancelPaymentMutationOptions,
  getSuppliersControllerCreateInvoiceMutationKey,
  getSuppliersControllerCreateInvoiceMutationOptions,
  getSuppliersControllerCreateSupplierMutationKey,
  getSuppliersControllerCreateSupplierMutationOptions,
  getSuppliersControllerCreateTejExportMutationKey,
  getSuppliersControllerCreateTejExportMutationOptions,
  getSuppliersControllerDownloadTejExportQueryKey,
  getSuppliersControllerDownloadTejExportQueryOptions,
  getSuppliersControllerGetInvoiceQueryKey,
  getSuppliersControllerGetInvoiceQueryOptions,
  getSuppliersControllerGetSupplierQueryKey,
  getSuppliersControllerGetSupplierQueryOptions,
  getSuppliersControllerListInvoicesQueryKey,
  getSuppliersControllerListInvoicesQueryOptions,
  getSuppliersControllerListSuppliersQueryKey,
  getSuppliersControllerListSuppliersQueryOptions,
  getSuppliersControllerListTejExportsQueryKey,
  getSuppliersControllerListTejExportsQueryOptions,
  getSuppliersControllerPayMutationKey,
  getSuppliersControllerPayMutationOptions,
  getSuppliersControllerPreviewPaymentMutationKey,
  getSuppliersControllerPreviewPaymentMutationOptions,
  getSuppliersControllerRevealBankDetailsMutationKey,
  getSuppliersControllerRevealBankDetailsMutationOptions,
  getSuppliersControllerSummaryQueryKey,
  getSuppliersControllerSummaryQueryOptions,
  getSuppliersControllerUpdateInvoiceMutationKey,
  getSuppliersControllerUpdateInvoiceMutationOptions,
  getSuppliersControllerUpdateSupplierMutationKey,
  getSuppliersControllerUpdateSupplierMutationOptions,
  getTasksControllerAddChecklistItemMutationKey,
  getTasksControllerAddChecklistItemMutationOptions,
  getTasksControllerAddDependencyMutationKey,
  getTasksControllerAddDependencyMutationOptions,
  getTasksControllerCreateCommentMutationKey,
  getTasksControllerCreateCommentMutationOptions,
  getTasksControllerCreateMutationKey,
  getTasksControllerCreateMutationOptions,
  getTasksControllerGetQueryKey,
  getTasksControllerGetQueryOptions,
  getTasksControllerListCommentsQueryKey,
  getTasksControllerListCommentsQueryOptions,
  getTasksControllerListQueryKey,
  getTasksControllerListQueryOptions,
  getTasksControllerMoveMutationKey,
  getTasksControllerMoveMutationOptions,
  getTasksControllerRemoveChecklistItemMutationKey,
  getTasksControllerRemoveChecklistItemMutationOptions,
  getTasksControllerRemoveCommentMutationKey,
  getTasksControllerRemoveCommentMutationOptions,
  getTasksControllerRemoveDependencyMutationKey,
  getTasksControllerRemoveDependencyMutationOptions,
  getTasksControllerRemoveMutationKey,
  getTasksControllerRemoveMutationOptions,
  getTasksControllerUpdateChecklistItemMutationKey,
  getTasksControllerUpdateChecklistItemMutationOptions,
  getTasksControllerUpdateCommentMutationKey,
  getTasksControllerUpdateCommentMutationOptions,
  getTasksControllerUpdateMutationKey,
  getTasksControllerUpdateMutationOptions,
  getTendersControllerAddRequirementMutationKey,
  getTendersControllerAddRequirementMutationOptions,
  getTendersControllerChangeStatusMutationKey,
  getTendersControllerChangeStatusMutationOptions,
  getTendersControllerConvertMutationKey,
  getTendersControllerConvertMutationOptions,
  getTendersControllerCreateMutationKey,
  getTendersControllerCreateMutationOptions,
  getTendersControllerGetQueryKey,
  getTendersControllerGetQueryOptions,
  getTendersControllerListQueryKey,
  getTendersControllerListQueryOptions,
  getTendersControllerRemoveMutationKey,
  getTendersControllerRemoveMutationOptions,
  getTendersControllerRemoveRequirementMutationKey,
  getTendersControllerRemoveRequirementMutationOptions,
  getTendersControllerUpdateMutationKey,
  getTendersControllerUpdateMutationOptions,
  getTendersControllerUpdateRequirementMutationKey,
  getTendersControllerUpdateRequirementMutationOptions,
  getTimesheetsControllerApprovalsQueryKey,
  getTimesheetsControllerApprovalsQueryOptions,
  getTimesheetsControllerCapacityQueryKey,
  getTimesheetsControllerCapacityQueryOptions,
  getTimesheetsControllerCreateEntryMutationKey,
  getTimesheetsControllerCreateEntryMutationOptions,
  getTimesheetsControllerCreateLeaveMutationKey,
  getTimesheetsControllerCreateLeaveMutationOptions,
  getTimesheetsControllerDecideMutationKey,
  getTimesheetsControllerDecideMutationOptions,
  getTimesheetsControllerDeleteEntryMutationKey,
  getTimesheetsControllerDeleteEntryMutationOptions,
  getTimesheetsControllerDeleteLeaveMutationKey,
  getTimesheetsControllerDeleteLeaveMutationOptions,
  getTimesheetsControllerListLeaveQueryKey,
  getTimesheetsControllerListLeaveQueryOptions,
  getTimesheetsControllerMyWeekQueryKey,
  getTimesheetsControllerMyWeekQueryOptions,
  getTimesheetsControllerSubmitMutationKey,
  getTimesheetsControllerSubmitMutationOptions,
  getTimesheetsControllerUpdateEntryMutationKey,
  getTimesheetsControllerUpdateEntryMutationOptions,
  getTimesheetsControllerWorkingTimeMutationKey,
  getTimesheetsControllerWorkingTimeMutationOptions,
  getTransmittalsControllerAcknowledgeMutationKey,
  getTransmittalsControllerAcknowledgeMutationOptions,
  getTransmittalsControllerCreateMutationKey,
  getTransmittalsControllerCreateMutationOptions,
  getTransmittalsControllerDiffusionQueryKey,
  getTransmittalsControllerDiffusionQueryOptions,
  getTransmittalsControllerGetQueryKey,
  getTransmittalsControllerGetQueryOptions,
  getTransmittalsControllerListQueryKey,
  getTransmittalsControllerListQueryOptions,
  getTransmittalsControllerPdfUrlQueryKey,
  getTransmittalsControllerPdfUrlQueryOptions,
  getTrashControllerListQueryKey,
  getTrashControllerListQueryOptions,
  getTrashControllerPurgeMutationKey,
  getTrashControllerPurgeMutationOptions,
  getTrashControllerRestoreMutationKey,
  getTrashControllerRestoreMutationOptions,
  getUploadsControllerAbortMutationKey,
  getUploadsControllerAbortMutationOptions,
  getUploadsControllerCompleteMutationKey,
  getUploadsControllerCompleteMutationOptions,
  getUploadsControllerCreateMutationKey,
  getUploadsControllerCreateMutationOptions,
  getUploadsControllerRefreshPartsMutationKey,
  getUploadsControllerRefreshPartsMutationOptions,
  getUploadsControllerStatusQueryKey,
  getUploadsControllerStatusQueryOptions,
  getVaultDocumentsControllerCreateMutationKey,
  getVaultDocumentsControllerCreateMutationOptions,
  getVaultDocumentsControllerListQueryKey,
  getVaultDocumentsControllerListQueryOptions,
  getVaultDocumentsControllerRemoveMutationKey,
  getVaultDocumentsControllerRemoveMutationOptions,
  getVaultDocumentsControllerUpdateMutationKey,
  getVaultDocumentsControllerUpdateMutationOptions,
  groupementControllerAddPayment,
  groupementControllerDeletePayment,
  groupementControllerGet,
  groupementControllerSave,
  healthControllerLive,
  healthControllerReady,
  icsPublicControllerFeed,
  invitationAcceptanceControllerAccept,
  invitationAcceptanceControllerPreview,
  invitationsControllerCreate,
  invitationsControllerList,
  invitationsControllerResend,
  invitationsControllerRevoke,
  invoiceEinvoiceControllerGet,
  invoiceEinvoiceControllerManual,
  invoiceEinvoiceControllerResubmit,
  invoiceEinvoiceControllerTeifUrl,
  invoicesControllerCreate,
  invoicesControllerCreditNote,
  invoicesControllerGet,
  invoicesControllerIssue,
  invoicesControllerList,
  invoicesControllerPdfUrl,
  invoicesControllerRemove,
  invoicesControllerRequestPdf,
  invoicesControllerUpdate,
  lateInterestControllerDeleteRate,
  lateInterestControllerEstimate,
  lateInterestControllerRates,
  lateInterestControllerSetRate,
  livekitWebhookControllerReceive,
  managementControllerDashboard,
  managementControllerForecast,
  meControllerCurrent,
  meControllerRevoke,
  meControllerRevokeOthers,
  meControllerSessions,
  meetingInvitationsControllerJoin,
  meetingInvitationsControllerPreview,
  meetingsControllerGet,
  meetingsControllerInvite,
  meetingsControllerInviteMembers,
  meetingsControllerToken,
  membersControllerChangeRole,
  membersControllerDeactivate,
  membersControllerList,
  membersControllerTransferPlan,
  messageControllerEdits,
  messageControllerGet,
  messageControllerRemove,
  messageControllerUpdate,
  messageReactionsControllerAdd,
  messageReactionsControllerRemove,
  minutesControllerCreate,
  minutesControllerGet,
  minutesControllerList,
  minutesControllerPdf,
  minutesControllerPublish,
  minutesControllerUpdate,
  myCalendarControllerCalendarOf,
  myCalendarControllerCreateFeed,
  myCalendarControllerListFeeds,
  myCalendarControllerRevokeFeed,
  myDataExportControllerDownloadUrl,
  myDataExportControllerList,
  myDataExportControllerRequest,
  mySpaceInvitationsControllerList,
  mySpacesControllerList,
  notificationsControllerActivity,
  notificationsControllerList,
  notificationsControllerMarkRead,
  observationsControllerCreate,
  observationsControllerGet,
  observationsControllerList,
  observationsControllerPhotoFolder,
  observationsControllerRemove,
  observationsControllerReopen,
  observationsControllerResolve,
  observationsControllerUpdate,
  orgCallsControllerStart,
  orgChannelsControllerCreate,
  orgChannelsControllerList,
  orgChannelsControllerUnread,
  orgMeetingsControllerList,
  orgSharingControllerLookup,
  orgSharingControllerPartnerships,
  orgSpacesControllerCreate,
  orgTemplatesControllerCreate,
  orgTemplatesControllerList,
  orgTemplatesControllerRemove,
  orgTemplatesControllerSaveAsTemplate,
  orgTemplatesControllerUpdate,
  organizationLogoControllerGet,
  organizationLogoControllerRemove,
  organizationLogoControllerSet,
  organizationLogoControllerUploadTarget,
  organizationPrivacyControllerCancelDeletion,
  organizationPrivacyControllerDeletion,
  organizationPrivacyControllerExportUrl,
  organizationPrivacyControllerListExports,
  organizationPrivacyControllerRequestDeletion,
  organizationPrivacyControllerRequestExport,
  organizationSettingsControllerPolicies,
  organizationSettingsControllerUpdatePolicies,
  organizationSettingsControllerUpdateProfile,
  organizationsControllerCreateOrganization,
  organizationsControllerGet,
  ownerTransferControllerAccept,
  ownerTransferControllerCancel,
  ownerTransferControllerPropose,
  ownerTransferControllerState,
  partnerOfficesControllerList,
  paymentWebhookControllerReceive,
  paymentsControllerAging,
  paymentsControllerAttachCertificate,
  paymentsControllerList,
  paymentsControllerRecord,
  paymentsControllerSettings,
  paymentsControllerUpdateSettings,
  phasesControllerCreate,
  phasesControllerList,
  phasesControllerReorder,
  phasesControllerUpdate,
  planningControllerCancelOrder,
  planningControllerCreateOrder,
  planningControllerGantt,
  planningControllerListOrders,
  plansControllerList,
  platformAuditControllerList,
  platformAuthControllerCallback,
  platformAuthControllerLogout,
  platformAuthControllerMe,
  platformAuthControllerSignIn,
  platformAuthControllerStepUp,
  platformBreakGlassControllerApprove,
  platformBreakGlassControllerCancel,
  platformBreakGlassControllerCreate,
  platformBreakGlassControllerList,
  platformBreakGlassControllerReject,
  platformBreakGlassControllerRevoke,
  platformDeletionsControllerApprove,
  platformDeletionsControllerCancel,
  platformDeletionsControllerCreate,
  platformDeletionsControllerList,
  platformDeletionsControllerReject,
  platformJobsControllerDiscard,
  platformJobsControllerList,
  platformJobsControllerRetry,
  platformOrganizationsControllerDetail,
  platformOrganizationsControllerList,
  platformOrganizationsControllerOverrideStatus,
  platformPaymentsControllerConfirm,
  platformSecurityControllerSignals,
  platformUsersControllerAccount,
  platformUsersControllerDelete,
  platformUsersControllerLock,
  platformUsersControllerMembers,
  platformUsersControllerReactivate,
  platformUsersControllerRemove,
  platformUsersControllerSuspend,
  platformUsersControllerUnlock,
  profileControllerGetPreferences,
  profileControllerPutPreferences,
  profileControllerUpdate,
  profitabilityControllerCreateRate,
  profitabilityControllerListRates,
  profitabilityControllerOverview,
  profitabilityControllerProject,
  profitabilityControllerRemoveRate,
  progressInvoicesControllerCreate,
  progressInvoicesControllerGet,
  projectTemplatesControllerList,
  projectsControllerArchive,
  projectsControllerCreateProject,
  projectsControllerGet,
  projectsControllerList,
  projectsControllerListMembers,
  projectsControllerReplaceMembers,
  projectsControllerRestore,
  projectsControllerUpdate,
  publicQuotesControllerAccept,
  publicQuotesControllerGet,
  publicQuotesControllerPdf,
  publicShareLinksControllerDownloadUrl,
  publicShareLinksControllerGet,
  publicShareLinksControllerPreviewUrl,
  publicShareLinksControllerUnlock,
  publicTransmittalsControllerAcknowledge,
  publicTransmittalsControllerDownloadUrl,
  publicTransmittalsControllerGet,
  publicTransmittalsControllerPreviewUrl,
  quotesControllerConvert,
  quotesControllerCreate,
  quotesControllerCreateFeeScale,
  quotesControllerDeleteFeeScale,
  quotesControllerFeeScales,
  quotesControllerGet,
  quotesControllerList,
  quotesControllerPdfUrl,
  quotesControllerReject,
  quotesControllerRemove,
  quotesControllerRequestPdf,
  quotesControllerSend,
  quotesControllerUpdate,
  recentDocumentsControllerList,
  receptionReportsControllerCreate,
  receptionReportsControllerDownloadUrl,
  receptionReportsControllerGet,
  receptionReportsControllerList,
  registerControllerGet,
  registerControllerGetExport,
  registerControllerRequestExport,
  responsibilitiesControllerMatrix,
  responsibilitiesControllerSynthesis,
  responsibilitiesControllerUpdate,
  revokeAccessControllerAudit,
  revokeAccessControllerClose,
  revokeAccessControllerRemoveMember,
  revokeAccessControllerRemovePartner,
  rolesControllerCreate,
  rolesControllerList,
  rolesControllerRemove,
  rolesControllerUpdate,
  searchControllerFind,
  shareLinksControllerCreate,
  shareLinksControllerList,
  shareLinksControllerRevoke,
  signaturesControllerCancel,
  signaturesControllerCreate,
  signaturesControllerDecline,
  signaturesControllerEvidenceUrl,
  signaturesControllerGet,
  signaturesControllerList,
  signaturesControllerSendCode,
  signaturesControllerSign,
  signaturesControllerVerify,
  signingBatchesControllerConfirm,
  signingBatchesControllerPending,
  signingBatchesControllerStart,
  spaceApprovalsControllerApprove,
  spaceApprovalsControllerDecline,
  spaceApprovalsControllerList,
  spaceChannelsControllerCreate,
  spaceChannelsControllerList,
  spaceEventsControllerCreate,
  spaceEventsControllerList,
  spaceInvitationAnswersControllerAccept,
  spaceInvitationAnswersControllerDecline,
  spaceInvitationsControllerCreate,
  spaceInvitationsControllerExtend,
  spaceInvitationsControllerList,
  spaceInvitationsControllerRevoke,
  spaceMeetingsControllerCreate,
  spaceMeetingsControllerList,
  spacePartnersControllerDelegate,
  spacePartnersControllerInvite,
  spacePartnersControllerList,
  spacePartnersControllerMembers,
  spacesControllerGet,
  spacesControllerUpdate,
  storageControllerReport,
  subscriptionControllerCancel,
  subscriptionControllerChange,
  subscriptionControllerGet,
  subscriptionControllerInvoices,
  subscriptionControllerPause,
  subscriptionControllerPaymentLink,
  subscriptionControllerPdfUrl,
  subscriptionControllerQuote,
  subscriptionControllerRenew,
  subscriptionControllerResume,
  subscriptionControllerWithdraw,
  suppliersControllerCancelInvoice,
  suppliersControllerCancelPayment,
  suppliersControllerCreateInvoice,
  suppliersControllerCreateSupplier,
  suppliersControllerCreateTejExport,
  suppliersControllerDownloadTejExport,
  suppliersControllerGetInvoice,
  suppliersControllerGetSupplier,
  suppliersControllerListInvoices,
  suppliersControllerListSuppliers,
  suppliersControllerListTejExports,
  suppliersControllerPay,
  suppliersControllerPreviewPayment,
  suppliersControllerRevealBankDetails,
  suppliersControllerSummary,
  suppliersControllerUpdateInvoice,
  suppliersControllerUpdateSupplier,
  tasksControllerAddChecklistItem,
  tasksControllerAddDependency,
  tasksControllerCreate,
  tasksControllerCreateComment,
  tasksControllerGet,
  tasksControllerList,
  tasksControllerListComments,
  tasksControllerMove,
  tasksControllerRemove,
  tasksControllerRemoveChecklistItem,
  tasksControllerRemoveComment,
  tasksControllerRemoveDependency,
  tasksControllerUpdate,
  tasksControllerUpdateChecklistItem,
  tasksControllerUpdateComment,
  tendersControllerAddRequirement,
  tendersControllerChangeStatus,
  tendersControllerConvert,
  tendersControllerCreate,
  tendersControllerGet,
  tendersControllerList,
  tendersControllerRemove,
  tendersControllerRemoveRequirement,
  tendersControllerUpdate,
  tendersControllerUpdateRequirement,
  timesheetsControllerApprovals,
  timesheetsControllerCapacity,
  timesheetsControllerCreateEntry,
  timesheetsControllerCreateLeave,
  timesheetsControllerDecide,
  timesheetsControllerDeleteEntry,
  timesheetsControllerDeleteLeave,
  timesheetsControllerListLeave,
  timesheetsControllerMyWeek,
  timesheetsControllerSubmit,
  timesheetsControllerUpdateEntry,
  timesheetsControllerWorkingTime,
  transmittalsControllerAcknowledge,
  transmittalsControllerCreate,
  transmittalsControllerDiffusion,
  transmittalsControllerGet,
  transmittalsControllerList,
  transmittalsControllerPdfUrl,
  trashControllerList,
  trashControllerPurge,
  trashControllerRestore,
  uploadsControllerAbort,
  uploadsControllerComplete,
  uploadsControllerCreate,
  uploadsControllerRefreshParts,
  uploadsControllerStatus,
  useAccountSecurityControllerChangePassword,
  useAccountSecurityControllerRemoveAuthenticator,
  useAccountSecurityControllerView,
  useAccountingControllerClose,
  useAccountingControllerClosedPeriods,
  useAccountingControllerCreate,
  useAccountingControllerDownloadUrl,
  useAccountingControllerList,
  useAccountingControllerReopen,
  useAccountingControllerSettings,
  useAccountingControllerUpdateSettings,
  useAnnotationsControllerAddComment,
  useAnnotationsControllerComments,
  useAnnotationsControllerCreate,
  useAnnotationsControllerList,
  useAnnotationsControllerRemove,
  useAnnotationsControllerReopen,
  useAnnotationsControllerResolve,
  useAnnotationsControllerUpdate,
  useApprovalTemplatesControllerCreate,
  useApprovalTemplatesControllerList,
  useApprovalTemplatesControllerRemove,
  useApprovalsControllerCancel,
  useApprovalsControllerDecide,
  useApprovalsControllerGet,
  useApprovalsControllerList,
  useApprovalsControllerListForDocument,
  useApprovalsControllerStart,
  useAuditControllerList,
  useAuditControllerVerify,
  useAuthControllerBackchannelLogout,
  useAuthControllerCallback,
  useAuthControllerLogout,
  useAuthControllerSignIn,
  useAuthControllerStepUp,
  useChannelControllerAttachmentsFolder,
  useChannelControllerGet,
  useChannelControllerMarkRead,
  useChannelControllerUpdate,
  useChannelMeetingsControllerList,
  useChannelMessagesControllerCreate,
  useChannelMessagesControllerList,
  useChannelPinsControllerList,
  useChannelPinsControllerPin,
  useChannelPinsControllerUnpin,
  useChecklistTemplatesControllerCreate,
  useChecklistTemplatesControllerList,
  useChecklistTemplatesControllerRetire,
  useChecklistTemplatesControllerUpdate,
  useChecklistsControllerArchive,
  useChecklistsControllerCreate,
  useChecklistsControllerGet,
  useChecklistsControllerList,
  useChecklistsControllerSetItem,
  useClientErrorsControllerReport,
  useClientsControllerArchive,
  useClientsControllerCreate,
  useClientsControllerCreateContact,
  useClientsControllerDeleteContact,
  useClientsControllerGet,
  useClientsControllerList,
  useClientsControllerListContacts,
  useClientsControllerUpdate,
  useClientsControllerUpdateContact,
  useContractsControllerAddAmendment,
  useContractsControllerAmendments,
  useContractsControllerCreate,
  useContractsControllerGet,
  useContractsControllerList,
  useContractsControllerUpdate,
  useDeliverablesControllerClosePhase,
  useDeliverablesControllerCreate,
  useDeliverablesControllerList,
  useDeliverablesControllerUpdate,
  useDirectoryControllerContact,
  useDirectoryControllerSearch,
  useDirectoryProfileControllerGet,
  useDirectoryProfileControllerUpdate,
  useDocumentSettingsControllerGet,
  useDocumentSettingsControllerPut,
  useDocumentsControllerDownloadUrl,
  useDocumentsControllerGet,
  useDocumentsControllerList,
  useDocumentsControllerPreviewUrl,
  useDocumentsControllerRemove,
  useDocumentsControllerRestore,
  useDocumentsControllerUpdate,
  useDocumentsControllerVersions,
  useEinvoicingControllerCreate,
  useEinvoicingControllerList,
  useEinvoicingControllerRevoke,
  useEinvoicingControllerSettings,
  useEinvoicingControllerUpdateSettings,
  useEntitlementsControllerGet,
  useEventControllerGet,
  useEventControllerRemove,
  useEventControllerRespond,
  useEventControllerUpdate,
  useExitExportsControllerClosed,
  useExitExportsControllerDownloadUrl,
  useExitExportsControllerRequest,
  useExpensesControllerApprove,
  useExpensesControllerGet,
  useExpensesControllerList,
  useExpensesControllerMine,
  useExpensesControllerReceiptFolder,
  useExpensesControllerReceiptUrl,
  useExpensesControllerReimbursed,
  useExpensesControllerReject,
  useExpensesControllerSubmit,
  useFinanceControllerCurrentRuleSet,
  useFinanceControllerPreview,
  useFinanceDashboardControllerGet,
  useFiscalSettingsControllerCreateProfile,
  useFiscalSettingsControllerCreateSeries,
  useFiscalSettingsControllerDeleteSeries,
  useFiscalSettingsControllerListProfiles,
  useFiscalSettingsControllerListSeries,
  useFiscalSettingsControllerRevealBankDetails,
  useFiscalSettingsControllerUpdateSeries,
  useFoldersControllerAcl,
  useFoldersControllerCreate,
  useFoldersControllerGet,
  useFoldersControllerItems,
  useFoldersControllerList,
  useFoldersControllerRemove,
  useFoldersControllerReplaceAcl,
  useFoldersControllerUpdate,
  useGroupementControllerAddPayment,
  useGroupementControllerDeletePayment,
  useGroupementControllerGet,
  useGroupementControllerSave,
  useHealthControllerLive,
  useHealthControllerReady,
  useIcsPublicControllerFeed,
  useInvitationAcceptanceControllerAccept,
  useInvitationAcceptanceControllerPreview,
  useInvitationsControllerCreate,
  useInvitationsControllerList,
  useInvitationsControllerResend,
  useInvitationsControllerRevoke,
  useInvoiceEinvoiceControllerGet,
  useInvoiceEinvoiceControllerManual,
  useInvoiceEinvoiceControllerResubmit,
  useInvoiceEinvoiceControllerTeifUrl,
  useInvoicesControllerCreate,
  useInvoicesControllerCreditNote,
  useInvoicesControllerGet,
  useInvoicesControllerIssue,
  useInvoicesControllerList,
  useInvoicesControllerPdfUrl,
  useInvoicesControllerRemove,
  useInvoicesControllerRequestPdf,
  useInvoicesControllerUpdate,
  useLateInterestControllerDeleteRate,
  useLateInterestControllerEstimate,
  useLateInterestControllerRates,
  useLateInterestControllerSetRate,
  useLivekitWebhookControllerReceive,
  useManagementControllerDashboard,
  useManagementControllerForecast,
  useMeControllerCurrent,
  useMeControllerRevoke,
  useMeControllerRevokeOthers,
  useMeControllerSessions,
  useMeetingInvitationsControllerJoin,
  useMeetingInvitationsControllerPreview,
  useMeetingsControllerGet,
  useMeetingsControllerInvite,
  useMeetingsControllerInviteMembers,
  useMeetingsControllerToken,
  useMembersControllerChangeRole,
  useMembersControllerDeactivate,
  useMembersControllerList,
  useMembersControllerTransferPlan,
  useMessageControllerEdits,
  useMessageControllerGet,
  useMessageControllerRemove,
  useMessageControllerUpdate,
  useMessageReactionsControllerAdd,
  useMessageReactionsControllerRemove,
  useMinutesControllerCreate,
  useMinutesControllerGet,
  useMinutesControllerList,
  useMinutesControllerPdf,
  useMinutesControllerPublish,
  useMinutesControllerUpdate,
  useMyCalendarControllerCalendarOf,
  useMyCalendarControllerCreateFeed,
  useMyCalendarControllerListFeeds,
  useMyCalendarControllerRevokeFeed,
  useMyDataExportControllerDownloadUrl,
  useMyDataExportControllerList,
  useMyDataExportControllerRequest,
  useMySpaceInvitationsControllerList,
  useMySpacesControllerList,
  useNotificationsControllerActivity,
  useNotificationsControllerList,
  useNotificationsControllerMarkRead,
  useObservationsControllerCreate,
  useObservationsControllerGet,
  useObservationsControllerList,
  useObservationsControllerPhotoFolder,
  useObservationsControllerRemove,
  useObservationsControllerReopen,
  useObservationsControllerResolve,
  useObservationsControllerUpdate,
  useOrgCallsControllerStart,
  useOrgChannelsControllerCreate,
  useOrgChannelsControllerList,
  useOrgChannelsControllerUnread,
  useOrgMeetingsControllerList,
  useOrgSharingControllerLookup,
  useOrgSharingControllerPartnerships,
  useOrgSpacesControllerCreate,
  useOrgTemplatesControllerCreate,
  useOrgTemplatesControllerList,
  useOrgTemplatesControllerRemove,
  useOrgTemplatesControllerSaveAsTemplate,
  useOrgTemplatesControllerUpdate,
  useOrganizationLogoControllerGet,
  useOrganizationLogoControllerRemove,
  useOrganizationLogoControllerSet,
  useOrganizationLogoControllerUploadTarget,
  useOrganizationPrivacyControllerCancelDeletion,
  useOrganizationPrivacyControllerDeletion,
  useOrganizationPrivacyControllerExportUrl,
  useOrganizationPrivacyControllerListExports,
  useOrganizationPrivacyControllerRequestDeletion,
  useOrganizationPrivacyControllerRequestExport,
  useOrganizationSettingsControllerPolicies,
  useOrganizationSettingsControllerUpdatePolicies,
  useOrganizationSettingsControllerUpdateProfile,
  useOrganizationsControllerCreateOrganization,
  useOrganizationsControllerGet,
  useOwnerTransferControllerAccept,
  useOwnerTransferControllerCancel,
  useOwnerTransferControllerPropose,
  useOwnerTransferControllerState,
  usePartnerOfficesControllerList,
  usePaymentWebhookControllerReceive,
  usePaymentsControllerAging,
  usePaymentsControllerAttachCertificate,
  usePaymentsControllerList,
  usePaymentsControllerRecord,
  usePaymentsControllerSettings,
  usePaymentsControllerUpdateSettings,
  usePhasesControllerCreate,
  usePhasesControllerList,
  usePhasesControllerReorder,
  usePhasesControllerUpdate,
  usePlanningControllerCancelOrder,
  usePlanningControllerCreateOrder,
  usePlanningControllerGantt,
  usePlanningControllerListOrders,
  usePlansControllerList,
  usePlatformAuditControllerList,
  usePlatformAuthControllerCallback,
  usePlatformAuthControllerLogout,
  usePlatformAuthControllerMe,
  usePlatformAuthControllerSignIn,
  usePlatformAuthControllerStepUp,
  usePlatformBreakGlassControllerApprove,
  usePlatformBreakGlassControllerCancel,
  usePlatformBreakGlassControllerCreate,
  usePlatformBreakGlassControllerList,
  usePlatformBreakGlassControllerReject,
  usePlatformBreakGlassControllerRevoke,
  usePlatformDeletionsControllerApprove,
  usePlatformDeletionsControllerCancel,
  usePlatformDeletionsControllerCreate,
  usePlatformDeletionsControllerList,
  usePlatformDeletionsControllerReject,
  usePlatformJobsControllerDiscard,
  usePlatformJobsControllerList,
  usePlatformJobsControllerRetry,
  usePlatformOrganizationsControllerDetail,
  usePlatformOrganizationsControllerList,
  usePlatformOrganizationsControllerOverrideStatus,
  usePlatformPaymentsControllerConfirm,
  usePlatformSecurityControllerSignals,
  usePlatformUsersControllerAccount,
  usePlatformUsersControllerDelete,
  usePlatformUsersControllerLock,
  usePlatformUsersControllerMembers,
  usePlatformUsersControllerReactivate,
  usePlatformUsersControllerRemove,
  usePlatformUsersControllerSuspend,
  usePlatformUsersControllerUnlock,
  useProfileControllerGetPreferences,
  useProfileControllerPutPreferences,
  useProfileControllerUpdate,
  useProfitabilityControllerCreateRate,
  useProfitabilityControllerListRates,
  useProfitabilityControllerOverview,
  useProfitabilityControllerProject,
  useProfitabilityControllerRemoveRate,
  useProgressInvoicesControllerCreate,
  useProgressInvoicesControllerGet,
  useProjectTemplatesControllerList,
  useProjectsControllerArchive,
  useProjectsControllerCreateProject,
  useProjectsControllerGet,
  useProjectsControllerList,
  useProjectsControllerListMembers,
  useProjectsControllerReplaceMembers,
  useProjectsControllerRestore,
  useProjectsControllerUpdate,
  usePublicQuotesControllerAccept,
  usePublicQuotesControllerGet,
  usePublicQuotesControllerPdf,
  usePublicShareLinksControllerDownloadUrl,
  usePublicShareLinksControllerGet,
  usePublicShareLinksControllerPreviewUrl,
  usePublicShareLinksControllerUnlock,
  usePublicTransmittalsControllerAcknowledge,
  usePublicTransmittalsControllerDownloadUrl,
  usePublicTransmittalsControllerGet,
  usePublicTransmittalsControllerPreviewUrl,
  useQuotesControllerConvert,
  useQuotesControllerCreate,
  useQuotesControllerCreateFeeScale,
  useQuotesControllerDeleteFeeScale,
  useQuotesControllerFeeScales,
  useQuotesControllerGet,
  useQuotesControllerList,
  useQuotesControllerPdfUrl,
  useQuotesControllerReject,
  useQuotesControllerRemove,
  useQuotesControllerRequestPdf,
  useQuotesControllerSend,
  useQuotesControllerUpdate,
  useRecentDocumentsControllerList,
  useReceptionReportsControllerCreate,
  useReceptionReportsControllerDownloadUrl,
  useReceptionReportsControllerGet,
  useReceptionReportsControllerList,
  useRegisterControllerGet,
  useRegisterControllerGetExport,
  useRegisterControllerRequestExport,
  useResponsibilitiesControllerMatrix,
  useResponsibilitiesControllerSynthesis,
  useResponsibilitiesControllerUpdate,
  useRevokeAccessControllerAudit,
  useRevokeAccessControllerClose,
  useRevokeAccessControllerRemoveMember,
  useRevokeAccessControllerRemovePartner,
  useRolesControllerCreate,
  useRolesControllerList,
  useRolesControllerRemove,
  useRolesControllerUpdate,
  useSearchControllerFind,
  useShareLinksControllerCreate,
  useShareLinksControllerList,
  useShareLinksControllerRevoke,
  useSignaturesControllerCancel,
  useSignaturesControllerCreate,
  useSignaturesControllerDecline,
  useSignaturesControllerEvidenceUrl,
  useSignaturesControllerGet,
  useSignaturesControllerList,
  useSignaturesControllerSendCode,
  useSignaturesControllerSign,
  useSignaturesControllerVerify,
  useSigningBatchesControllerConfirm,
  useSigningBatchesControllerPending,
  useSigningBatchesControllerStart,
  useSpaceApprovalsControllerApprove,
  useSpaceApprovalsControllerDecline,
  useSpaceApprovalsControllerList,
  useSpaceChannelsControllerCreate,
  useSpaceChannelsControllerList,
  useSpaceEventsControllerCreate,
  useSpaceEventsControllerList,
  useSpaceInvitationAnswersControllerAccept,
  useSpaceInvitationAnswersControllerDecline,
  useSpaceInvitationsControllerCreate,
  useSpaceInvitationsControllerExtend,
  useSpaceInvitationsControllerList,
  useSpaceInvitationsControllerRevoke,
  useSpaceMeetingsControllerCreate,
  useSpaceMeetingsControllerList,
  useSpacePartnersControllerDelegate,
  useSpacePartnersControllerInvite,
  useSpacePartnersControllerList,
  useSpacePartnersControllerMembers,
  useSpacesControllerGet,
  useSpacesControllerUpdate,
  useStorageControllerReport,
  useSubscriptionControllerCancel,
  useSubscriptionControllerChange,
  useSubscriptionControllerGet,
  useSubscriptionControllerInvoices,
  useSubscriptionControllerPause,
  useSubscriptionControllerPaymentLink,
  useSubscriptionControllerPdfUrl,
  useSubscriptionControllerQuote,
  useSubscriptionControllerRenew,
  useSubscriptionControllerResume,
  useSubscriptionControllerWithdraw,
  useSuppliersControllerCancelInvoice,
  useSuppliersControllerCancelPayment,
  useSuppliersControllerCreateInvoice,
  useSuppliersControllerCreateSupplier,
  useSuppliersControllerCreateTejExport,
  useSuppliersControllerDownloadTejExport,
  useSuppliersControllerGetInvoice,
  useSuppliersControllerGetSupplier,
  useSuppliersControllerListInvoices,
  useSuppliersControllerListSuppliers,
  useSuppliersControllerListTejExports,
  useSuppliersControllerPay,
  useSuppliersControllerPreviewPayment,
  useSuppliersControllerRevealBankDetails,
  useSuppliersControllerSummary,
  useSuppliersControllerUpdateInvoice,
  useSuppliersControllerUpdateSupplier,
  useTasksControllerAddChecklistItem,
  useTasksControllerAddDependency,
  useTasksControllerCreate,
  useTasksControllerCreateComment,
  useTasksControllerGet,
  useTasksControllerList,
  useTasksControllerListComments,
  useTasksControllerMove,
  useTasksControllerRemove,
  useTasksControllerRemoveChecklistItem,
  useTasksControllerRemoveComment,
  useTasksControllerRemoveDependency,
  useTasksControllerUpdate,
  useTasksControllerUpdateChecklistItem,
  useTasksControllerUpdateComment,
  useTendersControllerAddRequirement,
  useTendersControllerChangeStatus,
  useTendersControllerConvert,
  useTendersControllerCreate,
  useTendersControllerGet,
  useTendersControllerList,
  useTendersControllerRemove,
  useTendersControllerRemoveRequirement,
  useTendersControllerUpdate,
  useTendersControllerUpdateRequirement,
  useTimesheetsControllerApprovals,
  useTimesheetsControllerCapacity,
  useTimesheetsControllerCreateEntry,
  useTimesheetsControllerCreateLeave,
  useTimesheetsControllerDecide,
  useTimesheetsControllerDeleteEntry,
  useTimesheetsControllerDeleteLeave,
  useTimesheetsControllerListLeave,
  useTimesheetsControllerMyWeek,
  useTimesheetsControllerSubmit,
  useTimesheetsControllerUpdateEntry,
  useTimesheetsControllerWorkingTime,
  useTransmittalsControllerAcknowledge,
  useTransmittalsControllerCreate,
  useTransmittalsControllerDiffusion,
  useTransmittalsControllerGet,
  useTransmittalsControllerList,
  useTransmittalsControllerPdfUrl,
  useTrashControllerList,
  useTrashControllerPurge,
  useTrashControllerRestore,
  useUploadsControllerAbort,
  useUploadsControllerComplete,
  useUploadsControllerCreate,
  useUploadsControllerRefreshParts,
  useUploadsControllerStatus,
  useVaultDocumentsControllerCreate,
  useVaultDocumentsControllerList,
  useVaultDocumentsControllerRemove,
  useVaultDocumentsControllerUpdate,
  vaultDocumentsControllerCreate,
  vaultDocumentsControllerList,
  vaultDocumentsControllerRemove,
  vaultDocumentsControllerUpdate
};
//# sourceMappingURL=index.js.map